<script setup lang="ts">
defineProps<{
    icon: string;
}>();

const emit = defineEmits(["click"]);
</script>
<template>
    <div :class="[icon, 'Icon']" @click="emit('click', $event)">
        <template v-if="icon === 'interaction_logo'">
            <svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 543.04 534.11">
                <g id="Calque_2-2">
                    <path
                        d="M231.61,175.84c-13.49-3.21-22.48-15.09-21.86-28.88,.61-13.56,10.98-24.75,24.61-26.57,6.37-.85,9.57,.92,12.05,7.02,2.67,6.57,3.43,13.49,3.35,20.52,.03,6.68-.63,13.26-2.93,19.6-3.03,8.35-6.69,10.35-15.22,8.31h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M210.8,330.69c.1-3.11-.75-3.44-3.64-2.99-20.49,3.26-41,6.33-61.52,9.36-1.83,.28-4.17,1.35-5.53-.7-1.15-1.72,.16-3.52,.9-5.16,20.46-44.98,45.26-87.21,78.85-123.82,4.26-4.65,8.75-9.11,13.36-13.41,4.74-4.42,8.44-4.57,13.9-.99,10.92,7.17,20.07,16.31,28.98,25.76,2.47,2.61,.95,4.47-.24,6.6-10.82,19.43-21.76,38.79-32.46,58.29-5.66,10.33-10.56,21.04-14.63,32.13-1.17,3.19-1.25,6.08,.57,9.01,5.36,8.65,13.21,13.22,22.94,14.47,5.71-.84,11.15-1.52,16.54-2.48,2.55-.45,3.44-.39,3.13,2.8-5.32,53.55-31.67,92.3-80.65,115.25-9.62,4.51-19.55,8.27-29.64,11.58-1.2,.39-2.63,1.4-3.47-.24-.67-1.28,.73-2.03,1.54-2.8,28.8-27.18,41.9-61.9,48.01-99.96,1.73-10.82,2.71-21.73,3.06-32.7h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M353.51,21.36c-.83,2.17-3,.85-4.42,.52-19.34-4.47-38.99-6.67-58.77-6.64-27.56,.06-54.68,3.88-80.75,13.04C129.29,56.51,80.23,112.99,60.1,195.08c-7.12,29.05-10.02,58.62-6.97,88.5,3.4,33.27,13.38,64.07,36.95,88.88,16.33,17.19,36.15,27.37,60.57,26.47,4.82-.17,9.57-1.05,14.2-2.44,1.12-.33,2.22-.7,3.21,.37,.91,.99,.32,1.86-.15,2.71-10.51,19.26-22.36,37.49-41.72,49.15-17.26,10.39-34.98,10.38-52.52,.58-19.27-10.77-31.88-27.8-42.33-46.58-14.93-26.85-23.37-55.9-28.11-86.11-1.58-10.01-2.62-20.08-3.17-30.2v-.21c.18,.05,.36,.17,.53,.36,1.77,6.94,1.86,14.1,2.74,21.16,3.61,29.1,11,57.16,23.55,83.66,9.61,20.3,21.81,38.97,40.44,52.32,21.66,15.52,43.62,15.31,64.97-.7,14.58-10.94,24.16-25.9,33.12-41.36,.49-.84,1.21-1.85,.55-2.76-.98-1.36-2.49-.63-3.69-.34-9.53,2.31-19.07,2.4-28.67,.39-18.97-3.96-34.41-13.94-47.04-28.25-19.95-22.59-29.68-49.73-33.73-79.12-5.19-37.67-.54-74.57,9.69-110.9,8.86-31.48,23.85-59.86,44.7-85.03,17.26-20.82,38.05-37.42,61.59-50.76,31.09-17.61,64.64-27.07,100-29.95,25.56-2.08,51.09-.65,76.27,4.8,1.74,.37,3.45,1.23,5.63,.46-1.45-1.73-3.39-2.2-5.15-2.9-19.1-7.63-38.86-12.6-59.3-14.92-1.76-.21-4.17,.49-4.69-2.36,5.56,2.2,11.55,1.86,17.33,2.82,17.77,2.96,34.93,7.89,51.42,15.12,1.49,.65,4.18,.82,3.19,3.42h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M352.12,111.76c2.62,6.56,3.5,13.47,3.31,19.59,.05,8.13-.71,15.22-3.5,21.92-2.87,6.91-5.86,8.48-13.17,7.37-13.91-2.12-23.83-14.77-23.26-29.69,.5-13.19,11.79-25,25.02-26.18,6.31-.56,9.23,1.04,11.6,6.99h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M355.41,178.29c18.98,13.33,34.38,30.24,48.4,48.49,14.38,18.73,27.01,38.6,38.15,59.42,3.13,5.87,2.87,6.27-3.94,7.27-18.06,2.66-36.12,5.34-54.16,8.06-2.2,.33-4.26,.29-4.63,3.78-5.98,56.82-34.43,100.13-80.48,132.64-16.21,11.45-33.8,20.32-52.65,26.61-1.19,.4-2.7,1.39-3.71,.18-1.09-1.31,.6-2,1.35-2.69,29.47-26.97,47.52-60.96,60.35-98.16,5.36-15.55,9.24-31.48,12.14-47.66,.59-3.34,.45-4.72-3.71-4.05-20.32,3.25-40.69,6.19-61.04,9.21-1.56,.23-3.43,1.14-4.6-.59-1.09-1.63,.08-3.2,.83-4.64,25.62-48.78,54.07-95.66,91.62-136.44,2.36-2.56,4.78-4.58,7.6-4.59,3.84-.09,6.17,1.54,8.48,3.16h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M414.15,118.36c.57-13.66,12.27-25.01,26.28-25.82,4.69-.28,7.58,1.71,9.51,5.65,3.39,6.89,3.73,14.36,4.2,21.81-.42,7.5-.9,14.96-4.06,21.91-2.75,6.04-5.73,7.59-12.25,6.69-14.42-2.01-24.33-14.65-23.68-30.24h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M528.88,300.42c-1.91,15.17-4.56,30.23-9.4,44.74-33.31,99.94-101.52,161.4-204.28,184.3-16.39,3.65-33.18,5-46.47,4.58-42.36,.21-79.33-7.98-114.56-24.13-.9-.42-1.83-.79-2.72-1.22-1.09-.53-2.19-1.2-1.91-2.59,.39-1.96,2.04-1.35,3.24-1.19,8.56,1.12,17.09,2.53,25.66,3.47,65.65,7.16,129.33,.71,189.37-28.71,48.89-23.94,87.6-59.63,118.05-104.49,15.72-23.16,28.61-47.8,37.98-74.22,.22-.63,.32-1.3,.58-1.9,.7-1.58,2.12-2.35,3.64-1.98,1.89,.45,.96,2.23,.82,3.34h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M536.8,277.25c-18.06,2.69-36.11,5.44-54.18,7.97-2.68,.38-3.59,1.16-3.73,3.92-.88,17.86-4.12,35.23-11.16,51.78-12.6,29.61-33.35,52.45-58.86,71.43-20.64,15.35-43.3,27.11-66.58,37.8-1.01,.46-2.3,1.53-3.16,.39-1.16-1.57,.7-2.3,1.57-3.07,37.84-33.59,59.15-76.53,70.58-124.99,1.26-5.32,3.65-7.98,9.28-8.41,6.43-.5,12.81-1.76,19.2-2.83,9.3-1.55,20.51-15.59,20.57-25.64,.18-3.48-1.41-6.45-2.79-9.45-10.54-22.85-24.26-43.84-38.07-64.77-1.74-2.64-3.44-5.31-5.35-7.81-3.14-4.09-2.65-7.77,.42-11.73,7.74-9.99,15.83-19.67,24.34-29.01,4.71-5.17,8.61-5.7,14.45-1.72,21.14,14.42,37.96,33.19,53.2,53.47,12.99,17.28,24.69,35.42,34.52,54.71,3.26,6.39,2.96,6.89-4.25,7.96h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M350.71,20.18c-2.18,.77-3.89-.09-5.63-.46-25.18-5.45-50.71-6.88-76.27-4.8-35.36,2.88-68.91,12.34-100,29.95-23.54,13.34-44.33,29.94-61.59,50.76-20.85,25.17-35.84,53.55-44.7,85.03-10.23,36.33-14.88,73.23-9.69,110.9,4.05,29.39,13.78,56.53,33.73,79.12,12.63,14.31,28.07,24.29,47.04,28.25,9.6,2.01,19.14,1.92,28.67-.39,1.2-.29,2.71-1.02,3.69,.34,.66,.91-.06,1.92-.55,2.76-8.96,15.46-18.54,30.42-33.12,41.36-21.35,16.01-43.31,16.22-64.97,.7-18.63-13.35-30.83-32.02-40.44-52.32-12.55-26.5-19.94-54.56-23.55-83.66-.88-7.06-.97-14.22-2.74-21.16-.17-.19-.35-.31-.53-.36L0,280.47c0-7.7,.02-15.4,.04-23.11,0-1.66-.03-3.32-.04-4.98-.1,0,8.51-64.53,21.73-94.73,10.75-24.55,25.41-46.66,43.04-66.8,20.34-23.21,44.08-42.31,70.87-57.56C164.1,17.1,194.5,6.32,226.92,1.4,232.47,.56,238.13,1.08,243.65,0h4.99c2.33,1.58,4.66,1.58,6.99,0h14.96c2,1.54,4,1.53,5.99,0h4.99c.52,2.85,2.93,2.15,4.69,2.36,20.44,2.32,40.2,7.29,59.3,14.92,1.76,.7,3.7,1.17,5.15,2.9h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M353.51,21.36c-.83,2.17-3,.85-4.42,.52-19.34-4.47-38.99-6.67-58.77-6.64-27.56,.06-54.68,3.88-80.75,13.04C129.29,56.51,80.23,112.99,60.1,195.08c-7.12,29.05-10.02,58.62-6.97,88.5,3.4,33.27,13.38,64.07,36.95,88.88,16.33,17.19,36.15,27.37,60.57,26.47,4.82-.17,9.57-1.05,14.2-2.44,1.12-.33,2.22-.7,3.21,.37,.91,.99,.32,1.86-.15,2.71-10.51,19.26-22.36,37.49-41.72,49.15-17.26,10.39-34.98,10.38-52.52,.58-19.27-10.77-31.88-27.8-42.33-46.58-14.93-26.85-23.37-55.9-28.11-86.11-1.58-10.01-2.62-20.08-3.17-30.2v-.21c.18,.05,.36,.17,.53,.36,1.77,6.94,1.86,14.1,2.74,21.16,3.61,29.1,11,57.16,23.55,83.66,9.61,20.3,21.81,38.97,40.44,52.32,21.66,15.52,43.62,15.31,64.97-.7,14.58-10.94,24.16-25.9,33.12-41.36,.49-.84,1.21-1.85,.55-2.76-.98-1.36-2.49-.63-3.69-.34-9.53,2.31-19.07,2.4-28.67,.39-18.97-3.96-34.41-13.94-47.04-28.25-19.95-22.59-29.68-49.73-33.73-79.12-5.19-37.67-.54-74.57,9.69-110.9,8.86-31.48,23.85-59.86,44.7-85.03,17.26-20.82,38.05-37.42,61.59-50.76,31.09-17.61,64.64-27.07,100-29.95,25.56-2.08,51.09-.65,76.27,4.8,1.74,.37,3.45,1.23,5.63,.46-1.45-1.73-3.39-2.2-5.15-2.9-19.1-7.63-38.86-12.6-59.3-14.92-1.76-.21-4.17,.49-4.69-2.36,5.56,2.2,11.55,1.86,17.33,2.82,17.77,2.96,34.93,7.89,51.42,15.12,1.49,.65,4.18,.82,3.19,3.42h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M438.02,293.47c-18.06,2.66-36.12,5.34-54.16,8.06-2.2,.33-4.26,.29-4.63,3.78-5.98,56.82-34.43,100.13-80.48,132.64-16.21,11.45-33.8,20.32-52.65,26.61-1.19,.4-2.7,1.39-3.71,.18-1.09-1.31,.6-2,1.35-2.69,29.47-26.97,47.52-60.96,60.35-98.16,5.36-15.55,9.24-31.48,12.14-47.66,.59-3.34,.45-4.72-3.71-4.05-20.32,3.25-40.69,6.19-61.04,9.21-1.56,.23-3.43,1.14-4.6-.59-1.09-1.63,.08-3.2,.83-4.64,25.62-48.78,54.07-95.66,91.62-136.44,2.36-2.56,4.78-4.58,7.6-4.59,3.84-.09,6.17,1.54,8.48,3.16,18.98,13.33,34.38,30.24,48.4,48.49,14.38,18.73,27.01,38.6,38.15,59.42,3.13,5.87,2.87,6.27-3.94,7.27h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M228.77,315.76c-1.17,3.19-1.25,6.08,.57,9.01,5.36,8.65,13.21,13.22,22.94,14.47,5.71-.84,11.15-1.52,16.54-2.48,2.55-.45,3.44-.39,3.13,2.8-5.32,53.55-31.67,92.3-80.65,115.25-9.62,4.51-19.55,8.27-29.64,11.58-1.2,.39-2.63,1.4-3.47-.24-.67-1.28,.73-2.03,1.54-2.8,28.8-27.18,41.9-61.9,48.01-99.96,1.73-10.82,2.71-21.73,3.06-32.7,.1-3.11-.75-3.44-3.64-2.99-20.49,3.26-41,6.33-61.52,9.36-1.83,.28-4.17,1.35-5.53-.7-1.15-1.72,.16-3.52,.9-5.16,20.46-44.98,45.26-87.21,78.85-123.82,4.26-4.65,8.75-9.11,13.36-13.41,4.74-4.42,8.44-4.57,13.9-.99,10.92,7.17,20.07,16.31,28.98,25.76,2.47,2.61,.95,4.47-.24,6.6-10.82,19.43-21.76,38.79-32.46,58.29-5.66,10.33-10.56,21.04-14.63,32.13h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M536.8,277.25c-18.06,2.69-36.11,5.44-54.18,7.97-2.68,.38-3.59,1.16-3.73,3.92-.88,17.86-4.12,35.23-11.16,51.78-12.6,29.61-33.35,52.45-58.86,71.43-20.64,15.35-43.3,27.11-66.58,37.8-1.01,.46-2.3,1.53-3.16,.39-1.16-1.57,.7-2.3,1.57-3.07,37.84-33.59,59.15-76.53,70.58-124.99,1.26-5.32,3.65-7.98,9.28-8.41,6.43-.5,12.81-1.76,19.2-2.83,9.3-1.55,20.51-15.59,20.57-25.64,.18-3.48-1.41-6.45-2.79-9.45-10.54-22.85-24.26-43.84-38.07-64.77-1.74-2.64-3.44-5.31-5.35-7.81-3.14-4.09-2.65-7.77,.42-11.73,7.74-9.99,15.83-19.67,24.34-29.01,4.71-5.17,8.61-5.7,14.45-1.72,21.14,14.42,37.96,33.19,53.2,53.47,12.99,17.28,24.69,35.42,34.52,54.71,3.26,6.39,2.96,6.89-4.25,7.96h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M528.88,300.42c-1.91,15.17-4.56,30.23-9.4,44.74-33.31,99.94-101.52,161.4-204.28,184.3-16.39,3.65-33.18,5-46.47,4.58-42.36,.21-79.33-7.98-114.56-24.13-.9-.42-1.83-.79-2.72-1.22-1.09-.53-2.19-1.2-1.91-2.59,.39-1.96,2.04-1.35,3.24-1.19,8.56,1.12,17.09,2.53,25.66,3.47,65.65,7.16,129.33,.71,189.37-28.71,48.89-23.94,87.6-59.63,118.05-104.49,15.72-23.16,28.61-47.8,37.98-74.22,.22-.63,.32-1.3,.58-1.9,.7-1.58,2.12-2.35,3.64-1.98,1.89,.45,.96,2.23,.82,3.34h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M249.76,147.93c.03,6.68-.63,13.26-2.93,19.6-3.03,8.35-6.69,10.35-15.22,8.31-13.49-3.21-22.48-15.09-21.86-28.88,.61-13.56,10.98-24.75,24.61-26.57,6.37-.85,9.57,.92,12.05,7.02,2.67,6.57,3.43,13.49,3.35,20.52h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M355.43,131.35c.05,8.13-.71,15.22-3.5,21.92-2.87,6.91-5.86,8.48-13.17,7.37-13.91-2.12-23.83-14.77-23.26-29.69,.5-13.19,11.79-25,25.02-26.18,6.31-.56,9.23,1.04,11.6,6.99,2.62,6.56,3.5,13.47,3.31,19.59h0Z"
                        fill="#fff"
                    />
                    <path
                        d="M454.14,120c-.42,7.5-.9,14.96-4.06,21.91-2.75,6.04-5.73,7.59-12.25,6.69-14.42-2.01-24.33-14.65-23.68-30.24,.57-13.66,12.27-25.01,26.28-25.82,4.69-.28,7.58,1.71,9.51,5.65,3.39,6.89,3.73,14.36,4.2,21.81h0Z"
                        fill="#fff"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'interactiontxt_logo'">
            <svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1243.96 319.99">
                <g id="Calque_2-2">
                    <g>
                        <g>
                            <path
                                d="M1.61,180.31V16.79c0-6.92,.55-7.48,7.26-7.49,9.82-.01,19.64,.1,29.45-.05,4.25-.06,5.87,1.54,5.84,5.89-.13,27.75-.06,55.51-.06,83.26s0,55.17-.01,82.76c0,6.33-.21,6.56-6.36,6.57-9.65,.01-19.3,0-28.95,0-6.82,0-7.17-.34-7.17-7.42h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M187.15,182.87c.01,3.27-1.14,4.92-4.66,4.89-10.99-.09-21.98-.15-32.97,.03-4.39,.06-4.72-2.39-4.71-5.76,.06-22.45,.04-44.9,.01-67.35-.01-2.65-.15-5.32-.5-7.95-1.4-10.47-8.34-16.7-17.94-16.24-9.56,.45-16.23,7.82-16.31,18.48-.13,15.13-.04,30.26-.04,45.39,0,9.15-.11,18.3,.05,27.44,.08,4.11-1.14,6.1-5.68,6-10.49-.23-20.98-.2-31.47,0-4.14,.07-5.71-1.62-5.71-5.56,.03-40.24,.03-80.48,0-120.72,0-4,1.71-5.62,5.77-5.55,9.99,.17,19.98,.05,29.97,.06,6.69,0,7.05,.38,7.07,7.07v6.33c14.1-15.35,30.39-19.36,48.9-12.65,16.8,6.09,27.61,20.68,27.94,39.8,.51,28.76,.19,57.53,.28,86.29h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M289.07,84.93c.08,3.97-1.72,5.3-5.44,5.22-5.82-.13-11.65,.07-17.47-.08-3.03-.08-4.54,.6-4.5,4.1,.16,15.12-.06,30.24,.12,45.36,.1,8.47,4.21,12.4,12.76,12.41,12.44,0,11.32-.74,11.33,11.82,0,6.48-.06,12.96,.02,19.44,.03,2.68-.64,4.63-3.7,4.81-14.12,.82-28.28,1.7-42.05-2.57-12.76-3.95-18.97-12.99-19.18-27.58-.15-10.3-.03-20.61-.03-30.91s-.27-20.61,.12-30.9c.19-5.03-1.65-6.48-6.3-5.99-2.79,.29-5.65,.06-8.48,.04-2.83-.03-4.31-1.47-4.31-4.31-.01-8.48-.01-16.95,0-25.43,0-3.16,1.71-4.42,4.75-4.35,3.33,.08,6.67-.14,9.98,.06,3.32,.21,4.35-1.15,4.29-4.36-.16-8.47,.07-16.95-.1-25.42-.08-3.8,1.23-5.45,5.17-5.39,10.15,.14,20.3,.15,30.45,0,4.03-.06,5.26,1.88,5.24,5.47-.05,8.48,.09,16.95-.07,25.42-.06,3.27,1.1,4.41,4.35,4.3,5.99-.19,11.98,.04,17.97-.09,3.59-.07,5.13,1.37,5.07,5.02-.12,7.97-.15,15.95,.01,23.92h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M425.3,100.24c-8.29-28.93-31.84-47.58-62.28-46.43-25.63,.97-44.07,12.6-54.24,36.12-8.1,18.73-7.9,38.2-1.97,57.48,6.29,20.47,20.31,33.49,40.79,39.35,15.7,4.49,31.56,4.31,47.23-.27,9.69-2.83,18.35-7.64,25.55-14.9,2.36-2.38,3.06-4.35,.48-7.16-5.84-6.36-11.51-12.89-17.11-19.47-2.59-3.04-4.78-2.82-7.43-.11-8.47,8.63-19.13,10.34-30.41,8.54-9.05-1.44-15.96-6.21-19.11-15.44-1.08-3.18-.72-4.38,3.02-4.33,12.31,.18,24.62,.07,36.93,.07s23.64-.21,35.44,.1c4.65,.12,6.16-1.57,6.28-5.97,.24-9.36-.59-18.57-3.17-27.58h0Zm-45.23,8.89c-4.97-.23-9.97-.06-14.95-.06-5.32,0-10.64-.08-15.95,.04-2.39,.06-3.1-.48-2.63-3.08,1.69-9.35,8.06-15.22,17.3-15.55,10.63-.37,17.51,4.67,19.82,14.31,.79,3.3-.11,4.5-3.59,4.34h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M500.02,100.08c-8.17,3.48-12.24,9.74-12.21,18.73,.08,20.77,.04,41.55,.02,62.32,0,6.29-.3,6.59-6.38,6.6-10.15,.01-20.3-.16-30.45,.07-4.47,.11-5.85-1.82-5.84-5.92,.05-40.05,.05-80.1,0-120.15-.01-4.24,1.72-5.87,6.03-5.77,9.81,.22,19.63,.06,29.45,.07,7.14,0,7.15,.02,7.2,7.31v3.83c8.31-8.85,17.75-13.53,29.59-12.97,1,.05,2,.1,2.98,.24,10.56,1.54,11.71,3.01,10.06,13.31-1.44,9-3.3,17.96-4.46,27-.55,4.32-2.28,4.54-5.92,3.76-6.77-1.47-13.62-1.18-20.07,1.57h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M659.07,100.35c.05-12.58-4.57-22.93-14.02-31.17-23.12-20.15-68.55-20.44-91.96-.6-6.68,5.65-11.21,12.61-13.21,21.17-.89,3.78-.52,6.26,4.33,6.78,11.07,1.19,22.1,2.77,33.12,4.36,3.2,.46,4.75-.86,6.28-3.48,3.56-6.13,13.74-8.77,22.5-6.18,6.9,2.04,10.49,7.73,10.35,15.73-.06,3.05-1.11,4.06-4.12,4-7.65-.16-15.32-.17-22.97-.03-12.59,.23-24.92,1.75-35.83,8.76-22.56,14.49-22.29,51.1,.44,63.85,19.68,11.04,45.64,7.79,62.41-8.58v5.87c.03,6.76,.16,6.9,7.09,6.9,9.82,0,19.65-.19,29.47,.08,4.67,.13,6.15-1.78,6.13-6.16-.08-27.1-.12-54.2-.01-81.3h0Zm-42.77,43.09c-1.88,13.06-21.44,21-32.02,13-7.19-5.44-5.48-16.66,3.2-20.23,5.65-2.32,11.68-2.33,16.81-2.19h3.86c8.68,0,9.38,.81,8.15,9.42Z"
                                fill="#fff"
                            />
                            <path
                                d="M800.59,146.47c-2.24,12.14-8.41,21.87-17.91,29.57-28.4,23.05-75.39,16.94-94.86-12.42-8.56-12.9-11.5-27.4-11.38-42.67,.24-17.89,3.71-34.83,16.59-48.22,15.66-16.3,35.52-20.78,57.2-18.04,20.66,2.6,37.02,12.31,46.98,31.21,2.17,4.11,3.49,8.57,4.2,13.21,.5,3.28-.61,5.05-3.96,5.54-11.02,1.61-22.04,3.25-33.05,4.96-3.53,.55-4.6-1.34-5.27-4.36-1.77-7.91-6.76-12.87-14.73-14.36-12.13-2.25-20.02,2.86-23.06,14.82-2.76,10.84-2.51,21.75,.15,32.56,2.38,9.69,9.15,15.2,18.35,15.35,9.15,.16,15.91-5.16,18.61-14.83,.73-2.61,1.88-4.11,4.88-3.62,10.99,1.82,21.96,3.69,32.99,5.25,3.99,.56,4.96,2.36,4.27,6.05h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M812.48,61.72c-.16-4.37,1.69-6.05,5.96-5.73,2.98,.22,6-.12,8.98,.08,3.12,.22,4.04-1.06,3.98-4.05-.15-8.48,.05-16.96-.09-25.44-.07-3.96,1.32-5.76,5.51-5.69,9.99,.17,19.98,.18,29.96,0,4.26-.08,5.49,1.79,5.42,5.72-.17,8.31,.08,16.63-.12,24.93-.08,3.51,1.12,4.7,4.62,4.56,5.98-.23,11.98,.06,17.97-.1,3.69-.1,5.14,1.63,5.14,5.07-.01,7.98-.03,15.96,.01,23.94,.02,3.84-1.86,5.26-5.6,5.16-5.99-.17-11.99,.05-17.98-.09-2.98-.06-4.16,1-4.14,4.06,.15,15.12,0,30.25,.27,45.37,.15,8.67,4.11,12.43,12.73,12.43,12.77,0,11.1-.52,11.18,11.36,.04,6.81-.07,13.63,.05,20.44,.04,2.64-.83,4.15-3.56,4.31-13.96,.78-27.96,1.61-41.6-2.42-12.93-3.83-18.95-12.05-19.58-27.3-.45-10.79-.09-21.61-.09-32.41h-.15c0-10.31-.14-20.62,.07-30.92,.08-3.6-.83-5.43-4.69-4.89-.82,.11-1.66,0-2.5,0-12.66,0-11.72,1.16-11.7-11.93,.01-5.49,.16-10.98-.05-16.46h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M953.22,187.83c-10.14-.32-20.3-.26-30.44-.02-4.46,.1-5.74-1.67-5.73-5.89,.1-40.05,.1-80.1-.01-120.14-.01-4.32,1.51-5.91,5.84-5.82,10.31,.21,20.64,.23,30.95,0,4.5-.1,5.66,1.73,5.63,5.92-.15,20.11-.07,40.21-.07,60.32s-.12,39.55,.09,59.32c.05,4.75-1.38,6.47-6.26,6.32Z"
                                fill="#fff"
                            />
                            <path
                                d="M916.27,22.2C916.27,9.03,925.25,.07,938.47,0c13.12-.06,22.34,8.92,22.56,21.97,.21,12.58-9.43,22.43-22.12,22.61-13.23,.18-22.65-9.13-22.64-22.38Z"
                                fill="#fff"
                            />
                            <path
                                d="M1088.77,73.11c-14.2-15.73-32.62-20.18-52.96-18.98-26.45,1.55-46.99,17.64-54.33,42.55-3.04,10.31-3.81,20.89-3.09,31.57,2.51,37.21,25.98,60.62,62.04,61.54,21.84,.55,40.13-7.02,52.9-25.37,8.94-12.85,11.81-27.58,12.01-43.73-.11-17.22-4.21-33.88-16.57-47.58h0Zm-31.45,71.34c-7.61,12.11-24.29,12.53-31.03-.01-7.74-14.4-7.42-29.69-.84-44.51,3.02-6.8,9.22-9.6,16.72-9.48,7.36,.13,12.61,3.48,16.04,9.86,3.56,6.64,4.01,13.92,4.39,20.97-.34,8.21-.83,16.09-5.28,23.17Z"
                                fill="#fff"
                            />
                            <path
                                d="M1242.98,185.35c.35,.05,.67,.18,.98,.39l-.49-.03-.49,.04c-1.22,2.07-3.22,2-5.26,1.99-10.49-.03-20.98-.15-31.46,.06-4.19,.08-5.51-1.51-5.48-5.57,.12-22.94,.07-45.89,.04-68.83-.01-2.32-.08-4.67-.44-6.95-1.63-10.51-8.54-16.51-18.21-15.96-9.31,.53-15.95,7.81-16.09,18.24-.19,14.13-.05,28.26-.05,42.4,0,10.14-.18,20.29,.08,30.42,.13,4.86-1.69,6.4-6.45,6.27-9.98-.29-19.98-.34-29.96,.01-5.06,.18-6.24-1.88-6.22-6.45,.13-26.93,.06-53.87,.06-80.8v-35.92c0-5.75,2.8-8.63,8.39-8.63h26.97c6.83,0,7.11,.28,7.13,6.96,.01,1.63,0,3.27,0,5.74-1.53-.79-1.28-2.89-1.46-4.5-.68-6.09-1.17-6.62-7.4-6.68-8.32-.07-16.65-.06-24.97,0-6.53,.04-7.56,.99-7.59,7.57-.09,20.94-.03,41.89-.03,62.84,0,16.79-.05,33.58,.02,50.37,.03,6.93,.97,7.83,7.79,7.88,8.33,.06,16.65,.08,24.97,0,6.29-.06,7.14-.93,7.15-7.33,.04-22.11,.02-44.22,.01-66.34,0-4.01,.21-7.97,1.72-11.76,3.29-8.23,9.4-11.85,19.02-11.26,7.52,.46,14.05,6,15.9,13.63,1.02,4.21,1.37,8.51,1.36,12.86-.04,20.95-.04,41.89,0,62.84,0,6.94,.44,7.5,7.34,7.33,10.79-.26,21.63,1.01,32.38-.83,.13-.02,.24-.03,.36-.03,.13,0,.26,.01,.38,.03h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1243.1,95.89v.17s-.09-.02-.13-.05c-.21-.07-.39-.23-.56-.47-1.3-2.4-1.42-5.11-2.03-7.68-6.35-26.73-33.16-37.28-56.25-30.33-5.19,1.57-9.56,4.62-13.18,8.69-1.2,1.35-2.48,3.25-4.4,2.72,12.94-16.5,29.74-17.9,47.28-12.4,18.67,5.85,27.63,20.21,29.27,39.35h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M659.07,100.35c.05-12.58-4.57-22.93-14.02-31.17-23.12-20.15-68.55-20.44-91.96-.6-6.68,5.65-11.21,12.61-13.21,21.17-.89,3.78-.52,6.26,4.33,6.78,11.07,1.19,22.1,2.77,33.12,4.36,3.2,.46,4.75-.86,6.28-3.48,3.56-6.13,13.74-8.77,22.5-6.18,6.9,2.04,10.49,7.73,10.35,15.73-.06,3.05-1.11,4.06-4.12,4-7.65-.16-15.32-.17-22.97-.03-12.59,.23-24.92,1.75-35.83,8.76-22.56,14.49-22.29,51.1,.44,63.85,19.68,11.04,45.64,7.79,62.41-8.58v5.87c.03,6.76,.16,6.9,7.09,6.9,9.82,0,19.65-.19,29.47,.08,4.67,.13,6.15-1.78,6.13-6.16-.08-27.1-.12-54.2-.01-81.3h0Zm-42.77,43.09c-1.88,13.06-21.44,21-32.02,13-7.19-5.44-5.48-16.66,3.2-20.23,5.65-2.32,11.68-2.33,16.81-2.19h3.86c8.68,0,9.38,.81,8.15,9.42Z"
                                fill="#fff"
                            />
                            <path
                                d="M187.15,182.87c.01,3.27-1.14,4.92-4.66,4.89-10.99-.09-21.98-.15-32.97,.03-4.39,.06-4.72-2.39-4.71-5.76,.06-22.45,.04-44.9,.01-67.35-.01-2.65-.15-5.32-.5-7.95-1.4-10.47-8.34-16.7-17.94-16.24-9.56,.45-16.23,7.82-16.31,18.48-.13,15.13-.04,30.26-.04,45.39,0,9.15-.11,18.3,.05,27.44,.08,4.11-1.14,6.1-5.68,6-10.49-.23-20.98-.2-31.47,0-4.14,.07-5.71-1.62-5.71-5.56,.03-40.24,.03-80.48,0-120.72,0-4,1.71-5.62,5.77-5.55,9.99,.17,19.98,.05,29.97,.06,6.69,0,7.05,.38,7.07,7.07v6.33c14.1-15.35,30.39-19.36,48.9-12.65,16.8,6.09,27.61,20.68,27.94,39.8,.51,28.76,.19,57.53,.28,86.29h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1243.96,185.74l-.49-.03-.49,.04c-1.22,2.07-3.22,2-5.26,1.99-10.49-.03-20.98-.15-31.46,.06-4.19,.08-5.51-1.51-5.48-5.57,.12-22.94,.07-45.89,.04-68.83-.01-2.32-.08-4.67-.44-6.95-1.63-10.51-8.54-16.51-18.21-15.96-9.31,.53-15.95,7.81-16.09,18.24-.19,14.13-.05,28.26-.05,42.4,0,10.14-.18,20.29,.08,30.42,.13,4.86-1.69,6.4-6.45,6.27-9.98-.29-19.98-.34-29.96,.01-5.06,.18-6.24-1.88-6.22-6.45,.13-26.93,.06-53.87,.06-80.8v-35.92c0-5.75,2.8-8.63,8.39-8.63h26.97c6.83,0,7.11,.28,7.13,6.96,.01,1.63,0,3.27,0,5.74v.88c.17-.23,.35-.45,.52-.67,12.94-16.5,29.74-17.9,47.28-12.4,18.67,5.85,27.63,20.21,29.27,39.35v.17l.86,89.68h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M425.3,100.24c-8.29-28.93-31.84-47.58-62.28-46.43-25.63,.97-44.07,12.6-54.24,36.12-8.1,18.73-7.9,38.2-1.97,57.48,6.29,20.47,20.31,33.49,40.79,39.35,15.7,4.49,31.56,4.31,47.23-.27,9.69-2.83,18.35-7.64,25.55-14.9,2.36-2.38,3.06-4.35,.48-7.16-5.84-6.36-11.51-12.89-17.11-19.47-2.59-3.04-4.78-2.82-7.43-.11-8.47,8.63-19.13,10.34-30.41,8.54-9.05-1.44-15.96-6.21-19.11-15.44-1.08-3.18-.72-4.38,3.02-4.33,12.31,.18,24.62,.07,36.93,.07s23.64-.21,35.44,.1c4.65,.12,6.16-1.57,6.28-5.97,.24-9.36-.59-18.57-3.17-27.58h0Zm-45.23,8.89c-4.97-.23-9.97-.06-14.95-.06-5.32,0-10.64-.08-15.95,.04-2.39,.06-3.1-.48-2.63-3.08,1.69-9.35,8.06-15.22,17.3-15.55,10.63-.37,17.51,4.67,19.82,14.31,.79,3.3-.11,4.5-3.59,4.34h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1088.77,73.11c-14.2-15.73-32.62-20.18-52.96-18.98-26.45,1.55-46.99,17.64-54.33,42.55-3.04,10.31-3.81,20.89-3.09,31.57,2.51,37.21,25.98,60.62,62.04,61.54,21.84,.55,40.13-7.02,52.9-25.37,8.94-12.85,11.81-27.58,12.01-43.73-.11-17.22-4.21-33.88-16.57-47.58h0Zm-31.45,71.34c-7.61,12.11-24.29,12.53-31.03-.01-7.74-14.4-7.42-29.69-.84-44.51,3.02-6.8,9.22-9.6,16.72-9.48,7.36,.13,12.61,3.48,16.04,9.86,3.56,6.64,4.01,13.92,4.39,20.97-.34,8.21-.83,16.09-5.28,23.17Z"
                                fill="#fff"
                            />
                            <path
                                d="M800.59,146.47c-2.24,12.14-8.41,21.87-17.91,29.57-28.4,23.05-75.39,16.94-94.86-12.42-8.56-12.9-11.5-27.4-11.38-42.67,.24-17.89,3.71-34.83,16.59-48.22,15.66-16.3,35.52-20.78,57.2-18.04,20.66,2.6,37.02,12.31,46.98,31.21,2.17,4.11,3.49,8.57,4.2,13.21,.5,3.28-.61,5.05-3.96,5.54-11.02,1.61-22.04,3.25-33.05,4.96-3.53,.55-4.6-1.34-5.27-4.36-1.77-7.91-6.76-12.87-14.73-14.36-12.13-2.25-20.02,2.86-23.06,14.82-2.76,10.84-2.51,21.75,.15,32.56,2.38,9.69,9.15,15.2,18.35,15.35,9.15,.16,15.91-5.16,18.61-14.83,.73-2.61,1.88-4.11,4.88-3.62,10.99,1.82,21.96,3.69,32.99,5.25,3.99,.56,4.96,2.36,4.27,6.05h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M872.1,94.13c.15,15.12,0,30.25,.27,45.37,.15,8.67,4.11,12.43,12.73,12.43,12.77,0,11.1-.52,11.18,11.36,.04,6.81-.07,13.63,.05,20.44,.04,2.64-.83,4.15-3.56,4.31-13.96,.78-27.96,1.61-41.6-2.42-12.93-3.83-18.95-12.05-19.58-27.3-.45-10.79-.09-21.61-.09-32.41h-.15c0-10.31-.14-20.62,.07-30.92,.08-3.6-.83-5.43-4.69-4.89-.82,.11-1.66,0-2.5,0-12.66,0-11.72,1.16-11.7-11.93,.01-5.49,.16-10.98-.05-16.46-.16-4.37,1.69-6.05,5.96-5.73,2.98,.22,6-.12,8.98,.08,3.12,.22,4.04-1.06,3.98-4.05-.15-8.48,.05-16.96-.09-25.44-.07-3.96,1.32-5.76,5.51-5.69,9.99,.17,19.98,.18,29.96,0,4.26-.08,5.49,1.79,5.42,5.72-.17,8.31,.08,16.63-.12,24.93-.08,3.51,1.12,4.7,4.62,4.56,5.98-.23,11.98,.06,17.97-.1,3.69-.1,5.14,1.63,5.14,5.07-.01,7.98-.03,15.96,.01,23.94,.02,3.84-1.86,5.26-5.6,5.16-5.99-.17-11.99,.05-17.98-.09-2.98-.06-4.16,1-4.14,4.06h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M261.66,94.17c.16,15.12-.06,30.24,.12,45.36,.1,8.47,4.21,12.4,12.76,12.41,12.44,0,11.32-.74,11.33,11.82,0,6.48-.06,12.96,.02,19.44,.03,2.68-.64,4.63-3.7,4.81-14.12,.82-28.28,1.7-42.05-2.57-12.76-3.95-18.97-12.99-19.18-27.58-.15-10.3-.03-20.61-.03-30.91s-.27-20.61,.12-30.9c.19-5.03-1.65-6.48-6.3-5.99-2.79,.29-5.65,.06-8.48,.04-2.83-.03-4.31-1.47-4.31-4.31-.01-8.48-.01-16.95,0-25.43,0-3.16,1.71-4.42,4.75-4.35,3.33,.08,6.67-.14,9.98,.06,3.32,.21,4.35-1.15,4.29-4.36-.16-8.47,.07-16.95-.1-25.42-.08-3.8,1.23-5.45,5.17-5.39,10.15,.14,20.3,.15,30.45,0,4.03-.06,5.26,1.88,5.24,5.47-.05,8.48,.09,16.95-.07,25.42-.06,3.27,1.1,4.41,4.35,4.3,5.99-.19,11.98,.04,17.97-.09,3.59-.07,5.13,1.37,5.07,5.02-.12,7.97-.15,15.95,.01,23.92,.08,3.97-1.72,5.3-5.44,5.22-5.82-.13-11.65,.07-17.47-.08-3.03-.08-4.54,.6-4.5,4.1h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M44.1,98.4c0,27.59,0,55.17-.01,82.76,0,6.33-.21,6.56-6.36,6.57-9.65,.01-19.3,0-28.95,0-6.82,0-7.17-.34-7.17-7.42V16.79c0-6.92,.55-7.48,7.26-7.49,9.82-.01,19.64,.1,29.45-.05,4.25-.06,5.87,1.54,5.84,5.89-.13,27.75-.06,55.51-.06,83.26h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M530.47,67.75c-1.44,9-3.3,17.96-4.46,27-.55,4.32-2.28,4.54-5.92,3.76-6.77-1.47-13.62-1.18-20.07,1.57-8.17,3.48-12.24,9.74-12.21,18.73,.08,20.77,.04,41.55,.02,62.32,0,6.29-.3,6.59-6.38,6.6-10.15,.01-20.3-.16-30.45,.07-4.47,.11-5.85-1.82-5.84-5.92,.05-40.05,.05-80.1,0-120.15-.01-4.24,1.72-5.87,6.03-5.77,9.81,.22,19.63,.06,29.45,.07,7.14,0,7.15,.02,7.2,7.31v3.83c8.31-8.85,17.75-13.53,29.59-12.97,1,.05,2,.1,2.98,.24,10.56,1.54,11.71,3.01,10.06,13.31h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M959.48,181.51c.05,4.75-1.38,6.47-6.26,6.32-10.14-.32-20.3-.26-30.44-.02-4.46,.1-5.74-1.67-5.73-5.89,.1-40.05,.1-80.1-.01-120.14-.01-4.32,1.51-5.91,5.84-5.82,10.31,.21,20.64,.23,30.95,0,4.5-.1,5.66,1.73,5.63,5.92-.15,20.11-.07,40.21-.07,60.32s-.12,39.55,.09,59.32Z"
                                fill="#fff"
                            />
                            <path
                                d="M961.03,21.97c.21,12.58-9.43,22.43-22.12,22.61-13.23,.18-22.65-9.13-22.64-22.38C916.27,9.03,925.25,.07,938.47,0c13.12-.06,22.34,8.92,22.56,21.97Z"
                                fill="#fff"
                            />
                        </g>
                        <g>
                            <path
                                d="M36.56,316.15c-.06,3.16-1.87,3.33-4.26,3.32-9.48-.05-18.97-.1-28.44,.03-2.76,.03-3.88-.83-3.86-3.66C.07,299.84,.07,283.84,0,267.84c-.02-2.81,1.07-3.68,3.84-3.72,3.03-.04,4.09,.95,4.02,3.99-.18,6.93-.06,13.85-.06,20.78,0,6.27,.2,12.55-.08,18.8-.16,3.75,.73,5.29,4.88,5.05,6.47-.38,12.97-.05,19.46-.13,2.57-.03,4.57,.06,4.5,3.53h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M50.49,269.09c-1.21,3.04-2.64,6-3.7,9.08-.77,2.25-2.07,3.23-4.35,2.87-2.74,.29-3.14-.91-2.36-3.21,1.21-3.56,2.31-7.16,3.31-10.78,.5-1.8,1.31-2.71,3.34-2.88,4.98-.42,5.61,.28,3.76,4.92h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M69.83,268.29c-.1,15.7-.1,31.4,0,47.09,.01,2.85-.64,4.17-3.86,4.17s-4.3-1.27-4.24-4.42c.16-7.93,.05-15.86,.05-23.79s.11-15.2-.05-22.81c-.07-3.15,.88-4.41,4.24-4.41s3.87,1.31,3.86,4.16h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M126.5,267.56c-.05,16.18-.02,32.37-.03,48.55,0,1.52,.03,3.17-2.09,3.25-2.43,.1-5.04,.73-6.68-2.03-2.02-3.42-4.15-6.77-6.25-10.14-5.53-8.94-11.08-17.88-16.61-26.81-.36,.16-.71,.31-1.07,.47,0,11.38-.06,22.76,.05,34.14,.02,2.89-.32,4.61-3.97,4.55-3.47-.05-4.13-1.51-4.11-4.53,.1-15.35,.02-30.72,.07-46.08,.01-1.82-.8-4.38,2.25-4.62,2.53-.19,5.13-.77,6.96,2.31,6.07,10.24,12.42,20.32,18.67,30.46,1.37,2.22,2.77,4.4,4.95,7.86,0-12.98,.16-24.57-.1-36.17-.08-3.85,1.19-4.93,4.85-4.62,2.41,.21,3.11,1.19,3.11,3.41h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M178.8,268.06c.13,2.53-1.12,3.07-3.33,2.98-2.99-.11-6.01,.17-9-.08-3.11-.26-3.95,.86-3.91,3.9,.15,13.23,.04,26.44,.08,39.66,.01,2.75,.39,5.12-3.88,5.07-4.11-.05-4.05-2.21-4.01-5.07,.09-6.45,.03-12.89,.02-19.34,0-6.94-.09-13.88,.05-20.82,.05-2.59-.86-3.54-3.47-3.38-2.98,.17-5.99-.1-8.99,.07-2.8,.16-3.37-1.3-3.36-3.64,.01-2.29,.96-3.23,3.31-3.22,11.17,.07,22.33,.09,33.5,0,3.06-.03,2.9,1.78,3,3.88h-.01Z"
                                fill="#fff"
                            />
                            <path
                                d="M199.4,274.59c-.42,13.89-.5,13.78,13.89,14,2.25,.04,6.11-2.19,6.48,2.81,.17,2.4-.5,3.7-3.27,3.59-4.32-.15-8.67,.11-12.99-.08-2.92-.14-4.03,.64-4.11,3.8-.34,13.95-.45,13.95,13.75,13.95,4.16,0,8.34,.09,12.5-.03,2.57-.07,3,1.25,3.01,3.39,0,2.19-.6,3.45-3.06,3.44-10.34-.04-20.67-.08-30.99,.03-3.05,.03-3-1.76-2.99-3.88,.04-7.93,.02-15.86,.02-23.79s.12-15.53-.06-23.29c-.08-3.08,.6-4.45,4.07-4.37,9.66,.2,19.33,.11,28.99,.04,2.52,0,4.03,.44,4.06,3.5,.04,3.19-1.65,3.38-4.09,3.35-7.17-.08-14.33,.09-21.49-.08-2.83-.07-3.63,.83-3.71,3.63h-.01Z"
                                fill="#fff"
                            />
                            <path
                                d="M278.99,314.52c-2.61-5.69-5.33-11.35-8.18-16.94-1.04-2.04-.88-2.87,1.37-4.03,6.91-3.58,9.7-10.07,7.97-17.4-1.7-7.25-7.15-11.65-15.15-11.88-6.15-.18-12.33,.14-18.47-.11-3.45-.14-4.19,1.21-4.12,4.32,.18,7.76,.06,15.52,.06,23.27s.07,15.52-.04,23.28c-.04,2.83,.2,4.62,3.92,4.53,3.43-.08,3.72-1.7,3.67-4.34-.1-5.45-.05-10.89-.01-16.34,.01-1.25-.33-2.65,1.2-3.47,3.6-1.91,10.85,.37,12.59,4.02,2.85,5.96,5.65,11.93,8.53,17.89,1.7,3.53,5.16,2.59,7.38,1.71,2.23-.9-.05-3.08-.71-4.51h-.01Zm-19.89-25.52c-6.08,.02-9.12-3.01-9.12-9.1s2.96-8.89,8.89-8.88c1.99,0,4.01-.13,5.98,.12,4.85,.62,7.88,4.34,7.75,9.3-.13,4.78-3.09,7.94-8.02,8.41-1.81,.17-3.65,.15-5.48,.16h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M302.26,268.83c-.08,7.75-.03,15.51-.03,23.26s-.04,15.17,.03,22.77c.02,2.73-.09,4.69-3.86,4.72-3.59,.02-4.01-1.52-3.99-4.47,.1-15.5,.09-31.01,0-46.52-.02-2.89,.3-4.56,3.96-4.5,3.71,.07,3.92,1.98,3.89,4.74h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M362.15,270.07c.12,14.88,.03,29.74,.1,44.62,.01,2.99-.18,4.96-4.2,4.9s-3.61-2.31-3.61-4.84c.03-11.65,0-23.3,0-34.95-.31-.12-.61-.23-.92-.34-2.99,4.44-5.97,8.9-8.99,13.34-2.95,4.33-5.64,4.32-8.65-.04-2.87-4.17-5.69-8.38-9.67-12.34v17.94c0,5.78-.13,11.57,.05,17.35,.09,3.2-1.39,3.81-4.24,3.84-2.96,.04-3.63-1.13-3.62-3.82,.1-15.53,.02-31.06,.09-46.6,.01-1.63-1.05-4.14,1.39-4.66,2.65-.58,5.64-1.02,7.62,2,3.71,5.67,7.54,11.29,11.33,16.92,.35,.51,.84,.92,1.57,1.71,4.12-6.09,8.32-11.84,11.99-17.89,2-3.31,4.79-3.38,7.73-2.86,3.51,.63,2.01,3.73,2.03,5.72h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M433.75,303.11c.78,8.61-4.12,14.94-12.95,16.4-1.96,.33-3.97,.37-5,.46-12.25,.05-19.83-4.95-20.99-13.2-.63-4.5,.57-5.63,5.05-5.2,1.91,.19,2.55,.92,2.62,2.75,.16,4.7,3.22,7.11,7.36,8.22,4.95,1.33,9.99,1.67,14.11-2.17,3.11-2.89,2.93-7.13-.15-10.11-2.2-2.12-5.02-3.21-7.76-4.4-4.11-1.78-8.36-3.28-12.34-5.32-6.01-3.07-8.73-8.2-7.98-14.12,.76-5.98,4.6-10.44,11.09-11.89,6.26-1.4,12.56-1.37,18.49,1.66,4.43,2.27,7.27,5.81,7.98,10.71,.26,1.8,1.68,4.67-1.97,4.94-2.46,.18-5.03,.95-5.87-3.22-1.55-7.8-13.93-11.19-19.82-5.77-3.77,3.47-2.77,9.24,2.42,11.81,5.64,2.79,11.63,4.9,17.31,7.62,4.51,2.16,7.9,5.42,8.39,10.83h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M485.39,282.07c-.65-11.24-7.48-17.81-18.84-18.29-11.39-.49-19.13,5.4-20.45,16.42-.95,7.84-1.01,15.84,.06,23.69,1.49,10.81,8.41,16.18,19.71,16.09,11.08-.09,17.92-5.83,19.29-16.64,.47-3.73,.07-7.57,.07-11.36h.19c0-3.3,.16-6.61-.03-9.9h0Zm-8,19.9c-.18,6.69-5.28,11.48-11.87,11.5-6.54,0-11.49-4.79-11.77-11.58-.14-3.29-.02-6.59-.02-9.89,.01-3.46-.17-6.94,.05-10.38,.44-7.02,5.04-11.1,12.09-10.99,6.9,.11,11.39,4.5,11.53,11.57,.13,6.59,.16,13.19-.01,19.77Z"
                                fill="#fff"
                            />
                            <path
                                d="M538.61,268.35c-.11,11.39,.07,22.78-.08,34.16-.15,10.84-8.05,17.65-19.89,17.45-11.6-.19-18.95-7.02-19.07-17.78-.06-5.45-.01-10.89-.01-16.34s-.05-10.56,.02-15.85c.04-2.73-1.21-6.02,3.99-5.9,5.26,.12,3.76,3.58,3.79,6.19,.11,10.08,.03,20.14,.06,30.21,.02,8.15,4.46,13.02,11.73,12.95,7.13-.07,11.47-4.75,11.53-12.68,.08-10.73,.1-21.46-.03-32.19-.04-3.06,.67-4.5,4.13-4.45,3.23,.05,3.84,1.41,3.81,4.22h.02Z"
                                fill="#fff"
                            />
                            <path
                                d="M590.86,314.46c-2.32-5.28-4.81-10.5-7.58-15.57-1.55-2.85-1.59-4.26,1.77-5.88,5.7-2.76,8.18-8.75,7.3-15.51-.82-6.25-5.01-10.89-11.11-12.58-4.43-1.23-8.94-.4-12.74-.7-3.82,0-7,.17-10.14-.05-3.05-.21-4.03,.88-4,3.92,.12,15.84,.09,31.68,.02,47.52-.01,2.53,.4,3.96,3.49,3.94,2.93-.03,4.23-.77,4.12-3.91-.2-5.44-.08-10.88-.04-16.33,.01-1.27-.38-2.72,.84-3.7,2.51-2.01,11.17,.06,12.58,3.02,2.91,6.11,5.82,12.21,8.62,18.36,1.63,3.61,5,2.99,7.29,2.18,3.11-1.1,.2-3.3-.42-4.71h0Zm-19.78-25.46c-6.1,.02-9.15-3-9.15-9.05s2.94-9.03,8.81-8.93c1.99,0,4-.13,5.96,.11,4.81,.57,7.98,4.39,7.85,9.22-.13,4.71-3.18,8-8,8.49-1.81,.19-3.64,.16-5.47,.17h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M642.89,306.59c-2.04,9.23-9.6,14.02-20.9,13.34-9.95-.61-16.54-6.75-17.28-16.44-.31-3.95-.05-7.92-.06-11.88,0-3.8-.23-7.6,.04-11.38,.71-9.93,7.59-16.01,18.32-16.49,10.7-.48,18.32,4.77,20.05,13.89,.34,1.8,1.44,4.22-1.91,4.4-2.36,.12-5.09,1.59-5.87-2.86-1.09-6.22-6.2-9.37-12.48-8.73-6.42,.66-10.13,4.65-10.22,11.22-.08,6.77-.08,13.53,0,20.3,.08,6.63,3.57,10.43,10.15,11.3,6.09,.79,11.46-2.44,12.52-8.66,.77-4.52,3.61-3.06,5.86-2.89,3.6,.27,2.21,2.94,1.78,4.88h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M665.48,274.76c.28,3.28,.26,6.61,.01,9.9-.24,3.18,1.18,3.97,4.07,3.88,4.15-.16,8.33,.03,12.48-.07,2.33-.05,3.71,.39,3.71,3.21,.01,2.69-1.04,3.4-3.54,3.32-4.49-.14-9,.06-13.48-.07-2.32-.06-3.48,.67-3.19,3.08,.04,.33-.01,.67,.01,.99,.29,4.4-1.86,10.04,.89,12.86,2.54,2.62,8.21,.65,12.49,.78,3.99,.13,7.99,.11,11.98,0,2.31-.06,3.72,.26,3.71,3.15-.01,2.77-.85,3.77-3.71,3.73-9.82-.14-19.65-.14-29.46,0-3.11,.05-4-1.17-3.95-4.1,.15-7.92,.05-15.85,.05-23.77s.14-15.19-.06-22.79c-.08-3.3,.73-4.76,4.4-4.68,9.65,.21,19.31,.15,28.96,.02,2.78-.04,3.78,.81,3.77,3.67,0,2.81-1.27,3.24-3.65,3.21-7.16-.1-14.31,.09-21.47-.09-2.93-.08-4.29,.58-4.02,3.8v-.03Z"
                                fill="#fff"
                            />
                            <path
                                d="M765.67,280.23c-.07-8.38-4.29-13.54-12.64-15.31-7.07-1.5-14.26-.3-21.39-.74-3.41-.21-4.22,1.28-4.15,4.38,.18,7.59,.06,15.17,.06,22.77v23.75c0,.17,.02,.33,0,.5-.3,2.65,.64,3.96,3.57,3.91,6.15-.13,12.33,.22,18.46-.11,10.35-.56,16.06-6.74,16.09-16.87,.02-7.42,.06-14.85-.01-22.27h.01Zm-7.72,8.61c-.23,4.76,.1,9.55-.18,14.31-.36,6.08-3.84,9.25-9.88,9.5-8.23,.33-12.35-3.55-12.35-11.65v-9.38c0-5.76,.11-11.53-.05-17.28-.07-2.57,.77-3.36,3.39-3.39,14.68-.18,19.94-.63,19.07,17.89h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M785.15,268.18c-1.52,3.27-2.94,6.6-4.09,10.01-1.07,3.2-3.53,3.46-5.93,2.7-2.82-.9-.56-3.03-.28-4.44,.58-2.87,1.85-5.6,2.48-8.48,.64-2.98,2.16-4.29,5.13-3.71,3.66-.49,4.06,.98,2.69,3.92h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M831.16,314.88c-4.93-15.54-10.15-30.99-15.05-46.55-1.03-3.29-2.56-4.8-6-4.02-3.51-.73-5.41,.55-6.53,4.12-4.8,15.41-9.93,30.73-14.76,46.13-.44,1.4-3.02,4,.57,4.67,2.45,.46,6.42,1.65,6.91-2.48,.87-7.19,5.28-8.03,11.15-7.24,1.3,.18,2.66,.14,3.98,0,6.09-.58,11.34-.49,12.34,7.68,.48,3.95,4.77,2.43,7.13,2,3.09-.58,.68-3.02,.27-4.31h0Zm-15.5-11.49c-3.99-.12-8,0-11.99-.05-1.51-.02-3.17,.11-2.37-2.39,2.8-8.75,5.51-17.54,8.57-27.32,3,9.44,5.61,17.78,8.32,26.08,.8,2.46,.47,3.77-2.52,3.68h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M879.49,268.31c-3.51,10.81-6.96,21.64-10.43,32.47-1.51,4.71-3.12,9.38-4.46,14.14-.85,3.02-2.08,4.7-5.75,4.67-3.51-.03-4.48-1.74-5.33-4.51-4.73-15.26-9.63-30.48-14.32-45.75-.47-1.53-2.92-4.06,.26-4.85,2.7-.67,6.2-1.58,7.49,3.14,2.96,10.8,6.39,21.47,9.63,32.2,.74,2.45,1.52,4.89,2.68,8.6,4.31-14.25,8.35-27.28,12.13-40.38,.84-2.92,2.2-3.87,5.22-3.91,3.59-.05,3.8,1.4,2.89,4.18h-.01Z"
                                fill="#fff"
                            />
                            <path
                                d="M899.59,274.63c-.37,13.62-.45,13.47,13.22,13.75,2.48,.05,7.05-2.53,7.25,2.98,.22,6-4.66,3.42-7.29,3.48-13.23,.26-13.09,.12-13.2,13.19-.03,3.65,.85,4.9,4.68,4.72,6.98-.32,13.98,0,20.98-.14,2.57-.05,3.53,.75,3.49,3.37-.04,2.46-.7,3.55-3.4,3.52-9.99-.11-19.98-.11-29.97,0-2.87,.03-3.75-1.16-3.72-3.86,.11-7.93,.04-15.86,.04-23.78s.15-15.19-.07-22.79c-.1-3.57,.88-5.02,4.73-4.92,9.49,.24,18.99,.14,28.47,.04,2.61-.03,3.92,.49,3.95,3.5,.03,3.14-1.51,3.41-4,3.37-7.16-.1-14.32,.08-21.48-.09-2.87-.07-3.6,.9-3.68,3.67h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M982.84,314.81c-.01,1.61,.97,4.09-1.69,4.46-2.47,.35-5.17,.97-7.01-2.11-5.14-8.67-10.53-17.19-15.83-25.76-2.31-3.72-4.66-7.4-7.8-12.39,0,13-.16,24.45,.08,35.89,.09,3.94-1.48,4.85-4.99,4.58-2.38-.18-3.12-1.16-3.11-3.41,.05-16.18,.03-32.35,.02-48.52,0-1.57,.07-3.08,2.12-3.26,2.85-.25,5.41-.35,7.26,2.78,5.79,9.83,11.87,19.48,17.85,29.19,1.55,2.51,3.14,4.99,4.72,7.48,.3-.1,.6-.19,.9-.29,0-11.54,.02-23.06-.02-34.59-.01-2.59-.3-4.81,3.66-4.77,3.7,.04,3.92,1.85,3.91,4.66-.07,15.34-.01,30.7-.08,46.05h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1007.18,315.11c.05,3.01-.63,4.48-4.13,4.46-3.32-.02-3.75-1.47-3.74-4.21,.09-15.66,.09-31.33,0-47-.01-2.76,.48-4.2,3.77-4.25,3.54-.05,4.14,1.51,4.1,4.49-.13,7.91-.05,15.83-.05,23.75s-.09,15.17,.05,22.77h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1059.78,314.22c-2.48-5.57-5.23-11.03-7.98-16.49-.89-1.8-1.4-2.82,1.1-4.12,7.33-3.81,9.97-10.11,8.08-17.75-1.77-7.15-7.3-11.42-15.37-11.61-6.17-.15-12.33,.13-18.48-.1-3.26-.11-3.87,1.28-3.82,4.11,.14,7.76,.05,15.52,.05,23.28s.09,16.19-.05,24.27c-.05,2.82,.91,3.75,3.73,3.71,2.68-.03,3.97-.69,3.88-3.62-.16-5.6-.06-11.22-.02-16.83,0-1.26-.36-2.69,1.05-3.59,3.19-2,11,.32,12.67,3.82,2.78,5.8,5.67,11.56,8.25,17.46,1.71,3.94,5.22,3.28,7.59,2.34,2.64-1.05,0-3.38-.67-4.88h-.01Zm-23.41-25.15c-4.07,.44-5.91-.89-5.28-5.13,.21-1.45,.03-2.96,.03-4.45,0-5.65,2.92-8.48,8.75-8.47,1.83,0,3.67-.12,5.49,.06,4.95,.49,8.11,4.02,8.13,8.96,.03,4.99-3.01,8.39-8.14,8.79-2.98,.23-6.01-.1-8.98,.23h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M362.15,270.07c.12,14.88,.03,29.74,.1,44.62,.01,2.99-.18,4.96-4.2,4.9s-3.61-2.31-3.61-4.84c.03-11.65,0-23.3,0-34.95-.31-.12-.61-.23-.92-.34-2.99,4.44-5.97,8.9-8.99,13.34-2.95,4.33-5.64,4.32-8.65-.04-2.87-4.17-5.69-8.38-9.67-12.34v17.94c0,5.78-.13,11.57,.05,17.35,.09,3.2-1.39,3.81-4.24,3.84-2.96,.04-3.63-1.13-3.62-3.82,.1-15.53,.02-31.06,.09-46.6,.01-1.63-1.05-4.14,1.39-4.66,2.65-.58,5.64-1.02,7.62,2,3.71,5.67,7.54,11.29,11.33,16.92,.35,.51,.84,.92,1.57,1.71,4.12-6.09,8.32-11.84,11.99-17.89,2-3.31,4.79-3.38,7.73-2.86,3.51,.63,2.01,3.73,2.03,5.72h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M126.5,267.56c-.05,16.18-.02,32.37-.03,48.55,0,1.52,.03,3.17-2.09,3.25-2.43,.1-5.04,.73-6.68-2.03-2.02-3.42-4.15-6.77-6.25-10.14-5.53-8.94-11.08-17.88-16.61-26.81-.36,.16-.71,.31-1.07,.47,0,11.38-.06,22.76,.05,34.14,.02,2.89-.32,4.61-3.97,4.55-3.47-.05-4.13-1.51-4.11-4.53,.1-15.35,.02-30.72,.07-46.08,.01-1.82-.8-4.38,2.25-4.62,2.53-.19,5.13-.77,6.96,2.31,6.07,10.24,12.42,20.32,18.67,30.46,1.37,2.22,2.77,4.4,4.95,7.86,0-12.98,.16-24.57-.1-36.17-.08-3.85,1.19-4.93,4.85-4.62,2.41,.21,3.11,1.19,3.11,3.41h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M981.15,319.27c-2.47,.35-5.17,.97-7.01-2.11-5.14-8.67-10.53-17.19-15.83-25.76-2.31-3.72-4.66-7.4-7.8-12.39,0,13-.16,24.45,.08,35.89,.09,3.94-1.48,4.85-4.99,4.58-2.38-.18-3.12-1.16-3.11-3.41,.05-16.18,.03-32.35,.02-48.52,0-1.57,.07-3.08,2.12-3.26,2.85-.25,5.41-.35,7.26,2.78,5.79,9.83,11.87,19.48,17.85,29.19,1.55,2.51,3.14,4.99,4.72,7.48,.3-.1,.6-.19,.9-.29,0-11.54,.02-23.06-.02-34.59-.01-2.59-.3-4.81,3.66-4.77,3.7,.04,3.92,1.85,3.91,4.66-.07,15.34-.01,30.7-.08,46.05-.01,1.61,.97,4.09-1.69,4.46h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M765.67,280.23c-.07-8.38-4.29-13.54-12.64-15.31-7.07-1.5-14.26-.3-21.39-.74-3.41-.21-4.22,1.28-4.15,4.38,.18,7.59,.06,15.17,.06,22.77v23.75c0,.17,.02,.33,0,.5-.3,2.65,.64,3.96,3.57,3.91,6.15-.13,12.33,.22,18.46-.11,10.35-.56,16.06-6.74,16.09-16.87,.02-7.42,.06-14.85-.01-22.27h.01Zm-7.72,8.61c-.23,4.76,.1,9.55-.18,14.31-.36,6.08-3.84,9.25-9.88,9.5-8.23,.33-12.35-3.55-12.35-11.65v-9.38c0-5.76,.11-11.53-.05-17.28-.07-2.57,.77-3.36,3.39-3.39,14.68-.18,19.94-.63,19.07,17.89h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1059.78,314.22c-2.48-5.57-5.23-11.03-7.98-16.49-.89-1.8-1.4-2.82,1.1-4.12,7.33-3.81,9.97-10.11,8.08-17.75-1.77-7.15-7.3-11.42-15.37-11.61-6.17-.15-12.33,.13-18.48-.1-3.26-.11-3.87,1.28-3.82,4.11,.14,7.76,.05,15.52,.05,23.28s.09,16.19-.05,24.27c-.05,2.82,.91,3.75,3.73,3.71,2.68-.03,3.97-.69,3.88-3.62-.16-5.6-.06-11.22-.02-16.83,0-1.26-.36-2.69,1.05-3.59,3.19-2,11,.32,12.67,3.82,2.78,5.8,5.67,11.56,8.25,17.46,1.71,3.94,5.22,3.28,7.59,2.34,2.64-1.05,0-3.38-.67-4.88h-.01Zm-23.41-25.15c-4.07,.44-5.91-.89-5.28-5.13,.21-1.45,.03-2.96,.03-4.45,0-5.65,2.92-8.48,8.75-8.47,1.83,0,3.67-.12,5.49,.06,4.95,.49,8.11,4.02,8.13,8.96,.03,4.99-3.01,8.39-8.14,8.79-2.98,.23-6.01-.1-8.98,.23h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M590.86,314.46c-2.32-5.28-4.81-10.5-7.58-15.57-1.55-2.85-1.59-4.26,1.77-5.88,5.7-2.76,8.18-8.75,7.3-15.51-.82-6.25-5.01-10.89-11.11-12.58-4.43-1.23-8.94-.4-12.74-.7-3.82,0-7,.17-10.14-.05-3.05-.21-4.03,.88-4,3.92,.12,15.84,.09,31.68,.02,47.52-.01,2.53,.4,3.96,3.49,3.94,2.93-.03,4.23-.77,4.12-3.91-.2-5.44-.08-10.88-.04-16.33,.01-1.27-.38-2.72,.84-3.7,2.51-2.01,11.17,.06,12.58,3.02,2.91,6.11,5.82,12.21,8.62,18.36,1.63,3.61,5,2.99,7.29,2.18,3.11-1.1,.2-3.3-.42-4.71h0Zm-19.78-25.46c-6.1,.02-9.15-3-9.15-9.05s2.94-9.03,8.81-8.93c1.99,0,4-.13,5.96,.11,4.81,.57,7.98,4.39,7.85,9.22-.13,4.71-3.18,8-8,8.49-1.81,.19-3.64,.16-5.47,.17h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M278.99,314.52c-2.61-5.69-5.33-11.35-8.18-16.94-1.04-2.04-.88-2.87,1.37-4.03,6.91-3.58,9.7-10.07,7.97-17.4-1.7-7.25-7.15-11.65-15.15-11.88-6.15-.18-12.33,.14-18.47-.11-3.45-.14-4.19,1.21-4.12,4.32,.18,7.76,.06,15.52,.06,23.27s.07,15.52-.04,23.28c-.04,2.83,.2,4.62,3.92,4.53,3.43-.08,3.72-1.7,3.67-4.34-.1-5.45-.05-10.89-.01-16.34,.01-1.25-.33-2.65,1.2-3.47,3.6-1.91,10.85,.37,12.59,4.02,2.85,5.96,5.65,11.93,8.53,17.89,1.7,3.53,5.16,2.59,7.38,1.71,2.23-.9-.05-3.08-.71-4.51h-.01Zm-19.89-25.52c-6.08,.02-9.12-3.01-9.12-9.1s2.96-8.89,8.89-8.88c1.99,0,4.01-.13,5.98,.12,4.85,.62,7.88,4.34,7.75,9.3-.13,4.78-3.09,7.94-8.02,8.41-1.81,.17-3.65,.15-5.48,.16h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M485.39,282.07c-.65-11.24-7.48-17.81-18.84-18.29-11.39-.49-19.13,5.4-20.45,16.42-.95,7.84-1.01,15.84,.06,23.69,1.49,10.81,8.41,16.18,19.71,16.09,11.08-.09,17.92-5.83,19.29-16.64,.47-3.73,.07-7.57,.07-11.36h.19c0-3.3,.16-6.61-.03-9.9h0Zm-8,19.9c-.18,6.69-5.28,11.48-11.87,11.5-6.54,0-11.49-4.79-11.77-11.58-.14-3.29-.02-6.59-.02-9.89,.01-3.46-.17-6.94,.05-10.38,.44-7.02,5.04-11.1,12.09-10.99,6.9,.11,11.39,4.5,11.53,11.57,.13,6.59,.16,13.19-.01,19.77Z"
                                fill="#fff"
                            />
                            <path
                                d="M420.8,319.5c-1.96,.33-3.97,.37-5,.46-12.25,.05-19.83-4.95-20.99-13.2-.63-4.5,.57-5.63,5.05-5.2,1.91,.19,2.55,.92,2.62,2.75,.16,4.7,3.22,7.11,7.36,8.22,4.95,1.33,9.99,1.67,14.11-2.17,3.11-2.89,2.93-7.13-.15-10.11-2.2-2.12-5.02-3.21-7.76-4.4-4.11-1.78-8.36-3.28-12.34-5.32-6.01-3.07-8.73-8.2-7.98-14.12,.76-5.98,4.6-10.44,11.09-11.89,6.26-1.4,12.56-1.37,18.49,1.66,4.43,2.27,7.27,5.81,7.98,10.71,.26,1.8,1.68,4.67-1.97,4.94-2.46,.18-5.03,.95-5.87-3.22-1.55-7.8-13.93-11.19-19.82-5.77-3.77,3.47-2.77,9.24,2.42,11.81,5.64,2.79,11.63,4.9,17.31,7.62,4.51,2.16,7.9,5.42,8.39,10.83,.78,8.61-4.12,14.94-12.95,16.4h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M831.16,314.88c-4.93-15.54-10.15-30.99-15.05-46.55-1.03-3.29-2.56-4.8-6-4.02-3.51-.73-5.41,.55-6.53,4.12-4.8,15.41-9.93,30.73-14.76,46.13-.44,1.4-3.02,4,.57,4.67,2.45,.46,6.42,1.65,6.91-2.48,.87-7.19,5.28-8.03,11.15-7.24,1.3,.18,2.66,.14,3.98,0,6.09-.58,11.34-.49,12.34,7.68,.48,3.95,4.77,2.43,7.13,2,3.09-.58,.68-3.02,.27-4.31h0Zm-15.5-11.49c-3.99-.12-8,0-11.99-.05-1.51-.02-3.17,.11-2.37-2.39,2.8-8.75,5.51-17.54,8.57-27.32,3,9.44,5.61,17.78,8.32,26.08,.8,2.46,.47,3.77-2.52,3.68h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M928.73,315.98c-.04,2.46-.7,3.55-3.4,3.52-9.99-.11-19.98-.11-29.97,0-2.87,.03-3.75-1.16-3.72-3.86,.11-7.93,.04-15.86,.04-23.78s.15-15.19-.07-22.79c-.1-3.57,.88-5.02,4.73-4.92,9.49,.24,18.99,.14,28.47,.04,2.61-.03,3.92,.49,3.95,3.5,.03,3.14-1.51,3.41-4,3.37-7.16-.1-14.32,.08-21.48-.09-2.87-.07-3.6,.9-3.68,3.67-.37,13.62-.45,13.47,13.22,13.75,2.48,.05,7.05-2.53,7.25,2.98,.22,6-4.66,3.42-7.29,3.48-13.23,.26-13.09,.12-13.2,13.19-.03,3.65,.85,4.9,4.68,4.72,6.98-.32,13.98,0,20.98-.14,2.57-.05,3.53,.75,3.49,3.37h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M694.63,315.78c-.01,2.77-.85,3.77-3.71,3.73-9.82-.14-19.65-.14-29.46,0-3.11,.05-4-1.17-3.95-4.1,.15-7.92,.05-15.85,.05-23.77s.14-15.19-.06-22.79c-.08-3.3,.73-4.76,4.4-4.68,9.65,.21,19.31,.15,28.96,.02,2.78-.04,3.78,.81,3.77,3.67,0,2.81-1.27,3.24-3.65,3.21-7.16-.1-14.31,.09-21.47-.09-2.93-.08-4.29,.58-4.02,3.8,.28,3.28,.26,6.61,.01,9.9-.24,3.18,1.18,3.97,4.07,3.88,4.15-.16,8.33,.03,12.48-.07,2.33-.05,3.71,.39,3.71,3.21,.01,2.69-1.04,3.4-3.54,3.32-4.49-.14-9,.06-13.48-.07-2.32-.06-3.48,.67-3.19,3.08,.04,.33-.01,.67,.01,.99,.29,4.4-1.86,10.04,.89,12.86,2.54,2.62,8.21,.65,12.49,.78,3.99,.13,7.99,.11,11.98,0,2.31-.06,3.72,.26,3.71,3.15v-.03Z"
                                fill="#fff"
                            />
                            <path
                                d="M228.65,316.02c0,2.19-.6,3.45-3.06,3.44-10.34-.04-20.67-.08-30.99,.03-3.05,.03-3-1.76-2.99-3.88,.04-7.93,.02-15.86,.02-23.79s.12-15.53-.06-23.29c-.08-3.08,.6-4.45,4.07-4.37,9.66,.2,19.33,.11,28.99,.04,2.52,0,4.03,.44,4.06,3.5,.04,3.19-1.65,3.38-4.09,3.35-7.17-.08-14.33,.09-21.49-.08-2.83-.07-3.63,.83-3.71,3.63-.42,13.89-.5,13.78,13.89,14,2.25,.04,6.11-2.19,6.48,2.81,.17,2.4-.5,3.7-3.27,3.59-4.32-.15-8.67,.11-12.99-.08-2.92-.14-4.03,.64-4.11,3.8-.34,13.95-.45,13.95,13.75,13.95,4.16,0,8.34,.09,12.5-.03,2.57-.07,3,1.25,3.01,3.39h-.01Z"
                                fill="#fff"
                            />
                            <path
                                d="M538.53,302.51c-.15,10.84-8.05,17.65-19.89,17.45-11.6-.19-18.95-7.02-19.07-17.78-.06-5.45-.01-10.89-.01-16.34s-.05-10.56,.02-15.85c.04-2.73-1.21-6.02,3.99-5.9,5.26,.12,3.76,3.58,3.79,6.19,.11,10.08,.03,20.14,.06,30.21,.02,8.15,4.46,13.02,11.73,12.95,7.13-.07,11.47-4.75,11.53-12.68,.08-10.73,.1-21.46-.03-32.19-.04-3.06,.67-4.5,4.13-4.45,3.23,.05,3.84,1.41,3.81,4.22-.11,11.39,.07,22.78-.08,34.16h.02Z"
                                fill="#fff"
                            />
                            <path
                                d="M642.89,306.59c-2.04,9.23-9.6,14.02-20.9,13.34-9.95-.61-16.54-6.75-17.28-16.44-.31-3.95-.05-7.92-.06-11.88,0-3.8-.23-7.6,.04-11.38,.71-9.93,7.59-16.01,18.32-16.49,10.7-.48,18.32,4.77,20.05,13.89,.34,1.8,1.44,4.22-1.91,4.4-2.36,.12-5.09,1.59-5.87-2.86-1.09-6.22-6.2-9.37-12.48-8.73-6.42,.66-10.13,4.65-10.22,11.22-.08,6.77-.08,13.53,0,20.3,.08,6.63,3.57,10.43,10.15,11.3,6.09,.79,11.46-2.44,12.52-8.66,.77-4.52,3.61-3.06,5.86-2.89,3.6,.27,2.21,2.94,1.78,4.88h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M879.49,268.31c-3.51,10.81-6.96,21.64-10.43,32.47-1.51,4.71-3.12,9.38-4.46,14.14-.85,3.02-2.08,4.7-5.75,4.67-3.51-.03-4.48-1.74-5.33-4.51-4.73-15.26-9.63-30.48-14.32-45.75-.47-1.53-2.92-4.06,.26-4.85,2.7-.67,6.2-1.58,7.49,3.14,2.96,10.8,6.39,21.47,9.63,32.2,.74,2.45,1.52,4.89,2.68,8.6,4.31-14.25,8.35-27.28,12.13-40.38,.84-2.92,2.2-3.87,5.22-3.91,3.59-.05,3.8,1.4,2.89,4.18h-.01Z"
                                fill="#fff"
                            />
                            <path
                                d="M178.8,268.06c.13,2.53-1.12,3.07-3.33,2.98-2.99-.11-6.01,.17-9-.08-3.11-.26-3.95,.86-3.91,3.9,.15,13.23,.04,26.44,.08,39.66,.01,2.75,.39,5.12-3.88,5.07-4.11-.05-4.05-2.21-4.01-5.07,.09-6.45,.03-12.89,.02-19.34,0-6.94-.09-13.88,.05-20.82,.05-2.59-.86-3.54-3.47-3.38-2.98,.17-5.99-.1-8.99,.07-2.8,.16-3.37-1.3-3.36-3.64,.01-2.29,.96-3.23,3.31-3.22,11.17,.07,22.33,.09,33.5,0,3.06-.03,2.9,1.78,3,3.88h-.01Z"
                                fill="#fff"
                            />
                            <path
                                d="M36.56,316.15c-.06,3.16-1.87,3.33-4.26,3.32-9.48-.05-18.97-.1-28.44,.03-2.76,.03-3.88-.83-3.86-3.66C.07,299.84,.07,283.84,0,267.84c-.02-2.81,1.07-3.68,3.84-3.72,3.03-.04,4.09,.95,4.02,3.99-.18,6.93-.06,13.85-.06,20.78,0,6.27,.2,12.55-.08,18.8-.16,3.75,.73,5.29,4.88,5.05,6.47-.38,12.97-.05,19.46-.13,2.57-.03,4.57,.06,4.5,3.53h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M69.83,315.38c.01,2.85-.64,4.17-3.86,4.17s-4.3-1.27-4.24-4.42c.16-7.93,.05-15.86,.05-23.79s.11-15.2-.05-22.81c-.07-3.15,.88-4.41,4.24-4.41s3.87,1.31,3.86,4.16c-.1,15.7-.1,31.4,0,47.09h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M302.26,314.86c.02,2.73-.09,4.69-3.86,4.72-3.59,.02-4.01-1.52-3.99-4.47,.1-15.5,.09-31.01,0-46.52-.02-2.89,.3-4.56,3.96-4.5,3.71,.07,3.92,1.98,3.89,4.74-.08,7.75-.03,15.51-.03,23.26s-.04,15.17,.03,22.77h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M1003.05,319.57c-3.32-.02-3.75-1.47-3.74-4.21,.09-15.66,.09-31.33,0-47-.01-2.76,.48-4.2,3.77-4.25,3.54-.05,4.14,1.51,4.1,4.49-.13,7.91-.05,15.83-.05,23.75s-.09,15.17,.05,22.77c.05,3.01-.63,4.48-4.13,4.46h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M50.49,269.09c-1.21,3.04-2.64,6-3.7,9.08-.77,2.25-2.07,3.23-4.35,2.87-2.74,.29-3.14-.91-2.36-3.21,1.21-3.56,2.31-7.16,3.31-10.78,.5-1.8,1.31-2.71,3.34-2.88,4.98-.42,5.61,.28,3.76,4.92h0Z"
                                fill="#fff"
                            />
                            <path
                                d="M785.15,268.18c-1.52,3.27-2.94,6.6-4.09,10.01-1.07,3.2-3.53,3.46-5.93,2.7-2.82-.9-.56-3.03-.28-4.44,.58-2.87,1.85-5.6,2.48-8.48,.64-2.98,2.16-4.29,5.13-3.71,3.66-.49,4.06,.98,2.69,3.92h0Z"
                                fill="#fff"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'wizim.io'">
            <svg width="1028" height="206" viewBox="0 0 1028 206" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M41.3005 203.172L0.392578 58.3923H35.1737L60.6233 160.191H61.9429L87.9581 58.3923H122.362L148.377 159.625H149.791L174.864 58.3923H209.739L168.737 203.172H133.202L106.056 105.333H104.076L76.9299 203.172H41.3005Z"
                    fill="white"
                />
                <path
                    d="M233.563 203.172V58.3923H267.684V203.172H233.563ZM250.718 37.8441C245.314 37.8441 240.664 36.0532 236.768 32.4714C232.872 28.8268 230.924 24.4595 230.924 19.3696C230.924 14.2168 232.872 9.84953 236.768 6.26773C240.664 2.6231 245.314 0.800781 250.718 0.800781C256.185 0.800781 260.835 2.6231 264.668 6.26773C268.564 9.84953 270.512 14.2168 270.512 19.3696C270.512 24.4595 268.564 28.8268 264.668 32.4714C260.835 36.0532 256.185 37.8441 250.718 37.8441Z"
                    fill="white"
                />
                <path
                    d="M300.886 203.172V181.493L375.539 87.895V86.6696H303.337V58.3923H417.295V81.674L346.224 173.67V174.895H419.745V203.172H300.886Z"
                    fill="white"
                />
                <path
                    d="M451.817 203.172V58.3923H485.938V203.172H451.817ZM468.972 37.8441C463.567 37.8441 458.917 36.0532 455.021 32.4714C451.125 28.8268 449.177 24.4595 449.177 19.3696C449.177 14.2168 451.125 9.84953 455.021 6.26773C458.917 2.6231 463.567 0.800781 468.972 0.800781C474.439 0.800781 479.089 2.6231 482.922 6.26773C486.818 9.84953 488.766 14.2168 488.766 19.3696C488.766 24.4595 486.818 28.8268 482.922 32.4714C479.089 36.0532 474.439 37.8441 468.972 37.8441Z"
                    fill="white"
                />
                <path
                    d="M521.025 203.172V58.3923H553.639V82.9936H555.335C558.352 74.6989 563.347 68.2265 570.322 63.5765C577.297 58.8636 585.623 56.5071 595.301 56.5071C605.103 56.5071 613.367 58.895 620.09 63.6707C626.877 68.3836 631.653 74.8246 634.418 82.9936H635.926C639.13 74.9502 644.535 68.5407 652.138 63.765C659.804 58.9264 668.885 56.5071 679.379 56.5071C692.7 56.5071 703.571 60.7173 711.992 69.1377C720.412 77.558 724.622 89.843 724.622 105.992V203.172H690.407V111.271C690.407 102.285 688.019 95.7184 683.243 91.571C678.467 87.3608 672.623 85.2558 665.711 85.2558C657.479 85.2558 651.038 87.8321 646.388 92.9849C641.801 98.0748 639.508 104.704 639.508 112.873V203.172H606.046V109.857C606.046 102.379 603.784 96.4096 599.259 91.9481C594.798 87.4865 588.954 85.2558 581.727 85.2558C576.826 85.2558 572.365 86.5125 568.343 89.0261C564.321 91.4768 561.116 94.9643 558.729 99.4887C556.341 103.95 555.147 109.166 555.147 115.135V203.172H521.025Z"
                    fill="white"
                />
                <path
                    d="M780.258 205.246C774.54 205.246 769.638 203.235 765.554 199.213C761.469 195.192 759.458 190.29 759.521 184.509C759.458 178.854 761.469 174.015 765.554 169.994C769.638 165.972 774.54 163.961 780.258 163.961C785.788 163.961 790.595 165.972 794.679 169.994C798.827 174.015 800.932 178.854 800.995 184.509C800.932 188.342 799.926 191.83 797.978 194.972C796.093 198.114 793.58 200.627 790.438 202.512C787.359 204.335 783.965 205.246 780.258 205.246Z"
                    fill="white"
                />
                <path
                    d="M825.989 203.172V58.3923H860.11V203.172H825.989ZM843.144 37.8441C837.74 37.8441 833.09 36.0532 829.194 32.4714C825.298 28.8268 823.35 24.4595 823.35 19.3696C823.35 14.2168 825.298 9.84953 829.194 6.26773C833.09 2.6231 837.74 0.800781 843.144 0.800781C848.611 0.800781 853.261 2.6231 857.094 6.26773C860.99 9.84953 862.938 14.2168 862.938 19.3696C862.938 24.4595 860.99 28.8268 857.094 32.4714C853.261 36.0532 848.611 37.8441 843.144 37.8441Z"
                    fill="url(#paint0_linear_2972_5917)"
                />
                <path
                    d="M958.35 206C944.212 206 931.958 202.889 921.59 196.668C911.221 190.447 903.178 181.744 897.46 170.559C891.804 159.374 888.977 146.303 888.977 131.348C888.977 116.392 891.804 103.29 897.46 92.0423C903.178 80.7942 911.221 72.0597 921.59 65.8387C931.958 59.6176 944.212 56.5071 958.35 56.5071C972.489 56.5071 984.743 59.6176 995.111 65.8387C1005.48 72.0597 1013.49 80.7942 1019.15 92.0423C1024.86 103.29 1027.72 116.392 1027.72 131.348C1027.72 146.303 1024.86 159.374 1019.15 170.559C1013.49 181.744 1005.48 190.447 995.111 196.668C984.743 202.889 972.489 206 958.35 206ZM958.539 178.665C966.205 178.665 972.615 176.56 977.767 172.35C982.92 168.077 986.753 162.359 989.267 155.195C991.843 148.031 993.131 140.051 993.131 131.254C993.131 122.393 991.843 114.381 989.267 107.218C986.753 99.9914 982.92 94.2417 977.767 89.9686C972.615 85.6956 966.205 83.5591 958.539 83.5591C950.684 83.5591 944.149 85.6956 938.933 89.9686C933.78 94.2417 929.916 99.9914 927.34 107.218C924.826 114.381 923.569 122.393 923.569 131.254C923.569 140.051 924.826 148.031 927.34 155.195C929.916 162.359 933.78 168.077 938.933 172.35C944.149 176.56 950.684 178.665 958.539 178.665Z"
                    fill="url(#paint1_linear_2972_5917)"
                />
                <defs>
                    <linearGradient id="paint0_linear_2972_5917" x1="818.223" y1="-93.249" x2="1072" y2="-83.1047" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#DCC8FC" />
                        <stop offset="0.53125" stop-color="#B9D8F9" />
                        <stop offset="1" stop-color="#A0E29A" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_2972_5917" x1="818.223" y1="-93.249" x2="1072" y2="-83.1047" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#DCC8FC" />
                        <stop offset="0.53125" stop-color="#B9D8F9" />
                        <stop offset="1" stop-color="#A0E29A" />
                    </linearGradient>
                </defs>
            </svg>
        </template>
        <template v-if="icon === 'icon-wizm-white'">
            <svg width="1399" height="883" viewBox="0 0 1399 883" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.9"
                    d="M852.5 25.8702C931.889 25.8702 981.507 111.811 941.812 180.564L584.568 799.331C544.873 868.083 445.637 868.083 405.942 799.331L48.6973 180.564C9.00279 111.811 58.621 25.8702 138.01 25.8702L852.5 25.8702Z"
                    fill="white"
                />
                <path
                    opacity="0.7"
                    d="M1258.98 25.8702C1338.36 25.8702 1387.98 111.811 1348.29 180.564L991.043 799.331C951.349 868.083 852.112 868.083 812.418 799.331L455.173 180.564C415.478 111.811 465.097 25.8702 544.486 25.8702L1258.98 25.8702Z"
                    fill="white"
                />
                <path
                    d="M845.383 28.0578C924.298 27.9183 974.123 112.85 935.497 181.666L699 603L456.725 183.273C417.08 114.59 466.557 28.7275 545.861 28.5873L845.383 28.0578Z"
                    fill="white"
                />
            </svg>
        </template>
        <template v-if="icon === 'ariane-arrow'">
            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.4"
                    d="M6.75923 11.2102L5.73651 10.1989L9.28764 6.64773H0.367188V5.17045H9.28764L5.73651 1.625L6.75923 0.607954L12.0604 5.90909L6.75923 11.2102Z"
                    fill="#1B1B1B"
                />
            </svg>
        </template>
        <template v-if="icon === 'afternoon'">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.1921 7.95403H12.6098C12.5605 7.60532 12.4693 7.26381 12.3382 6.93692L14.5706 5.64321C14.6452 5.60306 14.711 5.54834 14.764 5.4823C14.8171 5.41625 14.8564 5.34022 14.8795 5.25872C14.9027 5.17722 14.9092 5.0919 14.8987 5.00782C14.8883 4.92374 14.8611 4.84262 14.8187 4.76926C14.7763 4.69589 14.7196 4.63179 14.652 4.58074C14.5844 4.52969 14.5072 4.49273 14.4251 4.47206C14.3429 4.45139 14.2574 4.44743 14.1737 4.4604C14.09 4.47338 14.0097 4.50304 13.9377 4.54761L11.7034 5.84322C11.4898 5.57341 11.2458 5.32917 10.9762 5.11535L12.2712 2.88048C12.3491 2.73557 12.3676 2.56599 12.3227 2.40769C12.2777 2.24939 12.1729 2.11481 12.0304 2.0325C11.8879 1.95018 11.719 1.9266 11.5594 1.96674C11.3998 2.00689 11.2621 2.10761 11.1756 2.24755L9.87995 4.47862C9.5531 4.34743 9.21158 4.25626 8.86284 4.2071V1.62475C8.86284 1.45689 8.79615 1.2959 8.67746 1.1772C8.55876 1.0585 8.39777 0.991821 8.22991 0.991821C8.06204 0.991821 7.90106 1.0585 7.78236 1.1772C7.66366 1.2959 7.59698 1.45689 7.59698 1.62475V4.2071C7.24823 4.25626 6.90671 4.34743 6.57986 4.47862L5.28616 2.24629C5.19958 2.10634 5.06191 2.00562 4.90232 1.96548C4.74273 1.92533 4.57379 1.94892 4.4313 2.03123C4.28881 2.11355 4.18398 2.24812 4.13904 2.40642C4.0941 2.56473 4.11258 2.73431 4.19056 2.87921L5.48553 5.11535C5.21591 5.32917 4.97188 5.57341 4.75829 5.84322L2.52406 4.54761C2.45201 4.50304 2.37174 4.47338 2.28802 4.4604C2.20429 4.44743 2.11881 4.45139 2.03665 4.47206C1.95449 4.49273 1.87731 4.52969 1.80969 4.58074C1.74207 4.63179 1.6854 4.69589 1.64301 4.76926C1.60063 4.84262 1.57341 4.92374 1.56296 5.00782C1.55252 5.0919 1.55906 5.17722 1.5822 5.25872C1.60533 5.34022 1.6446 5.41625 1.69767 5.4823C1.75073 5.54834 1.81652 5.60306 1.89113 5.64321L4.12157 6.93692C3.99052 7.26381 3.89935 7.60532 3.85004 7.95403H1.26769C1.09983 7.95403 0.938843 8.02072 0.820146 8.13942C0.701449 8.25811 0.634766 8.4191 0.634766 8.58696C0.634766 8.75483 0.701449 8.91581 0.820146 9.03451C0.938843 9.15321 1.09983 9.21989 1.26769 9.21989H3.85004C3.89935 9.56861 3.99052 9.91011 4.12157 10.237L1.88923 11.5307C1.81462 11.5709 1.74884 11.6256 1.69577 11.6916C1.6427 11.7577 1.60344 11.8337 1.5803 11.9152C1.55716 11.9967 1.55062 12.082 1.56107 12.1661C1.57151 12.2502 1.59873 12.3313 1.64111 12.4047C1.6835 12.478 1.74018 12.5421 1.80779 12.5932C1.87541 12.6442 1.95259 12.6812 2.03475 12.7019C2.11692 12.7225 2.20239 12.7265 2.28612 12.7135C2.36984 12.7005 2.45011 12.6709 2.52216 12.6263L4.7564 11.3307C4.96998 11.6005 5.21401 11.8448 5.48363 12.0586L4.19056 14.2934C4.11258 14.4384 4.0941 14.6079 4.13904 14.7662C4.18398 14.9245 4.28881 15.0591 4.4313 15.1414C4.57379 15.2237 4.74273 15.2473 4.90232 15.2072C5.06191 15.167 5.19958 15.0663 5.28616 14.9264L6.57986 12.694C6.90675 12.8254 7.24824 12.917 7.59698 12.9668V15.5492C7.59698 15.717 7.66366 15.878 7.78236 15.9967C7.90106 16.1154 8.06204 16.1821 8.22991 16.1821C8.39777 16.1821 8.55876 16.1154 8.67746 15.9967C8.79615 15.878 8.86284 15.717 8.86284 15.5492V12.9668C9.21153 12.9174 9.55301 12.8262 9.87995 12.6953L11.1737 14.9276C11.2602 15.0676 11.3979 15.1683 11.5575 15.2084C11.7171 15.2486 11.886 15.225 12.0285 15.1427C12.171 15.0604 12.2758 14.9258 12.3208 14.7675C12.3657 14.6092 12.3472 14.4396 12.2693 14.2947L10.9743 12.0598C11.2439 11.846 11.4879 11.6018 11.7015 11.332L13.9358 12.6276C14.0078 12.6722 14.0881 12.7018 14.1718 12.7148C14.2555 12.7278 14.341 12.7238 14.4232 12.7031C14.5053 12.6825 14.5825 12.6455 14.6501 12.5945C14.7177 12.5434 14.7744 12.4793 14.8168 12.4059C14.8592 12.3326 14.8864 12.2515 14.8969 12.1674C14.9073 12.0833 14.9008 11.998 14.8776 11.9165C14.8545 11.835 14.8152 11.7589 14.7621 11.6929C14.7091 11.6268 14.6433 11.5721 14.5687 11.532L12.3363 10.2383C12.4681 9.91106 12.56 9.56912 12.6098 9.21989H15.1921C15.36 9.21989 15.521 9.15321 15.6397 9.03451C15.7584 8.91581 15.825 8.75483 15.825 8.58696C15.825 8.4191 15.7584 8.25811 15.6397 8.13942C15.521 8.02072 15.36 7.95403 15.1921 7.95403ZM8.22991 11.7516C4.04752 11.6187 4.04878 5.5546 8.22991 5.42232C12.4123 5.55524 12.411 11.6193 8.22991 11.7516Z"
                    fill="#ACACAC"
                />
            </svg>
        </template>
        <template v-if="icon === 'evening'">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9351 17.0975H13.1696C12.8446 17.0964 12.5308 16.9785 12.2853 16.7654C12.0399 16.5523 11.8791 16.2582 11.8323 15.9366C11.7082 15.1353 11.3017 14.4049 10.686 13.8772C10.0704 13.3496 9.28634 13.0596 8.47554 13.0596C7.66474 13.0596 6.88069 13.3496 6.26506 13.8772C5.64943 14.4049 5.24284 15.1353 5.11876 15.9366C5.07198 16.2581 4.91131 16.5521 4.66601 16.7652C4.42071 16.9783 4.10707 17.0962 3.78215 17.0975H1.01603C0.836175 17.0975 0.663688 17.0261 0.536513 16.8989C0.409337 16.7717 0.337891 16.5992 0.337891 16.4194C0.337891 16.2395 0.409337 16.067 0.536513 15.9399C0.663688 15.8127 0.836175 15.7413 1.01603 15.7413H3.78215C3.83417 15.3673 3.93164 15.0011 4.07239 14.6508L1.68196 13.2661C1.53202 13.1733 1.42411 13.0258 1.38109 12.8548C1.33808 12.6838 1.36335 12.5028 1.45154 12.3501C1.53974 12.1975 1.68393 12.0851 1.85354 12.037C2.02314 11.9888 2.20484 12.0086 2.3601 12.0922L4.75324 13.479C4.9826 13.1905 5.24452 12.9295 5.53378 12.7012L4.14767 10.3067C4.06412 10.1514 4.04432 9.96971 4.09247 9.8001C4.14062 9.63049 4.25294 9.4863 4.4056 9.3981C4.55827 9.30991 4.73929 9.28464 4.91027 9.32765C5.08125 9.37067 5.22876 9.47858 5.32152 9.62852L6.70764 12.0183C7.05773 11.8763 7.4236 11.7768 7.7974 11.7219V8.95988C7.7974 8.78002 7.86885 8.60754 7.99603 8.48036C8.1232 8.35318 8.29569 8.28174 8.47554 8.28174C8.6554 8.28174 8.82788 8.35318 8.95506 8.48036C9.08223 8.60754 9.15368 8.78002 9.15368 8.95988V11.7213C9.52728 11.776 9.89294 11.8755 10.2428 12.0176L11.6296 9.62581C11.6726 9.54587 11.7312 9.47539 11.802 9.41853C11.8727 9.36167 11.9542 9.3196 12.0415 9.29481C12.1288 9.27002 12.2203 9.26301 12.3103 9.2742C12.4004 9.2854 12.4873 9.31456 12.5659 9.35997C12.6445 9.40538 12.7132 9.46611 12.7679 9.53855C12.8226 9.611 12.8622 9.69369 12.8844 9.78172C12.9065 9.86976 12.9108 9.96134 12.8969 10.051C12.8829 10.1407 12.8512 10.2267 12.8034 10.3039L11.4153 12.6984C11.7045 12.9268 11.9665 13.1878 12.1958 13.4763L14.5896 12.0895C14.7449 12.0059 14.9266 11.9861 15.0962 12.0343C15.2658 12.0824 15.41 12.1948 15.4982 12.3474C15.5864 12.5001 15.6116 12.6811 15.5686 12.8521C15.5256 13.0231 15.4177 13.1706 15.2678 13.2633L12.8834 14.6501C13.0264 15.0024 13.1257 15.3709 13.1791 15.7474L15.9351 15.7413C16.1149 15.7413 16.2874 15.8127 16.4146 15.9399C16.5417 16.067 16.6132 16.2395 16.6132 16.4194C16.6132 16.5992 16.5417 16.7717 16.4146 16.8989C16.2874 17.0261 16.1149 17.0975 15.9351 17.0975Z"
                    fill="#ACACAC"
                />
                <path
                    d="M5.96675 4.69308L8.00116 6.72749C8.12833 6.85462 8.30078 6.92604 8.4806 6.92604C8.66042 6.92604 8.83288 6.85462 8.96005 6.72749L10.9945 4.69308C11.1217 4.56592 11.1932 4.39342 11.1933 4.21353C11.1934 4.03364 11.122 3.8611 10.9948 3.73385C10.8676 3.6066 10.6951 3.53508 10.5153 3.53502C10.3354 3.53495 10.1628 3.60635 10.0356 3.73351L9.15399 4.61034V1.5004C9.15399 1.32055 9.08255 1.14806 8.95537 1.02089C8.8282 0.893712 8.65571 0.822266 8.47586 0.822266C8.296 0.822266 8.12352 0.893712 7.99634 1.02089C7.86916 1.14806 7.79772 1.32055 7.79772 1.5004V4.61034L6.91614 3.73351C6.7867 3.61829 6.61806 3.55699 6.44485 3.5622C6.27164 3.56742 6.10699 3.63874 5.98471 3.76154C5.86244 3.88434 5.79181 4.04928 5.78734 4.22252C5.78286 4.39575 5.84487 4.56413 5.96064 4.69308V4.69308H5.96675Z"
                    fill="#ACACAC"
                />
            </svg>
        </template>
        <template v-if="icon === 'morning'">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.2788 17.0972H13.5134C13.1884 17.0961 12.8747 16.9784 12.6293 16.7654C12.3838 16.5525 12.223 16.2585 12.1761 15.937C12.052 15.1357 11.6454 14.4053 11.0298 13.8776C10.4141 13.35 9.63009 13.06 8.81929 13.06C8.00849 13.06 7.22444 13.35 6.60881 13.8776C5.99318 14.4053 5.58659 15.1357 5.46251 15.937C5.41558 16.2584 5.25485 16.5523 5.00956 16.7652C4.76428 16.9781 4.45072 17.0959 4.1259 17.0972H1.35978C1.17992 17.0972 1.00744 17.0258 0.880263 16.8986C0.753087 16.7715 0.681641 16.599 0.681641 16.4191C0.681641 16.2393 0.753087 16.0668 0.880263 15.9396C1.00744 15.8124 1.17992 15.741 1.35978 15.741H4.1259C4.17784 15.3672 4.27531 15.0013 4.41614 14.6512L2.02571 13.2651C1.94577 13.2221 1.87529 13.1634 1.81843 13.0927C1.76157 13.0219 1.7195 12.9405 1.69471 12.8531C1.66992 12.7658 1.66291 12.6744 1.6741 12.5843C1.6853 12.4942 1.71446 12.4073 1.75987 12.3287C1.80528 12.2501 1.86601 12.1814 1.93845 12.1267C2.0109 12.072 2.09359 12.0324 2.18162 12.0103C2.26966 11.9881 2.36124 11.9839 2.45095 11.9978C2.54065 12.0117 2.62665 12.0435 2.70385 12.0912L5.09699 13.4787C5.32634 13.19 5.58825 12.9288 5.87753 12.7002L4.49142 10.305C4.40787 10.1498 4.38807 9.96807 4.43622 9.79846C4.48437 9.62885 4.59669 9.48466 4.74935 9.39647C4.90202 9.30827 5.08304 9.283 5.25402 9.32602C5.425 9.36903 5.57251 9.47695 5.66527 9.62688L7.05139 12.0187C7.40132 11.8759 7.76723 11.7759 8.14115 11.721V8.9596C8.14115 8.77974 8.2126 8.60726 8.33978 8.48008C8.46695 8.35291 8.63944 8.28146 8.81929 8.28146C8.99915 8.28146 9.17163 8.35291 9.29881 8.48008C9.42598 8.60726 9.49743 8.77974 9.49743 8.9596V11.721C9.8713 11.7755 10.2372 11.875 10.5872 12.0173L11.9733 9.62485C12.0661 9.47491 12.2136 9.367 12.3846 9.32398C12.5555 9.28097 12.7366 9.30624 12.8892 9.39443C13.0419 9.48263 13.1542 9.62682 13.2024 9.79643C13.2505 9.96604 13.2307 10.1477 13.1472 10.303L11.759 12.6975C12.0483 12.9261 12.3102 13.1873 12.5396 13.476L14.9327 12.0885C15.088 12.005 15.2697 11.9852 15.4393 12.0333C15.6089 12.0815 15.7531 12.1938 15.8413 12.3465C15.9295 12.4991 15.9547 12.6801 15.9117 12.8511C15.8687 13.0221 15.7608 13.1696 15.6108 13.2624L13.2272 14.6498C13.3702 15.0019 13.4695 15.3702 13.5229 15.7464L16.2788 15.741C16.4587 15.741 16.6311 15.8124 16.7583 15.9396C16.8855 16.0668 16.9569 16.2393 16.9569 16.4191C16.9569 16.599 16.8855 16.7715 16.7583 16.8986C16.6311 17.0258 16.4587 17.0972 16.2788 17.0972ZM11.3318 3.05437L9.29738 1.01996C9.17021 0.892829 8.99775 0.821411 8.81794 0.821411C8.63812 0.821411 8.46566 0.892829 8.33849 1.01996L6.30408 3.05437C6.17683 3.18153 6.10531 3.35403 6.10525 3.53392C6.10518 3.71381 6.17658 3.88635 6.30374 4.0136C6.4309 4.14085 6.60339 4.21237 6.78328 4.21243C6.96317 4.21249 7.13572 4.14109 7.26297 4.01394L8.14115 3.13711V6.24705C8.14115 6.4269 8.2126 6.59939 8.33978 6.72656C8.46695 6.85374 8.63944 6.92518 8.81929 6.92518C8.99915 6.92518 9.17163 6.85374 9.29881 6.72656C9.42598 6.59939 9.49743 6.4269 9.49743 6.24705V3.13711L10.379 4.01394C10.5082 4.1306 10.6773 4.19311 10.8514 4.18852C11.0254 4.18393 11.191 4.11259 11.3138 3.98928C11.4367 3.86597 11.5075 3.70013 11.5114 3.5261C11.5154 3.35206 11.4523 3.18316 11.3352 3.05437H11.3318Z"
                    fill="#ACACAC"
                />
            </svg>
        </template>
        <template v-if="icon === 'night'">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.89198 13.0972C5.98033 13.0917 5.07987 12.8959 4.24828 12.5223C3.4167 12.1487 2.67231 11.6055 2.06282 10.9275C1.45333 10.2495 0.992165 9.4517 0.708866 8.58516C0.425568 7.71863 0.326382 6.80248 0.417664 5.89539C0.579858 4.47895 1.198 3.1536 2.17895 2.11902C3.1599 1.08445 4.45052 0.396711 5.85633 0.159432C6.76453 0.0185239 7.69152 0.056488 8.58516 0.271189C8.82046 0.331583 9.03523 0.454072 9.20701 0.625852C9.37879 0.797633 9.50128 1.0124 9.56167 1.24771C9.62252 1.48088 9.61936 1.72614 9.55252 1.95767C9.48569 2.1892 9.35766 2.39842 9.18192 2.56329C6.70861 4.82448 6.92236 8.33831 9.61972 10.382C9.81026 10.5316 9.95722 10.7296 10.0453 10.9554C10.1334 11.1811 10.1594 11.4263 10.1207 11.6655C10.0819 11.9047 9.97977 12.1291 9.82489 12.3154C9.67001 12.5018 9.46803 12.6432 9.23996 12.7251C8.48196 12.9727 7.68941 13.0983 6.89198 13.0972V13.0972ZM6.93213 1.16199C6.62789 1.16128 6.32407 1.18431 6.02342 1.23089C4.85376 1.42933 3.78011 2.00204 2.96382 2.86294C2.14753 3.72384 1.6327 4.82643 1.49672 6.00498C1.41212 6.76452 1.49013 7.53336 1.72557 8.26042C1.961 8.98749 2.34846 9.65613 2.86221 10.2219C3.614 11.0253 4.58287 11.5931 5.65118 11.8564C6.71949 12.1197 7.84127 12.0672 8.88028 11.7051C8.9249 11.6882 8.96428 11.6599 8.99445 11.6229C9.02461 11.586 9.0445 11.5417 9.05209 11.4946C9.05968 11.4475 9.05472 11.3992 9.0377 11.3547C9.02068 11.3101 8.9922 11.2708 8.95515 11.2407V11.2407C5.7386 8.81138 5.48579 4.46425 8.44139 1.77177C8.47514 1.74025 8.49945 1.69996 8.51162 1.65541C8.52379 1.61086 8.52333 1.56381 8.51029 1.5195C8.49905 1.47228 8.47511 1.42902 8.44108 1.39441C8.40704 1.3598 8.36419 1.33514 8.31715 1.32312C7.86365 1.21385 7.39861 1.15975 6.93213 1.16199V1.16199ZM11.4984 6.58709C11.3775 6.58709 11.26 6.54667 11.1647 6.47227C11.0693 6.39786 11.0016 6.29373 10.9722 6.17641L10.778 5.40062L10.0011 5.19176C9.88427 5.16031 9.7813 5.0907 9.70857 4.99401C9.63584 4.89731 9.59752 4.77908 9.5997 4.65811C9.60188 4.53713 9.64444 4.42036 9.72062 4.32635C9.79679 4.23235 9.9022 4.1665 10.0201 4.13929L10.7796 3.96297L10.97 3.2002C10.9994 3.0829 11.0672 2.97878 11.1625 2.90438C11.2579 2.82998 11.3753 2.78958 11.4963 2.78958C11.6172 2.78958 11.7347 2.82998 11.83 2.90438C11.9253 2.97878 11.9931 3.0829 12.0225 3.2002L12.2151 3.96948L12.9844 4.16207C13.1017 4.19147 13.2058 4.25922 13.2802 4.35456C13.3546 4.44991 13.395 4.56737 13.395 4.68831C13.395 4.80924 13.3546 4.92671 13.2802 5.02205C13.2058 5.11739 13.1017 5.18514 12.9844 5.21454L12.2151 5.40713L12.0225 6.17641C11.9932 6.29337 11.9258 6.39723 11.8309 6.4716C11.736 6.54597 11.619 6.58661 11.4984 6.58709V6.58709ZM9.05714 7.67211C9.05714 7.81599 9.1143 7.95398 9.21604 8.05572C9.31778 8.15747 9.45577 8.21462 9.59965 8.21462C9.74353 8.21462 9.88152 8.15747 9.98326 8.05572C10.085 7.95398 10.1422 7.81599 10.1422 7.67211C10.1422 7.52823 10.085 7.39024 9.98326 7.2885C9.88152 7.18676 9.74353 7.1296 9.59965 7.1296C9.45577 7.1296 9.31778 7.18676 9.21604 7.2885C9.1143 7.39024 9.05714 7.52823 9.05714 7.67211ZM12.3122 9.84215C12.3122 9.98604 12.3694 10.124 12.4711 10.2258C12.5728 10.3275 12.7108 10.3847 12.8547 10.3847C12.9986 10.3847 13.1366 10.3275 13.2383 10.2258C13.3401 10.124 13.3972 9.98604 13.3972 9.84215C13.3972 9.69827 13.3401 9.56028 13.2383 9.45854C13.1366 9.3568 12.9986 9.29964 12.8547 9.29964C12.7108 9.29964 12.5728 9.3568 12.4711 9.45854C12.3694 9.56028 12.3122 9.69827 12.3122 9.84215Z"
                    fill="#ACACAC"
                />
            </svg>
        </template>
        <template v-if="icon === 'contract'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.01 49.27">
                <g id="a" />
                <g id="b">
                    <g id="c">
                        <g>
                            <path
                                d="M45.78,25.51c-.39-.58-.83-1.12-1.31-1.63-.45-.47-1.1-.53-1.6-.19-.49,.33-.94,.72-1.44,1.12,.95,1.18,1.86,2.31,2.8,3.47,.47-.39,.94-.74,1.35-1.14,.47-.45,.56-1.09,.2-1.63Z"
                            />
                            <path
                                d="M38.21,35.01c-.15,.11-.25,.19-.35,.27-.79,.64-1.58,1.29-2.38,1.92-.2,.16-.27,.32-.27,.57,0,2.64,0,5.29,0,7.93v.55h-.47c-9.58,0-19.17,0-28.75,0-.83,0-1.05-.22-1.05-1.06,0-6.42,0-12.85,0-19.27,0-3.77,0-7.53,0-11.3,0-.3-.09-.4-.37-.52-.78-.34-1.54-.74-2.3-1.13-.11-.06-.21-.13-.37-.24v.46c0,11.43,0,22.87,0,34.3,0,1.24,.55,1.8,1.78,1.8,10.77,0,21.55,0,32.32,0,1.38,0,2.23-.85,2.23-2.22,0-3.89,0-7.77,0-11.66,0-.11-.02-.22-.03-.39Z"
                            />
                            <path
                                d="M34.17,9.91c.81,0,1.04,.23,1.04,1.04,0,4.79,0,9.57,0,14.36v2.74c.13-.09,.2-.13,.25-.18,.81-.65,1.62-1.32,2.44-1.96,.24-.19,.33-.39,.33-.7,0-5.51,0-11.03,0-16.54,0-1.22-.57-1.79-1.8-1.79-7.25,0-14.49,0-21.74,0h-.37c-.21,1.04-.42,2.02-.63,3.03h.39c6.69,0,13.38,0,20.07,0Z"
                            />
                            <path
                                d="M13.2,6.66C13.22,2.98,10.29,.02,6.61,0,3.01-.02,.02,2.94,0,6.53c-.02,3.67,2.9,6.65,6.54,6.68,3.66,.03,6.64-2.91,6.66-6.55Zm-7.54,3.66c-1.09-.94-2.18-1.88-3.26-2.84-.43-.38-.46-.9-.13-1.26,.36-.39,.84-.38,1.29,.01,.65,.56,1.3,1.13,1.95,1.69,.32,.28,.49,.26,.75-.09,1.12-1.54,2.24-3.07,3.36-4.61,.26-.36,.6-.5,1-.37,.35,.11,.59,.44,.59,.93-.04,.09-.1,.3-.21,.46-1.09,1.51-2.19,3.02-3.28,4.52-.35,.48-.7,.97-1.06,1.44-.28,.37-.65,.42-1,.12Z"
                            />
                            <path
                                d="M25.41,37.5c.93,1.17,1.84,2.3,2.76,3.46,.17-.13,.31-.24,.45-.36,4.37-3.53,8.73-7.06,13.1-10.59,.12-.1,1.07-.91,1.52-1.25-.91-1.16-1.81-2.32-2.72-3.48-5.06,4.09-10.08,8.15-15.12,12.22Z"
                            />
                            <path d="M10.72,19.18h.22c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-.22c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" />
                            <path d="M15.05,19.18h13.52c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H15.05c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" />
                            <path d="M10.72,25.33h.22c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-.22c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" />
                            <path d="M15.05,25.33h13.52c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H15.05c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" />
                            <path d="M10.72,31.48h.22c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-.22c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" />
                            <path d="M15.05,31.48h13.52c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H15.05c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z" />
                            <path
                                d="M23.33,42.54c1.28-.27,2.56-.56,3.83-.85,.09-.02,.18-.07,.3-.11-.93-1.15-1.83-2.27-2.76-3.43-.62,1.34-1.21,2.62-1.79,3.91-.06,.13-.04,.3-.06,.45,.16,.01,.33,.07,.48,.03Z"
                            />
                            <path
                                d="M12.45,42.2c.79,.68,1.98,.35,2.78-.16,.04-.03,.09-.06,.13-.09,.1,.2,.25,.37,.48,.48,.8,.39,1.68-.05,2.38-.67,.04,.08,.08,.15,.15,.2,.33,.3,.75,.21,1.11,0,.32,.35,.78,.55,1.26,.54,.36,.26,.81,.26,1.29,.18,.69-.12,.4-1.16-.29-1.05-.09,.01-.17,.02-.26,.02-.07,0-.17-.08-.1,.01-.15-.21-.36-.31-.61-.25-.28,.06-.54-.13-.61-.39-.11-.4-.62-.52-.91-.24h0c.02-.12,.04-.24,.06-.36,.14-.6-.65-.94-.99-.42-.22,.34-.48,.64-.78,.9-.27,.24-.69,.57-1.07,.57-.18,0-.16-.03-.17-.21,0-.07,0-.14,0-.22,.35-.47,.59-1.02,.68-1.6,.07-.48-.51-.99-.91-.53-.42,.49-.71,1.06-.81,1.7-.16,.19-.35,.35-.56,.49-.33,.21-.75,.4-1.15,.4-.43,0-.61-.39-.65-.77-.09-.86,.27-2.02,.95-2.59,.48-.4,1.52-.76,2.1-.36,.58,.4,1.12-.54,.55-.94-.75-.52-1.97-.3-2.73,.07-.92,.45-1.49,1.33-1.76,2.3-.27,.98-.4,2.26,.46,2.99Zm6.76-.9v.04h0v-.04h0Z"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'notification-info'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.56 23.56">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="11.78" cy="11.78" r="11.78" />
                        <path
                            class="cls-2"
                            d="M11.78,3.65a8.14,8.14,0,1,0,8.14,8.13A8.13,8.13,0,0,0,11.78,3.65ZM13,16.34a1.15,1.15,0,0,1-1.15,1.14h-.22a1.14,1.14,0,0,1-1.14-1.14v-5.4A1.14,1.14,0,0,1,11.67,9.8h.22A1.15,1.15,0,0,1,13,10.94ZM11.78,8.59A1.26,1.26,0,1,1,13,7.34,1.25,1.25,0,0,1,11.78,8.59Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'notification-warning'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.56 23.56">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="11.78" cy="11.78" r="11.78" />
                        <path
                            class="cls-2"
                            d="M19.2,16.09,12.71,3.85a1,1,0,0,0-1.86,0C10,5.58,9,7.28,8.13,9L4.36,16.11a.83.83,0,0,0,.71,1.28h13.4A.83.83,0,0,0,19.2,16.09Zm-7.43.07a.94.94,0,0,1-.92-.94.92.92,0,0,1,.94-.92.93.93,0,0,1,0,1.86Zm.67-3.55c0,.16,0,.32,0,.48,0,.37-.18.5-.61.51s-.59-.12-.62-.51C11,11.38,10.88,9.66,10.73,8c0-.14,0-.28,0-.42a1,1,0,0,1,1.06-1.07,1,1,0,0,1,1.09,1.07Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'notification-alert'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.56 23.56">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="11.78" cy="11.78" r="11.78" />
                        <path
                            class="cls-2"
                            d="M17.08,16a9.3,9.3,0,0,1-.72-1.76A9,9,0,0,1,16,11.69c0-.61,0-1.23,0-1.84a3.83,3.83,0,0,0-.09-.69,4.33,4.33,0,0,0-1.09-2.11,4.12,4.12,0,0,0-1.37-1,3.81,3.81,0,0,0-1.2-.32c-.11,0-.11,0-.11-.13V4.89a.38.38,0,1,0-.76,0v.77c0,.09,0,.09-.09.1l-.2,0a4.08,4.08,0,0,0-1.68.66A4.28,4.28,0,0,0,7.94,8.16,4,4,0,0,0,7.54,10c0,.55,0,1.1,0,1.64a10.53,10.53,0,0,1-.07,1.26A8.16,8.16,0,0,1,7,14.78a8.56,8.56,0,0,1-1,2,.5.5,0,0,0-.08.2.39.39,0,0,0,.39.42H9.71c.07,0,.1,0,.12.08a1.72,1.72,0,0,0,.4.81,1.92,1.92,0,0,0,1.08.68,2,2,0,0,0,1.35-.15,2,2,0,0,0,.91-.88,1.42,1.42,0,0,0,.16-.45c0-.08,0-.09.12-.09h3.43a.37.37,0,0,0,.35-.2.38.38,0,0,0,0-.42A9.13,9.13,0,0,1,17.08,16ZM8,14.33c.08-.3.15-.6.2-.9a9.1,9.1,0,0,0,.13-1.28c0-.69,0-1.37,0-2.06a3.91,3.91,0,0,1,.16-1.18,3.32,3.32,0,0,1,.54-1,3.69,3.69,0,0,1,.65-.66,3.42,3.42,0,0,1,1.64-.69,3.35,3.35,0,0,1,2.8.85,3.56,3.56,0,0,1,1.15,2.17,3.52,3.52,0,0,1,0,.56c0,.65,0,1.3,0,2a8.47,8.47,0,0,0,.09,1.13,10.8,10.8,0,0,0,.24,1.13c0,.08,0,.09-.07.09H8C7.94,14.4,7.93,14.38,8,14.33Zm5,3.19A1.25,1.25,0,0,1,11,18a1.27,1.27,0,0,1-.34-.48c0-.07,0-.07.05-.07h2.23C13,17.44,13,17.44,13,17.52Zm3.54-.84H7s-.06,0-.07,0,0-.05,0-.07a10.51,10.51,0,0,0,.63-1.31s0-.07,0-.11,0,0,.06,0h8c.11,0,.12,0,.16.11a8.82,8.82,0,0,0,.61,1.28s0,0,0,0S16.6,16.68,16.49,16.68Z"
                        />
                        <path
                            class="cls-2"
                            d="M20.36,11.2a5.21,5.21,0,0,0-.46-1.64,5.12,5.12,0,0,0-1-1.51.38.38,0,0,0-.55,0,.39.39,0,0,0,0,.54,5.15,5.15,0,0,1,.43.5,4.66,4.66,0,0,1,.47.77,4.6,4.6,0,0,1,.4,2.45,4.64,4.64,0,0,1-.51,1.62,3.49,3.49,0,0,1-.43.65c-.07.09-.11.22-.25.25h0c0,.07,0,.09-.08.12a.45.45,0,0,0-.14.33.34.34,0,0,0,.22.33.37.37,0,0,0,.4-.06c.08-.09.17-.17.24-.26a4.84,4.84,0,0,0,.88-1.35,5.36,5.36,0,0,0,.45-2.21C20.38,11.59,20.38,11.39,20.36,11.2Z"
                        />
                        <path
                            class="cls-2"
                            d="M4.89,14.57a4.34,4.34,0,0,1-.76-1.46,4.29,4.29,0,0,1-.19-1.59,4.11,4.11,0,0,1,.2-1.1,4.41,4.41,0,0,1,1.1-1.83.33.33,0,0,0,.12-.26A.39.39,0,0,0,5.13,8a.39.39,0,0,0-.42.1,5.82,5.82,0,0,0-.46.53,5.15,5.15,0,0,0-.67,1.16,5.4,5.4,0,0,0-.41,2,5.52,5.52,0,0,0,.06.81,5.41,5.41,0,0,0,.58,1.74,5.1,5.1,0,0,0,.57.83,2.53,2.53,0,0,0,.38.42.36.36,0,0,0,.4,0A.38.38,0,0,0,5.24,15C5.12,14.84,5,14.71,4.89,14.57Z"
                        />
                        <path
                            class="cls-2"
                            d="M6.35,14.42a.38.38,0,0,0,.11-.5c0-.07-.11-.13-.16-.19A2.62,2.62,0,0,1,5.8,13a2.85,2.85,0,0,1-.2-1.73,2.89,2.89,0,0,1,.8-1.51.39.39,0,0,0,0-.53.38.38,0,0,0-.55,0,4.32,4.32,0,0,0-.34.39,3.76,3.76,0,0,0-.73,2.25c0,.07,0,.18,0,.3a3.74,3.74,0,0,0,.5,1.53,2.64,2.64,0,0,0,.33.47l.19.21A.39.39,0,0,0,6.35,14.42Z"
                        />
                        <path
                            class="cls-2"
                            d="M17.13,13.88a.37.37,0,0,0,0,.5.36.36,0,0,0,.51,0,3.19,3.19,0,0,0,.56-.71,3.76,3.76,0,0,0,.51-1.52,3.68,3.68,0,0,0-1.06-3,.35.35,0,0,0-.36-.09.37.37,0,0,0-.15.65,3,3,0,0,1,.64,1A3,3,0,0,1,18,11.88a2.8,2.8,0,0,1-.75,1.86Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'phonetel'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.48 50.03">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M31.47,3.86A3.63,3.63,0,0,0,27.6,0C19.75,0,11.89.05,4,0A3.86,3.86,0,0,0,0,4C.07,10.66,0,17.28,0,23.9H0Q0,34,0,44a6,6,0,0,0,4.66,5.8A11.91,11.91,0,0,0,7.54,50c5.93,0,11.87,0,17.8,0a6.3,6.3,0,0,0,1.88-.28,6.06,6.06,0,0,0,4.25-6q0-6.81,0-13.61Q31.48,17,31.47,3.86Zm-13,41.89H13a1.17,1.17,0,0,1-1.31-1.2c0-.77.49-1.21,1.35-1.21s1.84,0,2.76,0,1.8,0,2.7,0a1.21,1.21,0,0,1,1.33,1.19A1.22,1.22,0,0,1,18.5,45.75ZM26.07,39q-10.33,0-20.66,0c-.49,0-.58-.16-.58-.61q0-14.19,0-28.39c0-.89,0-1.77,0-2.65,0-.48.19-.67.69-.67q10.27,0,20.56,0c.39,0,.54.16.55.51V22.91q0,7.72,0,15.46C26.66,38.83,26.54,39,26.07,39Z"
                        />
                        <path
                            class="cls-1"
                            d="M20,17l-5.15,6-3.37-3.63a1.37,1.37,0,0,0-2,1.86L13.87,26a1.36,1.36,0,0,0,1,.44h0a1.35,1.35,0,0,0,1-.48l6.15-7.17A1.37,1.37,0,1,0,20,17Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'copypaste'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2z" />
            </svg>
        </template>
        <template v-if="icon === 'download'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M16 11h5l-9 10-9-10h5v-11h8v11zm1 11h-10v2h10v-2z" />
            </svg>
        </template>
        <template v-if="icon === 'cv'">
            <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 60 60"
                style="enable-background: new 0 0 60 60"
                xml:space="preserve"
            >
                <g fill="#D5D8E2">
                    <path d="M34.5,37c0.552,0,1-0.447,1-1s-0.448-1-1-1h-17c-0.552,0-1,0.447-1,1s0.448,1,1,1H34.5z" />
                    <path d="M44.5,30h-7c-0.552,0-1,0.447-1,1s0.448,1,1,1h7c0.552,0,1-0.447,1-1S45.052,30,44.5,30z" />
                    <path d="M21.5,31c0,0.553,0.448,1,1,1h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10C21.948,30,21.5,30.447,21.5,31z" />
                    <path
                        d="M16.79,30.29c-0.18,0.189-0.29,0.449-0.29,0.71c0,0.26,0.11,0.52,0.29,0.7c0.18,0.189,0.44,0.3,0.71,0.3
		s0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71C17.84,29.92,17.15,29.93,16.79,30.29z"
                    />
                    <path
                        d="M38.79,35.29c-0.18,0.189-0.29,0.439-0.29,0.71c0,0.27,0.1,0.52,0.29,0.71C38.98,36.89,39.24,37,39.5,37
		c0.26,0,0.52-0.11,0.71-0.29c0.19-0.19,0.29-0.44,0.29-0.71c0-0.261-0.11-0.521-0.29-0.71C39.83,34.92,39.17,34.92,38.79,35.29z"
                    />
                    <path
                        d="M43.79,35.29c-0.18,0.189-0.29,0.439-0.29,0.71c0,0.27,0.1,0.52,0.29,0.71C43.98,36.89,44.24,37,44.5,37
		c0.26,0,0.52-0.11,0.71-0.3c0.19-0.19,0.29-0.44,0.29-0.7c0-0.261-0.11-0.521-0.29-0.71C44.83,34.92,44.17,34.92,43.79,35.29z"
                    />
                    <path
                        d="M23.025,40.166c-2.19,1.14-2.927,3.321-3.196,5.582c-0.414-0.347-0.828-0.693-1.242-1.04
		c-0.98-0.821-2.402,0.586-1.414,1.415c0.935,0.783,1.871,1.567,2.806,2.351c0.658,0.551,1.676,0.203,1.707-0.707
		c0.073-2.166,0.175-4.742,2.348-5.873C25.177,41.299,24.166,39.572,23.025,40.166z"
                    />
                    <path
                        d="M36.455,44.108c-1.458-0.092-3.592,2.155-4.716,0.153c-0.26-0.464-0.913-0.638-1.368-0.359
		c-1.416,0.869-3.267,2.119-4.756,0.5c-0.873-0.949-2.285,0.468-1.414,1.414c1.87,2.033,4.276,1.415,6.399,0.263
		c0.478,0.535,1.071,0.926,1.837,1.081c0.792,0.16,4.025-1.141,4.2-0.901c0.752,1.029,2.488,0.032,1.727-1.009
		C37.847,44.543,37.371,44.166,36.455,44.108z"
                    />
                    <path
                        d="M28.666,23.963l0.674-0.479l-0.344-0.752c-0.312-0.682-0.813-1.212-1.45-1.532l-2.12-1.082
		c0.975-0.623,1.676-1.561,2.095-2.801c0.684-0.417,1.115-1.158,1.115-1.984v-0.667c0-0.677-0.294-1.308-0.794-1.745
		c-0.357-1.898-1.644-3.951-5.54-3.951c-0.153,0-0.303,0.006-0.451,0.018c-0.523,0.043-1.285,0-1.937-0.438
		c-0.303-0.204-0.458-0.362-0.534-0.459c-0.317-0.403-0.849-0.544-1.324-0.35c-0.474,0.195-0.752,0.669-0.694,1.179
		c0.03,0.257,0.073,0.557,0.138,0.884c0.084,0.42,0.089,0.541,0.086,0.573c-0.008,0.035-0.066,0.159-0.112,0.259
		c-0.07,0.15-0.156,0.335-0.257,0.582c-0.217,0.529-0.375,1.105-0.471,1.719c-0.489,0.438-0.778,1.063-0.778,1.73v0.667
		c0,0.826,0.431,1.567,1.115,1.984c0.417,1.235,1.115,2.171,2.083,2.793l-2.204,1.087c-0.613,0.334-1.091,0.867-1.382,1.541
		l-0.32,0.741l0.656,0.469C17.797,25.291,20.004,26,22.302,26C24.592,26,26.792,25.296,28.666,23.963z M18.016,22.907l2.445-1.204
		c0.519-0.257,0.842-0.776,0.842-1.355v-1.422l-0.604-0.261c-0.912-0.392-1.506-1.151-1.819-2.321l-0.143-0.533l-0.527-0.164
		c-0.116-0.036-0.24-0.149-0.24-0.313v-0.667c0-0.142,0.095-0.242,0.184-0.289l0.469-0.25l0.055-0.529
		c0.062-0.595,0.193-1.14,0.391-1.622c0.086-0.211,0.16-0.368,0.22-0.497c0.155-0.332,0.249-0.578,0.283-0.855
		c0.73,0.305,1.559,0.425,2.44,0.358c0.095-0.008,0.192-0.012,0.291-0.012c2.919,0,3.469,1.334,3.622,2.638l0.061,0.523l0.466,0.245
		c0.089,0.047,0.185,0.147,0.185,0.29v0.667c0,0.164-0.125,0.277-0.24,0.313l-0.527,0.164l-0.143,0.533
		c-0.313,1.17-0.908,1.93-1.819,2.321l-0.604,0.261v1.428c0,0.57,0.315,1.086,0.825,1.347l2.415,1.233
		C23.923,24.343,20.628,24.334,18.016,22.907z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_validated'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <path
                        class="st1"
                        d="M35.7,18.8c-0.4,0-0.9-0.2-1.2-0.5l-5.2-5.6c-0.6-0.7-0.5-1.7,0.1-2.3c0.6-0.6,1.6-0.5,2.2,0.1l4,4.3l6-7
                        c0.5-0.8,1.5-1,2.2-0.5c0.8,0.5,1,1.5,0.5,2.2c-0.1,0.1-0.2,0.3-0.3,0.4l-7.2,8.4C36.6,18.6,36.2,18.8,35.7,18.8L35.7,18.8z"
                    />
                </g>
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
                        c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9c0,0.2,0.1,0.4,0.3,0.4c0.6,0.2,1.2,0.4,1.8,0.5
                        c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
                        C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1c0,0,0,0,0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3
                        C8.8,10.3,8.8,10.3,8.8,10.3L8.8,10.3z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_rejectedByCompany'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <g>
                        <path
                            class="st0"
                            d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
                            c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9C0,21.8,0.1,22,0.3,22c0.6,0.2,1.2,0.4,1.8,0.5
                            c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
                            C17.6,18.8,17.6,18.7,17.6,18.7z"
                        />
                    </g>
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1l0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3L8.8,10.3
                        L8.8,10.3z"
                    />
                </g>
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <g class="st1">
                        <path
                            class="st2"
                            d="M30.9,8l3.3,5.1V8c0-0.3,0.1-0.6,0.2-0.7S34.8,7,35,7c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.7v6.8
                            c0,0.8-0.3,1.1-0.9,1.1c-0.2,0-0.3,0-0.4-0.1s-0.2-0.1-0.4-0.2s-0.2-0.2-0.3-0.3s-0.2-0.3-0.3-0.4l-3.3-5v5c0,0.3-0.1,0.6-0.2,0.7
                            s-0.3,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.6-0.3s-0.2-0.4-0.2-0.7V8.2c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.3,0.4-0.4S29.5,7,29.7,7
                            C29.8,7,30,7,30.1,7s0.2,0.1,0.3,0.2s0.2,0.2,0.3,0.3S30.8,7.9,30.9,8z"
                        />
                        <path
                            class="st2"
                            d="M40.1,12h-0.6v2.8c0,0.4-0.1,0.6-0.2,0.8s-0.4,0.3-0.6,0.3c-0.3,0-0.5-0.1-0.6-0.3s-0.2-0.4-0.2-0.8V8.2
                            c0-0.4,0.1-0.6,0.3-0.8s0.4-0.3,0.8-0.3h2.8c0.4,0,0.7,0,1,0s0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.3,0.7,0.5s0.4,0.5,0.5,0.7
                            s0.2,0.6,0.2,0.9c0,0.6-0.2,1.2-0.5,1.5s-0.9,0.7-1.6,0.8c0.3,0.2,0.6,0.4,0.9,0.7s0.5,0.7,0.8,1s0.4,0.7,0.5,1s0.2,0.5,0.2,0.6
                            c0,0.1,0,0.2-0.1,0.3s-0.2,0.2-0.3,0.3s-0.3,0.1-0.4,0.1c-0.2,0-0.4,0-0.5-0.1s-0.2-0.2-0.3-0.3S43,15,42.8,14.7l-0.7-1.2
                            c-0.2-0.4-0.5-0.8-0.7-1s-0.4-0.4-0.6-0.5S40.4,12,40.1,12z M41.1,8.4h-1.6v2.4H41c0.4,0,0.8,0,1.1-0.1s0.5-0.2,0.7-0.4
                            S43,9.9,43,9.6c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.3-0.5-0.4C42.1,8.5,41.7,8.4,41.1,8.4z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_rejectedByAgency'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
		c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9C0,21.8,0.1,22,0.3,22c0.6,0.2,1.2,0.4,1.8,0.5
		c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
		C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1l0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3L8.8,10.3
		L8.8,10.3z"
                    />
                </g>
                <g>
                    <path class="st0" d="M36.7,0c-6.5,0-11.8,5.3-11.8,11.8s5.3,11.8,11.8,11.8s11.8-5.3,11.8-11.8S43.2,0,36.7,0L36.7,0z" />
                    <path
                        class="st1"
                        d="M30.9,17.9c0.7,0.6,1.7,0.5,2.4-0.1l3.4-3.6l3.4,3.6c0.6,0.7,1.7,0.7,2.3,0.1l0,0c0.7-0.6,0.7-1.5,0.2-2.2
		c0,0,0,0-0.1-0.1l-3.6-3.8L42.6,8c0.6-0.6,0.6-1.6,0-2.2c0,0,0,0-0.1-0.1c-0.7-0.6-1.7-0.5-2.3,0.1l-3.4,3.6l-3.4-3.6
		c-0.6-0.7-1.7-0.7-2.4-0.1c-0.7,0.6-0.7,1.5-0.2,2.2c0,0,0,0.1,0.1,0.1l3.6,3.8l-3.6,3.8C30.2,16.2,30.2,17.2,30.9,17.9
		C30.9,17.8,30.9,17.8,30.9,17.9z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_proposed'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
		c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9c0,0.2,0.1,0.4,0.3,0.4c0.6,0.2,1.2,0.4,1.8,0.5
		c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
		C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1c0,0,0,0,0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3
		C8.8,10.3,8.8,10.3,8.8,10.3L8.8,10.3z"
                    />
                </g>
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <circle class="st1" cx="30.5" cy="11.8" r="2.2" />
                    <circle class="st1" cx="36.7" cy="11.8" r="2.2" />
                    <circle class="st1" cx="42.8" cy="11.8" r="2.2" />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_reproposed'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
		c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9c0,0.2,0.1,0.4,0.3,0.4c0.6,0.2,1.2,0.4,1.8,0.5
		c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
		C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1c0,0,0,0,0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3
		C8.8,10.3,8.8,10.3,8.8,10.3L8.8,10.3z"
                    />
                </g>
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <circle class="st1" cx="30.5" cy="11.8" r="2.2" />
                    <circle class="st1" cx="36.7" cy="11.8" r="2.2" />
                    <circle class="st1" cx="42.8" cy="11.8" r="2.2" />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_presented'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.4 23.6"
                style="enable-background: new 0 0 48.4 23.6"
                xml:space="preserve"
            >
                <g id="Calque_1-2">
                    <circle class="st0" cx="36.6" cy="11.8" r="11.8" />
                    <circle class="st1" cx="30.5" cy="11.8" r="2.2" />
                    <circle class="st1" cx="36.6" cy="11.8" r="2.2" />
                    <circle class="st1" cx="42.8" cy="11.8" r="2.2" />
                </g>
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
		c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9c0,0.2,0.1,0.4,0.3,0.4c0.6,0.2,1.2,0.4,1.8,0.5
		c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
		C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1c0,0,0,0,0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3
		C8.8,10.3,8.8,10.3,8.8,10.3L8.8,10.3z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_notconfirmed'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <g>
                        <path
                            class="st0"
                            d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
                            c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9C0,21.8,0.1,22,0.3,22c0.6,0.2,1.2,0.4,1.8,0.5
                            c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
                            C17.6,18.8,17.6,18.7,17.6,18.7z"
                        />
                    </g>
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1l0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3L8.8,10.3
                        L8.8,10.3z"
                    />
                </g>
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <g class="st1">
                        <path
                            class="st2"
                            d="M30.9,8l3.3,5.1V8c0-0.3,0.1-0.6,0.2-0.7S34.8,7,35,7c0.2,0,0.4,0.1,0.6,0.2s0.2,0.4,0.2,0.7v6.8
                            c0,0.8-0.3,1.1-0.9,1.1c-0.2,0-0.3,0-0.4-0.1s-0.2-0.1-0.4-0.2s-0.2-0.2-0.3-0.3s-0.2-0.3-0.3-0.4l-3.3-5v5c0,0.3-0.1,0.6-0.2,0.7
                            s-0.3,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.6-0.3s-0.2-0.4-0.2-0.7V8.2c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.3,0.4-0.4S29.5,7,29.7,7
                            C29.8,7,30,7,30.1,7s0.2,0.1,0.3,0.2s0.2,0.2,0.3,0.3S30.8,7.9,30.9,8z"
                        />
                        <path
                            class="st2"
                            d="M45.1,13c0,0.3-0.1,0.6-0.2,0.9s-0.3,0.6-0.6,0.9s-0.7,0.6-1.1,0.7s-1,0.3-1.6,0.3c-0.5,0-0.9,0-1.2-0.1
                            s-0.7-0.2-1-0.4s-0.6-0.4-0.8-0.7c-0.2-0.3-0.4-0.6-0.6-0.9s-0.3-0.7-0.4-1.1s-0.1-0.8-0.1-1.2c0-0.7,0.1-1.3,0.3-1.9
                            s0.5-1,0.9-1.4s0.8-0.7,1.3-0.9s1-0.3,1.6-0.3c0.7,0,1.3,0.1,1.9,0.4s1,0.6,1.2,1S45,9.2,45,9.6c0,0.2-0.1,0.4-0.2,0.5
                            s-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2s-0.2-0.3-0.4-0.5c-0.2-0.4-0.5-0.7-0.8-1S42,8.3,41.5,8.3c-0.7,0-1.3,0.3-1.7,0.8
                            s-0.6,1.3-0.6,2.3c0,0.7,0.1,1.2,0.3,1.7s0.5,0.8,0.8,1s0.7,0.3,1.2,0.3c0.5,0,0.9-0.1,1.3-0.4s0.6-0.6,0.8-1.1
                            c0.1-0.2,0.2-0.4,0.3-0.6s0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2S45.1,12.8,45.1,13z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_declined'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
		c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9c0,0.2,0.1,0.4,0.3,0.4c0.6,0.2,1.2,0.4,1.8,0.5
		c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
		C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1c0,0,0,0,0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3
		C8.8,10.3,8.8,10.3,8.8,10.3L8.8,10.3z"
                    />
                </g>
                <g>
                    <path
                        class="st0"
                        d="M36.7,0c-6.5,0-11.8,5.3-11.8,11.8s5.3,11.8,11.8,11.8s11.8-5.3,11.8-11.8C48.5,5.3,43.2,0,36.7,0
		C36.7,0,36.7,0,36.7,0z"
                    />
                    <path
                        class="st1"
                        d="M30.9,17.9c0.7,0.6,1.7,0.5,2.4-0.1l3.4-3.6l3.4,3.6c0.6,0.7,1.7,0.7,2.3,0.1l0,0c0.7-0.6,0.7-1.5,0.2-2.2
		c0,0,0,0-0.1-0.1l-3.6-3.8L42.6,8c0.6-0.6,0.6-1.6,0-2.2c0,0,0,0-0.1-0.1c-0.7-0.6-1.7-0.5-2.3,0.1l-3.4,3.6l-3.4-3.6
		c-0.6-0.7-1.7-0.7-2.4-0.1c-0.7,0.6-0.7,1.5-0.2,2.2c0,0,0,0.1,0.1,0.1l3.6,3.8l-3.6,3.8C30.2,16.2,30.2,17.2,30.9,17.9
		C30.9,17.8,30.9,17.8,30.9,17.9z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_lost'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
		c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9C0,21.8,0.1,22,0.3,22c0.6,0.2,1.2,0.4,1.8,0.5
		c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
		C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1l0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3L8.8,10.3
		L8.8,10.3z"
                    />
                </g>
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <circle class="st1" cx="30.5" cy="11.8" r="2.2" />
                    <circle class="st1" cx="36.7" cy="11.8" r="2.2" />
                    <circle class="st1" cx="42.8" cy="11.8" r="2.2" />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_confirmed'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g id="Calque_2_00000093154777100040823020000005166616838060460449_">
                    <g id="Calque_1-2">
                        <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    </g>
                </g>
                <g>
                    <path
                        class="st0"
                        d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
                        c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9C0,21.8,0.1,22,0.3,22c0.6,0.2,1.2,0.4,1.8,0.5
                        c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
                        C17.6,18.8,17.6,18.7,17.6,18.7z"
                    />
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1l0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3L8.8,10.3
                        L8.8,10.3z"
                    />
                </g>
                <g class="st1">
                    <path
                        class="st2"
                        d="M32.2,7c0.9,0,1.7,0.2,2.3,0.5s1.1,0.9,1.5,1.5s0.5,1.4,0.5,2.3c0,0.7-0.1,1.3-0.3,1.8s-0.4,1-0.8,1.4
                        s-0.8,0.7-1.3,0.9s-1.1,0.3-1.8,0.3c-0.7,0-1.3-0.1-1.8-0.3s-1-0.5-1.3-0.9s-0.6-0.9-0.8-1.4S28,12,28,11.4c0-0.7,0.1-1.3,0.3-1.8
                        s0.5-1,0.8-1.4s0.8-0.7,1.3-0.9S31.5,7,32.2,7z M34.7,11.4c0-0.6-0.1-1.2-0.3-1.6s-0.5-0.8-0.9-1s-0.8-0.4-1.3-0.4
                        c-0.3,0-0.7,0.1-1,0.2s-0.5,0.3-0.8,0.6s-0.4,0.6-0.5,1s-0.2,0.8-0.2,1.3c0,0.5,0.1,0.9,0.2,1.3s0.3,0.7,0.5,1s0.5,0.5,0.8,0.6
                        s0.6,0.2,1,0.2c0.4,0,0.9-0.1,1.2-0.3s0.7-0.6,0.9-1S34.7,12.1,34.7,11.4z"
                    />
                    <path
                        class="st2"
                        d="M39.7,8v3l3.4-3.6c0.2-0.2,0.3-0.3,0.4-0.4S43.8,7,44,7c0.2,0,0.5,0.1,0.6,0.2s0.2,0.3,0.2,0.5
                        c0,0.3-0.1,0.5-0.4,0.8l-2.1,2l2.4,3.5c0.2,0.2,0.3,0.5,0.4,0.6s0.1,0.4,0.1,0.5c0,0.2-0.1,0.4-0.2,0.5s-0.4,0.2-0.6,0.2
                        c-0.2,0-0.4-0.1-0.6-0.2s-0.3-0.2-0.4-0.4s-0.2-0.3-0.3-0.5l-2.1-3.2L39.7,13v1.8c0,0.4-0.1,0.6-0.2,0.8s-0.4,0.3-0.6,0.3
                        c-0.1,0-0.3,0-0.4-0.1s-0.2-0.2-0.3-0.3C38,15.3,38,15.2,38,15s0-0.4,0-0.6V8c0-0.4,0.1-0.6,0.2-0.8S38.5,7,38.8,7
                        c0.3,0,0.5,0.1,0.6,0.3S39.7,7.7,39.7,8z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_accepted'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50.3 23.6"
                style="enable-background: new 0 0 50.3 23.6"
                xml:space="preserve"
            >
                <g id="Calque_2_00000070114475343717718200000015669993869739603599_">
                    <g>
                        <circle class="st0" cx="38.5" cy="11.8" r="11.8" />
                        <path
                            class="st1"
                            d="M37.5,18.8c-0.4,0-0.9-0.2-1.2-0.5l-5.2-5.6c-0.6-0.6-0.6-1.7,0-2.3c0.6-0.6,1.7-0.6,2.3,0c0,0,0,0,0,0l4,4.3
			l6-7c0.6-0.6,1.6-0.6,2.3,0c0.6,0.6,0.6,1.5,0.2,2.1l-7.2,8.4C38.4,18.6,38,18.8,37.5,18.8L37.5,18.8z"
                        />
                    </g>
                    <g>
                        <path
                            class="st0"
                            d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
			c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9c0,0.2,0.1,0.4,0.3,0.4c0.6,0.2,1.2,0.4,1.8,0.5
			c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
			C17.6,18.8,17.6,18.7,17.6,18.7z"
                        />
                        <path
                            class="st0"
                            d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1c0,0,0,0,0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3
			C8.8,10.3,8.8,10.3,8.8,10.3L8.8,10.3z"
                        />
                    </g>
                    <rect x="70.3" y="-2.6" class="st0" width="7.3" height="10.9" />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_aborted'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 48.5 23.6"
                style="enable-background: new 0 0 48.5 23.6"
                xml:space="preserve"
            >
                <g>
                    <g>
                        <path
                            class="st0"
                            d="M17.6,18.7c0,0,0-0.1,0-0.3c0-1-0.2-2-0.7-2.9c-1.1-2.3-3.4-3.8-5.9-3.8c-1.4,0-2.8,0-4.2,0
                            c-1.6,0-3.1,0.5-4.3,1.5c-1.4,1.1-2.3,2.7-2.4,4.5c-0.1,1.9,0,2-0.1,3.9C0,21.8,0.1,22,0.3,22c0.6,0.2,1.2,0.4,1.8,0.5
                            c2,0.5,4.1,0.8,6.1,0.9c1.6,0.1,3.3,0,4.9-0.3c1.4-0.2,2.8-0.6,4.1-1.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.8,0-1.6,0-2.5
                            C17.6,18.8,17.6,18.7,17.6,18.7z"
                        />
                    </g>
                    <path
                        class="st0"
                        d="M8.8,10.3c2.8,0,5.1-2.3,5.2-5.1l0,0C14,2.3,11.7,0,8.8,0S3.6,2.3,3.6,5.1C3.6,8,5.9,10.3,8.8,10.3L8.8,10.3
                        L8.8,10.3z"
                    />
                </g>
                <g>
                    <circle class="st0" cx="36.7" cy="11.8" r="11.8" />
                    <path
                        class="st1"
                        d="M35.5,13.2l-0.4-5.3C35,6.8,35,6,35,5.6c0-0.6,0.2-1.1,0.5-1.4c0.3-0.3,0.7-0.5,1.3-0.5c0.6,0,1.1,0.2,1.3,0.7
                        c0.2,0.4,0.3,1.1,0.3,1.9c0,0.5,0,1-0.1,1.5l-0.5,5.5c-0.1,0.7-0.2,1.2-0.3,1.5s-0.5,0.5-0.8,0.5c-0.4,0-0.7-0.2-0.8-0.5
                        S35.5,13.9,35.5,13.2z M36.7,20.5c-0.5,0-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.7-0.5,1.2-0.5
                        s0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2C37.5,20.4,37.2,20.5,36.7,20.5z"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'workerStatus_placed'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.38 37.96">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            d="M18.29,29.19,16.46,31.4c3.37.47,5.16,1.41,5.41,1.89-.33.65-3.54,2.17-9.68,2.17S2.71,33.88,2.5,33.33c.16-.47,2-1.45,5.42-1.93L6.09,29.19c-3.45.69-6.09,2-6.09,4.1C0,36.5,6.32,38,12.19,38s12.19-1.46,12.19-4.67C24.38,31.22,21.74,29.88,18.29,29.19Z"
                        />
                        <path d="M22.9,22.75c0,.13,0,0,0,0Z" />
                        <path
                            d="M1.5,24.36a.46.46,0,0,0,.39.53c.75.21,1.49.44,2.24.63s1.52.36,2.28.51a.36.36,0,0,0,0,.09l5.14,6.72a.72.72,0,0,0,1.2,0l5-6.6a17.9,17.9,0,0,0,4.68-1.4.6.6,0,0,0,.39-.65c0-1,0,0,0-1v-.41c0-.05,0-.14,0-.33a8.1,8.1,0,0,0-8-8.1c-1.71-.06-3.42,0-5.12,0A8,8,0,0,0,4.5,16.12a7.65,7.65,0,0,0-2.93,5.46A16.15,16.15,0,0,0,1.5,24.36Z"
                        />
                        <path d="M12.19,12.56a6.24,6.24,0,0,0,6.29-6.25,6.29,6.29,0,1,0-6.29,6.25Z" />
                    </g>
                </g>
            </svg>
        </template>

        <template v-if="icon === 'leftArrow'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.59 17.18">
                <g id="Calque_2" data-name="Calque 2" transform="rotate(180,5.292506,8.5942073)">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="m 2,17.18 a 2,2 0 0 1 -1.41,-0.59 2,2 0 0 1 0,-2.83 L 5.76,8.59 0.59,3.41 a 2,2 0 0 1 0,-2.82 2,2 0 0 1 2.82,0 L 10,7.18 A 2,2 0 0 1 10,10 L 3.41,16.59 A 2,2 0 0 1 2,17.18 Z"
                            id="path2"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'company'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.57 29.03">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            d="M23.32,26.53H21.59V14.94c.05-.34,0-.91,0-1.48q0-5.4,0-10.8a.8.8,0,0,0-.83-.83h-.61c-.45,0-.66-.63-.68-1.09S19.28,0,18.72,0L15.55,0,11.84,0c-.5,0-.71.23-.68.74s-.26,1.1-.61,1.11c-1,0-1.92,0-2.89,0-1.2,0-2.41,0-3.62,0a1,1,0,0,0-.93.53,1.2,1.2,0,0,0-.15.7Q3,9.78,3,16.51c0,3.34,0,6.68,0,10H1.25a1.25,1.25,0,0,0,0,2.5H23.32a1.25,1.25,0,0,0,0-2.5ZM6.24,22c0-.27,0-.53,0-.79a.56.56,0,0,1,.6-.62h1.7a.55.55,0,0,1,.6.59c0,.57,0,1.15,0,1.73a.55.55,0,0,1-.58.57q-.87,0-1.74,0a.56.56,0,0,1-.58-.6C6.23,22.63,6.24,22.33,6.24,22Zm4.67-.79a.56.56,0,0,1,.63-.62h1.64c.41,0,.62.22.63.65v1.64a.57.57,0,0,1-.58.61c-.58,0-1.16,0-1.74,0a.55.55,0,0,1-.58-.6C10.9,22.36,10.9,21.81,10.91,21.25Zm7.51.43v1.21a.58.58,0,0,1-.59.64c-.58,0-1.16,0-1.74,0a.56.56,0,0,1-.58-.61c0-.55,0-1.11,0-1.67a.57.57,0,0,1,.64-.61h1.64a.58.58,0,0,1,.63.62ZM15.51,16.4a.56.56,0,0,1,.59-.6c.59,0,1.17,0,1.76,0a.53.53,0,0,1,.55.54c0,.62,0,1.24,0,1.85a.56.56,0,0,1-.59.51H16.11a.57.57,0,0,1-.6-.59Q15.5,17.26,15.51,16.4Zm.58-10.13H17.8a.57.57,0,0,1,.62.6c0,.57,0,1.13,0,1.7a.54.54,0,0,1-.56.59q-.88,0-1.77,0a.56.56,0,0,1-.57-.58q0-.87,0-1.74A.57.57,0,0,1,16.09,6.27Zm.05,4.84h1.64a.59.59,0,0,1,.64.65v1.61c0,.45-.21.64-.65.64H16.16a.58.58,0,0,1-.65-.63c0-.54,0-1.08,0-1.61A.59.59,0,0,1,16.14,11.11Zm-2.33,5.33v.85h0c0,.27,0,.54,0,.82a.55.55,0,0,1-.59.59c-.57,0-1.14,0-1.7,0a.55.55,0,0,1-.6-.56q0-.9,0-1.8a.51.51,0,0,1,.52-.53c.62,0,1.24,0,1.85,0a.55.55,0,0,1,.53.57Zm0-3a.55.55,0,0,1-.59.59H11.54a.57.57,0,0,1-.63-.61c0-.56,0-1.12,0-1.67a.57.57,0,0,1,.61-.62h1.7a.55.55,0,0,1,.58.6Q13.82,12.56,13.8,13.42ZM11.54,6.26h1.67a.55.55,0,0,1,.59.59c0,.57,0,1.13,0,1.7a.55.55,0,0,1-.58.61c-.58,0-1.15,0-1.73,0a.55.55,0,0,1-.58-.61c0-.55,0-1.11,0-1.67A.57.57,0,0,1,11.54,6.26Zm-5.3.58a.55.55,0,0,1,.58-.57H8.55a.56.56,0,0,1,.59.57c0,.58,0,1.17,0,1.76a.53.53,0,0,1-.53.56q-.91,0-1.83,0a.55.55,0,0,1-.54-.58Q6.23,7.71,6.24,6.84Zm0,4.87a.57.57,0,0,1,.57-.6H8.57a.56.56,0,0,1,.57.6c0,.57,0,1.15,0,1.73a.56.56,0,0,1-.59.57H6.82a.54.54,0,0,1-.58-.6v-.82C6.24,12.3,6.23,12,6.24,11.71Zm.59,4.09q.86,0,1.71,0a.57.57,0,0,1,.61.62c0,.55,0,1.11,0,1.67a.58.58,0,0,1-.62.61H7.68c-.29,0-.57,0-.86,0a.57.57,0,0,1-.58-.58c0-.57,0-1.13,0-1.7A.59.59,0,0,1,6.83,15.8Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'info'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.96 12.96">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M7,13H6a1.28,1.28,0,0,0-.39-.07A6.48,6.48,0,0,1,.18,8C.1,7.66.08,7.31,0,7V6a1.06,1.06,0,0,0,.06-.39A6.51,6.51,0,0,1,5,.18C5.29.1,5.64.08,6,0H7s.11,0,.16,0A6.49,6.49,0,0,1,12.78,5c.08.34.1.68.18,1V7c-.08.34-.1.69-.19,1A6.43,6.43,0,0,1,8,12.77C7.68,12.86,7.32,12.88,7,13ZM6.47,1.05A5.43,5.43,0,1,0,11.9,6.49,5.45,5.45,0,0,0,6.47,1.05Z"
                        />
                        <path
                            class="cls-1"
                            d="M7.39,7.33c0,.74,0,1.48,0,2.22,0,.15,0,.19.19.19.41,0,.41,0,.4.42,0,.18.08.42,0,.54s-.35,0-.54,0H5c-.11,0-.16,0-.16-.15s0-.48,0-.73c0-.09,0-.13.14-.13h.44c.1,0,.14,0,.14-.13V6.09c0-.11,0-.15-.14-.14H5c-.09,0-.14,0-.14-.13,0-.27,0-.53,0-.8,0-.11,0-.13.14-.13H7.24c.15,0,.15.08.15.18Z"
                        />
                        <path class="cls-1" d="M6.46,4.17a.89.89,0,0,1-.94-.92.91.91,0,0,1,1-.9.9.9,0,0,1,1,.91A.91.91,0,0,1,6.46,4.17Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'agency'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.68 22.68">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            d="M22,22.68H.72A1.08,1.08,0,0,1,0,21.54q0-6.9,0-13.81a1.28,1.28,0,0,1,.4-1Q3.6,3.59,6.77.4a1.28,1.28,0,0,1,1-.4h7.19a1.34,1.34,0,0,1,1,.42q3.12,3.15,6.26,6.26a2.12,2.12,0,0,1,.47.64V22A1.09,1.09,0,0,1,22,22.68Zm-20-8.36v6.11c0,.33,0,.34.33.34q5.31,0,10.63,0c.32,0,.33,0,.33-.34V8.26a.69.69,0,0,0-.2-.51Q10.39,5.14,7.78,2.52c-.21-.2-.21-.2-.42,0L2.15,7.73a.71.71,0,0,0-.23.55C1.93,10.29,1.92,12.31,1.92,14.32Zm18.86.32c0-1.93,0-3.86,0-5.79,0-.32,0-.33-.32-.33h-5c-.32,0-.34,0-.34.34V20.43c0,.33,0,.34.35.34q2.46,0,4.92,0c.35,0,.36,0,.36-.35ZM10,2a.37.37,0,0,0,.13.17l4.29,4.29a.6.6,0,0,0,.47.19c1.42,0,2.83,0,4.25,0h.15c.09,0,.11,0,.05-.11l-.11-.11L14.94,2.12a.64.64,0,0,0-.49-.2c-1.42,0-2.83,0-4.25,0A.34.34,0,0,0,10,2Z"
                        />
                        <path d="M7.57,8.52h-1a.94.94,0,0,1-.94-.9.92.92,0,0,1,.87-1q1,0,2,0a.94.94,0,0,1,.88,1,1,1,0,0,1-1,.92Z" />
                        <path d="M5.21,13.26H4.74a1,1,0,1,1,0-1.91h.91a1,1,0,0,1,1,.92,1,1,0,0,1-.92,1H5.21Z" />
                        <path d="M5.2,17c-.15,0-.31,0-.46,0a1,1,0,0,1-.07-1.9,7.5,7.5,0,0,1,1.06,0A1,1,0,0,1,5.67,17C5.51,17,5.36,17,5.2,17Z" />
                        <path d="M9.94,11.34h.47a1,1,0,0,1,.95.89.94.94,0,0,1-.87,1,6.86,6.86,0,0,1-1.11,0,.93.93,0,0,1-.87-1,1,1,0,0,1,1-.9Z" />
                        <path
                            d="M9.92,17c-.15,0-.31,0-.46,0a.94.94,0,0,1-1-.91.93.93,0,0,1,.89-1,6.25,6.25,0,0,1,1.06,0,1,1,0,0,1-.05,1.9C10.25,17,10.09,17,9.92,17Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'forbidden'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.56 23.56">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path d="M11.78,0A11.78,11.78,0,1,0,23.56,11.78,11.77,11.77,0,0,0,11.78,0Z" />
                        <path
                            class="cls-1"
                            d="M11.78,2.85a8.94,8.94,0,1,0,8.94,8.93A8.93,8.93,0,0,0,11.78,2.85ZM5.35,11.78A6.41,6.41,0,0,1,6.44,8.2l8.92,8.93a6.43,6.43,0,0,1-10-5.35Zm11.78,3.58L8.2,6.44a6.43,6.43,0,0,1,8.93,8.92Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'reload'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M23 12c0 1.042-.154 2.045-.425 3h-2.101c.335-.94.526-1.947.526-3 0-4.962-4.037-9-9-9-1.706 0-3.296.484-4.655 1.314l1.858 2.686h-6.994l2.152-7 1.849 2.673c1.684-1.049 3.659-1.673 5.79-1.673 6.074 0 11 4.925 11 11zm-6.354 7.692c-1.357.826-2.944 1.308-4.646 1.308-4.962 0-9-4.038-9-9 0-1.053.191-2.06.525-3h-2.1c-.271.955-.425 1.958-.425 3 0 6.075 4.925 11 11 11 2.127 0 4.099-.621 5.78-1.667l1.853 2.667 2.152-6.989h-6.994l1.855 2.681z"
                />
            </svg>
        </template>
        <template v-if="icon === 'release'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.95 29.88">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path class="cls-1" d="M2,10.11A1.63,1.63,0,0,0,.48,12.86l0,0h0L3.57,16l4.85-4.85L2,10.09Z" />
                        <path class="cls-1" d="M19.69,27.63h0l-1-6.15-4.83,4.83,3,3,0,0,.13.15a1.63,1.63,0,0,0,2.67-1.77Z" />
                        <path
                            class="cls-1"
                            d="M14.21,17l-1.35-1.35a1.18,1.18,0,0,0-1.66,0L8.73,18.15l-.38.37a1.18,1.18,0,0,0,0,1.66L9.7,21.53a1.16,1.16,0,0,0,.83.34,1.14,1.14,0,0,0,.82-.34l2.86-2.86a1.13,1.13,0,0,0,.34-.82A1.16,1.16,0,0,0,14.21,17Z"
                        />
                        <path
                            class="cls-1"
                            d="M26.29,12.72v0l3.5-10.5a1.42,1.42,0,0,0,.11-.35h0A1.58,1.58,0,0,0,29.49.46,1.61,1.61,0,0,0,28,0h0l-.23.07L17.52,3.49a2,2,0,0,0-1,.5L9.29,11.25,4.07,16.47l-.88.88a2,2,0,0,0,0,2.8l1.2,1.2-.3.59,3.82,3.81.59-.3,1.23,1.24a2,2,0,0,0,2.8,0l.88-.89,5.2-5.19,7.28-7.28A2,2,0,0,0,26.29,12.72ZM11.72,21.89a1.69,1.69,0,0,1-2.39,0L8,20.55a1.69,1.69,0,0,1,0-2.39l.37-.38,2.48-2.47a1.69,1.69,0,0,1,2.39,0l1.34,1.34a1.69,1.69,0,0,1,0,2.39Zm5.11-8.84a3,3,0,1,1,4.3,0A3,3,0,0,1,16.83,13.05Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'development'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.03 32.49">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <rect class="cls-1" x="18.96" y="12.92" width="7.45" height="17.06" />
                        <rect class="cls-1" x="10.22" y="17.79" width="7.45" height="12.19" />
                        <rect class="cls-1" x="1.49" y="21.86" width="7.45" height="8.13" />
                        <path class="cls-1" d="M17.72,2.67l2.39,1.17C15,16,1.68,15,1.68,15c12.91,2.81,18-3.91,21.17-9.36L25.2,7,24,0Z" />
                        <rect class="cls-1" y="31.13" width="28.03" height="1.35" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'beta'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.03 32.22">
                <g>
                    <g>
                        <path
                            class="cls-1"
                            d="M11,0A11,11,0,0,0,5.3,20.42l.32,8.14a2,2,0,0,0,1.67,1.87c.34,1,1.88,1.79,3.72,1.79s3.37-.76,3.73-1.77a2,2,0,0,0,1.86-1.89l.28-8.23A11,11,0,0,0,11,0ZM14.8,29l0,0H7.47a.07.07,0,0,1,0,0v0l7.43-1.43Zm.08-2.2L7.4,28.21l0-1,7.55-1.45Zm0-1.76-7.6,1.47,0-1L15,24Zm1.8-12.84-3.32,5.94-.19,5H15v.13L7.26,24.74,7.2,23.12H8.8l-.18-5L5.3,12.17a.39.39,0,0,1,.06-.46l.08-.07h0a.47.47,0,0,1,.21-.06H16.28l.11,0a.43.43,0,0,1,.19,0A.4.4,0,0,1,16.73,12.17Z"
                        />
                        <path
                            class="cls-1"
                            d="M6.94,13.5h0l.24.43h0l2.17,3.88A.41.41,0,0,1,9.4,18l.19,5.13h2.85L12.63,18a.41.41,0,0,1,0-.18l2.16-3.87h0l.25-.44.64-1.15H6.3Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'instagram'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
            </svg>
        </template>
        <template v-if="icon === 'link'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z" />
            </svg>
        </template>
        <template v-if="icon === 'tiktok'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" />
            </svg>
        </template>
        <template v-if="icon === 'facebook'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.45 18.31">
                <g>
                    <g>
                        <path d="M1.92,18.31H5.6V9.08H8.18L8.45,6H5.6V4.22c0-.72.15-1,.85-1h2V0H5.9c-2.75,0-4,1.21-4,3.52V6H0V9.11H1.92Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'linkedin'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.18 15.19">
                <g>
                    <g>
                        <rect x="0.3" y="5.06" width="3.13" height="10.12" />
                        <path d="M1.85,3.74A1.87,1.87,0,1,0,0,1.87,1.87,1.87,0,0,0,1.85,3.74Z" />
                        <path
                            d="M8.44,9.87c0-1.42.66-2.27,1.91-2.27s1.71.81,1.71,2.27v5.32h3.12V8.78c0-2.72-1.54-4-3.68-4A3.55,3.55,0,0,0,8.44,6.43V5.06h-3V15.19h3Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'add'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.96 22.96">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M11.48,0A11.48,11.48,0,1,0,23,11.48,11.49,11.49,0,0,0,11.48,0Zm0,22A10.48,10.48,0,1,1,22,11.48,10.49,10.49,0,0,1,11.48,22Z"
                        />
                        <polygon
                            class="cls-1"
                            points="13.2 5.87 9.76 5.87 9.76 9.76 5.87 9.76 5.87 13.19 9.76 13.19 9.76 17.09 13.2 17.09 13.2 13.19 17.09 13.19 17.09 9.76 13.2 9.76 13.2 5.87"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'agencyProfile'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.14 30.85">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M1.84,0A1.84,1.84,0,0,0,0,1.84V29a1.84,1.84,0,0,0,1.84,1.84H18.25V27.24a2.89,2.89,0,0,1,2.89-2.89h4V1.84A1.84,1.84,0,0,0,23.3,0Z"
                        />
                        <path class="cls-1" d="M19.3,27.24v2.92l5-4.76h-3.2A1.84,1.84,0,0,0,19.3,27.24Z" />
                        <path class="cls-2" d="M19.26,7.83H5.88a.76.76,0,1,1,0-1.52H19.26a.76.76,0,1,1,0,1.52Z" />
                        <path
                            class="cls-2"
                            d="M19.26,12.33H5.88a.77.77,0,0,1-.77-.77.76.76,0,0,1,.77-.76H19.26a.76.76,0,0,1,.77.76A.77.77,0,0,1,19.26,12.33Z"
                        />
                        <path class="cls-2" d="M13,16.82H5.88a.76.76,0,1,1,0-1.52H13a.76.76,0,0,1,0,1.52Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'agencyProfile2'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path
                    d="M19,0H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V5A5.006,5.006,0,0,0,19,0ZM7,22V21a5,5,0,0,1,10,0v1Zm15-3a3,3,0,0,1-3,3V21A7,7,0,0,0,5,21v1a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2H19a3,3,0,0,1,3,3Z"
                />
                <path d="M12,4a4,4,0,1,0,4,4A4,4,0,0,0,12,4Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,10Z" />
            </svg>
        </template>
        <template v-if="icon === 'agenda'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.43 15.34">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            id="Icon_awesome-calendar-alt"
                            data-name="Icon awesome-calendar-alt"
                            class="cls-1"
                            d="M0,13.91a1.43,1.43,0,0,0,1.44,1.43H12a1.44,1.44,0,0,0,1.44-1.43V5.75H0ZM9.59,8A.36.36,0,0,1,10,7.67h1.2a.36.36,0,0,1,.36.36v1.2a.36.36,0,0,1-.36.36H10a.36.36,0,0,1-.36-.36Zm0,3.84a.36.36,0,0,1,.36-.36h1.2a.36.36,0,0,1,.36.36v1.2a.36.36,0,0,1-.36.35H10a.36.36,0,0,1-.36-.35ZM5.75,8a.37.37,0,0,1,.36-.36h1.2A.36.36,0,0,1,7.67,8v1.2a.36.36,0,0,1-.36.36H6.11a.36.36,0,0,1-.35-.36Zm0,3.84a.37.37,0,0,1,.36-.36h1.2a.36.36,0,0,1,.36.36v1.2a.36.36,0,0,1-.36.35H6.11a.35.35,0,0,1-.35-.35ZM1.92,8a.36.36,0,0,1,.36-.36h1.2A.36.36,0,0,1,3.84,8v1.2a.36.36,0,0,1-.36.36H2.28a.36.36,0,0,1-.36-.36Zm0,3.84a.36.36,0,0,1,.36-.36h1.2a.36.36,0,0,1,.36.36v1.2a.36.36,0,0,1-.36.35H2.28a.36.36,0,0,1-.36-.35ZM12,1.92H10.55V.48A.49.49,0,0,0,10.07,0h-1a.49.49,0,0,0-.48.48V1.92H4.8V.48A.49.49,0,0,0,4.32,0h-1a.48.48,0,0,0-.48.48V1.92H1.44A1.43,1.43,0,0,0,0,3.36H0V4.8H13.43V3.36A1.44,1.44,0,0,0,12,1.92Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'bag'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.86 15.64">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M17.8,4.28A1.7,1.7,0,0,0,16.29,3L16,3h-3.5V2.37A2,2,0,0,0,11.63.65,3,3,0,0,0,10,0c-.42,0-.84,0-1.26,0H8.14A2.71,2.71,0,0,0,7.4.09,2.71,2.71,0,0,0,5.91.92,2,2,0,0,0,5.4,2.27V3H1.93a1.92,1.92,0,0,0-1.5.65A1.65,1.65,0,0,0,0,4.75v3a.75.75,0,0,0,.43.7l.13.06.19.1v5.78a1.47,1.47,0,0,0,0,.21,1.27,1.27,0,0,0,.48.87,1.18,1.18,0,0,0,.39.19l14.51,0,.05,0a1.27,1.27,0,0,0,.72-.51,1.3,1.3,0,0,0,.22-.75V8.57l.09-.05.13-.06a.9.9,0,0,0,.51-.54V4.59ZM7.07,2.36c0-.37.1-.5.46-.61a2.51,2.51,0,0,1,.64-.07H9.78a1.62,1.62,0,0,1,.68.15c.25.11.31.23.33.34a.34.34,0,0,1,0,.11V3H7.07V2.36ZM9.48,9.69v.55H8.38V9.13h1.1v.56ZM4.41,10a14.21,14.21,0,0,0,2.3.56.9.9,0,0,0,0,.23,1.11,1.11,0,0,0,1,.92H10a1.12,1.12,0,0,0,1.16-1s0-.11,0-.18a16.74,16.74,0,0,0,4.1-1.26l.19-.08v4.64h-13V9.24C3.05,9.52,3.71,9.79,4.41,10Zm6.75-1.13v-.1A1.13,1.13,0,0,0,10,7.63H7.77A1.11,1.11,0,0,0,6.71,8.73a.86.86,0,0,1,0,.16A16.86,16.86,0,0,1,5,8.49,20.91,20.91,0,0,1,1.67,7.1l.06-2.44H16.19V7.1a23.84,23.84,0,0,1-2.75,1.19A16.84,16.84,0,0,1,11.16,8.89Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'edit'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path
                    d="M18.656.93,6.464,13.122A4.966,4.966,0,0,0,5,16.657V18a1,1,0,0,0,1,1H7.343a4.966,4.966,0,0,0,3.535-1.464L23.07,5.344a3.125,3.125,0,0,0,0-4.414A3.194,3.194,0,0,0,18.656.93Zm3,3L9.464,16.122A3.02,3.02,0,0,1,7.343,17H7v-.343a3.02,3.02,0,0,1,.878-2.121L20.07,2.344a1.148,1.148,0,0,1,1.586,0A1.123,1.123,0,0,1,21.656,3.93Z"
                />
                <path
                    d="M23,8.979a1,1,0,0,0-1,1V15H18a3,3,0,0,0-3,3v4H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2h9.042a1,1,0,0,0,0-2H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H16.343a4.968,4.968,0,0,0,3.536-1.464l2.656-2.658A4.968,4.968,0,0,0,24,16.343V9.979A1,1,0,0,0,23,8.979ZM18.465,21.122a2.975,2.975,0,0,1-1.465.8V18a1,1,0,0,1,1-1h3.925a3.016,3.016,0,0,1-.8,1.464Z"
                />
            </svg>
        </template>
        <template v-if="icon === 'listcheck'">
            <svg id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
                <path
                    d="m4 6a2.982 2.982 0 0 1 -2.122-.879l-1.544-1.374a1 1 0 0 1 1.332-1.494l1.585 1.414a1 1 0 0 0 1.456.04l3.604-3.431a1 1 0 0 1 1.378 1.448l-3.589 3.414a2.964 2.964 0 0 1 -2.1.862zm20-2a1 1 0 0 0 -1-1h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 1-1zm-17.9 9.138 3.589-3.414a1 1 0 1 0 -1.378-1.448l-3.6 3.431a1.023 1.023 0 0 1 -1.414 0l-1.59-1.585a1 1 0 0 0 -1.414 1.414l1.585 1.585a3 3 0 0 0 4.226.017zm17.9-1.138a1 1 0 0 0 -1-1h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 1-1zm-17.9 9.138 3.585-3.414a1 1 0 1 0 -1.378-1.448l-3.6 3.431a1 1 0 0 1 -1.456-.04l-1.585-1.414a1 1 0 0 0 -1.332 1.494l1.544 1.374a3 3 0 0 0 4.226.017zm17.9-1.138a1 1 0 0 0 -1-1h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 1-1z"
                />
            </svg>
        </template>
        <template v-if="icon === 'bar3'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="512" height="512">
                <path d="M23,22H5a3,3,0,0,1-3-3V1A1,1,0,0,0,0,1V19a5.006,5.006,0,0,0,5,5H23a1,1,0,0,0,0-2Z" />
                <path d="M6,20a1,1,0,0,0,1-1V12a1,1,0,0,0-2,0v7A1,1,0,0,0,6,20Z" />
                <path d="M10,10v9a1,1,0,0,0,2,0V10a1,1,0,0,0-2,0Z" />
                <path d="M15,13v6a1,1,0,0,0,2,0V13a1,1,0,0,0-2,0Z" />
                <path d="M20,9V19a1,1,0,0,0,2,0V9a1,1,0,0,0-2,0Z" />
                <path
                    d="M6,9a1,1,0,0,0,.707-.293l3.586-3.586a1.025,1.025,0,0,1,1.414,0l2.172,2.172a3,3,0,0,0,4.242,0l5.586-5.586A1,1,0,0,0,22.293.293L16.707,5.878a1,1,0,0,1-1.414,0L13.121,3.707a3,3,0,0,0-4.242,0L5.293,7.293A1,1,0,0,0,6,9Z"
                />
            </svg>
        </template>
        <template v-if="icon === 'bar2'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.68 25.4">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <rect class="cls-1" x="1.86" y="5.8" width="7.42" height="16.06" />
                        <rect class="cls-1" x="10.56" y="11.61" width="7.42" height="10.26" />
                        <rect class="cls-1" x="19.27" width="7.42" height="21.87" />
                        <rect class="cls-1" y="23.04" width="28.68" height="2.36" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'bar'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.57 20.04">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M15.27,20H1.21a1.27,1.27,0,0,1-.78-.22A1,1,0,0,1,0,18.73,1.07,1.07,0,0,1,1,18c.76,0,1.53,0,2.29,0,.32,0,.42-.06.42-.41,0-2.63,0-5.26,0-7.89A1.09,1.09,0,0,1,4.94,8.49H9.35a1,1,0,0,1,1.16,1.16c0,2.66,0,5.33,0,8,0,.27.05.39.34.35s.79.15,1-.08.05-.63.05-1V6.41A1.34,1.34,0,0,1,12,5.67a1.1,1.1,0,0,1,1-.58h4.6a1,1,0,0,1,1.08,1.16q0,5.67,0,11.34c0,.32.06.45.39.4a3.64,3.64,0,0,1,.66,0c.27,0,.33-.08.33-.33q0-3.64,0-7.29V1.15A1.08,1.08,0,0,1,21.17,0h4.47a1.06,1.06,0,0,1,1.18,1.19V17.57c0,.48-.06.42.42.42h2.19a1,1,0,1,1,0,2Zm9.51-10c0-2.55,0-5.1,0-7.66,0-.27-.07-.35-.35-.35C23.74,2,23,2,22.34,2c-.21,0-.29.06-.28.28,0,.64,0,1.28,0,1.92q0,6.7,0,13.42c0,.29.09.35.36.35.67,0,1.35,0,2,0,.27,0,.35-.06.35-.35C24.77,15.11,24.78,12.57,24.78,10ZM13.92,12.58h0c0,1.69,0,3.38,0,5.07,0,.29.08.35.35.35.7,0,1.4,0,2.09,0,.21,0,.29,0,.28-.27,0-.55,0-1.11,0-1.66q0-4.29,0-8.58c0-.29-.08-.38-.37-.37-.67,0-1.33,0-2,0-.3,0-.37.08-.37.37C13.92,9.18,13.92,10.88,13.92,12.58ZM8.49,14.27h0c0-1.15,0-2.3,0-3.44,0-.22,0-.32-.29-.32-.72,0-1.43,0-2.15,0-.22,0-.28.07-.28.29,0,2.31,0,4.61,0,6.92,0,.23.08.28.28.27H8.17c.25,0,.32-.06.32-.31C8.48,16.55,8.49,15.41,8.49,14.27Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'bell'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.63 17.55">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M13.45,12.54c-.88-.73-2-2-2-7.32a3,3,0,0,0-.24-1c-.38-.91-1.37-2.09-3.94-2.09S3.76,3.27,3.38,4.18a2.86,2.86,0,0,0-.25,1c0,5.35-1.07,6.59-1.95,7.32A2.2,2.2,0,0,0,0,14.63H14.63A2.2,2.2,0,0,0,13.45,12.54Z"
                        />
                        <path
                            class="cls-1"
                            d="M7.31,14.63H0a2.2,2.2,0,0,1,1.18-2.09c.88-.73,2-2,2-7.32a2.86,2.86,0,0,1,.25-1c.38-.91,1.37-2.09,3.93-2.09Z"
                        />
                        <circle class="cls-1" cx="7.31" cy="1.04" r="1.04" />
                        <path class="cls-1" d="M3.14,5.14a3.06,3.06,0,0,1,.24-1H7.32v1H3.14Z" />
                        <path class="cls-1" d="M11.49,5.14a3.06,3.06,0,0,0-.24-1H7.31v1h4.18Z" />
                        <path class="cls-1" d="M13.45,12.54H7.31v2.09h7.32A2.2,2.2,0,0,0,13.45,12.54Z" />
                        <path class="cls-1" d="M1.18,12.54H7.31v2.09H0A2.2,2.2,0,0,1,1.18,12.54Z" />
                        <path class="cls-1" d="M7.31,17.55A2.08,2.08,0,0,0,9.4,15.46H5.22A2.09,2.09,0,0,0,7.31,17.55Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'bell3'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path
                    d="M22.555,13.662l-1.9-6.836A9.321,9.321,0,0,0,2.576,7.3L1.105,13.915A5,5,0,0,0,5.986,20H7.1a5,5,0,0,0,9.8,0h.838a5,5,0,0,0,4.818-6.338ZM12,22a3,3,0,0,1-2.816-2h5.632A3,3,0,0,1,12,22Zm8.126-5.185A2.977,2.977,0,0,1,17.737,18H5.986a3,3,0,0,1-2.928-3.651l1.47-6.616a7.321,7.321,0,0,1,14.2-.372l1.9,6.836A2.977,2.977,0,0,1,20.126,16.815Z"
                />
            </svg>
        </template>
        <template v-if="icon === 'blocks'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.18 13.18">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M5.29,6H.74A.74.74,0,0,1,0,5.29V.74A.74.74,0,0,1,.74,0H5.29A.74.74,0,0,1,6,.74V5.29A.74.74,0,0,1,5.29,6ZM1.47,4.55H4.55V1.47H1.47Z"
                        />
                        <path
                            class="cls-1"
                            d="M12.44,6H7.89a.74.74,0,0,1-.74-.74V.74A.74.74,0,0,1,7.89,0h4.55a.74.74,0,0,1,.74.74V5.29A.74.74,0,0,1,12.44,6ZM8.63,4.55h3.08V1.47H8.63Z"
                        />
                        <path
                            class="cls-1"
                            d="M12.44,13.18H7.89a.74.74,0,0,1-.74-.74V7.89a.74.74,0,0,1,.74-.74h4.55a.74.74,0,0,1,.74.74v4.55A.74.74,0,0,1,12.44,13.18ZM8.63,11.71h3.08V8.63H8.63Z"
                        />
                        <path
                            class="cls-1"
                            d="M5.29,13.18H.74A.74.74,0,0,1,0,12.44V7.89a.74.74,0,0,1,.74-.74H5.29A.74.74,0,0,1,6,7.89v4.55A.74.74,0,0,1,5.29,13.18ZM1.47,11.71H4.55V8.63H1.47Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'burgermenu'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.69 25.68">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="8.78" cy="12.83" r="1.65" />
                        <circle class="cls-1" cx="13.82" cy="12.83" r="1.65" />
                        <circle class="cls-1" cx="18.85" cy="12.83" r="1.65" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'calendar2'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.05 14.89">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M16.05,3.23A2.06,2.06,0,0,0,14,1.16c-.43,0-.86,0-1.3,0-.07,0-.09,0-.09-.1V.52a.52.52,0,1,0-1,0c0,.17,0,.35,0,.52s0,.12-.12.12H5c-.14,0-.28,0-.42,0s-.08,0-.08-.08a5.23,5.23,0,0,0,0-.56A.5.5,0,0,0,4,0a.51.51,0,0,0-.51.52c0,.18,0,.36,0,.54s0,.1-.09.1c-.44,0-.88,0-1.32,0A2,2,0,0,0,0,3.21v9.62a2,2,0,0,0,0,.42,2,2,0,0,0,2,1.63H14a2.31,2.31,0,0,0,.37,0,2.06,2.06,0,0,0,1.72-2.06Zm-1,9.54a1,1,0,0,1-1.08,1.09H2.11A1,1,0,0,1,1,12.77V5.38c0-.1,0-.12.11-.12H14.88c.16,0,.14,0,.14.13Z"
                        />
                        <circle class="cls-1" cx="3.29" cy="10.95" r="1.11" />
                        <circle class="cls-1" cx="6.43" cy="10.95" r="1.11" />
                        <circle class="cls-1" cx="9.57" cy="10.95" r="1.11" />
                        <circle class="cls-1" cx="12.71" cy="10.95" r="1.11" />
                        <circle class="cls-1" cx="9.57" cy="7.88" r="1.11" />
                        <circle class="cls-1" cx="6.43" cy="7.88" r="1.11" />
                        <circle class="cls-1" cx="12.71" cy="7.88" r="1.11" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'calendar'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.58 27.43">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M29.58,6a3.78,3.78,0,0,0-3.82-3.82H23.37c-.15,0-.19,0-.18-.18,0-.33,0-.66,0-1A.95.95,0,1,0,21.3,1c0,.32,0,.64,0,1s-.05.21-.22.21H8.42c-.1,0-.14,0-.14-.13,0-.35,0-.69,0-1a1,1,0,1,0-1.9,0c0,.34,0,.67,0,1,0,.14,0,.17-.18.17H3.8A3.78,3.78,0,0,0,0,5.92V23.64a3.94,3.94,0,0,0,.08.77,3.78,3.78,0,0,0,3.73,3H25.73a3.82,3.82,0,0,0,.68-.06,3.78,3.78,0,0,0,3.17-3.79ZM27.69,23.53a1.9,1.9,0,0,1-2,2H3.89a1.89,1.89,0,0,1-2-2q0-6.81,0-13.62c0-.18.05-.22.22-.22H27.44c.28,0,.25,0,.25.24Z"
                        />
                        <path
                            class="cls-1"
                            d="M20.51,16.32h4.4c.14,0,.18,0,.18-.19q0-2.07,0-4.14c0-.13,0-.17-.17-.17h-4.4c-.14,0-.17,0-.17.17v4.16C20.35,16.28,20.38,16.32,20.51,16.32Z"
                        />
                        <path
                            class="cls-1"
                            d="M25.09,19.08c0-.13,0-.17-.16-.17q-2.2,0-4.41,0c-.13,0-.17,0-.17.17v4.16c0,.13,0,.17.16.17h4.4c.13,0,.18,0,.18-.17C25.08,21.85,25.08,20.46,25.09,19.08Z"
                        />
                        <path
                            class="cls-1"
                            d="M4.5,16.17c0,.12,0,.15.14.14H9.08c.12,0,.15,0,.15-.15V12c0-.13,0-.15-.15-.15H4.64c-.11,0-.14,0-.14.14Z"
                        />
                        <path
                            class="cls-1"
                            d="M12.49,16.32h4.39c.12,0,.16,0,.16-.17V12c0-.13,0-.17-.17-.17h-4.4c-.13,0-.16,0-.16.16v4.16C12.3,16.29,12.35,16.32,12.49,16.32Z"
                        />
                        <path
                            class="cls-1"
                            d="M9.23,19.09c0-.14,0-.18-.18-.18q-2.19,0-4.38,0c-.13,0-.17,0-.17.17v4.16c0,.13,0,.17.16.17h4.4c.13,0,.18,0,.18-.17C9.23,21.86,9.23,20.48,9.23,19.09Z"
                        />
                        <path
                            class="cls-1"
                            d="M16.86,18.91c-.73,0-1.45,0-2.17,0s-1.47,0-2.2,0c-.14,0-.19,0-.18.18v4.14c0,.16,0,.18.18.18,1.46,0,2.91,0,4.37,0,.14,0,.18,0,.18-.18V19.09C17,18.94,17,18.91,16.86,18.91Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'car'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14C7.79565 14 8.55871 14.3161 9.12132 14.8787C9.68393 15.4413 10 16.2043 10 17C10 17.7957 9.68393 18.5587 9.12132 19.1213C8.55871 19.6839 7.79565 20 7 20C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17C4 16.2044 4.31607 15.4413 4.87868 14.8787ZM7 16C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18C7.26522 18 7.51957 17.8946 7.70711 17.7071C7.89464 17.5196 8 17.2652 8 17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16Z"
                    fill="currentColor"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.8787 14.8787C15.4413 14.3161 16.2043 14 17 14C17.7957 14 18.5587 14.3161 19.1213 14.8787C19.6839 15.4413 20 16.2043 20 17C20 17.7957 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7957 20 17 20C16.2043 20 15.4413 19.6839 14.8787 19.1213C14.3161 18.5587 14 17.7957 14 17C14 16.2043 14.3161 15.4413 14.8787 14.8787ZM17 16C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17C18 16.7348 17.8946 16.4804 17.7071 16.2929C17.5196 16.1054 17.2652 16 17 16Z"
                    fill="currentColor"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.07152 5.62861C4.22339 5.24895 4.5911 5 5 5H14C14.3038 5 14.5911 5.13809 14.7809 5.3753L18.4806 10H19C19.7957 10 20.5587 10.3161 21.1213 10.8787C21.6839 11.4413 22 12.2043 22 13V17C22 17.5523 21.5523 18 21 18H19C18.4477 18 18 17.5523 18 17C18 16.4477 18.4477 16 19 16H20V13C20 12.7348 19.8946 12.4804 19.7071 12.2929C19.5196 12.1054 19.2652 12 19 12H4V16H5C5.55228 16 6 16.4477 6 17C6 17.5523 5.55228 18 5 18H3C2.44772 18 2 17.5523 2 17V11C2 10.8728 2.02428 10.7467 2.07152 10.6286L4.07152 5.62861ZM4.47703 10H11V7H5.67703L4.47703 10ZM13 7V10H15.9194L13.5194 7H13ZM8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z"
                    fill="currentColor"
                />
            </svg>
        </template>
        <template v-if="icon === 'clients'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.14 31.65">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M23.53.37A3.08,3.08,0,0,0,22.38,0l-.31,0H4.8A3.08,3.08,0,0,0,1.72,3.07V4.6H.56A.57.57,0,0,0,0,5.17V8a.56.56,0,0,0,.56.56H1.72v2.12H.56a.56.56,0,0,0-.56.56v2.82a.56.56,0,0,0,.56.56H1.72v2.12H.56a.56.56,0,0,0-.56.56v2.82a.56.56,0,0,0,.56.56H1.72v2.12H.56a.56.56,0,0,0-.56.57v2.81a.56.56,0,0,0,.56.57H1.72v1.84A3.08,3.08,0,0,0,4.8,31.65H22.07l.31,0a3.06,3.06,0,0,0,2.76-3.05V3.07A3.08,3.08,0,0,0,23.53.37ZM19.88,6.5a.59.59,0,0,0-.48-.2.67.67,0,0,0-.48.2L16.67,8.76V1.12h5.45V8.78Z"
                        />
                        <path class="cls-1" d="M.56,8.55H1.69v-4H.56A.57.57,0,0,0,0,5.17V8A.56.56,0,0,0,.56,8.55Z" />
                        <path class="cls-1" d="M.56,14.61H1.69V10.67H.56a.56.56,0,0,0-.56.56v2.82A.56.56,0,0,0,.56,14.61Z" />
                        <path class="cls-1" d="M1.69,22.79H.56a.56.56,0,0,0-.56.57v2.81a.56.56,0,0,0,.56.57H1.69Z" />
                        <path class="cls-1" d="M.56,20.67H1.69V16.73H.56a.56.56,0,0,0-.56.56v2.82A.56.56,0,0,0,.56,20.67Z" />
                        <path class="cls-2" d="M19.88,6.5a.59.59,0,0,0-.48-.2.67.67,0,0,0-.48.2L16.67,8.76V1.12h5.45V8.78Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'clients2'">
            <svg id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
                <path
                    d="m19 3.022c0-.008 0-.014 0-.022v-2a1 1 0 0 0 -2 0v1.1a5 5 0 0 0 -1-.1h-1v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0v1h-1a5 5 0 0 0 -1 .1v-1.1a1 1 0 0 0 -2 0v2 .022a4.979 4.979 0 0 0 -2 3.978v12a5.006 5.006 0 0 0 5 5h8a5.006 5.006 0 0 0 5-5v-12a4.979 4.979 0 0 0 -2-3.978zm0 15.978a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3-3v-12a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3zm-2-11a1 1 0 0 1 -1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1zm0 4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1zm-4 4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1z"
                />
            </svg>
        </template>
        <template v-if="icon === 'clock3'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path
                    d="M12,0A11.972,11.972,0,0,0,4,3.073V1A1,1,0,0,0,2,1V4A3,3,0,0,0,5,7H8A1,1,0,0,0,8,5H5a.854.854,0,0,1-.1-.021A9.987,9.987,0,1,1,2,12a1,1,0,0,0-2,0A12,12,0,1,0,12,0Z"
                />
                <path d="M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414L13,11.586V7A1,1,0,0,0,12,6Z" />
            </svg>
        </template>
        <template v-if="icon === 'clock2'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.07 27.07">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="13.54" cy="13.54" r="13.54" />
                        <path class="cls-2" d="M20.5,12H15V6.57a1.5,1.5,0,0,0-3,0V13.5A1.59,1.59,0,0,0,13.57,15H20.5a1.5,1.5,0,0,0,0-3Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'clock'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.38 15.42">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M15.37,7.69A7.61,7.61,0,0,1,8,15.41,7.71,7.71,0,1,1,7.76,0,7.63,7.63,0,0,1,15.37,7.69ZM13.67,7a.06.06,0,0,1,0,0A6.36,6.36,0,0,0,13,4.9a6.17,6.17,0,0,0-1.77-2,6.23,6.23,0,0,0-2.8-1.12c-.09,0-.13,0-.13.11a2.74,2.74,0,0,1,0,.28.54.54,0,0,1-.5.43.56.56,0,0,1-.55-.41,2.7,2.7,0,0,1,0-.28c0-.1,0-.14-.16-.12A6.86,6.86,0,0,0,6,2,6,6,0,0,0,2.8,4.3a5.92,5.92,0,0,0-1,2.52c-.06.31-.06.31.24.34h0a.59.59,0,0,1,.5.56A.59.59,0,0,1,2,8.26l-.15,0c-.09,0-.12.05-.1.14a6.5,6.5,0,0,0,.32,1.3,6.07,6.07,0,0,0,2.56,3.11A6.32,6.32,0,0,0,7,13.66c.12,0,.19,0,.19-.15a.83.83,0,0,1,0-.22.54.54,0,0,1,1.07.08c0,.4.05.32.35.27a6,6,0,0,0,3.73-2.15,5.94,5.94,0,0,0,1.3-2.86c.06-.33,0-.32-.28-.38a.54.54,0,0,1-.48-.38.56.56,0,0,1,.21-.59.73.73,0,0,1,.43-.13C13.59,7.15,13.67,7.14,13.67,7Z"
                        />
                        <path
                            class="cls-1"
                            d="M11.24,10.64a.55.55,0,0,1-.37.53.52.52,0,0,1-.6-.09c-.76-.65-1.5-1.33-2.24-2a.88.88,0,0,0-.47-.24,1.12,1.12,0,0,1-1-1.39,1,1,0,0,1,.35-.59.58.58,0,0,0,.18-.42c0-.7.06-1.39.1-2.08a8.14,8.14,0,0,1,.08-.85.42.42,0,0,1,.39-.36.43.43,0,0,1,.41.32,2,2,0,0,1,.06.42l.06,1.4.06,1.26a.27.27,0,0,0,.12.23,1.28,1.28,0,0,1,.46.89.2.2,0,0,0,.08.14l1.55,1.74.66.81A.45.45,0,0,1,11.24,10.64Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'clock4'">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_103_2)">
                    <path
                        d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456726 3.7039C0.00259972 4.80026 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40353 1.75736 10.2426C2.59648 11.0818 3.66558 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0892 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C11.9983 4.40923 11.3656 2.88411 10.2407 1.75926C9.1159 0.634414 7.59077 0.00172054 6 0V0ZM6 11C5.0111 11 4.0444 10.7068 3.22215 10.1573C2.39991 9.60794 1.75904 8.82705 1.38061 7.91342C1.00217 6.99979 0.90315 5.99445 1.09608 5.02455C1.289 4.05464 1.76521 3.16373 2.46447 2.46447C3.16373 1.7652 4.05465 1.289 5.02455 1.09607C5.99446 0.903148 6.99979 1.00216 7.91342 1.3806C8.82705 1.75904 9.60794 2.3999 10.1574 3.22215C10.7068 4.0444 11 5.01109 11 6C10.9985 7.32564 10.4713 8.59656 9.53393 9.53393C8.59656 10.4713 7.32564 10.9985 6 11V11Z"
                        fill="#1B1B1B"
                    />
                    <path
                        d="M6.00022 3C5.86761 3 5.74043 3.05268 5.64666 3.14645C5.5529 3.24021 5.50022 3.36739 5.50022 3.5V5.6625L3.81472 6.7185C3.702 6.78891 3.62187 6.90122 3.59196 7.03072C3.56205 7.16021 3.5848 7.29628 3.65522 7.409C3.72563 7.52172 3.83794 7.60184 3.96743 7.63176C4.09693 7.66167 4.233 7.63891 4.34572 7.5685L6.26572 6.3685C6.33826 6.32305 6.39792 6.25973 6.43898 6.18462C6.48004 6.1095 6.50112 6.0251 6.50022 5.9395V3.5C6.50022 3.36739 6.44754 3.24021 6.35377 3.14645C6.26 3.05268 6.13283 3 6.00022 3Z"
                        fill="#1B1B1B"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_103_2">
                        <rect width="12" height="12" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>
        <template v-if="icon === 'comment'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.4 21.07">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M22.4,1.73A2.36,2.36,0,0,0,20,0h0c-4.3,0-8.67,0-12.9,0H2.21a1.94,1.94,0,0,0-.34,0A2.27,2.27,0,0,0,0,1.74V14.48a2.35,2.35,0,0,0,2.37,1.74h0c1.89,0,3.81,0,5.66,0h2.67a.28.28,0,0,1,.23.09l2.43,2.43,2,2a.83.83,0,0,0,1,.24.82.82,0,0,0,.5-.83c0-1.3,0-2.61,0-3.91v-.06h3.36a2.17,2.17,0,0,0,2.06-1.46c0-.07.05-.15.08-.22l0-.1V1.73ZM15.25,17.9v.38l-.38-.37-3.13-3.14a.65.65,0,0,0-.48-.19h-9a.59.59,0,0,1-.65-.64V2.28a.58.58,0,0,1,.64-.64H20.17a.58.58,0,0,1,.63.63V13.91a.59.59,0,0,1-.68.67H15.54a.33.33,0,0,0-.23.07.32.32,0,0,0-.07.23C15.25,15.89,15.25,16.89,15.25,17.9Z"
                        />
                        <path
                            class="cls-1"
                            d="M18.11,7.88a.82.82,0,0,0,.8-.53.8.8,0,0,0-.09-.74.87.87,0,0,0-.72-.35H4.27a.8.8,0,0,0-.61.26.86.86,0,0,0-.21.64.82.82,0,0,0,.87.72H18.11Z"
                        />
                        <path
                            class="cls-1"
                            d="M4.33,5.11h13.8a.84.84,0,0,0,.6-.25A.78.78,0,0,0,19,4.27a.8.8,0,0,0-.84-.79H4.3a.81.81,0,0,0-.71,1.27A.88.88,0,0,0,4.33,5.11Z"
                        />
                        <path
                            class="cls-1"
                            d="M11.2,9H4.28a.83.83,0,0,0-.44.12.82.82,0,0,0,.44,1.51H11.2a.82.82,0,0,0,.82-.8.84.84,0,0,0-.23-.59A.87.87,0,0,0,11.2,9Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'cross'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.11 18.09">
                <g>
                    <g>
                        <path
                            d="M9.07,0h0A9,9,0,0,0,0,9a9,9,0,0,0,9.06,9.05h0A9,9,0,1,0,9.07,0Zm6.78,9.07A6.76,6.76,0,0,1,9,15.84H9A6.8,6.8,0,1,1,9.1,2.24h0a6.69,6.69,0,0,1,4.77,2A6.81,6.81,0,0,1,15.85,9.07Z"
                        />
                        <path
                            d="M12.66,5.44a1.25,1.25,0,0,0-1.77,0L9.05,7.28,7.21,5.44A1.25,1.25,0,0,0,5.44,7.2L7.29,9,5.44,10.89A1.25,1.25,0,0,0,6.33,13a1.21,1.21,0,0,0,.88-.37l1.84-1.84,1.84,1.84a1.25,1.25,0,0,0,.89.37,1.21,1.21,0,0,0,.88-.37,1.24,1.24,0,0,0,0-1.76L10.82,9,12.66,7.2A1.24,1.24,0,0,0,12.66,5.44Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'doors'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.02 14.02">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M11.85,14H2.17A2.17,2.17,0,0,1,0,11.85V2.17A2.17,2.17,0,0,1,2.17,0h9.68A2.17,2.17,0,0,1,14,2.17v9.68A2.18,2.18,0,0,1,11.85,14ZM7.79,12.45h4.06a.6.6,0,0,0,.6-.6V2.17a.6.6,0,0,0-.6-.6H7.79ZM2.17,1.57a.6.6,0,0,0-.6.6v9.68a.6.6,0,0,0,.6.6H6.22V1.57Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'eye'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.85 12.5">
                <g>
                    <g>
                        <path
                            d="M17.11,4.89a11.51,11.51,0,0,0-3.25-3.38A8.62,8.62,0,0,0,8.33,0,8.84,8.84,0,0,0,3,2.28,11.94,11.94,0,0,0,.08,6.11L0,6.24l.08.17a11.9,11.9,0,0,0,3.79,4.48,8.52,8.52,0,0,0,4.35,1.58,8.83,8.83,0,0,0,6.65-2.25,12.12,12.12,0,0,0,3-3.86.08.08,0,0,1,0-.05v0C17.61,5.84,17.38,5.31,17.11,4.89ZM8.94,10.26a4,4,0,1,1,4-4A4,4,0,0,1,8.94,10.26Z"
                        />
                        <path d="M8.94,4a2.23,2.23,0,1,0,2.23,2.23A2.22,2.22,0,0,0,8.94,4Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'filter'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.4 11.4">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M5.7,0h4.92c.3,0,.59,0,.73.34a.67.67,0,0,1-.25.8L7.59,4.65a.89.89,0,0,0-.29.69c0,1.75,0,3.49,0,5.24,0,.31,0,.61-.35.76s-.59,0-.83-.27C5.57,10.5,5,9.93,4.43,9.37a1.1,1.1,0,0,1-.34-.84c0-1.06,0-2.13,0-3.19a.85.85,0,0,0-.28-.69L.27,1.11A.65.65,0,0,1,0,.41C.13.08.38,0,.7,0Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'folder'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.89 26.41">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path class="cls-1" d="M2.49,0A2.8,2.8,0,0,0,0,2.83V3a2.58,2.58,0,0,1,1.88-.82H23.6A2.83,2.83,0,0,0,21.19,0Z" />
                        <rect class="cls-1" y="3.48" width="35.89" height="22.93" rx="2.49" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'following'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.48 35.77">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M32.48,13c0,.4,0,.81,0,1.22a.24.24,0,0,1-.16.26,7.23,7.23,0,0,1-2,.58,11.2,11.2,0,0,1-2.38.15,13.87,13.87,0,0,1-3-.46l-.9-.25a.19.19,0,0,1-.16-.22c0-.93,0-1,0-1.92a3.05,3.05,0,0,1,1.18-2.19,3.23,3.23,0,0,1,2.11-.73c.68,0,1.37,0,2.06,0a3.17,3.17,0,0,1,2.89,1.84,3.13,3.13,0,0,1,.32,1.41C32.48,13.07,32.48,12.59,32.48,13Z"
                        />
                        <path class="cls-1" d="M28.18,8.72A2.53,2.53,0,1,1,30.7,6.21,2.5,2.5,0,0,1,28.18,8.72Z" />
                        <path
                            class="cls-1"
                            d="M28.17,16.62a8.31,8.31,0,1,1,8.31-8.31A8.32,8.32,0,0,1,28.17,16.62Zm0-14A5.73,5.73,0,1,0,33.9,8.31,5.74,5.74,0,0,0,28.17,2.58Z"
                        />
                        <path
                            class="cls-1"
                            d="M27.29,32.68c0,.31,0,.62,0,.93a.2.2,0,0,1-.12.2,5.85,5.85,0,0,1-1.53.45,9.33,9.33,0,0,1-1.83.11,10.49,10.49,0,0,1-2.3-.35l-.7-.19a.16.16,0,0,1-.12-.17,14.42,14.42,0,0,1,0-1.47,2.34,2.34,0,0,1,.9-1.68A2.44,2.44,0,0,1,23.24,30c.52,0,1.05,0,1.58,0a2.49,2.49,0,0,1,2.46,2.5A1.69,1.69,0,0,1,27.29,32.68Z"
                        />
                        <path class="cls-1" d="M24,29.41a1.94,1.94,0,1,1,1.94-1.92A1.94,1.94,0,0,1,24,29.41Z" />
                        <path
                            class="cls-1"
                            d="M24,35.77a6.67,6.67,0,1,1,6.67-6.67A6.68,6.68,0,0,1,24,35.77ZM24,25a4.09,4.09,0,1,0,4.08,4.09A4.09,4.09,0,0,0,24,25Z"
                        />
                        <path
                            class="cls-1"
                            d="M15.26,23.14c0,.5,0,1,0,1.51a.3.3,0,0,1-.19.32,9.15,9.15,0,0,1-2.46.72,13.8,13.8,0,0,1-2.94.18A17.89,17.89,0,0,1,6,25.31L4.85,25a.23.23,0,0,1-.2-.26c0-1.15-.05-1.22,0-2.37a3.77,3.77,0,0,1,1.45-2.7,4,4,0,0,1,2.61-.9c.84,0,1.69,0,2.53,0A4,4,0,0,1,14.86,21a4,4,0,0,1,.4,1.74C15.27,23.26,15.26,22.66,15.26,23.14Z"
                        />
                        <path class="cls-1" d="M10,17.89a3.11,3.11,0,1,1,3.12-3.09A3.1,3.1,0,0,1,10,17.89Z" />
                        <path
                            class="cls-1"
                            d="M10,27.34a10,10,0,1,1,10-9.95A10,10,0,0,1,10,27.34ZM10,10a7.37,7.37,0,1,0,7.36,7.37A7.38,7.38,0,0,0,10,10Z"
                        />
                        <rect class="cls-1" x="17.31" y="10.78" width="4.12" height="2.58" transform="translate(-3.34 9.79) rotate(-26.19)" />
                        <rect class="cls-1" x="16.51" y="22.92" width="2.58" height="3.83" transform="translate(-12.65 22.24) rotate(-49.5)" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'megaphone'">
            <svg id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
                <path
                    d="m17 0a1 1 0 0 0 -1 1c0 2.949-2.583 4-5 4h-7a4 4 0 0 0 -4 4v2a3.979 3.979 0 0 0 1.514 3.109l3.572 7.972a3.233 3.233 0 0 0 2.953 1.919 2.982 2.982 0 0 0 2.72-4.2l-2.2-4.8h2.441c2.417 0 5 1.051 5 4a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1zm-8.063 20.619a.983.983 0 0 1 -.898 1.381 1.232 1.232 0 0 1 -1.126-.734l-2.808-6.266h2.254zm7.063-6.019a7.723 7.723 0 0 0 -5-1.6h-7a2 2 0 0 1 -2-2v-2a2 2 0 0 1 2-2h7a7.723 7.723 0 0 0 5-1.595zm7.9.852a1 1 0 0 1 -1.342.448l-2-1a1 1 0 0 1 .894-1.79l2 1a1 1 0 0 1 .448 1.337zm-3.79-9a1 1 0 0 1 .448-1.342l2-1a1 1 0 1 1 .894 1.79l-2 1a1 1 0 0 1 -1.342-.448zm-.11 3.548a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 -1-1z"
                />
            </svg>
        </template>
        <template v-if="icon === 'gantt'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.83 12.96">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path class="cls-1" d="M11.51,2H1A1,1,0,0,1,1,0H11.51a1,1,0,0,1,0,2Z" />
                        <path class="cls-1" d="M16.83,5.65H8.41a1,1,0,0,1,0-2h8.42a1,1,0,0,1,0,2Z" />
                        <path class="cls-1" d="M4.9,5.65H1a1,1,0,0,1,0-2H4.9a1,1,0,0,1,0,2Z" />
                        <path class="cls-1" d="M9.63,9.31H1a1,1,0,0,1,0-2H9.63a1,1,0,0,1,0,2Z" />
                        <path class="cls-1" d="M16.83,9.31H13.3a1,1,0,1,1,0-2h3.53a1,1,0,0,1,0,2Z" />
                        <path class="cls-1" d="M14.21,13H1a1,1,0,0,1,0-2H14.21a1,1,0,0,1,0,2Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'hand'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.54 29.5">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M25.3,12.08A2.21,2.21,0,0,1,26,15.76c-.28.31-.59.59-.89.89-3.19,3.19-6.37,6.39-9.58,9.57a5.6,5.6,0,0,1-7.83,0C6.53,25.09,5.34,24,4.22,22.74a5.4,5.4,0,0,1-1.15-5.92A17.88,17.88,0,0,1,5,13.53,21.12,21.12,0,0,0,8.24,6.91a2.13,2.13,0,0,1,2.64-1.48,2.2,2.2,0,0,1,1.59,2.72c-.1.47-.22.95-.36,1.5l.46-.43L17.81,4a2.25,2.25,0,0,1,3.31.11,8.18,8.18,0,0,1,.43.7l.35-.24a2.22,2.22,0,0,1,2.67.22A2.2,2.2,0,0,1,25,7.45c-.14.25-.15.33.13.47a2.19,2.19,0,0,1,.71,3.39c-.2.24-.43.46-.67.7ZM5.11,22c1.12,1.13,2.25,2.27,3.39,3.39a4.39,4.39,0,0,0,6.24,0l8.75-8.74,1.69-1.69a1,1,0,0,0,.07-1.43.93.93,0,0,0-1.43-.05c-.88.85-1.74,1.73-2.61,2.59l-2.6,2.57a.61.61,0,0,1-.91.07c-.26-.26-.23-.61.09-.94l7-7a1,1,0,1,0-1.43-1.45c-1.42,1.41-2.83,2.84-4.24,4.26l-2.72,2.7a.77.77,0,0,1-.6.32.63.63,0,0,1-.54-.33.56.56,0,0,1,.12-.65c.45-.48.92-.94,1.39-1.41l7-7a1,1,0,0,0,.07-1.48,1,1,0,0,0-1.51,0l-5,5L14,14.07a.59.59,0,0,1-.86,0,.57.57,0,0,1,0-.82c.28-.31.59-.6.88-.9l6-6c.56-.56.63-1.13.19-1.58a1.06,1.06,0,0,0-1.62.12l-8.62,8.6a3.14,3.14,0,0,1-.32.31.59.59,0,0,1-.83,0,.62.62,0,0,1,0-.81A1.75,1.75,0,0,1,9,12.78a5.25,5.25,0,0,0,1.52-2.27,15.39,15.39,0,0,0,.79-2.64,1,1,0,0,0-.74-1.29,1,1,0,0,0-1.26.85,15.76,15.76,0,0,1-.78,2.38,26.69,26.69,0,0,1-2.28,4c-.61,1-1.24,1.95-1.84,2.93A4.38,4.38,0,0,0,5.11,22Z"
                        />
                        <path
                            class="cls-1"
                            d="M19.43,3.29a2.24,2.24,0,0,1,1.69.79,8.18,8.18,0,0,1,.43.7l.35-.24a2.28,2.28,0,0,1,1.2-.34,2.16,2.16,0,0,1,1.47.56A2.2,2.2,0,0,1,25,7.45c-.14.25-.15.33.13.47a2.19,2.19,0,0,1,.71,3.39c-.2.24-.43.46-.67.7l.1.07A2.21,2.21,0,0,1,26,15.76c-.28.31-.59.59-.89.89-3.19,3.19-6.37,6.39-9.58,9.57a5.59,5.59,0,0,1-7.83,0C6.53,25.09,5.34,24,4.22,22.74a5.4,5.4,0,0,1-1.15-5.92A17.88,17.88,0,0,1,5,13.53,21.12,21.12,0,0,0,8.24,6.91a2.07,2.07,0,0,1,2.07-1.55,2.78,2.78,0,0,1,.57.07,2.2,2.2,0,0,1,1.59,2.72c-.1.47-.22.95-.36,1.5l.46-.43L17.81,4a2.3,2.3,0,0,1,1.62-.68M9.19,14a.59.59,0,0,1-.42-.18.62.62,0,0,1,0-.81A1.75,1.75,0,0,1,9,12.78a5.25,5.25,0,0,0,1.52-2.27,15.39,15.39,0,0,0,.79-2.64,1,1,0,0,0-.74-1.29,1,1,0,0,0-.24,0,1.07,1.07,0,0,0-1,.88,15.76,15.76,0,0,1-.78,2.38,26.69,26.69,0,0,1-2.28,4c-.61,1-1.24,1.95-1.84,2.93A4.38,4.38,0,0,0,5.11,22c1.12,1.13,2.25,2.27,3.39,3.39a4.38,4.38,0,0,0,6.24,0l8.75-8.74,1.69-1.69a1,1,0,0,0,.07-1.43.93.93,0,0,0-1.43-.05c-.88.85-1.74,1.73-2.61,2.59l-2.6,2.57a.73.73,0,0,1-.51.24.52.52,0,0,1-.4-.17c-.26-.26-.23-.61.09-.93l7-7a1,1,0,0,0,.08-1.53,1,1,0,0,0-.69-.3,1.14,1.14,0,0,0-.82.38c-1.42,1.41-2.83,2.84-4.24,4.26l-2.72,2.71a.86.86,0,0,1-.56.31h0a.63.63,0,0,1-.54-.33.56.56,0,0,1,.12-.65c.45-.48.92-.94,1.39-1.41l7-7a1,1,0,0,0-.64-1.79,1.13,1.13,0,0,0-.8.36l-5,5L14,14.07a.6.6,0,0,1-.43.19.63.63,0,0,1-.43-.18.57.57,0,0,1,0-.82c.28-.31.59-.6.88-.9l6-6c.56-.56.63-1.13.19-1.59a1,1,0,0,0-.71-.31,1.28,1.28,0,0,0-.91.44l-8.62,8.6a3.14,3.14,0,0,1-.32.31.61.61,0,0,1-.41.16M19.43,3.09a2.49,2.49,0,0,0-1.76.74L14.43,7.07l-2,2c.07-.29.14-.56.2-.84a2.41,2.41,0,0,0-1.74-2.95,2.57,2.57,0,0,0-.62-.08A2.26,2.26,0,0,0,8,6.87a20.7,20.7,0,0,1-3.2,6.55l-.5.75a12.81,12.81,0,0,0-1.46,2.58,5.59,5.59,0,0,0,1.2,6.12C5.07,24,6.15,25,7.18,26l.39.38a5.78,5.78,0,0,0,8.11,0c2.15-2.13,4.29-4.28,6.43-6.42l3.16-3.15.29-.29q.3-.29.6-.6a2.57,2.57,0,0,0,.71-2.23A2.5,2.5,0,0,0,25.52,12l.05-.05c.16-.16.32-.32.46-.49a2.4,2.4,0,0,0-.78-3.69l-.12-.07h0s0,0,.07-.12A2.4,2.4,0,0,0,23.1,4a2.46,2.46,0,0,0-1.31.38l-.18.13-.06-.12A2.26,2.26,0,0,0,21.27,4a2.39,2.39,0,0,0-1.84-.86ZM9.19,14.2A.8.8,0,0,0,9.73,14a3.2,3.2,0,0,0,.27-.25l.06-.07,3.17-3.16,5.45-5.44a1.15,1.15,0,0,1,.77-.39.76.76,0,0,1,.56.26c.46.48.16,1-.18,1.31l-6,6-.2.2c-.23.23-.47.46-.69.7a.77.77,0,0,0,0,1.11.82.82,0,0,0,.56.23.8.8,0,0,0,.57-.25L16.35,12l1.12-1.11,1.35-1.36,3.63-3.63a1,1,0,0,1,.66-.3.81.81,0,0,1,.57.25A.82.82,0,0,1,23.61,7l-4.24,4.24L16.65,14l-.13.13c-.43.42-.85.85-1.27,1.29a.74.74,0,0,0-.15.87.82.82,0,0,0,.71.44h0a1,1,0,0,0,.7-.37l.09-.09,2.63-2.62,1.77-1.79,2.47-2.47a1,1,0,0,1,.68-.32.77.77,0,0,1,.55.24.78.78,0,0,1,.25.56,1,1,0,0,1-.33.69l-3.78,3.78-3.24,3.23a1.07,1.07,0,0,0-.32.62.74.74,0,0,0,.23.6.73.73,0,0,0,.54.24.93.93,0,0,0,.65-.31l2.42-2.38.18-.19.86-.86c.58-.58,1.16-1.16,1.75-1.73a.82.82,0,0,1,.55-.25A.84.84,0,0,1,25,14.76L24,15.81l-.64.64L20.83,19q-3.1,3.12-6.24,6.23a4.18,4.18,0,0,1-5.95,0C7.58,24.15,6.47,23,5.25,21.8a4.14,4.14,0,0,1-1.2-2.93,3.93,3.93,0,0,1,.54-2c.41-.69.84-1.36,1.26-2l.57-.89c.15-.25.31-.5.47-.74A21,21,0,0,0,8.72,9.88a16.9,16.9,0,0,0,.79-2.41.86.86,0,0,1,.82-.72l.2,0a.82.82,0,0,1,.59,1,16.52,16.52,0,0,1-.79,2.61,5,5,0,0,1-1.46,2.18,2.23,2.23,0,0,0-.26.27.8.8,0,0,0,0,1.07.76.76,0,0,0,.56.24Z"
                        />
                        <path
                            class="cls-2"
                            d="M20.7,29.5a9.41,9.41,0,0,0,8.7-8A9.91,9.91,0,0,0,29.54,20a.62.62,0,0,0-.61-.69.63.63,0,0,0-.62.68,8.38,8.38,0,0,1-2.41,5.88,7.72,7.72,0,0,1-5.53,2.42c-.44,0-.68.18-.72.52a.57.57,0,0,0,.54.69A4.34,4.34,0,0,0,20.7,29.5Z"
                        />
                        <path
                            class="cls-2"
                            d="M0,8.88v.41a.58.58,0,0,0,.58.59.57.57,0,0,0,.63-.57,9,9,0,0,1,.2-1.72A8.06,8.06,0,0,1,6.62,1.76,8.55,8.55,0,0,1,9.5,1.22c.46,0,.72-.25.7-.62S9.93,0,9.47,0A9.51,9.51,0,0,0,.12,7.82,4.72,4.72,0,0,0,0,8.88Z"
                        />
                        <path
                            class="cls-2"
                            d="M26.46,20.3V20c0-.41-.23-.66-.58-.67a.6.6,0,0,0-.62.64,7.55,7.55,0,0,1-.28,1.7,5,5,0,0,1-4.54,3.61c-.45,0-.72.27-.7.64s.32.6.78.59a6.18,6.18,0,0,0,5.55-4.24A7,7,0,0,0,26.46,20.3Z"
                        />
                        <path
                            class="cls-2"
                            d="M9.3,3.07A6.39,6.39,0,0,0,3,8.9a.79.79,0,0,0,.19.71.61.61,0,0,0,1-.49A4.38,4.38,0,0,1,5,6.69a5.38,5.38,0,0,1,4.27-2.4H9.6a.62.62,0,0,0,.57-.61.59.59,0,0,0-.61-.6Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'home'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path
                    d="M23.121,9.069,15.536,1.483a5.008,5.008,0,0,0-7.072,0L.879,9.069A2.978,2.978,0,0,0,0,11.19v9.817a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V11.19A2.978,2.978,0,0,0,23.121,9.069ZM15,22.007H9V18.073a3,3,0,0,1,6,0Zm7-1a1,1,0,0,1-1,1H17V18.073a5,5,0,0,0-10,0v3.934H3a1,1,0,0,1-1-1V11.19a1.008,1.008,0,0,1,.293-.707L9.878,2.9a3.008,3.008,0,0,1,4.244,0l7.585,7.586A1.008,1.008,0,0,1,22,11.19Z"
                />
            </svg>
        </template>
        <template v-if="icon === 'layout'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path d="M2,11H13a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V9A2,2,0,0,0,2,11ZM2,2H13V9H2Z" />
                <path d="M22,0H19a2,2,0,0,0-2,2V9a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,9H19V2h3Z" />
                <path d="M5,13H2a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2H5a2,2,0,0,0,2-2V15A2,2,0,0,0,5,13Zm0,9H2V15H5Z" />
                <path d="M22,13H11a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V15A2,2,0,0,0,22,13Zm0,9H11V15H22Z" />
            </svg>
        </template>
        <template v-if="icon === 'interim'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.14 30.85">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M1.84,0A1.84,1.84,0,0,0,0,1.84V29a1.84,1.84,0,0,0,1.84,1.84H18.25V27.24a2.89,2.89,0,0,1,2.89-2.89h4V1.84A1.84,1.84,0,0,0,23.3,0Z"
                        />
                        <path class="cls-1" d="M19.3,27.24v2.92l5-4.76h-3.2A1.84,1.84,0,0,0,19.3,27.24Z" />
                        <path
                            class="cls-2"
                            d="M17.88,17.28c0,.5,0,1,0,1.5a.3.3,0,0,1-.19.32,9.39,9.39,0,0,1-2.46.73,14.47,14.47,0,0,1-2.94.17,17.14,17.14,0,0,1-3.71-.55l-1.12-.32a.23.23,0,0,1-.19-.26,23.43,23.43,0,0,1,0-2.37,3.79,3.79,0,0,1,1.45-2.71,4,4,0,0,1,2.6-.9c.85,0,1.7,0,2.54,0a4,4,0,0,1,3.58,2.28,3.84,3.84,0,0,1,.39,1.73A2.32,2.32,0,0,1,17.88,17.28Z"
                        />
                        <path class="cls-2" d="M12.57,12a3.11,3.11,0,1,1,3.12-3.1A3.11,3.11,0,0,1,12.57,12Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'interim2'">
            <svg id="Layer_1" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
                <path
                    d="m7.5 13a4.5 4.5 0 1 1 4.5-4.5 4.505 4.505 0 0 1 -4.5 4.5zm0-7a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0 -2.5-2.5zm7.5 17v-.5a7.5 7.5 0 0 0 -15 0v.5a1 1 0 0 0 2 0v-.5a5.5 5.5 0 0 1 11 0v.5a1 1 0 0 0 2 0zm9-5a7 7 0 0 0 -11.667-5.217 1 1 0 1 0 1.334 1.49 5 5 0 0 1 8.333 3.727 1 1 0 0 0 2 0zm-6.5-9a4.5 4.5 0 1 1 4.5-4.5 4.505 4.505 0 0 1 -4.5 4.5zm0-7a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0 -2.5-2.5z"
                />
            </svg>
        </template>
        <template v-if="icon === 'lock'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.76 20.84">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M14.92,8.34h-.5V6.09a6,6,0,1,0-12.08,0V8.34h-.5A1.84,1.84,0,0,0,0,10.19V19a1.84,1.84,0,0,0,1.84,1.85H14.92A1.85,1.85,0,0,0,16.76,19v-8.8A1.85,1.85,0,0,0,14.92,8.34ZM9.15,14.71v1.15a.31.31,0,0,1-.31.31H7.92a.31.31,0,0,1-.31-.31V14.71a1.47,1.47,0,1,1,1.54,0Zm2.62-6.37H5V6.09a3.39,3.39,0,1,1,6.78,0V8.34Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'locked'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.24 14.72">
                <g>
                    <g>
                        <path
                            d="M12.24,6.69a2.79,2.79,0,0,0-.78-1.44A2.38,2.38,0,0,0,10,4.61v0A5,5,0,0,0,9.51,2a3.49,3.49,0,0,0-2.79-2L6.56,0H5.67l-.21,0A4.15,4.15,0,0,0,5,.16,3.71,3.71,0,0,0,2.3,3.33a7.65,7.65,0,0,0-.08,1.28,2.43,2.43,0,0,0-2.2,2l0,5.92.05.2a3.12,3.12,0,0,0,.39.88,2.66,2.66,0,0,0,1.71,1.07h8a2.67,2.67,0,0,0,1.62-1,3,3,0,0,0,.47-1.2V6.69Zm-1.77.5v5a.71.71,0,0,1-.81.81H2.58c-.55,0-.81-.26-.81-.82v-5a.7.7,0,0,1,.8-.8H9.65C10.23,6.36,10.47,6.61,10.47,7.19ZM4.27,4.6a3.25,3.25,0,0,1,.41-1.83,1.62,1.62,0,0,1,1.62-.7A1.52,1.52,0,0,1,7.7,3,3.67,3.67,0,0,1,8,4.6H4.27Z"
                        />
                        <path
                            d="M5.21,8.21a1.31,1.31,0,0,0-.38.95,1.19,1.19,0,0,0,.4.88.33.33,0,0,1,.13.31,2,2,0,0,0,0,.25v.58a.77.77,0,0,0,.77.8h0a.76.76,0,0,0,.75-.79c0-.28,0-.57,0-.85A.3.3,0,0,1,7,10.05a1.26,1.26,0,0,0,.41-.89A1.32,1.32,0,0,0,7,8.22,1.3,1.3,0,0,0,5.21,8.21Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'login'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.52 16.35">
                <g>
                    <g>
                        <path
                            d="M17.63,3a8,8,0,0,0-6.57-3,8.15,8.15,0,0,0-6.42,3.5,1.39,1.39,0,0,0-.26,1,1.23,1.23,0,0,0,.54.79A1.25,1.25,0,0,0,6.64,4.9a5.59,5.59,0,0,1,5.7-2.38,5.68,5.68,0,0,1,4.74,5.6,6,6,0,0,1-.26,1.77,5.76,5.76,0,0,1-6,4,5.62,5.62,0,0,1-4.18-2.44,1.19,1.19,0,0,0-1.73-.38,1.23,1.23,0,0,0-.24,1.81,8.22,8.22,0,0,0,6.69,3.49,7.83,7.83,0,0,0,1.6-.17A8.15,8.15,0,0,0,17.63,3Z"
                        />
                        <path
                            d="M9.55,9.42c-.27.25-.54.5-.8.77a1.21,1.21,0,0,0,0,1.74,1.16,1.16,0,0,0,.84.37,1.27,1.27,0,0,0,.9-.39c1-1,1.93-1.91,2.88-2.88a1.19,1.19,0,0,0,0-1.72c-1-1-1.93-1.94-2.9-2.9A1.16,1.16,0,0,0,9.3,4.08a1.23,1.23,0,0,0-.88.83,1.28,1.28,0,0,0,.3,1.21c.25.27.52.54.81.82H1.45C.57,6.94,0,7.42,0,8.17S.57,9.39,1.44,9.4H9.57Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'logo'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 326.89 43.92">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M71.16,1.19l-13.44,42H42.54L35.76,20.75,28.62,43.19H13.44L0,1.19H14.58L21.9,25.07,29.64,1.19h13L50,25.37,57.72,1.19Z"
                        />
                        <path class="cls-1" d="M78.18,1.19H92.34v42H78.18Z" />
                        <path class="cls-1" d="M140.16,32.21v11H101.58v-8.7l19.2-22.32h-18.6v-11h37v8.7L120,32.21Z" />
                        <path class="cls-1" d="M148.2,1.19h14.16v42H148.2Z" />
                        <path
                            class="cls-1"
                            d="M210.6,43.19l-.12-19.14-9.12,15.36h-6.24L186,24.71V43.19H173.1v-42h11.64l13.68,22.38L211.74,1.19h11.64l.12,42Z"
                        />
                        <path class="cls-2" d="M231.91,35.76c0-4.62,3.42-7.68,7.92-7.68s7.92,3.06,7.92,7.68a7.92,7.92,0,0,1-15.84,0Z" />
                        <path class="cls-2" d="M256.27,1h14.16V43H256.27Z" />
                        <path
                            class="cls-2"
                            d="M279.49,22c0-12.72,10-22,23.7-22s23.7,9.24,23.7,22-10,22-23.7,22S279.49,34.68,279.49,22Zm33.12,0c0-6.54-4.2-10.5-9.42-10.5s-9.42,4-9.42,10.5,4.2,10.5,9.42,10.5S312.61,28.5,312.61,22Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'logo2'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 2000 2000"
                style="enable-background: new 0 0 2000 2000"
                xml:space="preserve"
            >
                <path
                    class="st0"
                    d="M1000,1139.1l-202.7,351.1c-64.3,111.4-225.2,111.4-289.4,0l-234.7-406.5L38.5,677 c-64.3-111.4,16.1-250.6,144.7-250.6H878c-128.6,0-209,139.2-144.7,250.6l234.6,406.4L1000,1139.1z"
                />
                <path
                    class="st1"
                    d="M1266.7,676.9L1032,1083.5l-32,55.6l-32.2-55.6L733.1,676.9c-64.3-111.4,16.1-250.6,144.7-250.6h244.1 C1250.7,426.3,1331,565.5,1266.7,676.9z"
                />
                <path
                    class="st2"
                    d="M1961.5,676.9l-234.7,406.6L1492,1490c-64.3,111.4-225.2,111.4-289.4,0L1000,1139.1l32-55.5L1266.7,677 c64.3-111.4-16.1-250.6-144.7-250.6h694.8C1945.4,426.3,2025.8,565.5,1961.5,676.9z"
                />
            </svg>
        </template>
        <template v-if="icon === 'logotxt'">
            <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 1336.5 295.8"
                style="enable-background: new 0 0 1336.5 295.8"
                xml:space="preserve"
            >
                <g class="st0">
                    <path
                        class="st1"
                        d="M314.6,57.3L254.7,242h-55.9l-35.4-112.4L126.5,242H70.5L10.6,57.3h53.8l37.2,118l39.1-118h48l37.2,119 l38.8-119H314.6z"
                    />
                </g>
                <g class="st0">
                    <path class="st1" d="M336,57.3h52.2V242H336V57.3z" />
                    <path class="st1" d="M581.7,200.6V242H416.2v-32.7l93.2-110.6h-90.8V57.3h159.1V90l-93.2,110.6H581.7z" />
                    <path class="st1" d="M604.6,57.3h52.2V242h-52.2V57.3z" />
                    <path
                        class="st1"
                        d="M860.8,242l-0.5-97.9l-47.5,79.7h-23.2l-47.2-77.1V242h-48.3V57.3h43L802,163.9l63.3-106.6h43l0.5,184.7H860.8 z"
                    />
                </g>
                <g>
                    <defs>
                        <path
                            id="SVGID_1_"
                            d="M934.2,211.6c0-17.9,13.2-29.6,30.1-29.6c17.2,0,30.1,11.6,30.1,29.6c0,17.4-12.9,29.8-30.1,29.8 C947.4,241.4,934.2,229,934.2,211.6z M1020.2,54.3h52.2V239h-52.2V54.3z M1100.1,146.7c0-55.4,43.5-96.1,102.7-96.1 c59.1,0,102.7,40.6,102.7,96.1c0,55.4-43.5,96.1-102.7,96.1C1143.7,242.7,1100.1,202.1,1100.1,146.7z M1252.7,146.7 c0-31.9-21.9-52.8-49.9-52.8c-28,0-49.9,20.8-49.9,52.8c0,31.9,21.9,52.8,49.9,52.8C1230.8,199.5,1252.7,178.6,1252.7,146.7z"
                        />
                    </defs>
                    <clipPath id="SVGID_00000117674537159623117030000000930381964517668012_">
                        <use xlink:href="#SVGID_1_" style="overflow: visible" />
                    </clipPath>
                    <g style="clip-path: url(#SVGID_00000117674537159623117030000000930381964517668012_)">
                        <linearGradient
                            id="SVGID_00000114772608652049172780000012007563204764820135_"
                            gradientUnits="userSpaceOnUse"
                            x1="1020.2347"
                            y1="782.5593"
                            x2="1219.5254"
                            y2="1127.7505"
                            gradientTransform="matrix(1 0 0 1 0 -808.26)"
                        >
                            <stop offset="0" style="stop-color: #dcc8fc" />
                            <stop offset="0.61" style="stop-color: #b9d8f9" />
                            <stop offset="1" style="stop-color: #a2e1a2" />
                        </linearGradient>
                        <rect
                            x="911.2"
                            y="37.2"
                            style="fill: url(#SVGID_00000114772608652049172780000012007563204764820135_)"
                            width="417.3"
                            height="219.4"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'mail'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.43 11.31">
                <g>
                    <g>
                        <path
                            d="M14.43,1.55A1.47,1.47,0,0,0,14,.43,1.56,1.56,0,0,0,12.89,0C11.52,0,10.16,0,8.8,0H1.5A1.39,1.39,0,0,0,0,1.51V9.79a1.41,1.41,0,0,0,1.51,1.52H12.93A1.48,1.48,0,0,0,14,10.89a1.54,1.54,0,0,0,.42-1.09C14.41,6.78,14.41,4.08,14.43,1.55ZM1.58,2.9,3.77,5.24q-1,1.37-2,2.73l-.18.24Zm2.19,5L4.86,6.41A3.26,3.26,0,0,0,9,6.86a3.21,3.21,0,0,0,.6-.49L12,9.71H2.43Zm8.14-6.3Q10.23,3.4,8.54,5.21a1.82,1.82,0,0,1-1.33.63h0a1.8,1.8,0,0,1-1.29-.6c-.94-1-1.87-2-2.81-3l-.6-.65Zm.92,6.62-2.12-3c.71-.75,1.41-1.5,2.12-2.27Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'mapMarker2'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.06 26.6">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M18.05,8.54c0-.07,0-.14,0-.21V8.05a.88.88,0,0,1,0-.17l0-.12a1.1,1.1,0,0,0,0-.18.59.59,0,0,0,0-.14l0-.12,0-.2,0-.16,0-.15,0-.15a1.6,1.6,0,0,1-.05-.21l0-.12,0-.11L17.62,6l0-.1,0-.11a1.43,1.43,0,0,1-.08-.22l0-.09a.3.3,0,0,0,0-.1,1.86,1.86,0,0,0-.1-.25l0-.09,0-.07c0-.11-.1-.21-.16-.32l0-.07-.18-.33,0,0c-.06-.11-.13-.21-.2-.33l0,0-.22-.32,0,0-.24-.31,0,0-.27-.32-.29-.3h0A9,9,0,0,0,9,0,8.64,8.64,0,0,0,0,9a9.69,9.69,0,0,0,1.21,4.69l.14.25,0,0,.22.35.07.1,5.77,9.7h0L8.77,26.4a.4.4,0,0,0,.34.2h0a.4.4,0,0,0,.35-.2l1.3-2.25h0l5.63-9.69.14-.21a2.29,2.29,0,0,1,.15-.24l0,0,.3-.54A9.64,9.64,0,0,0,18.06,9C18.06,8.86,18.05,8.7,18.05,8.54Zm-3.87.6s0,.07,0,.11l0,.18,0,.23c0,.05,0,.1,0,.16L14,10a.83.83,0,0,1,0,.15c0,.07-.05.14-.07.21l-.07.17,0,.1-.13.27,0,0,0,.08,0,.06c-.06.11-.13.22-.2.33l-.06.09c-.08.12-.16.24-.25.35l0,.05-.33.37A5.17,5.17,0,0,1,9.06,13.8H9A5.2,5.2,0,0,1,9,3.42h.06a5.12,5.12,0,0,1,3.62,1.52l0,0c.12.12.22.24.32.36l0,0c.09.11.17.23.27.38l0,.06c.07.11.14.22.2.33l0,.06.05.11a2.59,2.59,0,0,1,.14.29l0,.09.07.17c0,.07,0,.14.07.21a.83.83,0,0,1,0,.15l.05.18c0,.06,0,.11,0,.17l0,.23,0,.18s0,.07,0,.1c0,.18,0,.35,0,.53S14.19,9,14.18,9.14Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'mapMarker'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.71 15.61">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            id="Icon_awesome-map-marker-alt"
                            data-name="Icon awesome-map-marker-alt"
                            class="cls-1"
                            d="M5.25,15.29C.82,8.87,0,8.21,0,5.85a5.86,5.86,0,0,1,11.71,0c0,2.36-.82,3-5.25,9.44a.73.73,0,0,1-1,.19A.58.58,0,0,1,5.25,15.29Zm.6-7A2.44,2.44,0,1,0,3.41,5.85h0A2.44,2.44,0,0,0,5.85,8.29Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'map'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.25 20.55">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M0,20l.76-1.53q1.64-3.39,3.29-6.76a.54.54,0,0,1,.57-.36H7.85a.6.6,0,0,1,.49.22l1.19,1.33s.09.07.1.14-.12,0-.18,0H5.68a.56.56,0,0,0-.57.35c-.83,1.74-1.68,3.47-2.53,5.21l-.07.17H23.74c0-.07,0-.12-.07-.17-.84-1.74-1.69-3.47-2.53-5.21a.55.55,0,0,0-.56-.35h-4l.26-.31,1.08-1.19a.56.56,0,0,1,.47-.21h3.27a.52.52,0,0,1,.54.34l4,8.16c.2.4,0,.65-.4.66H.52c-.23,0-.42,0-.52-.27Z"
                        />
                        <path
                            class="cls-1"
                            d="M13,0A6,6,0,0,1,19,4.86,6.32,6.32,0,0,1,17.84,9.8c-.53.74-4.54,6.16-4.7,6.17s-4.28-5.52-4.76-6.2A6.16,6.16,0,0,1,7.22,5.48,6.07,6.07,0,0,1,8.77,2,5.67,5.67,0,0,1,13,0ZM10.89,5.87a2.24,2.24,0,1,0,2.17-2.22A2.23,2.23,0,0,0,10.89,5.87Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'menu'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.31 11.63">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            id="Icon_awesome-list-ul"
                            data-name="Icon awesome-list-ul"
                            class="cls-1"
                            d="M1.34,0A1.34,1.34,0,1,0,2.68,1.34h0A1.34,1.34,0,0,0,1.34,0Zm0,4.47A1.34,1.34,0,0,0,0,5.81,1.36,1.36,0,0,0,1.34,7.16,1.35,1.35,0,0,0,2.68,5.81h0A1.34,1.34,0,0,0,1.34,4.47Zm0,4.47a1.35,1.35,0,1,0,1.34,1.35h0A1.34,1.34,0,0,0,1.34,8.94Zm12.52.45H4.92a.45.45,0,0,0-.45.45v.89a.45.45,0,0,0,.45.45h8.94a.45.45,0,0,0,.45-.45h0V9.84a.45.45,0,0,0-.45-.45Zm0-8.94H4.92a.45.45,0,0,0-.45.44v.9a.45.45,0,0,0,.45.45h8.94a.45.45,0,0,0,.45-.45h0V.89A.45.45,0,0,0,13.86.45Zm0,4.47H4.92a.45.45,0,0,0-.45.45v.89a.45.45,0,0,0,.45.45h8.94a.45.45,0,0,0,.45-.45h0V5.37a.45.45,0,0,0-.45-.45Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'pen'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.15 16.15">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M13.28,0a2.74,2.74,0,0,1,2.66,1.61,2.61,2.61,0,0,1-.56,2.89L12,7.91,5.55,14.34a1.13,1.13,0,0,1-.48.29L.65,16.1A.45.45,0,0,1,.13,16,.47.47,0,0,1,0,15.5Q.81,13.24,1.55,11a1.06,1.06,0,0,1,.22-.33l9.17-9.16.71-.72A2.51,2.51,0,0,1,13.28,0Zm-.41,3.87-.08-.08-.35-.36c-.2-.19-.15-.19-.35,0L5.93,9.6,3.68,11.85c-.1.09-.12.15,0,.25a2.32,2.32,0,0,1,.35.35c.12.15.19.12.31,0L8.79,8l4-4A.31.31,0,0,0,12.87,3.87Zm-.94-.93-.07-.09c-.13-.13-.27-.25-.39-.39s-.17-.1-.28,0C9.46,4.21,7.72,5.94,6,7.68L2.77,10.89c-.15.15-.15.15,0,.31s.22.2.31.32.19.11.3,0l5.1-5.11C9.6,5.3,10.71,4.2,11.81,3.09A.36.36,0,0,0,11.93,2.94ZM13.79,4.8s0,0-.06-.07a4.64,4.64,0,0,1-.38-.39c-.11-.13-.18-.12-.3,0L8,9.42,4.6,12.79c-.09.09-.11.14,0,.23a4.31,4.31,0,0,1,.37.37c.1.13.17.12.29,0l5.58-5.58L13.68,5S13.78,4.88,13.79,4.8Zm1.48-2.06a1.78,1.78,0,0,0-2-1.84,1.91,1.91,0,0,0-1.21.69c-.09.09-.1.14,0,.23.33.32.65.65,1,1l1.3,1.3s.08.12.16,0A1.91,1.91,0,0,0,15.27,2.74Zm-11,11.18-.08-.08c-.62-.62-1.24-1.23-1.85-1.86-.12-.12-.15-.08-.2.06-.16.52-.34,1-.52,1.56a.17.17,0,0,0,0,.21l.69.69s.08.09.15.06L4.18,14S4.25,14,4.25,13.92Zm-2.3.8-.46-.45s-.09-.06-.11,0a5,5,0,0,0-.22.72l.69-.22Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'phone'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.05 32.35">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M10.1,14l1-1.08a4.48,4.48,0,0,0-.32-6.35L9.11,5.09a4.45,4.45,0,0,0-3-1.16A4.49,4.49,0,0,0,2.77,5.41l-1,1.08a3.94,3.94,0,0,0-.36.45l0,0A5.47,5.47,0,0,0,.13,12.05,25.22,25.22,0,0,0,22.54,32.32a6.33,6.33,0,0,0,3.86-.81,4.49,4.49,0,0,0,1.1-.88l1-1.08a4.5,4.5,0,0,0-.32-6.35l-1.65-1.49a4.5,4.5,0,0,0-6.35.32l-1,1.08a4.43,4.43,0,0,0-.93,1.58l-.09.26-.26-.1a19,19,0,0,1-10-9.18l-.14-.28.3-.09A4.51,4.51,0,0,0,10.1,14Z"
                            transform="translate(0)"
                        />
                        <path
                            class="cls-1"
                            d="M15.59,1.05a1,1,0,0,0,1.05,1A13.33,13.33,0,0,1,30,15.41a1.05,1.05,0,1,0,2.1,0A15.43,15.43,0,0,0,16.64,0,1,1,0,0,0,15.59,1.05Z"
                            transform="translate(0)"
                        />
                        <path
                            class="cls-1"
                            d="M15.42,6.17a1,1,0,0,0,1,1,8.37,8.37,0,0,1,8.36,8.36,1,1,0,1,0,2.09,0A10.46,10.46,0,0,0,16.47,5.13,1,1,0,0,0,15.42,6.17Z"
                            transform="translate(0)"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'pie'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.14 25.03">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path class="cls-1" d="M20.69,2.72A10.57,10.57,0,0,0,13.85.07l-.06,9.76Z" />
                        <path class="cls-1" d="M12,0C5.1,0,0,5.6,0,12.51A12.51,12.51,0,0,0,12.51,25c4.85,0,9.36-2.86,11-6.55l-11.26-6V0Z" />
                        <polygon class="cls-1" points="18.47 7.21 16.66 12.98 17.7 13.54 20.27 5.36 18.47 7.21" />
                        <polygon class="cls-1" points="16.13 9.61 15.3 12.26 16.35 12.82 17.94 7.76 16.13 9.61" />
                        <path class="cls-1" d="M23.56,6.13l-2.84,9,1.05.56L24.3,7.64A11.73,11.73,0,0,0,23.56,6.13Z" />
                        <path class="cls-1" d="M24.5,8.16l-2.42,7.73,1,.56L25,10.35A11.68,11.68,0,0,0,24.5,8.16Z" />
                        <path class="cls-1" d="M25.14,11.81c0-.2,0-.4,0-.59l-1.7,5.39.62.33A11.26,11.26,0,0,0,25.14,11.81Z" />
                        <path class="cls-1" d="M21.78,3.81l-1,1L18,13.71l1,.56,3.14-10Z" />
                        <polygon class="cls-1" points="14.15 11.64 14.99 12.09 15.6 10.16 14.15 11.64" />
                        <path class="cls-1" d="M22.46,4.57l-3.09,9.86,1,.56,2.91-9.25A12.58,12.58,0,0,0,22.46,4.57Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'profile'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.66 21.01">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M19.57,2A2.63,2.63,0,0,0,16.9,0H2.82A2.64,2.64,0,0,0,0,2.81V18.17c0,.74.3,1,1,1H7.58a.22.22,0,0,1,.18.06l1.09,1.1.31.3a.93.93,0,0,0,.67.34,1,1,0,0,0,.68-.34l.28-.29c.37-.37.75-.74,1.11-1.11,0-.05.07-.06.16-.06h6.63a.87.87,0,0,0,1-1V2.73A2.89,2.89,0,0,0,19.57,2ZM18,17.56H11.78a1.11,1.11,0,0,0-.86.36l-.65.66c-.15.14-.29.29-.44.44l-.45-.45-.64-.65a1.11,1.11,0,0,0-.86-.36H1.64c0-3.94,0-7.87,0-11.81v-3A1,1,0,0,1,2.78,1.65H16.87A1,1,0,0,1,18,2.79Z"
                        />
                        <path
                            class="cls-1"
                            d="M14.31,12.4a6.59,6.59,0,0,0-1.4-.71l-.26-.11a3.37,3.37,0,0,1-.71-.36.17.17,0,0,1-.09-.16v-.18c0-.29,0-.42.11-.54a.8.8,0,0,0,.19-.32l.09-.23a2.17,2.17,0,0,1,.34-.66,1.57,1.57,0,0,0,.21-1.7,3.09,3.09,0,0,0-.08-2.19,2.09,2.09,0,0,0-1.57-1.42l-.08.36V3.75a.88.88,0,0,0-1-.59l-.25,0c-.17,0-.35,0-.52.06A3.41,3.41,0,0,0,7,4.66a3.24,3.24,0,0,0-.4,2.57c0,.18,0,.22,0,.27a1,1,0,0,0-.11.81l0,.12a1.39,1.39,0,0,0,.51,1,5.13,5.13,0,0,0,.53,1.21v.21c0,.41,0,.41-.55.68l-.31.14-.1,0a8.08,8.08,0,0,0-1.17.6,3,3,0,0,0-1.4,2.22,1,1,0,0,0,.18.84,1,1,0,0,0,.82.27h9.58a.82.82,0,0,0,.92-1A2.91,2.91,0,0,0,14.31,12.4Zm-5.61,0a1.6,1.6,0,0,0,.55-1.25c0-.14,0-.28,0-.42a1.53,1.53,0,0,0-.4-1.26,1.07,1.07,0,0,1-.21-.59,1,1,0,0,0-.5-.74.86.86,0,0,0,.13-1,1.79,1.79,0,0,1-.1-1.09A1.49,1.49,0,0,1,9.33,5l.22,0,.15,0,.09,0a.71.71,0,0,0,.58.45c.68.14.9.39.93,1.1a1.42,1.42,0,0,1-.14.77.78.78,0,0,0,.09.89l0,.1a.87.87,0,0,0-.41.61,1.51,1.51,0,0,1-.39.89.77.77,0,0,0-.22.59v.21c0,.19,0,.38,0,.57A1.7,1.7,0,0,0,11,12.56a4.75,4.75,0,0,0,1.19.6l.07,0a6.89,6.89,0,0,1,1.09.53,3.23,3.23,0,0,1,.27.23H6a1.77,1.77,0,0,1,.62-.45l.8-.38.47-.21A3,3,0,0,0,8.7,12.39Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'removePlain'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.07 27.07">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="13.54" cy="13.54" r="13.54" />
                        <path
                            class="cls-2"
                            d="M15.66,13.54l3.86-3.87A1.5,1.5,0,1,0,17.4,7.55l-3.86,3.86L9.67,7.55A1.5,1.5,0,1,0,7.55,9.67l3.86,3.87L7.55,17.4A1.5,1.5,0,0,0,8.61,20a1.49,1.49,0,0,0,1.06-.44l3.87-3.86,3.86,3.86a1.49,1.49,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'remove'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.96 22.96">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M11.48,0A11.48,11.48,0,1,0,23,11.48,11.49,11.49,0,0,0,11.48,0Zm0,22A10.48,10.48,0,1,1,22,11.48,10.49,10.49,0,0,1,11.48,22Z"
                        />
                        <path
                            class="cls-1"
                            d="M16.22,6.81a1,1,0,0,0-1.41,0l-3.33,3.33L8.15,6.81A1,1,0,1,0,6.74,8.23l3.32,3.33L6.74,14.88a1,1,0,0,0,0,1.42,1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29L11.48,13l3.33,3.33a1,1,0,1,0,1.41-1.42l-3.33-3.32,3.33-3.33A1,1,0,0,0,16.22,6.81Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'rightArrow'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.59 17.18">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M2,17.18a2,2,0,0,1-1.41-.59,2,2,0,0,1,0-2.83L5.76,8.59.59,3.41A2,2,0,0,1,.59.59a2,2,0,0,1,2.82,0L10,7.18A2,2,0,0,1,10,10L3.41,16.59A2,2,0,0,1,2,17.18Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'save'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.28 29.3">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M15.62,8.76h1.29a.39.39,0,0,1,.39.39v2.59a.38.38,0,0,1-.38.38H15.62a.38.38,0,0,1-.38-.38V9.14a.39.39,0,0,1,.39-.39Z"
                        />
                        <path
                            class="cls-1"
                            d="M21.25,9.6,19.44,7.79a1.39,1.39,0,0,0-.87-.34H8.94A1.14,1.14,0,0,0,7.8,8.6V20.7A1.14,1.14,0,0,0,9,21.84H20.34a1.15,1.15,0,0,0,1.14-1.15s0-10.32,0-10.48A.82.82,0,0,0,21.25,9.6ZM18,8.16v3.9a.73.73,0,0,1-.68.66h-5a.69.69,0,0,1-.66-.66V8.16Zm1.56,12.52H9.72V15.23a.73.73,0,0,1,.71-.74h8.42a.73.73,0,0,1,.71.74Z"
                        />
                        <path
                            class="cls-1"
                            d="M14.64,0A14.65,14.65,0,1,0,29.28,14.65,14.66,14.66,0,0,0,14.64,0Zm0,28.3A13.65,13.65,0,1,1,28.28,14.65,13.65,13.65,0,0,1,14.64,28.3Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'searchAdd'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.63 23.65">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M0,8.59c.06-.38.11-.76.18-1.14A9.23,9.23,0,0,1,17.9,6a9,9,0,0,1-1.23,8.67c-.12.17-.13.26,0,.41,2.15,2.14,4.27,4.31,6.45,6.42a1.18,1.18,0,0,1-.36,2.11h-.46a2.14,2.14,0,0,1-.8-.57l-6.41-6.42c-.13-.13-.2-.13-.35,0a9.12,9.12,0,0,1-7.07,1.7A9.24,9.24,0,0,1,.18,11C.11,10.64.06,10.26,0,9.88Zm2.22.62a7,7,0,1,0,7-7A7,7,0,0,0,2.22,9.21Z"
                        />
                        <path
                            class="cls-1"
                            d="M8.13,11.75c0-.39,0-.77,0-1.15,0-.23-.07-.27-.27-.26H5.63a1.11,1.11,0,1,1,0-2.22H7.87c.2,0,.27,0,.27-.26,0-.76,0-1.52,0-2.29a1.11,1.11,0,1,1,2.22,0c0,.77,0,1.53,0,2.29,0,.19,0,.26.24.26.77,0,1.53,0,2.29,0a1.12,1.12,0,0,1,1.17,1.11,1.11,1.11,0,0,1-1.17,1.11H10.61c-.2,0-.27,0-.27.25,0,.77,0,1.53,0,2.29a1.11,1.11,0,1,1-2.22,0Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'searchLess'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_101_2)">
                    <path
                        d="M0 8.59C0.06 8.21 0.11 7.83 0.18 7.45C0.562098 5.4715 1.58116 3.67241 3.08161 2.32738C4.58205 0.982348 6.48144 0.165293 8.48978 0.000953993C10.4981 -0.163385 12.5051 0.33402 14.2042 1.41723C15.9034 2.50044 17.2013 4.10994 17.9 6C18.4501 7.43033 18.6258 8.97742 18.4106 10.4947C18.1953 12.0119 17.5962 13.4491 16.67 14.67C16.55 14.84 16.54 14.93 16.67 15.08C18.82 17.22 20.94 19.39 23.12 21.5C23.3052 21.6277 23.45 21.8057 23.5374 22.0129C23.6248 22.2202 23.6511 22.4481 23.6133 22.6699C23.5755 22.8916 23.475 23.0979 23.3239 23.2645C23.1727 23.431 22.977 23.5509 22.76 23.61H22.3C21.9927 23.4846 21.7189 23.2895 21.5 23.04L15.09 16.62C14.96 16.49 14.89 16.49 14.74 16.62C13.7411 17.3731 12.598 17.9126 11.3818 18.2051C10.1655 18.4976 8.90204 18.5367 7.67 18.32C5.82749 18.0011 4.1251 17.1306 2.78778 15.8236C1.45046 14.5167 0.541153 12.8347 0.18 11C0.11 10.64 0.06 10.26 0 9.88V8.59ZM2.22 9.21C2.22 10.5945 2.63054 11.9478 3.39971 13.099C4.16888 14.2501 5.26213 15.1473 6.54122 15.6772C7.8203 16.207 9.22777 16.3456 10.5856 16.0755C11.9435 15.8054 13.1908 15.1387 14.1697 14.1597C15.1487 13.1808 15.8154 11.9335 16.0855 10.5756C16.3556 9.21776 16.217 7.8103 15.6872 6.53122C15.1573 5.25213 14.2601 4.15888 13.109 3.38971C11.9578 2.62054 10.6045 2.21 9.22 2.21C7.36348 2.21 5.58301 2.9475 4.27025 4.26025C2.9575 5.57301 2.22 7.35348 2.22 9.21Z"
                        fill="white"
                    />
                    <path
                        d="M5.63 10.34C5.33561 10.34 5.05328 10.2231 4.84512 10.0149C4.63695 9.80672 4.52 9.52439 4.52 9.23C4.52 8.93561 4.63695 8.65328 4.84512 8.44511C5.05328 8.23695 5.33561 8.12 5.63 8.12H12.89C13.0404 8.11327 13.1906 8.13694 13.3316 8.18958C13.4727 8.24221 13.6017 8.32275 13.7109 8.42636C13.8201 8.52998 13.9073 8.65455 13.9673 8.79263C14.0273 8.9307 14.0588 9.07946 14.06 9.23C14.0602 9.38096 14.0297 9.53037 13.9702 9.66911C13.9107 9.80785 13.8235 9.93299 13.714 10.0369C13.6045 10.1408 13.4749 10.2213 13.3332 10.2734C13.1916 10.3255 13.0407 10.3482 12.89 10.34H5.63Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_101_2">
                        <rect width="23.63" height="23.65" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>
        <template v-if="icon === 'search'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.27 24.27">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M23.83,21.71l-4.15-4.16a11,11,0,1,0-2.13,2.13l4.16,4.15a1.5,1.5,0,0,0,2.12,0A1.49,1.49,0,0,0,23.83,21.71ZM3,11a8,8,0,1,1,13.6,5.6l0,0,0,0A7.95,7.95,0,0,1,3,11Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'sebmenuSquare'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.69 25.68">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M21.19,0H6.5A6.51,6.51,0,0,0,0,6.5V19.18a6.51,6.51,0,0,0,6.5,6.5H21.19a6.51,6.51,0,0,0,6.5-6.5V6.5A6.51,6.51,0,0,0,21.19,0Zm5.5,19.18a5.5,5.5,0,0,1-5.5,5.5H6.5A5.5,5.5,0,0,1,1,19.18V6.5A5.51,5.51,0,0,1,6.5,1H21.19a5.51,5.51,0,0,1,5.5,5.5Z"
                        />
                        <circle class="cls-1" cx="8.78" cy="12.83" r="1.65" />
                        <circle class="cls-1" cx="13.82" cy="12.83" r="1.65" />
                        <circle class="cls-1" cx="18.85" cy="12.83" r="1.65" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'settings'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.51 17.04">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M1,3.53H3.73a2.52,2.52,0,0,0,4.64,0H21.51a1,1,0,1,0,0-2H8.37a2.52,2.52,0,0,0-4.64,0H1a1,1,0,0,0,0,2Z"
                        />
                        <path
                            class="cls-1"
                            d="M21.51,7.52h-3.1a2.52,2.52,0,0,0-4.64,0H1a1,1,0,0,0,0,2H13.77a2.52,2.52,0,0,0,4.64,0h3.1a1,1,0,0,0,0-2Z"
                        />
                        <path
                            class="cls-1"
                            d="M21.51,13.51H11.09a2.67,2.67,0,0,0-.53-.79h0a2.59,2.59,0,0,0-3.57,0,2.5,2.5,0,0,0-.53.79H1a1,1,0,0,0,0,2H6.46A2.29,2.29,0,0,0,7,16.3a2.52,2.52,0,0,0,3.57,0,2.44,2.44,0,0,0,.53-.79H21.51a1,1,0,0,0,0-2Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'smallLogo'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 326.49 189.38">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M124.5,182.09a15.13,15.13,0,0,1-25.87,0l-48.7-80.37L2.21,23A15.13,15.13,0,0,1,15.15,0H208a15.12,15.12,0,0,1,12.93,23l-47.72,78.76Z"
                        />
                        <path
                            class="cls-2"
                            d="M227.86,182.09a15.12,15.12,0,0,1-25.86,0l-48.7-80.37L105.58,23A15.12,15.12,0,0,1,118.51,0H311.35a15.12,15.12,0,0,1,12.93,23l-47.72,78.76Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'smallLogo2'">
            <svg
                id="Calque_1"
                data-name="Calque 1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 1326.82 260.34"
            >
                <defs>
                    <clipPath id="clip-path" transform="translate(-288.38 -416.06)">
                        <text class="cls-1" transform="translate(1371.77 605.92)">.IO</text>
                    </clipPath>
                    <linearGradient id="Dégradé_sans_nom_28" x1="1139.9" y1="29.34" x2="1260.74" y2="238.65" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stop-color="#dcc8fc" />
                        <stop offset="0.61" stop-color="#b9d8f9" />
                        <stop offset="1" stop-color="#a2e1a2" />
                    </linearGradient>
                </defs>
                <text class="cls-5" transform="translate(516.45 189.36)">
                    W
                    <tspan class="cls-6" x="188.64" y="0">IZIM</tspan>
                </text>
                <g class="cls-7">
                    <rect class="cls-8" x="1073.82" y="67.49" width="253" height="133" />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'submenu'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.47 15.47">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M7.74,0a7.74,7.74,0,1,0,7.73,7.74A7.73,7.73,0,0,0,7.74,0Zm-4,9a1.31,1.31,0,0,1,0-2.61A1.31,1.31,0,1,1,3.74,9Zm4,0A1.31,1.31,0,1,1,9,7.74,1.31,1.31,0,0,1,7.74,9Zm4,0a1.31,1.31,0,0,1,0-2.61,1.31,1.31,0,1,1,0,2.61Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'target'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.44 16.15">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M7.77.56a8,8,0,0,1,4.17,1.18c.38.23.46.36.11.75a1.09,1.09,0,0,1-1.6.3A6.1,6.1,0,0,0,3.34,4a6.2,6.2,0,1,0,9.88,1.3c-.09-.18-.37-.36-.14-.6a4.74,4.74,0,0,1,1-.88c.15-.1.28.24.39.41A7.81,7.81,0,1,1,6.59.66C7,.6,7.38.59,7.77.56Z"
                        />
                        <path
                            class="cls-1"
                            d="M11.68,6a4.52,4.52,0,0,1-.33,5.22,4.56,4.56,0,0,1-5,1.45,4.49,4.49,0,0,1-3.07-4A4.55,4.55,0,0,1,9.44,4.09c.47.18.73.3.22.8a1.55,1.55,0,0,1-1.56.53,2.85,2.85,0,0,0-3,1.75,3,3,0,0,0,.71,3.38,2.93,2.93,0,0,0,3.48.4A2.9,2.9,0,0,0,10.7,7.76a.86.86,0,0,1,.3-1A6.12,6.12,0,0,0,11.68,6Z"
                        />
                        <path
                            class="cls-1"
                            d="M14.66,0c.07.52-.34,1.16.05,1.51s.95-.07,1.73,0L14.72,3.1c-.05,0-.12.11-.17.1-1-.07-1.4.71-2,1.25-1,1-2,2-3.06,3a1.12,1.12,0,0,0-.4.9A1.29,1.29,0,0,1,7.73,9.7,1.32,1.32,0,0,1,6.46,8.39,1.29,1.29,0,0,1,7.81,7a1,1,0,0,0,.78-.34l4-4a1,1,0,0,0,.32-.44A3.56,3.56,0,0,1,14.66,0Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'thumb'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.59 24.79">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M7.13,10.45H1.27A1.19,1.19,0,0,0,.06,11.78L0,23.3a.31.31,0,0,0,0,.1,1.64,1.64,0,0,0,1.57,1.39H9.07a1.18,1.18,0,0,0,1.2-1.29l-1.62-12h0A1.66,1.66,0,0,0,7.13,10.45Z"
                        />
                        <path
                            class="cls-1"
                            d="M27.58,15.43a2.74,2.74,0,0,0-1.09-2,1.78,1.78,0,0,0,.75-1.32,3.82,3.82,0,0,0-.92-2.8,3,3,0,0,0-2.27-.94H18.71c0-.78,0-2,.05-3.06A7.14,7.14,0,0,0,17.11.9,2.24,2.24,0,0,0,15.75,0a3.19,3.19,0,0,0-.45,0c-1,0-2.14.39-2.37,1.26A2.41,2.41,0,0,0,13,2.44a4.94,4.94,0,0,1,.12,2.22c-.29,1.64-2.76,5.6-3.56,6.33l1.67,12.34a19,19,0,0,0,5,1.35H22.9a2.48,2.48,0,0,0,2.42-1.37,2.27,2.27,0,0,0-.07-1.69v-.15a2,2,0,0,0,1.52-1.6,2.67,2.67,0,0,0-.43-2.09A2.2,2.2,0,0,0,27.58,15.43Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'trash'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.83 14.82">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M1.48,8.26c0-1.55,0-3.1,0-4.65,0-.13,0-.16-.16-.15H.51a.5.5,0,1,1,0-1H3.81c.12,0,.15,0,.14-.14v-1A1.45,1.45,0,0,1,5.3,0H8.53A1.45,1.45,0,0,1,9.88,1.36v1c0,.1,0,.13.12.13h3.31a.48.48,0,0,1,.47.28.49.49,0,0,1-.45.71h-.84c-.11,0-.15,0-.15.14q0,3.59,0,7.19v2a2,2,0,0,1-2,2H3.45a2,2,0,0,1-2-2Zm9.88,0V3.61c0-.12,0-.15-.14-.15H2.62c-.12,0-.15,0-.15.15v9.27a.86.86,0,0,0,.63.91,1.75,1.75,0,0,0,.4,0h6.91a.86.86,0,0,0,.91-.63,1.55,1.55,0,0,0,0-.37ZM6.91,2.47H8.77c.1,0,.12,0,.12-.12v-1c0-.27-.09-.37-.37-.37H5.3c-.26,0-.36.1-.36.36v1c0,.11,0,.12.13.12Z"
                        />
                        <path class="cls-1" d="M8.89,9.14V6.42a.5.5,0,0,1,.43-.49.5.5,0,0,1,.55.38.86.86,0,0,1,0,.16v5.35a.5.5,0,1,1-1,0Z" />
                        <path class="cls-1" d="M6.42,9.13V6.42a.49.49,0,0,1,1-.12.52.52,0,0,1,0,.17v5.35a.5.5,0,1,1-1,0Z" />
                        <path class="cls-1" d="M4,9.13V6.42a.49.49,0,0,1,1-.12.52.52,0,0,1,0,.17v5.35a.5.5,0,1,1-1,0Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'triangle'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.27 12.09">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <polygon class="cls-1" points="0 0 7.64 12.09 15.27 0 0 0" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'unlock'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.76 20.84">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M14.92,8.34H5V6.09a3.38,3.38,0,0,1,6.76-.21h2.66a6,6,0,0,0-12.07.21V8.34h-.5A1.84,1.84,0,0,0,0,10.19V19a1.84,1.84,0,0,0,1.84,1.85H14.92A1.85,1.85,0,0,0,16.76,19v-8.8A1.85,1.85,0,0,0,14.92,8.34ZM9.15,14.71v1.15a.31.31,0,0,1-.31.31H7.92a.31.31,0,0,1-.31-.31V14.71a1.47,1.47,0,1,1,1.54,0Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'update'">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="11" cy="11" r="11" fill="white" />
                <path
                    d="M15.3999 15.8151H16.9999V17.2318H12.9999V12.9818H14.3332V14.9155C15.5532 13.8743 16.3332 12.2876 16.3332 10.5026C16.3332 7.6197 14.2932 5.23261 11.6665 4.88553V3.4547C15.0332 3.80886 17.6665 6.82636 17.6665 10.5026C17.6665 12.6205 16.7865 14.5189 15.3999 15.8151ZM5.66652 10.5026C5.66652 8.71761 6.44652 7.12386 7.66652 6.0897V8.02345H8.99986V3.77345H4.99986V5.19011H6.59986C5.21319 6.48636 4.33319 8.3847 4.33319 10.5026C4.33319 14.1789 6.96652 17.1964 10.3332 17.5505V16.1197C7.70652 15.7726 5.66652 13.3855 5.66652 10.5026ZM13.8265 7.7472L10.0532 11.7564L8.16652 9.75178L7.22652 10.7505L10.0532 13.7539L14.7665 8.74595L13.8265 7.7472Z"
                    fill="#8C5117"
                />
            </svg>
        </template>
        <template v-if="icon === 'user'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.1 16.19">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M12.09,13.07c0,.57,0,1.14,0,1.71a.35.35,0,0,1-.22.37,10.59,10.59,0,0,1-2.8.82,15.68,15.68,0,0,1-3.35.2,19,19,0,0,1-4.23-.64L.23,15.18a.27.27,0,0,1-.22-.3c0-1.31-.06-1.39,0-2.7A4.35,4.35,0,0,1,1.71,9.1a4.52,4.52,0,0,1,3-1c1,0,1.92,0,2.89,0a4.47,4.47,0,0,1,4.07,2.59,4.52,4.52,0,0,1,.45,2C12.1,13.2,12.09,12.52,12.09,13.07Z"
                        />
                        <path class="cls-1" d="M6.05,7.09A3.55,3.55,0,1,1,9.6,3.56,3.53,3.53,0,0,1,6.05,7.09Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'useradd'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path d="M23,11H21V9a1,1,0,0,0-2,0v2H17a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V13h2a1,1,0,0,0,0-2Z" />
                <path d="M9,12A6,6,0,1,0,3,6,6.006,6.006,0,0,0,9,12ZM9,2A4,4,0,1,1,5,6,4,4,0,0,1,9,2Z" />
                <path d="M9,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,9,14Z" />
            </svg>
        </template>
        <template v-if="icon === 'cvtheque'">
            <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512">
                <path
                    d="M21,12H18a2,2,0,0,0-2,2,2,2,0,0,1-2,2H10a2,2,0,0,1-2-2,2,2,0,0,0-2-2H3a3,3,0,0,0-3,3v4a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V15A3,3,0,0,0,21,12Zm1,7a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V15a1,1,0,0,1,1-1H6a4,4,0,0,0,4,4h4a4,4,0,0,0,4-4h3a1,1,0,0,1,1,1Z"
                />
                <path d="M3,10H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z" />
                <path d="M3,6H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,6Z" />
            </svg>
        </template>
        <template v-if="icon === 'valid'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.07 27.07">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <circle class="cls-1" cx="13.54" cy="13.54" r="13.54" />
                        <path
                            class="cls-2"
                            d="M12.67,20.91a2,2,0,0,1-1.42-.59L5.37,14.45A2,2,0,0,1,8.2,11.62l4.27,4.26L18.66,7.8a2,2,0,0,1,3.18,2.43l-7.59,9.9a2,2,0,0,1-1.45.78Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'warning'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.84 21.61">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M22.52,17.61Q18.28,9.56,14,1.51A2.73,2.73,0,0,0,11.44,0,2.73,2.73,0,0,0,8.86,1.52Q4.59,9.54.33,17.59A2.62,2.62,0,0,0,0,19,2.76,2.76,0,0,0,2.88,21.6h17a4.35,4.35,0,0,0,.51,0A2.72,2.72,0,0,0,22.52,17.61Z"
                        />
                        <path
                            class="cls-2"
                            d="M12.81,7.24l-.54,6.53c0,.21,0,.42,0,.63,0,.48-.24.64-.78.65s-.77-.16-.81-.66c-.19-2.2-.37-4.41-.56-6.61,0-.19,0-.37,0-.55a1.32,1.32,0,0,1,1.37-1.38A1.32,1.32,0,0,1,12.81,7.24Z"
                        />
                        <path class="cls-2" d="M12.62,17.16a1.2,1.2,0,0,1-2.4,0,1.2,1.2,0,0,1,2.4,0Z" />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'website'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M13.144 8.171c-.035-.066.342-.102.409-.102.074.009-.196.452-.409.102zm-2.152-3.072l.108-.031c.064.055-.072.095-.051.136.086.155.021.248.008.332-.014.085-.104.048-.149.093-.053.066.258.075.262.085.011.033-.375.089-.304.171.096.136.824-.195.708-.176.225-.113.029-.125-.097-.19-.043-.215-.079-.547-.213-.68l.088-.102c-.206-.299-.36.362-.36.362zm13.008 6.901c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12zm-8.31-5.371c-.006-.146-.19-.284-.382-.031-.135.174-.111.439-.184.557-.104.175.567.339.567.174.025-.277.732-.063.87-.025.248.069.643-.226.211-.381-.355-.13-.542-.269-.574-.523 0 0 .188-.176.106-.166-.218.027-.614.786-.614.395zm6.296 5.371c0-1.035-.177-2.08-.357-2.632-.058-.174-.189-.312-.359-.378-.256-.1-1.337.597-1.5.254-.107-.229-.324.146-.572.008-.12-.066-.454-.515-.605-.46-.309.111.474.964.688 1.076.201-.152.852-.465.992-.038.268.804-.737 1.685-1.251 2.149-.768.694-.624-.449-1.147-.852-.275-.211-.272-.66-.55-.815-.124-.07-.693-.725-.688-.813l-.017.166c-.094.071-.294-.268-.315-.321 0 .295.48.765.639 1.001.271.405.416.995.748 1.326.178.178.858.914 1.035.898.193-.017.803-.458.911-.433.644.152-1.516 3.205-1.721 3.583-.169.317.138 1.101.113 1.476-.029.433-.37.573-.693.809-.346.253-.265.745-.556.925-.517.318-.889 1.353-1.623 1.348-.216-.001-1.14.36-1.261.007-.094-.256-.22-.45-.353-.703-.13-.248-.015-.505-.173-.724-.109-.152-.475-.497-.508-.677-.002-.155.117-.626.28-.708.229-.117.044-.458.016-.656-.048-.354-.267-.646-.53-.851-.389-.299-.188-.537-.097-.964 0-.204-.124-.472-.398-.392-.564.164-.393-.44-.804-.413-.296.021-.538.209-.813.292-.346.104-.7-.082-1.042-.125-1.407-.178-1.866-1.786-1.499-2.946.037-.19-.114-.542-.048-.689.158-.352.48-.747.762-1.014.158-.15.361-.112.547-.229.287-.181.291-.553.572-.781.4-.325.946-.318 1.468-.388.278-.037 1.336-.266 1.503-.06 0 .038.191.604-.019.572.433.023 1.05.749 1.461.579.211-.088.134-.736.567-.423.262.188 1.436.272 1.68.069.15-.124.234-.93.052-1.021.116.115-.611.124-.679.098-.12-.044-.232.114-.425.025.116.055-.646-.354-.218-.667-.179.131-.346-.037-.539.107-.133.108.062.18-.128.274-.302.153-.53-.525-.644-.602-.116-.076-1.014-.706-.77-.295l.789.785c-.039.025-.207-.286-.207-.059.053-.135.02.579-.104.347-.055-.089.09-.139.006-.268 0-.085-.228-.168-.272-.226-.125-.155-.457-.497-.637-.579-.05-.023-.764.087-.824.11-.07.098-.13.201-.179.311-.148.055-.287.126-.419.214l-.157.353c-.068.061-.765.291-.769.3.029-.075-.487-.171-.453-.321.038-.165.213-.68.168-.868-.048-.197 1.074.284 1.146-.235.029-.225.046-.487-.313-.525.068.008.695-.246.799-.36.146-.168.481-.442.724-.442.284 0 .223-.413.354-.615.131.053-.07.376.087.507-.01-.103.445.057.489.033.104-.054.684-.022.594-.294-.1-.277.051-.195.181-.253-.022.009.34-.619.402-.413-.043-.212-.421.074-.553.063-.305-.024-.176-.52-.061-.665.089-.115-.243-.256-.247-.036-.006.329-.312.627-.241 1.064.108.659-.735-.159-.809-.114-.28.17-.509-.214-.364-.444.148-.235.505-.224.652-.476.104-.178.225-.385.385-.52.535-.449.683-.09 1.216-.041.521.048.176.124.104.324-.069.19.286.258.409.099.07-.092.229-.323.298-.494.089-.222.901-.197.334-.536-.374-.223-2.004-.672-3.096-.672-.236 0-.401.263-.581.412-.356.295-1.268.874-1.775.698-.519-.179-1.63.66-1.808.666-.065.004.004-.634.358-.681-.153.023 1.247-.707 1.209-.859-.046-.18-2.799.822-2.676 1.023.059.092.299.092-.016.294-.18.109-.372.801-.541.801-.505.221-.537-.435-1.099.409l-.894.36c-1.328 1.411-2.247 3.198-2.58 5.183-.013.079.334.226.379.28.112.134.112.712.167.901.138.478.479.744.74 1.179.154.259.41.914.329 1.186.108-.178 1.07.815 1.246 1.022.414.487.733 1.077.061 1.559-.217.156.33 1.129.048 1.368l-.361.093c-.356.219-.195.756.021.982 1.818 1.901 4.38 3.087 7.22 3.087 5.517 0 9.989-4.472 9.989-9.989zm-11.507-6.357c.125-.055.293-.053.311-.22.015-.148.044-.046.08-.1.035-.053-.067-.138-.11-.146-.064-.014-.108.069-.149.104l-.072.019-.068.087.008.048-.087.106c-.085.084.002.139.087.102z"
                />
            </svg>
        </template>
        <template v-if="icon === 'xFile'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.64 49.36">
                <g id="Calque_2" data-name="Calque 2">
                    <g id="Calque_1-2" data-name="Calque 1">
                        <path
                            class="cls-1"
                            d="M49.34,14.51Q43.22,7.45,37.13.36C37,.25,36.91.16,36.9,0H14.08c-.34.14-.7.26-1,.43A5,5,0,0,0,10.2,4.89c0,1.52,0,3.05,0,4.57,0,.64,0,.64-.62.64-3,0-6,0-9,0-.38,0-.52.08-.52.5q0,15.5,0,31c0,.39.1.49.48.49,3.06,0,6.12,0,9.18,0,.43,0,.56.1.54.54a7.59,7.59,0,0,0,.61,3.88,4.7,4.7,0,0,0,4.48,2.9c9.67,0,19.33,0,29,0a5.18,5.18,0,0,0,5.18-3.81A5.78,5.78,0,0,0,49.63,44q0-14.37,0-28.75A1.14,1.14,0,0,0,49.34,14.51ZM3.74,38.89c-.44,0-.57-.1-.57-.56q0-12.25,0-24.51c0-.46.13-.56.57-.56h26c.44,0,.57.1.57.56q0,12.25,0,24.51c0,.46-.13.56-.57.56-4.34,0-8.67,0-13,0S8.07,38.87,3.74,38.89Zm42.74,2.46,0,1.46a3,3,0,0,1-3.08,3H31.67c-5.05,0-10.1-.05-15.15,0a3.14,3.14,0,0,1-3.15-3.54c0-.21.09-.29.3-.28s.29,0,.43,0c6.28,0,12.57,0,18.85,0,.45,0,.55-.14.55-.57,0-5.14,0-10.29,0-15.44s0-10.26,0-15.4c0-.44-.12-.56-.56-.56H14c-.68,0-.68,0-.68-.67,0-1,0-1.95,0-2.92a2.92,2.92,0,0,1,3.12-3.12l17.58,0c.43,0,.54.1.54.53,0,2.65,0,5.31,0,8a5.81,5.81,0,0,0,5.08,6,5.26,5.26,0,0,0,1,.05h5.68c.33,0,.45.06.45.43Q46.6,29.83,46.48,41.35Z"
                        />
                        <path
                            class="cls-1"
                            d="M20.19,34.16a.69.69,0,0,0,.64.33h4.71c.12,0,.25.05.39-.08-.15-.21-.3-.41-.46-.61q-3-3.88-5.93-7.75a.5.5,0,0,1,0-.74c1.77-2.27,3.52-4.56,5.27-6.84.11-.13.27-.24.25-.48H19.63c-.25,0-.32.18-.43.34l-2.3,3.42c-.31.46-.3.45-.61,0-.71-1.13-1.44-2.26-2.14-3.4a.63.63,0,0,0-.63-.34H8.72c-.12,0-.26-.06-.37.09l.3.43c1.66,2.25,3.31,4.52,5,6.76a.56.56,0,0,1,0,.82C12.05,28,10.5,30,9,31.92l-2,2.56c1.79,0,3.44,0,5.09,0a.89.89,0,0,0,.83-.43c1.11-1.52,2.23-3,3.35-4.53.38-.5.38-.5.76,0C18,31.09,19.12,32.62,20.19,34.16Z"
                        />
                    </g>
                </g>
            </svg>
        </template>
        <template v-if="icon === 'check'">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs"
                version="1.1"
                width="512"
                height="512"
                x="0"
                y="0"
                viewBox="0 0 24 24"
                style="enable-background: new 0 0 512 512"
                xml:space="preserve"
            >
                <g>
                    <path
                        xmlns="http://www.w3.org/2000/svg"
                        d="M24,12c0-1.626-.714-3.16-1.925-4.124,.14-1.622-.44-3.211-1.59-4.362-1.15-1.149-2.735-1.728-4.277-1.555-2.014-2.556-6.365-2.604-8.332-.035-1.624-.144-3.211,.439-4.361,1.59-1.149,1.15-1.729,2.74-1.555,4.277-2.556,2.014-2.605,6.365-.035,8.333-.14,1.622,.44,3.211,1.59,4.362,1.15,1.149,2.737,1.73,4.277,1.555,2.014,2.556,6.365,2.604,8.332,.035,1.62,.136,3.21-.439,4.361-1.59,1.149-1.15,1.729-2.74,1.555-4.277,1.246-1.048,1.96-2.582,1.96-4.208Zm-6.46-1.434l-4.739,4.568c-1.163,1.161-3.066,1.151-4.229-.013l-2.252-2.092c-.404-.376-.428-1.009-.052-1.413,.377-.405,1.011-.427,1.413-.052l2.278,2.117c.418,.417,1.05,.416,1.44,.025l4.752-4.581c.398-.382,1.031-.371,1.414,.026,.384,.397,.372,1.031-.025,1.414Z"
                        fill="#a0e29a"
                        data-original="#000000"
                    />
                </g>
            </svg>
        </template>
        <template v-if="icon === 'simple-arrow'">
            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                <path
                    d="M480 699q-6 0-11-2t-10-7L261 492q-8-8-7.5-21.5T262 449q10-10 21.5-8.5T304 450l176 176 176-176q8-8 21.5-9t21.5 9q10 8 8.5 21t-9.5 22L501 690q-5 5-10 7t-11 2Z"
                />
            </svg>
        </template>
        <template v-if="icon === 'closeModal'">
            <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M57.7309 10.4353C44.6662 -2.62947 23.2266 -2.62947 10.1618 10.4353C-2.90291 23.5 -2.90291 44.9396 10.1618 58.0044C23.2266 71.0691 44.3312 71.0691 57.3959 58.0044C70.4607 44.9396 70.7957 23.5 57.7309 10.4353ZM43.3262 48.2896L33.9464 38.9097L24.5666 48.2896L19.8767 43.5996L29.2565 34.2198L19.8767 24.84L24.5666 20.1501L33.9464 29.5299L43.3262 20.1501L48.0161 24.84L38.6363 34.2198L48.0161 43.5996L43.3262 48.2896Z"
                    fill="#111827"
                />
            </svg>
        </template>
        <template v-if="icon === 'merge'">
            <svg width="95" height="73" viewBox="0 0 95 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M41.1583 21.0781C41.1583 21.0781 41.0872 21.1695 41.0567 21.2203C41.0262 21.271 40.9957 21.3117 40.9754 21.3624C40.955 21.403 40.9245 21.4436 40.9042 21.4944C40.8737 21.5452 40.8534 21.5959 40.8331 21.6467C40.8127 21.6873 40.7924 21.7381 40.7721 21.7787C40.7518 21.8295 40.7314 21.8802 40.7213 21.931C40.7009 21.9818 40.6806 22.0325 40.6704 22.0833C40.6603 22.1341 40.6399 22.1848 40.6298 22.2356C40.6196 22.2864 40.5993 22.3371 40.5891 22.3879C40.579 22.4488 40.5688 22.5097 40.5586 22.5707C40.5586 22.6113 40.5485 22.662 40.5383 22.7027C40.518 22.9159 40.518 23.1291 40.5383 23.3423C40.5383 23.3829 40.5485 23.4337 40.5586 23.4743C40.5586 23.5352 40.579 23.5961 40.5891 23.6571C40.5993 23.7078 40.6094 23.7586 40.6298 23.8094C40.6399 23.8601 40.6501 23.9109 40.6704 23.9617C40.6908 24.0124 40.7009 24.0632 40.7213 24.114C40.7416 24.1647 40.7518 24.2155 40.7721 24.2662C40.7924 24.317 40.8127 24.3576 40.8331 24.3982C40.8534 24.449 40.8839 24.4998 40.9042 24.5505C40.9245 24.5912 40.955 24.6318 40.9754 24.6825C41.0059 24.7333 41.0262 24.7739 41.0567 24.8247C41.0872 24.8754 41.1278 24.9161 41.1583 24.9668C41.1888 25.0074 41.2092 25.048 41.2396 25.0785C41.3108 25.1597 41.382 25.241 41.4531 25.312L61.274 45.0703C62.5344 46.3293 64.5775 46.3293 65.8277 45.0703C67.078 43.8112 67.0881 41.7704 65.8277 40.5216L51.516 26.2258L91.7778 26.2258C93.5566 26.2258 95 24.7841 95 23.0073C95 21.2304 93.5566 19.7887 91.7778 19.7887L51.516 19.7887L65.8277 5.49291C67.0881 4.2339 67.0881 2.1931 65.8277 0.944252C65.1975 0.314751 64.3742 7.18976e-08 63.5509 0C62.7275 -7.18976e-08 61.9042 0.314751 61.274 0.944252L41.4531 20.7431C41.382 20.8141 41.3108 20.8954 41.2396 20.9766C41.2092 21.0172 41.1787 21.0578 41.1583 21.0883V21.0781Z"
                    fill="#D1D5DB"
                />
                <path
                    d="M53.8417 51.9219C53.8417 51.9219 53.9128 51.8305 53.9433 51.7797C53.9738 51.729 54.0043 51.6883 54.0246 51.6376C54.045 51.597 54.0755 51.5563 54.0958 51.5056C54.1263 51.4548 54.1466 51.404 54.1669 51.3533C54.1873 51.3127 54.2076 51.2619 54.2279 51.2213C54.2482 51.1705 54.2686 51.1198 54.2787 51.069C54.2991 51.0182 54.3194 50.9675 54.3296 50.9167C54.3397 50.8659 54.3601 50.8152 54.3702 50.7644C54.3804 50.7136 54.4007 50.6629 54.4109 50.6121C54.421 50.5512 54.4312 50.4903 54.4414 50.4293C54.4414 50.3887 54.4515 50.338 54.4617 50.2973C54.482 50.0841 54.482 49.8709 54.4617 49.6577C54.4617 49.6171 54.4515 49.5663 54.4414 49.5257C54.4414 49.4648 54.421 49.4039 54.4109 49.3429C54.4007 49.2922 54.3906 49.2414 54.3702 49.1906C54.3601 49.1399 54.3499 49.0891 54.3296 49.0383C54.3092 48.9876 54.2991 48.9368 54.2787 48.886C54.2584 48.8353 54.2482 48.7845 54.2279 48.7337C54.2076 48.683 54.1873 48.6424 54.1669 48.6018C54.1466 48.551 54.1161 48.5002 54.0958 48.4495C54.0755 48.4088 54.045 48.3682 54.0246 48.3175C53.9941 48.2667 53.9738 48.2261 53.9433 48.1753C53.9128 48.1246 53.8722 48.0839 53.8417 48.0332C53.8112 47.9926 53.7908 47.9519 53.7604 47.9215C53.6892 47.8403 53.6181 47.759 53.5469 47.688L33.726 27.9298C32.4656 26.6707 30.4225 26.6707 29.1723 27.9298C27.922 29.1888 27.9119 31.2296 29.1723 32.4784L43.484 46.7742H3.22217C1.44337 46.7742 0 48.2159 0 49.9927C0 51.7696 1.44337 53.2113 3.22217 53.2113H43.484L29.1723 67.5071C27.9119 68.7661 27.9119 70.8069 29.1723 72.0558C29.8025 72.6853 30.6258 73 31.4491 73C32.2725 73 33.0958 72.6853 33.726 72.0558L53.5469 52.2569C53.6181 52.1859 53.6892 52.1046 53.7604 52.0234C53.7908 51.9828 53.8213 51.9422 53.8417 51.9117V51.9219Z"
                    fill="#D1D5DB"
                />
            </svg>
        </template>
        <template v-if="icon === 'action'">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.31712 16.1647C7.78736 16.0851 6.49663 15.4955 5.44492 14.396C4.39321 13.2965 3.86736 11.9739 3.86736 10.4282C3.86736 8.83467 4.42508 7.4802 5.54053 6.36475C6.65598 5.2493 8.01045 4.69158 9.60394 4.69158C11.1496 4.69158 12.4722 5.21743 13.5717 6.26914C14.6713 7.32085 15.2609 8.61158 15.3405 10.1413L13.3327 9.54377C13.1256 8.68329 12.6794 7.97832 11.9942 7.42889C11.309 6.87945 10.5122 6.60441 9.60394 6.60377C8.55224 6.60377 7.65191 6.97824 6.90297 7.72719C6.15403 8.47613 5.77955 9.37646 5.77955 10.4282C5.77955 11.3365 6.05459 12.1332 6.60467 12.8184C7.15474 13.5036 7.8597 13.9498 8.71955 14.1569L9.31712 16.1647ZM10.4644 19.9413C10.321 19.9732 10.1776 19.9891 10.0342 19.9891H9.60394C8.28134 19.9891 7.03842 19.738 5.87516 19.2357C4.71191 18.7335 3.70004 18.0524 2.83955 17.1926C1.97907 16.3321 1.29801 15.3202 0.796374 14.1569C0.294741 12.9937 0.0436061 11.7508 0.0429688 10.4282C0.0429688 9.10556 0.294104 7.86264 0.796374 6.69938C1.29864 5.53613 1.9797 4.52426 2.83955 3.66377C3.70004 2.80329 4.71191 2.12223 5.87516 1.62059C7.03842 1.11896 8.28134 0.867825 9.60394 0.867188C10.9265 0.867188 12.1695 1.11832 13.3327 1.62059C14.496 2.12286 15.5078 2.80392 16.3683 3.66377C17.2288 4.52426 17.9102 5.53613 18.4125 6.69938C18.9147 7.86264 19.1656 9.10556 19.1649 10.4282V10.8584C19.1649 11.0018 19.149 11.1452 19.1171 11.2887L17.2527 10.715V10.4282C17.2527 8.29288 16.5117 6.48426 15.0298 5.00231C13.5478 3.52036 11.7392 2.77938 9.60394 2.77938C7.46866 2.77938 5.66004 3.52036 4.17809 5.00231C2.69614 6.48426 1.95516 8.29288 1.95516 10.4282C1.95516 12.5634 2.69614 14.3721 4.17809 15.854C5.66004 17.336 7.46866 18.0769 9.60394 18.0769H9.89077L10.4644 19.9413ZM17.7547 20.4672L13.6674 16.3799L12.4722 19.9891L9.60394 10.4282L19.1649 13.2965L15.5557 14.4916L19.643 18.5789L17.7547 20.4672Z"
                    fill="black"
                />
            </svg>
        </template>
        <template v-if="icon === 'news'">
            <svg width="116" height="116" viewBox="0 0 116 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.7602 32.4987C21.9902 33.2939 21.5576 34.372 21.5576 35.4965C21.5576 36.6209 21.9902 37.6992 22.7602 38.4942C23.5302 39.2894 24.5746 39.7359 25.6637 39.7359H75.9645C77.0536 39.7359 78.0981 39.2894 78.8681 38.4942C79.6383 37.6992 80.0709 36.6209 80.0709 35.4965C80.0709 34.372 79.6383 33.2939 78.8681 32.4987C78.0981 31.7037 77.0536 31.2571 75.9645 31.2571H25.6637C24.5746 31.2571 23.5302 31.7037 22.7602 32.4987ZM61.593 53.5142C60.504 53.5142 59.4595 53.9609 58.6895 54.7558C57.9193 55.5508 57.4867 56.6292 57.4867 57.7536C57.4867 58.878 57.9193 59.9564 58.6895 60.7513C59.4595 61.5463 60.504 61.993 61.593 61.993H75.9645C77.0536 61.993 78.0981 61.5463 78.8681 60.7513C79.6383 59.9564 80.0709 58.878 80.0709 57.7536C80.0709 56.6292 79.6383 55.5508 78.8681 54.7558C78.0981 53.9609 77.0536 53.5142 75.9645 53.5142H61.593ZM58.6895 77.013C57.9193 77.808 57.4867 78.8863 57.4867 80.0107C57.4867 81.1349 57.9193 82.2133 58.6895 83.0085C59.4595 83.8035 60.504 84.2501 61.593 84.2501H75.9645C77.0536 84.2501 78.0981 83.8035 78.8681 83.0085C79.6383 82.2133 80.0709 81.1349 80.0709 80.0107C80.0709 78.8863 79.6383 77.808 78.8681 77.013C78.0981 76.2178 77.0536 75.7711 75.9645 75.7711H61.593C60.504 75.7711 59.4595 76.2178 58.6895 77.013ZM25.6637 53.5142C24.5746 53.5142 23.5302 53.9609 22.7602 54.7558C21.9902 55.5508 21.5576 56.6292 21.5576 57.7536V80.0107C21.5576 81.1352 21.9902 82.2133 22.7602 83.0085C23.5302 83.8035 24.5746 84.2501 25.6637 84.2501H47.2213C48.3102 84.2501 49.3546 83.8035 50.1248 83.0085C50.8948 82.2133 51.3275 81.1349 51.3275 80.0107V57.7536C51.3275 56.6292 50.8948 55.5508 50.1248 54.7558C49.3546 53.9609 48.3102 53.5142 47.2213 53.5142H25.6637ZM29.7699 75.7711V61.993H43.1149V75.7711H29.7699ZM4.35971 13.5012C1.56823 16.3832 0 20.2922 0 24.368V87.4298C0 92.4894 1.94675 97.3419 5.41205 100.92C8.87732 104.497 13.5772 106.507 18.4779 106.507H97.5221C102.423 106.507 107.123 104.497 110.588 100.92C114.053 97.3419 116 92.4894 116 87.4298V46.6252C116 42.5493 114.432 38.6403 111.64 35.7584C108.97 33.0013 105.39 31.4001 101.628 31.2662V24.368C101.628 20.2922 100.06 16.3832 97.2687 13.5012C94.4771 10.6191 90.6912 9 86.7435 9H14.885C10.9372 9 7.15118 10.6191 4.35971 13.5012ZM91.4617 19.4967C92.7131 20.7887 93.416 22.5408 93.416 24.368V87.4298C93.416 88.554 93.8486 89.6323 94.6186 90.4275C95.3888 91.2225 96.4331 91.6692 97.5221 91.6692C98.6112 91.6692 99.6557 91.2225 100.426 90.4275C101.196 89.6323 101.628 88.554 101.628 87.4298V39.7564C103.21 39.8822 104.704 40.5872 105.833 41.7538C107.085 43.0456 107.788 44.7979 107.788 46.6252V87.4298C107.788 90.2406 106.706 92.9363 104.781 94.924C102.856 96.9117 100.245 98.0282 97.5221 98.0282H18.4779C15.7554 98.0282 13.1442 96.9117 11.2191 94.924C9.29392 92.9363 8.21238 90.2406 8.21238 87.4298V24.368C8.21238 22.5408 8.91538 20.7887 10.1667 19.4967C11.4181 18.2047 13.1153 17.479 14.885 17.479H86.7435C88.513 17.479 90.2102 18.2047 91.4617 19.4967Z"
                    fill="black"
                />
            </svg>
        </template>
        <template v-if="icon === 'squareLoader'">
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="50px"
                height="70px"
                viewBox="0 0 24 30"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve"
            >
                <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                    <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                </rect>
                <rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2">
                    <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                </rect>
                <rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2">
                    <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                </rect>
            </svg>
        </template>
        <template v-if="icon === 'design-system-academic-cap'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 18.8487L29 11.6265L16 4.4043L3 11.6265L16 18.8487ZM16 18.8487L24.8965 13.9062C25.6803 15.8827 26.1111 18.0376 26.1111 20.2931C26.1111 21.3061 26.0242 22.2988 25.8575 23.2642C22.0873 23.6308 18.6708 25.2052 16 27.5956C13.3292 25.2052 9.9127 23.6308 6.14256 23.2642C5.9758 22.2988 5.88889 21.3061 5.88889 20.293C5.88889 18.0375 6.31969 15.8827 7.10349 13.9062L16 18.8487ZM10.2222 27.5153V16.6821L16 13.4722"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-archive'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 10.2221H26.1111M5.88889 10.2221C4.2934 10.2221 3 8.92871 3 7.33322C3 5.73774 4.2934 4.44434 5.88889 4.44434H26.1111C27.7066 4.44434 29 5.73774 29 7.33322C29 8.92871 27.7066 10.2221 26.1111 10.2221M5.88889 10.2221L5.88889 24.6666C5.88889 26.262 7.18229 27.5554 8.77778 27.5554H23.2222C24.8177 27.5554 26.1111 26.262 26.1111 24.6666V10.2221M13.1111 15.9999H18.8889"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 17.4444L16 21.7778M16 21.7778L11.6667 17.4444M16 21.7778L16 10.2222M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 11.6667L21.7778 16M21.7778 16L17.4444 20.3333M21.7778 16L10.2222 16M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 20.3333L10.2222 16M10.2222 16L14.5556 11.6667M10.2222 16L21.7778 16M3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 18.8889L16 29M16 29L5.88892 18.8889M16 29L16 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-circle-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 14.5556L16 10.2222M16 10.2222L20.3333 14.5556M16 10.2222L16 21.7778M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-annotation'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 10.2222H23.2222M8.77778 16H14.5556M16 27.5556L10.2222 21.7778H5.88889C4.2934 21.7778 3 20.4844 3 18.8889V7.33335C3 5.73786 4.2934 4.44446 5.88889 4.44446H26.1111C27.7066 4.44446 29 5.73786 29 7.33335V18.8889C29 20.4844 27.7066 21.7778 26.1111 21.7778H21.7778L16 27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 26.1111L3 16M3 16L13.1111 5.88892M3 16L29 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 21.7777L3 15.9999M3 15.9999L8.77778 10.2222M3 15.9999L29 15.9999"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 10.2222L29 15.9999M29 15.9999L23.2222 21.7777M29 15.9999L3 15.9999"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 23.2222L15.9999 29M15.9999 29L10.2222 23.2222M15.9999 29L15.9999 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-adjustments'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 6.25V3M16 6.25C14.2051 6.25 12.75 7.70507 12.75 9.5C12.75 11.2949 14.2051 12.75 16 12.75M16 6.25C17.7949 6.25 19.25 7.70507 19.25 9.5C19.25 11.2949 17.7949 12.75 16 12.75M6.25 25.75C8.04493 25.75 9.5 24.2949 9.5 22.5C9.5 20.7051 8.04493 19.25 6.25 19.25M6.25 25.75C4.45507 25.75 3 24.2949 3 22.5C3 20.7051 4.45507 19.25 6.25 19.25M6.25 25.75V29M6.25 19.25V3M16 12.75V29M25.75 25.75C27.5449 25.75 29 24.2949 29 22.5C29 20.7051 27.5449 19.25 25.75 19.25M25.75 25.75C23.9551 25.75 22.5 24.2949 22.5 22.5C22.5 20.7051 23.9551 19.25 25.75 19.25M25.75 25.75V29M25.75 19.25V3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-narrow-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 8.77778L15.9999 3M15.9999 3L21.7777 8.77778M15.9999 3V29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8889 5.88892L29 16M29 16L18.8889 26.1111M29 16L3 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.8333 26.8333L3 16M3 16L13.8333 5.16663M3 16L29 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88892 13.1111L16 3M16 3L26.1111 13.1111M16 3V29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1667 5.16663L29 16M29 16L18.1667 26.8333M29 16L3 16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-ajout_intérimaire'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1477_136679)">
                    <path
                        d="M27.9173 14.9165H25.7507V12.7498C25.7507 12.4625 25.6365 12.187 25.4334 11.9838C25.2302 11.7806 24.9546 11.6665 24.6673 11.6665C24.38 11.6665 24.1044 11.7806 23.9013 11.9838C23.6981 12.187 23.584 12.4625 23.584 12.7498V14.9165H21.4173C21.13 14.9165 20.8544 15.0306 20.6513 15.2338C20.4481 15.437 20.334 15.7125 20.334 15.9998C20.334 16.2872 20.4481 16.5627 20.6513 16.7659C20.8544 16.969 21.13 17.0832 21.4173 17.0832H23.584V19.2498C23.584 19.5372 23.6981 19.8127 23.9013 20.0159C24.1044 20.219 24.38 20.3332 24.6673 20.3332C24.9546 20.3332 25.2302 20.219 25.4334 20.0159C25.6365 19.8127 25.7507 19.5372 25.7507 19.2498V17.0832H27.9173C28.2046 17.0832 28.4802 16.969 28.6834 16.7659C28.8865 16.5627 29.0007 16.2872 29.0007 15.9998C29.0007 15.7125 28.8865 15.437 28.6834 15.2338C28.4802 15.0306 28.2046 14.9165 27.9173 14.9165Z"
                        fill="#111827"
                    />
                    <path
                        d="M12.75 16C14.0356 16 15.2923 15.6188 16.3612 14.9046C17.4301 14.1903 18.2632 13.1752 18.7552 11.9874C19.2472 10.7997 19.3759 9.49279 19.1251 8.23191C18.8743 6.97104 18.2552 5.81285 17.3462 4.90381C16.4371 3.99477 15.279 3.3757 14.0181 3.1249C12.7572 2.87409 11.4503 3.00282 10.2626 3.49479C9.07484 3.98676 8.05968 4.81988 7.34545 5.8888C6.63122 6.95771 6.25 8.21442 6.25 9.5C6.25172 11.2234 6.93709 12.8757 8.15571 14.0943C9.37432 15.3129 11.0266 15.9983 12.75 16ZM12.75 5.16667C13.607 5.16667 14.4449 5.42081 15.1575 5.89697C15.8701 6.37312 16.4255 7.04989 16.7535 7.84171C17.0815 8.63352 17.1673 9.50481 17.0001 10.3454C16.8329 11.186 16.4202 11.9581 15.8141 12.5641C15.2081 13.1702 14.436 13.5829 13.5954 13.7501C12.7548 13.9173 11.8835 13.8315 11.0917 13.5035C10.2999 13.1755 9.62312 12.6201 9.14696 11.9075C8.67081 11.1949 8.41667 10.3571 8.41667 9.5C8.41667 8.35073 8.87321 7.24853 9.68587 6.43587C10.4985 5.62321 11.6007 5.16667 12.75 5.16667Z"
                        fill="#111827"
                    />
                    <path
                        d="M12.75 18.1667C10.165 18.1695 7.68673 19.1977 5.85888 21.0255C4.03102 22.8534 3.00287 25.3317 3 27.9167C3 28.204 3.11414 28.4795 3.3173 28.6827C3.52047 28.8859 3.79602 29 4.08333 29C4.37065 29 4.6462 28.8859 4.84937 28.6827C5.05253 28.4795 5.16667 28.204 5.16667 27.9167C5.16667 25.9054 5.96562 23.9766 7.38777 22.5544C8.80992 21.1323 10.7388 20.3333 12.75 20.3333C14.7612 20.3333 16.6901 21.1323 18.1122 22.5544C19.5344 23.9766 20.3333 25.9054 20.3333 27.9167C20.3333 28.204 20.4475 28.4795 20.6506 28.6827C20.8538 28.8859 21.1293 29 21.4167 29C21.704 29 21.9795 28.8859 22.1827 28.6827C22.3859 28.4795 22.5 28.204 22.5 27.9167C22.4971 25.3317 21.469 22.8534 19.6411 21.0255C17.8133 19.1977 15.335 18.1695 12.75 18.1667Z"
                        fill="#111827"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1477_136679">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrows-expand'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 9.5V3M3 3H9.5M3 3L11.125 11.125M29 9.5V3M29 3H22.5M29 3L20.875 11.125M3 22.5V29M3 29H9.5M3 29L11.125 20.875M29 29L20.875 20.875M29 29V22.5M29 29H22.5"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-ban'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M25.1924 25.1924C30.2692 20.1156 30.2692 11.8844 25.1924 6.80761C20.1156 1.7308 11.8844 1.7308 6.80761 6.80761M25.1924 25.1924C20.1156 30.2692 11.8844 30.2692 6.80761 25.1924C1.7308 20.1156 1.7308 11.8844 6.80761 6.80761M25.1924 25.1924L6.80761 6.80761"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-bell'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3332 23.2222H27.5554L25.5261 21.1929C24.9757 20.6425 24.6666 19.8961 24.6666 19.1178V14.5556C24.6666 10.782 22.2549 7.57179 18.8888 6.38204V5.88889C18.8888 4.2934 17.5954 3 15.9999 3C14.4044 3 13.111 4.2934 13.111 5.88889V6.38204C9.74489 7.57179 7.33322 10.782 7.33322 14.5556V19.1178C7.33322 19.8961 7.02404 20.6425 6.47368 21.1929L4.44434 23.2222H11.6666M20.3332 23.2222V24.6667C20.3332 27.0599 18.3931 29 15.9999 29C13.6067 29 11.6666 27.0599 11.6666 24.6667V23.2222M20.3332 23.2222H11.6666"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-book-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 7.51587V26.2936M16 7.51587C14.313 6.3951 12.0227 5.7063 9.5 5.7063C6.97729 5.7063 4.68696 6.3951 3 7.51587V26.2936C4.68696 25.1729 6.97729 24.4841 9.5 24.4841C12.0227 24.4841 14.313 25.1729 16 26.2936M16 7.51587C17.687 6.3951 19.9773 5.7063 22.5 5.7063C25.0227 5.7063 27.313 6.3951 29 7.51587V26.2936C27.313 25.1729 25.0227 24.4841 22.5 24.4841C19.9773 24.4841 17.687 25.1729 16 26.2936"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-bookmark-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 3V22.5L16 19.25L9.5 22.5V3M6.25 29H25.75C27.5449 29 29 27.5449 29 25.75V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-backspace'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 18.8889L18.8889 16M18.8889 16L21.7778 13.1111M18.8889 16L16 13.1111M18.8889 16L21.7778 18.8889M3 16L12.265 25.265C12.8067 25.8068 13.5415 26.1111 14.3077 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H14.3077C13.5415 5.88892 12.8067 6.19328 12.265 6.73505L3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-at-symbol'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7772 15.9989C21.7772 12.8082 19.1906 10.2216 15.9999 10.2216C12.8092 10.2216 10.2226 12.8082 10.2226 15.9989C10.2226 19.1896 12.8092 21.7762 15.9999 21.7762C19.1906 21.7762 21.7772 19.1896 21.7772 15.9989ZM21.7772 15.9989V18.1654C21.7772 20.1596 23.3938 21.7762 25.388 21.7762C27.3822 21.7762 28.9988 20.1596 28.9988 18.1654V15.9989C28.9988 8.81981 23.179 3 15.9999 3C8.82079 3 3.00098 8.81981 3.00098 15.9989C3.00098 23.178 8.82079 28.9978 15.9999 28.9978M22.4993 27.2563C20.4485 28.4404 18.2091 29.0021 15.9998 29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-briefcase'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 19.2578C24.9855 20.8829 20.5972 21.7778 16 21.7778C11.4028 21.7778 7.01454 20.8829 3 19.2578M21.7778 8.77778V5.88889C21.7778 4.2934 20.4844 3 18.8889 3H13.1111C11.5156 3 10.2222 4.2934 10.2222 5.88889V8.77778M16 17.4444H16.0144M5.88889 29H26.1111C27.7066 29 29 27.7066 29 26.1111V11.6667C29 10.0712 27.7066 8.77778 26.1111 8.77778H5.88889C4.2934 8.77778 3 10.0712 3 11.6667V26.1111C3 27.7066 4.2934 29 5.88889 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-bookmark'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88892 5.88889C5.88892 4.2934 7.18232 3 8.7778 3H23.2222C24.8177 3 26.1111 4.2934 26.1111 5.88889V29L16 23.9444L5.88892 29V5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cake'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 21.1218C28.2447 21.1218 27.4893 21.3404 26.8333 21.7778C25.5213 22.6525 23.812 22.6525 22.5 21.7778C21.188 20.9031 19.4787 20.9031 18.1667 21.7778C16.8546 22.6525 15.1454 22.6525 13.8333 21.7778C12.5213 20.9031 10.812 20.9031 9.5 21.7778C8.18797 22.6525 6.47869 22.6525 5.16667 21.7778C4.51065 21.3404 3.75533 21.1218 3 21.1218M11.6667 7.33333V10.2222M16 7.33333V10.2222M20.3333 7.33333V10.2222M11.6667 3H11.6811M16 3H16.0144M20.3333 3H20.3478M29 29V18.8889C29 17.2934 27.7066 16 26.1111 16H5.88889C4.2934 16 3 17.2934 3 18.8889V29H29ZM24.6667 16V13.1111C24.6667 11.5156 23.3733 10.2222 21.7778 10.2222H10.2222C8.62673 10.2222 7.33333 11.5156 7.33333 13.1111V16H24.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-beaker'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.5243 20.857C26.1287 20.4615 25.6249 20.1918 25.0763 20.0821L21.6937 19.4056C19.84 19.0348 17.9156 19.2925 16.2248 20.1379L15.7752 20.3628C14.0844 21.2082 12.16 21.4659 10.3063 21.0952L7.56942 20.5478C6.6404 20.362 5.67998 20.6528 5.01005 21.3227M10.3328 4.66553H21.6672L20.2504 6.08233V13.4094C20.2504 14.161 20.549 14.8817 21.0804 15.4131L28.1644 22.4971C29.9495 24.2822 28.6852 27.3344 26.1607 27.3344H5.83929C3.31481 27.3344 2.05055 24.2822 3.83563 22.4971L10.9196 15.4131C11.451 14.8817 11.7496 14.161 11.7496 13.4094V6.08233L10.3328 4.66553Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-calculator'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 8.77778H20.3334M20.3334 23.2222V18.8889M16 23.2222H16.0145M11.6667 23.2222H11.6811M11.6667 18.8889H11.6811M16 18.8889H16.0145M20.3334 14.5556H20.3478M16 14.5556H16.0145M11.6667 14.5556H11.6811M8.77781 29H23.2223C24.8177 29 26.1111 27.7066 26.1111 26.1111V5.88889C26.1111 4.2934 24.8177 3 23.2223 3H8.77781C7.18232 3 5.88892 4.2934 5.88892 5.88889V26.1111C5.88892 27.7066 7.18232 29 8.77781 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chart-bar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 26.1111V17.4444C11.6667 15.849 10.3733 14.5556 8.77778 14.5556H5.88889C4.2934 14.5556 3 15.849 3 17.4444V26.1111C3 27.7066 4.2934 29 5.88889 29H8.77778C10.3733 29 11.6667 27.7066 11.6667 26.1111ZM11.6667 26.1111V11.6667C11.6667 10.0712 12.9601 8.77778 14.5556 8.77778H17.4444C19.0399 8.77778 20.3333 10.0712 20.3333 11.6667V26.1111M11.6667 26.1111C11.6667 27.7066 12.9601 29 14.5556 29H17.4444C19.0399 29 20.3333 27.7066 20.3333 26.1111M20.3333 26.1111V5.88889C20.3333 4.2934 21.6267 3 23.2222 3H26.1111C27.7066 3 29 4.2934 29 5.88889V26.1111C29 27.7066 27.7066 29 26.1111 29H23.2222C21.6267 29 20.3333 27.7066 20.3333 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-camera'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 11.6666C3 10.0711 4.2934 8.77767 5.88889 8.77767H7.23169C8.1976 8.77767 9.0996 8.29493 9.63539 7.49125L10.8091 5.73076C11.3448 4.92707 12.2468 4.44434 13.2128 4.44434H18.7872C19.7532 4.44434 20.6552 4.92707 21.1909 5.73076L22.3646 7.49125C22.9004 8.29493 23.8024 8.77767 24.7683 8.77767H26.1111C27.7066 8.77767 29 10.0711 29 11.6666V24.6666C29 26.262 27.7066 27.5554 26.1111 27.5554H5.88889C4.2934 27.5554 3 26.262 3 24.6666V11.6666Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.3333 17.4443C20.3333 19.8376 18.3932 21.7777 16 21.7777C13.6068 21.7777 11.6667 19.8376 11.6667 17.4443C11.6667 15.0511 13.6068 13.111 16 13.111C18.3932 13.111 20.3333 15.0511 20.3333 17.4443Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cash'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 11.6667V8.7778C23.2222 7.18232 21.9288 5.88892 20.3333 5.88892H5.88889C4.2934 5.88892 3 7.18232 3 8.7778V17.4445C3 19.04 4.2934 20.3334 5.88889 20.3334H8.77778M11.6667 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V14.5556C29 12.9601 27.7066 11.6667 26.1111 11.6667H11.6667C10.0712 11.6667 8.77778 12.9601 8.77778 14.5556V23.2222C8.77778 24.8177 10.0712 26.1111 11.6667 26.1111ZM21.7778 18.8889C21.7778 20.4844 20.4844 21.7778 18.8889 21.7778C17.2934 21.7778 16 20.4844 16 18.8889C16 17.2934 17.2934 16 18.8889 16C20.4844 16 21.7778 17.2934 21.7778 18.8889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chart-pie'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5909 3C8.0711 3.72073 3 9.24826 3 15.9602C3 23.1619 8.83811 29 16.0398 29C22.7517 29 28.2793 23.9289 29 17.4091H14.5909V3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.3375 11.6136H20.3864V3.66267C24.0914 4.9722 27.0279 7.90864 28.3375 11.6136Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chart-square-bar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 9.5V22.5M16 14.375V22.5M9.5 19.25V22.5M6.25 29H25.75C27.5449 29 29 27.5449 29 25.75V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-calendar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 8.77778V3M21.7778 8.77778V3M8.77778 14.5556H23.2222M5.88889 29H26.1111C27.7066 29 29 27.7066 29 26.1111V8.77778C29 7.18229 27.7066 5.88889 26.1111 5.88889H5.88889C4.2934 5.88889 3 7.18229 3 8.77778V26.1111C3 27.7066 4.2934 29 5.88889 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chat-alt-2'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 8.77778H26.1111C27.7066 8.77778 29 10.0712 29 11.6667V20.3333C29 21.9288 27.7066 23.2222 26.1111 23.2222H23.2222V29L17.4444 23.2222H11.6667C10.8689 23.2222 10.1467 22.8989 9.62391 22.3761M9.62391 22.3761L14.5556 17.4444H20.3333C21.9288 17.4444 23.2222 16.151 23.2222 14.5556V5.88889C23.2222 4.2934 21.9288 3 20.3333 3H5.88889C4.2934 3 3 4.2934 3 5.88889V14.5556C3 16.151 4.2934 17.4444 5.88889 17.4444H8.77778V23.2222L9.62391 22.3761Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chat-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 12.3888H10.2367M16 12.3888H16.0144M21.7778 12.3888H21.7922M11.6667 21.0555H5.88889C4.2934 21.0555 3 19.7621 3 18.1666V6.61106C3 5.01557 4.2934 3.72217 5.88889 3.72217H26.1111C27.7066 3.72217 29 5.01557 29 6.61106V18.1666C29 19.7621 27.7066 21.0555 26.1111 21.0555H18.8889L11.6667 28.2777V21.0555Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chat'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 16H10.2367M16 16H16.0144M21.7778 16H21.7922M29 16C29 22.382 23.1797 27.5556 16 27.5556C13.7766 27.5556 11.6836 27.0594 9.85341 26.1849L3 27.5556L5.01498 22.1823C3.73893 20.3945 3 18.274 3 16C3 9.61806 8.8203 4.44446 16 4.44446C23.1797 4.44446 29 9.61806 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-check-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 16L14.5556 18.8889L20.3333 13.1111M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 17.8572L10.4286 25.2858L29 6.71436" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.5 29L9.5 16L22.5 3" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 9.5L16 22.5L3 9.5" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.8334 18.1667L16.0001 29M16.0001 29L5.16675 18.1667M16.0001 29L16.0001 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 22.5L16 9.5L3 22.5" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27 16.8L16 28L5 16.8M27 4L16 15.2L5 4"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 15.2L16 4L27 15.2M5 28L16 16.8L27 28"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.8 5L28 16L16.8 27M4 5L15.2 16L4 27"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chip'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 3V5.88889M20.3333 3V5.88889M11.6667 26.1111V29M20.3333 26.1111V29M5.88889 11.6667H3M5.88889 20.3333H3M29 11.6667H26.1111M29 20.3333H26.1111M8.77778 26.1111H23.2222C24.8177 26.1111 26.1111 24.8177 26.1111 23.2222V8.77778C26.1111 7.18229 24.8177 5.88889 23.2222 5.88889H8.77778C7.18229 5.88889 5.88889 7.18229 5.88889 8.77778V23.2222C5.88889 24.8177 7.18229 26.1111 8.77778 26.1111ZM11.6667 11.6667H20.3333V20.3333H11.6667V11.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.6107 17.9449C12.0893 17.4236 11.2441 17.4236 10.7227 17.9449C10.2014 18.4663 10.2014 19.3115 10.7227 19.8329L12.6107 17.9449ZM14.5556 21.7778L13.6116 22.7218C14.1329 23.2431 14.9782 23.2431 15.4996 22.7218L14.5556 21.7778ZM21.2773 16.944C21.7987 16.4226 21.7987 15.5774 21.2773 15.056C20.756 14.5347 19.9107 14.5347 19.3894 15.056L21.2773 16.944ZM24.7761 8.77778V26.1111H27.4461V8.77778H24.7761ZM23.2222 27.665H8.7778V30.335H23.2222V27.665ZM7.22392 26.1111V8.77778H4.55392V26.1111H7.22392ZM8.7778 7.22389H11.6667V4.55389H8.7778V7.22389ZM20.3334 7.22389H23.2222V4.55389H20.3334V7.22389ZM8.7778 27.665C7.91962 27.665 7.22392 26.9693 7.22392 26.1111H4.55392C4.55392 28.4439 6.44502 30.335 8.7778 30.335V27.665ZM24.7761 26.1111C24.7761 26.9693 24.0804 27.665 23.2222 27.665V30.335C25.555 30.335 27.4461 28.4439 27.4461 26.1111H24.7761ZM27.4461 8.77778C27.4461 6.44499 25.555 4.55389 23.2222 4.55389V7.22389C24.0804 7.22389 24.7761 7.91959 24.7761 8.77778H27.4461ZM7.22392 8.77778C7.22392 7.91959 7.91962 7.22389 8.7778 7.22389V4.55389C6.44502 4.55389 4.55392 6.44499 4.55392 8.77778H7.22392ZM10.7227 19.8329L13.6116 22.7218L15.4996 20.8338L12.6107 17.9449L10.7227 19.8329ZM15.4996 22.7218L21.2773 16.944L19.3894 15.056L13.6116 20.8338L15.4996 22.7218ZM14.5556 4.335H17.4445V1.665H14.5556V4.335ZM17.4445 7.44278H14.5556V10.1128H17.4445V7.44278ZM14.5556 7.44278C13.6974 7.44278 13.0017 6.74708 13.0017 5.88889H10.3317C10.3317 8.22168 12.2228 10.1128 14.5556 10.1128V7.44278ZM18.9984 5.88889C18.9984 6.74708 18.3027 7.44278 17.4445 7.44278V10.1128C19.7773 10.1128 21.6684 8.22168 21.6684 5.88889H18.9984ZM17.4445 4.335C18.3027 4.335 18.9984 5.0307 18.9984 5.88889H21.6684C21.6684 3.5561 19.7773 1.665 17.4445 1.665V4.335ZM14.5556 1.665C12.2228 1.665 10.3317 3.5561 10.3317 5.88889H13.0017C13.0017 5.0307 13.6974 4.335 14.5556 4.335V1.665Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard-copy'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2221 5.88889H7.33322C5.73774 5.88889 4.44434 7.18229 4.44434 8.77778V26.1111C4.44434 27.7066 5.73774 29 7.33322 29H21.7777C23.3732 29 24.6666 27.7066 24.6666 26.1111V24.6667M10.2221 5.88889C10.2221 7.48438 11.5155 8.77778 13.111 8.77778H15.9999C17.5954 8.77778 18.8888 7.48438 18.8888 5.88889M10.2221 5.88889C10.2221 4.2934 11.5155 3 13.111 3H15.9999C17.5954 3 18.8888 4.2934 18.8888 5.88889M18.8888 5.88889H21.7777C23.3732 5.88889 24.6666 7.18229 24.6666 8.77778V13.1111M27.5554 18.8889H13.111M13.111 18.8889L17.4443 14.5556M13.111 18.8889L17.4443 23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-badge-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6309 16L14.5436 18.9127L20.3691 13.0873M9.9339 5.3643C10.9789 5.28091 11.9709 4.86999 12.7688 4.19005C14.6307 2.60332 17.3693 2.60332 19.2312 4.19005C20.0291 4.86999 21.0211 5.28091 22.0661 5.3643C24.5047 5.5589 26.4411 7.49533 26.6357 9.9339C26.7191 10.9789 27.13 11.9709 27.81 12.7688C29.3967 14.6307 29.3967 17.3693 27.81 19.2312C27.13 20.0291 26.7191 21.0211 26.6357 22.0661C26.4411 24.5047 24.5047 26.4411 22.0661 26.6357C21.0211 26.7191 20.0291 27.13 19.2312 27.81C17.3693 29.3967 14.6307 29.3967 12.7688 27.81C11.9709 27.13 10.9789 26.7191 9.9339 26.6357C7.49533 26.4411 5.5589 24.5047 5.3643 22.0661C5.28091 21.0211 4.86999 20.0291 4.19005 19.2312C2.60332 17.3693 2.60332 14.6307 4.19005 12.7688C4.86999 11.9709 5.28091 10.9789 5.3643 9.9339C5.5589 7.49533 7.49533 5.5589 9.9339 5.3643Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cloud-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50005 21.2C6.62817 21.2 4.30005 18.8719 4.30005 16C4.30005 13.5208 6.03498 11.4469 8.35697 10.926C8.25424 10.4671 8.20005 9.98989 8.20005 9.5C8.20005 5.91015 11.1102 3 14.7 3C17.8451 3 20.4685 5.23373 21.0703 8.20127C21.1134 8.20043 21.1567 8.2 21.2 8.2C24.7899 8.2 27.7001 11.1101 27.7001 14.7C27.7001 17.8446 25.467 20.4677 22.5 21.07M12.1 25.1L16 29M16 29L19.9 25.1M16 29V13.4"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clock'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10.2222V16L20.3333 20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cloud-upload'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50005 21.2C6.62817 21.2 4.30005 18.8719 4.30005 16C4.30005 13.5208 6.03498 11.4469 8.35697 10.926C8.25424 10.4671 8.20005 9.98989 8.20005 9.5C8.20005 5.91015 11.1102 3 14.7 3C17.8451 3 20.4685 5.23373 21.0703 8.20127C21.1134 8.20043 21.1567 8.2 21.2 8.2C24.7899 8.2 27.7001 11.1101 27.7001 14.7C27.7001 17.8446 25.467 20.4677 22.5 21.07M19.9 17.3L16 13.4M16 13.4L12.1 17.3M16 13.4L16 29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-arrow-sm-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.16675 13.8333L16.0001 3M16.0001 3L26.8334 13.8333M16.0001 3V29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard-list'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 5.88889H8.7778C7.18232 5.88889 5.88892 7.18229 5.88892 8.77778V26.1111C5.88892 27.7066 7.18232 29 8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V8.77778C26.1111 7.18229 24.8177 5.88889 23.2222 5.88889H20.3334M11.6667 5.88889C11.6667 7.48438 12.9601 8.77778 14.5556 8.77778H17.4445C19.04 8.77778 20.3334 7.48438 20.3334 5.88889M11.6667 5.88889C11.6667 4.2934 12.9601 3 14.5556 3H17.4445C19.04 3 20.3334 4.2934 20.3334 5.88889M16 16H20.3334M16 21.7778H20.3334M11.6667 16H11.6811M11.6667 21.7778H11.6811"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-double-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.2 27L4 16L15.2 5M28 27L16.8 16L28 5"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-credit-card'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.1111H29M8.77778 20.3334H10.2222M16 20.3334H17.4444M7.33333 26.1111H24.6667C27.0599 26.1111 29 24.171 29 21.7778V10.2222C29 7.82902 27.0599 5.88892 24.6667 5.88892H7.33333C4.9401 5.88892 3 7.82902 3 10.2222V21.7778C3 24.171 4.9401 26.1111 7.33333 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-color-swatch'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 29C5.5868 29 3 26.4132 3 23.2222V5.88889C3 4.2934 4.2934 3 5.88889 3H11.6667C13.2622 3 14.5556 4.2934 14.5556 5.88889V23.2222C14.5556 26.4132 11.9688 29 8.77778 29ZM8.77778 29H26.1111C27.7066 29 29 27.7066 29 26.1111V20.3333C29 18.7378 27.7066 17.4444 26.1111 17.4444H22.7266M14.5556 9.2734L16.9488 6.8802C18.077 5.75202 19.9061 5.75202 21.0343 6.8802L25.1198 10.9657C26.248 12.0939 26.248 13.923 25.1198 15.0512L12.8633 27.3077M8.77778 23.2222H8.79222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cog'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.58 4.90278C14.1959 2.36574 17.8041 2.36574 18.42 4.90278C18.8179 6.54168 20.6955 7.31943 22.1357 6.44189C24.3652 5.08345 26.9165 7.63479 25.5581 9.86427C24.6806 11.3045 25.4583 13.1821 27.0972 13.58C29.6343 14.1959 29.6343 17.8041 27.0972 18.42C25.4583 18.8179 24.6806 20.6955 25.5581 22.1357C26.9165 24.3652 24.3652 26.9165 22.1357 25.5581C20.6955 24.6806 18.8179 25.4583 18.42 27.0972C17.8041 29.6343 14.1959 29.6343 13.58 27.0972C13.1821 25.4583 11.3045 24.6806 9.86427 25.5581C7.6348 26.9165 5.08345 24.3652 6.44189 22.1357C7.31943 20.6955 6.54168 18.8179 4.90278 18.42C2.36574 17.8041 2.36574 14.1959 4.90278 13.58C6.54168 13.1821 7.31943 11.3045 6.44189 9.86427C5.08345 7.63479 7.63479 5.08345 9.86427 6.44189C11.3045 7.31943 13.1821 6.54168 13.58 4.90278Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.3333 16C20.3333 18.3932 18.3932 20.3333 16 20.3333C13.6068 20.3333 11.6667 18.3932 11.6667 16C11.6667 13.6068 13.6068 11.6667 16 11.6667C18.3932 11.6667 20.3333 13.6068 20.3333 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-collection'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 14.5556H5.88889M26.1111 14.5556C27.7066 14.5556 29 15.849 29 17.4444V26.1111C29 27.7066 27.7066 29 26.1111 29H5.88889C4.2934 29 3 27.7066 3 26.1111V17.4444C3 15.849 4.2934 14.5556 5.88889 14.5556M26.1111 14.5556V11.6667C26.1111 10.0712 24.8177 8.77778 23.2222 8.77778M5.88889 14.5556V11.6667C5.88889 10.0712 7.18229 8.77778 8.77778 8.77778M8.77778 8.77778V5.88889C8.77778 4.2934 10.0712 3 11.6667 3H20.3333C21.9288 3 23.2222 4.2934 23.2222 5.88889V8.77778M8.77778 8.77778H23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cube-transparent'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.8888 13.1111L15.9999 14.5556M15.9999 14.5556L13.111 13.1111M15.9999 14.5556V18.1667M27.5554 8.77778L24.6666 10.2222M27.5554 8.77778L24.6666 7.33333M27.5554 8.77778V12.3889M18.8888 4.44444L15.9999 3L13.111 4.44444M4.44434 8.77778L7.33322 7.33333M4.44434 8.77778L7.33322 10.2222M4.44434 8.77778V12.3889M15.9999 29L13.111 27.5556M15.9999 29L18.8888 27.5556M15.9999 29V25.3889M7.33322 24.6667L4.44434 23.2222V19.6111M24.6666 24.6667L27.5554 23.2222V19.6111"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cloud'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 20.3334C3 23.5243 5.5868 26.1111 8.77778 26.1111H21.7778C25.7665 26.1111 29 22.8776 29 18.8889C29 14.9002 25.7665 11.6667 21.7778 11.6667C21.7296 11.6667 21.6815 11.6672 21.6336 11.6681C20.965 8.37083 18.0501 5.88892 14.5556 5.88892C10.5668 5.88892 7.33333 9.12241 7.33333 13.1111C7.33333 13.6555 7.39355 14.1857 7.50769 14.6956C4.92771 15.2743 3 17.5787 3 20.3334Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-code'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.4 26.4L18.6 5.59998M23.8 10.8L29 16L23.8 21.2M8.2 21.2L3 16L8.2 10.8"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-rupee'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 10.2222H20.3333M13.1111 10.2222C15.5043 10.2222 17.4444 12.1623 17.4444 14.5556C17.4444 16.9488 15.5043 18.8889 13.1111 18.8889H11.6667L16 23.2222M11.6667 14.5556H20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cube'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27.5554 8.77778L15.9999 3L4.44434 8.77778M27.5554 8.77778L15.9999 14.5556M27.5554 8.77778V23.2222L15.9999 29M15.9999 14.5556L4.44434 8.77778M15.9999 14.5556V29M4.44434 8.77778V23.2222L15.9999 29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-bangladeshi'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 14.5556V11.6667C14.5556 10.0712 13.2622 8.77778 11.6667 8.77778M14.5556 14.5556V20.3333C14.5556 21.9288 15.849 23.2222 17.4444 23.2222C19.0399 23.2222 20.3333 21.9288 20.3333 20.3333V18.8889M14.5556 14.5556H11.6667M14.5556 14.5556H20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-euro'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0641 21.1069C17.3719 23.9273 14.6281 23.9273 12.9359 21.1069C11.2436 18.2864 11.2436 13.7136 12.9359 10.8931C14.6281 8.07266 17.3719 8.07266 19.0641 10.8931M10.2222 13.8333H16M10.2222 18.1667H16M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-clipboard'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 5.88889H8.7778C7.18232 5.88889 5.88892 7.18229 5.88892 8.77778V26.1111C5.88892 27.7066 7.18232 29 8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V8.77778C26.1111 7.18229 24.8177 5.88889 23.2222 5.88889H20.3334M11.6667 5.88889C11.6667 7.48438 12.9601 8.77778 14.5556 8.77778H17.4445C19.04 8.77778 20.3334 7.48438 20.3334 5.88889M11.6667 5.88889C11.6667 4.2934 12.9601 3 14.5556 3H17.4445C19.04 3 20.3334 4.2934 20.3334 5.88889"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cheveron-right'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 3L22.5 16L9.5 29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-device-mobile'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9999 24.6667H16.0144M10.2221 29H21.7777C23.3732 29 24.6666 27.7066 24.6666 26.1111V5.88889C24.6666 4.2934 23.3732 3 21.7777 3H10.2221C8.62665 3 7.33325 4.2934 7.33325 5.88889V26.1111C7.33325 27.7066 8.62665 29 10.2221 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-desktop-computer'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.75 23.2222L11.6667 27.5556L10.2222 29H21.7778L20.3333 27.5556L19.25 23.2222M3 17.4444H29M5.88889 23.2222H26.1111C27.7066 23.2222 29 21.9288 29 20.3333V5.88889C29 4.2934 27.7066 3 26.1111 3H5.88889C4.2934 3 3 4.2934 3 5.88889V20.3333C3 21.9288 4.2934 23.2222 5.88889 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-database'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.44434 8.77778V23.2222C4.44434 26.4132 9.61793 29 15.9999 29C22.3818 29 27.5554 26.4132 27.5554 23.2222V8.77778M4.44434 8.77778C4.44434 11.9688 9.61793 14.5556 15.9999 14.5556C22.3818 14.5556 27.5554 11.9688 27.5554 8.77778M4.44434 8.77778C4.44434 5.5868 9.61793 3 15.9999 3C22.3818 3 27.5554 5.5868 27.5554 8.77778M27.5554 16C27.5554 19.191 22.3818 21.7778 15.9999 21.7778C9.61793 21.7778 4.44434 19.191 4.44434 16"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-device-tablet'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 24.6667H16.0145M8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V5.88889C26.1111 4.2934 24.8177 3 23.2222 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V26.1111C5.88892 27.7066 7.18232 29 8.7778 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-remove'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4444H20.3334M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-pound'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 11.6667C20.3333 10.0712 19.0399 8.77778 17.4444 8.77778C15.849 8.77778 14.5556 10.0712 14.5556 11.6667V18.8889C14.5556 20.4844 13.2622 21.7778 11.6667 21.7778H20.3333M11.6667 16H17.4444M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-cursor-click'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.6808 21.6807L18.7531 28.9999L12.8978 12.8977L29 18.753L21.6808 21.6807ZM21.6808 21.6807L29 28.9999M10.2457 3L11.3823 7.24187M7.24187 11.3822L3 10.2456M20.1434 5.65213L17.0381 8.7574M8.75753 17.038L5.65226 20.1432"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-search'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V12.265C26.1111 11.8819 25.959 11.5145 25.6881 11.2436L17.8675 3.42307C17.5967 3.15218 17.2293 3 16.8462 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V21.7778M5.88892 29L12.9359 21.953M12.9359 21.953C13.7201 22.7372 14.8034 23.2222 16 23.2222C18.3933 23.2222 20.3334 21.2821 20.3334 18.8889C20.3334 16.4957 18.3933 14.5556 16 14.5556C13.6068 14.5556 11.6667 16.4957 11.6667 18.8889C11.6667 20.0855 12.1517 21.1688 12.9359 21.953Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-report'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 23.2222V20.3333M16 23.2222V17.4444M20.3334 23.2222V14.5556M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-duplicate'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2221 8.77778V20.3333C10.2221 21.9288 11.5155 23.2222 13.111 23.2222H21.7777M10.2221 8.77778V5.88889C10.2221 4.2934 11.5155 3 13.111 3H19.7349C20.118 3 20.4854 3.15218 20.7563 3.42307L27.1324 9.79915C27.4033 10.07 27.5554 10.4374 27.5554 10.8205V20.3333C27.5554 21.9288 26.262 23.2222 24.6666 23.2222H21.7777M10.2221 8.77778H6.44434C5.33977 8.77778 4.44434 9.67321 4.44434 10.7778V26.1111C4.44434 27.7066 5.73774 29 7.33322 29H19.7777C20.8822 29 21.7777 28.1046 21.7777 27V23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 13.1111V21.7778M16 21.7778L11.6667 17.4444M16 21.7778L20.3334 17.4444M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-dots-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.625 16H4.64125M16 16H16.0163M27.375 16H27.3913M6.25 16C6.25 16.8975 5.52246 17.625 4.625 17.625C3.72754 17.625 3 16.8975 3 16C3 15.1025 3.72754 14.375 4.625 14.375C5.52246 14.375 6.25 15.1025 6.25 16ZM17.625 16C17.625 16.8975 16.8975 17.625 16 17.625C15.1025 17.625 14.375 16.8975 14.375 16C14.375 15.1025 15.1025 14.375 16 14.375C16.8975 14.375 17.625 15.1025 17.625 16ZM29 16C29 16.8975 28.2725 17.625 27.375 17.625C26.4775 17.625 25.75 16.8975 25.75 16C25.75 15.1025 26.4775 14.375 27.375 14.375C28.2725 14.375 29 15.1025 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-yen'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 10.2222L16 17.4444M16 17.4444L20.3333 10.2222M16 17.4444V23.2222M11.6667 16H20.3333M11.6667 20.3333H20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 22.5L3 24.125C3 26.8174 5.18261 29 7.875 29L24.125 29C26.8174 29 29 26.8174 29 24.125L29 22.5M22.5 16L16 22.5M16 22.5L9.5 16M16 22.5L16 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-currency-dollar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.7453 12.5416C19.2285 13.0985 20.0717 13.1582 20.6285 12.675C21.1854 12.1918 21.2451 11.3486 20.7619 10.7917L18.7453 12.5416ZM13.2547 19.4584C12.7715 18.9015 11.9284 18.8418 11.3715 19.325C10.8146 19.8082 10.7549 20.6514 11.2381 21.2083L13.2547 19.4584ZM17.335 8.77778C17.335 8.04048 16.7373 7.44278 16 7.44278C15.2627 7.44278 14.665 8.04048 14.665 8.77778H17.335ZM14.665 23.2222C14.665 23.9595 15.2627 24.5572 16 24.5572C16.7373 24.5572 17.335 23.9596 17.335 23.2222L14.665 23.2222ZM27.665 16C27.665 22.4424 22.4424 27.665 16 27.665V30.335C23.917 30.335 30.335 23.917 30.335 16H27.665ZM16 27.665C9.5576 27.665 4.335 22.4424 4.335 16H1.665C1.665 23.917 8.083 30.335 16 30.335V27.665ZM4.335 16C4.335 9.5576 9.5576 4.335 16 4.335V1.665C8.083 1.665 1.665 8.083 1.665 16H4.335ZM16 4.335C22.4424 4.335 27.665 9.5576 27.665 16H30.335C30.335 8.083 23.917 1.665 16 1.665V4.335ZM16 14.665C15.0302 14.665 14.2126 14.4005 13.6764 14.0431C13.1309 13.6794 13.0017 13.3236 13.0017 13.1111H10.3317C10.3317 14.4941 11.1725 15.5827 12.1953 16.2647C13.2275 16.9528 14.5766 17.335 16 17.335V14.665ZM13.0017 13.1111C13.0017 12.8986 13.1309 12.5428 13.6764 12.1791C14.2126 11.8217 15.0302 11.5572 16 11.5572V8.88722C14.5766 8.88722 13.2275 9.26945 12.1953 9.95757C11.1725 10.6395 10.3317 11.7281 10.3317 13.1111H13.0017ZM16 11.5572C17.3281 11.5572 18.3143 12.0449 18.7453 12.5416L20.7619 10.7917C19.6944 9.56148 17.8798 8.88722 16 8.88722V11.5572ZM16 17.335C16.9698 17.335 17.7874 17.5995 18.3236 17.9569C18.8691 18.3206 18.9984 18.6764 18.9984 18.8889H21.6684C21.6684 17.5059 20.8275 16.4172 19.8047 15.7353C18.7725 15.0472 17.4234 14.665 16 14.665V17.335ZM14.665 8.77778V10.2222H17.335V8.77778H14.665ZM14.665 21.7778L14.665 23.2222L17.335 23.2222L17.335 21.7778L14.665 21.7778ZM16 20.4428C14.672 20.4428 13.6857 19.9551 13.2547 19.4584L11.2381 21.2083C12.3056 22.4385 14.1202 23.1128 16 23.1128L16 20.4428ZM18.9984 18.8889C18.9984 19.1014 18.8691 19.4572 18.3236 19.8209C17.7875 20.1783 16.9698 20.4428 16 20.4428V23.1128C17.4234 23.1128 18.7725 22.7306 19.8047 22.0424C20.8275 21.3605 21.6684 20.2719 21.6684 18.8889H18.9984ZM14.665 10.2222L14.665 21.7778L17.335 21.7778L17.335 10.2222L14.665 10.2222Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-text'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 16H20.3334M11.6667 21.7778H20.3334M23.2223 29H8.77781C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.77781 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2223 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.7778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V12.265C26.1111 11.8819 25.959 11.5145 25.6881 11.2436L17.8675 3.42307C17.5967 3.15218 17.2293 3 16.8462 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V26.1111C5.88892 27.7066 7.18232 29 8.7778 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-dots-vertical'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 27.375L16 27.3587M16 16L16 15.9837M16 4.625L16 4.60875M16 25.75C16.8975 25.75 17.625 26.4775 17.625 27.375C17.625 28.2725 16.8975 29 16 29C15.1025 29 14.375 28.2725 14.375 27.375C14.375 26.4775 15.1025 25.75 16 25.75ZM16 14.375C16.8975 14.375 17.625 15.1025 17.625 16C17.625 16.8975 16.8975 17.625 16 17.625C15.1025 17.625 14.375 16.8975 14.375 16C14.375 15.1025 15.1025 14.375 16 14.375ZM16 3C16.8975 3 17.625 3.72754 17.625 4.625C17.625 5.52246 16.8975 6.25 16 6.25C15.1025 6.25 14.375 5.52246 14.375 4.625C14.375 3.72754 15.1025 3 16 3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-emoji-sad'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0854 22.0257C17.8291 19.7693 14.1708 19.7693 11.9144 22.0257M20.3333 13.1111H20.3189M11.6667 13.1111H11.6522M3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-dots-circle-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 16H10.2367M16 16H16.0144M21.7778 16H21.7922M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-exclamation-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10.2222V16M16 21.7778H16.0144M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-exclamation'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 13.0889V16.0001M16 21.8224H16.0146M5.91549 27.6446H26.0845C28.3255 27.6446 29.7261 25.2187 28.6056 23.2779L18.5211 5.81104C17.4006 3.87028 14.5994 3.87028 13.4789 5.81104L3.39436 23.2779C2.27386 25.2187 3.67449 27.6446 5.91549 27.6446Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-fire'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.1709 25.6155C19.6582 30.1282 12.3416 30.1282 7.82888 25.6155C5.57252 23.3591 4.44434 20.4018 4.44434 17.4445C4.44433 14.4871 5.57251 11.5298 7.82888 9.27342C7.82888 9.27342 8.77774 11.6666 11.6666 13.1111C11.6666 10.2222 12.3888 5.88883 15.9795 3C18.8888 5.88889 21.9094 7.01187 24.1709 9.27342C26.4273 11.5298 27.5555 14.4871 27.5555 17.4445C27.5555 20.4018 26.4273 23.3591 24.1709 25.6155Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.9358 21.953C14.628 23.6452 17.3718 23.6452 19.064 21.953C19.9102 21.1068 20.3332 19.9979 20.3332 18.8889C20.3332 17.7799 19.9102 16.6709 19.064 15.8247C18.2232 14.9839 17.1229 14.5609 16.0209 14.5555L14.5554 18.8888L11.6666 18.8889C11.6666 19.9979 12.0896 21.1068 12.9358 21.953Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-finger-print'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.7282 14.6568C16.7282 19.7818 15.2583 24.5634 12.7171 28.6031M7.70442 25.6293C7.73022 25.5859 7.75665 25.5427 7.78372 25.4996C9.75735 22.3622 10.8999 18.6519 10.8999 14.6568C10.8999 11.4379 13.5094 8.82841 16.7283 8.82841C19.9472 8.82841 22.5567 11.4379 22.5567 14.6568C22.5567 16.1388 22.4558 17.5981 22.2605 19.0281M19.1752 29C20.0665 27.2209 20.7973 25.3474 21.3485 23.3994M26.9422 25.0488C27.8821 21.7466 28.3853 18.2605 28.3853 14.6568C28.3853 8.21894 23.1663 3 16.7284 3C14.6052 3 12.6146 3.56765 10.9 4.55948M3.6145 21.0158C4.54801 19.0942 5.07161 16.9367 5.07161 14.6568C5.07161 12.5336 5.63926 10.543 6.63108 8.82841"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-eye-off'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.73806 3.73865L8.62782 8.62841M28.2607 28.2613L23.3714 23.372M18.5537 25.2976C17.7265 25.4545 16.8728 25.5366 16 25.5366C9.89979 25.5366 4.736 21.5272 3 15.9999C3.4726 14.4952 4.19923 13.103 5.12963 11.8736M13.1094 13.11C13.849 12.3703 14.8708 11.9129 15.9994 11.9129C18.2566 11.9129 20.0865 13.7427 20.0865 16C20.0865 17.1286 19.629 18.1504 18.8894 18.89M13.1094 13.11L18.8894 18.89M13.1094 13.11L8.62782 8.62841M18.8894 18.89L8.62782 8.62841M18.8894 18.89L23.3714 23.372M8.62782 8.62841C10.7529 7.25839 13.2836 6.46339 16 6.46339C22.1002 6.46339 27.264 10.4727 29 16C28.0369 19.0663 26.019 21.6654 23.3714 23.372"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-external-link'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.75 6.25H6.25C4.45507 6.25 3 7.70507 3 9.5V25.75C3 27.5449 4.45507 29 6.25 29H22.5C24.2949 29 25.75 27.5449 25.75 25.75V19.25M19.25 3H29M29 3V12.75M29 3L12.75 19.25"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-duplicate'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.5 22.5H6.25C4.45507 22.5 3 21.0449 3 19.25V6.25C3 4.45507 4.45507 3 6.25 3H19.25C21.0449 3 22.5 4.45507 22.5 6.25V9.5M12.75 29H25.75C27.5449 29 29 27.5449 29 25.75V12.75C29 10.9551 27.5449 9.5 25.75 9.5H12.75C10.9551 9.5 9.5 10.9551 9.5 12.75V25.75C9.5 27.5449 10.9551 29 12.75 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-flag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 29V23.2222M3 23.2222V5.88889C3 4.2934 4.2934 3 5.88889 3H15.2778L16.7222 4.44444H29L24.6667 13.1111L29 21.7778H16.7222L15.2778 20.3333H5.88889C4.2934 20.3333 3 21.6267 3 23.2222ZM16 3.72222V11.6667"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4445H20.3333M16 13.1111V21.7778M3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H14.5556L17.4444 8.7778H26.1111C27.7066 8.7778 29 10.0712 29 11.6667V23.2222C29 24.8177 27.7066 26.1111 26.1111 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-remove'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4445H20.3333M3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H14.5556L17.4444 8.7778H26.1111C27.7066 8.7778 29 10.0712 29 11.6667V23.2222C29 24.8177 27.7066 26.1111 26.1111 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-film'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 4.44446V27.5556M23.2222 4.44446V27.5556M3 10.2222H8.77778M23.2222 10.2222H29M3 16H29M3 21.7778H8.77778M23.2222 21.7778H29M4.44444 27.5556H27.5556C28.3533 27.5556 29 26.9089 29 26.1111V5.8889C29 5.09116 28.3533 4.44446 27.5556 4.44446H4.44444C3.6467 4.44446 3 5.09116 3 5.8889V26.1111C3 26.9089 3.6467 27.5556 4.44444 27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 26.1111C4.2934 26.1111 3 24.8177 3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H11.6667L14.5556 8.7778H20.3333C21.9288 8.7778 23.2222 10.0712 23.2222 11.6667V13.1111M5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V16C29 14.4045 27.7066 13.1111 26.1111 13.1111H11.6667C10.0712 13.1111 8.77778 14.4045 8.77778 16V23.2222C8.77778 24.8177 7.48438 26.1111 5.88889 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 8.7778V23.2222C3 24.8177 4.2934 26.1111 5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V11.6667C29 10.0712 27.7066 8.7778 26.1111 8.7778H17.4444L14.5556 5.88892H5.88889C4.2934 5.88892 3 7.18232 3 8.7778Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-document-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 17.4444H20.3334M16 13.1111L16 21.7778M23.2222 29H8.7778C7.18232 29 5.88892 27.7066 5.88892 26.1111V5.88889C5.88892 4.2934 7.18232 3 8.7778 3H16.8462C17.2293 3 17.5967 3.15218 17.8675 3.42307L25.6881 11.2436C25.959 11.5145 26.1111 11.8819 26.1111 12.265V26.1111C26.1111 27.7066 24.8177 29 23.2222 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-hashtag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.875 29L14.375 3M17.625 29L24.125 3M6.25 11.125H29M3 20.875H25.75"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-filter'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4C3 3.44772 3.44772 3 4 3H28C28.5523 3 29 3.44772 29 4V8.36356C29 8.62878 28.8946 8.88313 28.7071 9.07067L19.1818 18.596C18.9942 18.7835 18.8889 19.0379 18.8889 19.3031V23.2222L13.1111 29V19.3031C13.1111 19.0379 13.0058 18.7835 12.8182 18.596L3.29289 9.07067C3.10536 8.88313 3 8.62878 3 8.36356V4Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-eye'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.0865 16C20.0865 18.2572 18.2566 20.0871 15.9994 20.0871C13.7421 20.0871 11.9123 18.2572 11.9123 16C11.9123 13.7427 13.7421 11.9129 15.9994 11.9129C18.2566 11.9129 20.0865 13.7427 20.0865 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3 15.9999C4.73603 10.4727 9.8998 6.46338 16 6.46338C22.1002 6.46338 27.264 10.4727 29 16C27.264 21.5273 22.1002 25.5366 16 25.5366C9.89979 25.5366 4.736 21.5272 3 15.9999Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-gift'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 10.2222V29M16 10.2222C16 10.2222 16 8.06599 16 7.33333C16 5.73784 17.2934 4.44444 18.8889 4.44444C20.4844 4.44444 21.7778 5.73784 21.7778 7.33333C21.7778 8.92882 20.4844 10.2222 18.8889 10.2222C18.0261 10.2222 16 10.2222 16 10.2222ZM16 10.2222C16 10.2222 16 7.42421 16 6.61111C16 4.61675 14.3833 3 12.3889 3C10.3945 3 8.77778 4.61675 8.77778 6.61111C8.77778 8.60547 10.3945 10.2222 12.3889 10.2222C13.5702 10.2222 16 10.2222 16 10.2222ZM5.88889 16H26.1111M5.88889 16C4.2934 16 3 14.7066 3 13.1111C3 11.5156 4.2934 10.2222 5.88889 10.2222H26.1111C27.7066 10.2222 29 11.5156 29 13.1111C29 14.7066 27.7066 16 26.1111 16M5.88889 16L5.88889 26.1111C5.88889 27.7066 7.18229 29 8.77778 29H23.2222C24.8177 29 26.1111 27.7066 26.1111 26.1111V16"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-heart'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.90381 6.80761C2.3654 9.34602 2.3654 13.4616 4.90381 16L16.0001 27.0963L27.0962 16C29.6346 13.4616 29.6346 9.34602 27.0962 6.80761C24.5578 4.26921 20.4422 4.26921 17.9038 6.80762L16.0001 8.7115L14.0962 6.80761C11.5578 4.26921 7.44221 4.26921 4.90381 6.80761Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-fast-forward'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.7565 17.3565C15.6609 16.6783 15.6609 15.3218 14.7565 14.6435L5.71304 7.86089C4.59521 7.02251 3 7.82011 3 9.21741L3 22.7826C3 24.1799 4.59521 24.9775 5.71304 24.1391L14.7565 17.3565Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M28.3217 17.3565C29.2261 16.6783 29.2261 15.3218 28.3217 14.6435L19.2783 7.86089C18.1604 7.02251 16.5652 7.82011 16.5652 9.21741L16.5652 22.7826C16.5652 24.1799 18.1604 24.9775 19.2783 24.1391L28.3217 17.3565Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-icon-user-remove'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 16H20.3333M17.4444 8.77778C17.4444 11.9688 14.8576 14.5556 11.6667 14.5556C8.47569 14.5556 5.88889 11.9688 5.88889 8.77778C5.88889 5.5868 8.47569 3 11.6667 3C14.8576 3 17.4444 5.5868 17.4444 8.77778ZM3 27.5556C3 22.7691 6.8802 18.8889 11.6667 18.8889C16.4531 18.8889 20.3333 22.7691 20.3333 27.5556V29H3V27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-folder-download'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 13.1111V21.7778M16 21.7778L11.6667 17.4445M16 21.7778L20.3333 17.4445M3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H14.5556L17.4444 8.7778H26.1111C27.7066 8.7778 29 10.0712 29 11.6667V23.2222C29 24.8177 27.7066 26.1111 26.1111 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-home'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 16L5.88889 13.1111M5.88889 13.1111L16 3L26.1111 13.1111M5.88889 13.1111V27.5556C5.88889 28.3533 6.53559 29 7.33333 29H11.6667M26.1111 13.1111L29 16M26.1111 13.1111V27.5556C26.1111 28.3533 25.4644 29 24.6667 29H20.3333M11.6667 29C12.4644 29 13.1111 28.3533 13.1111 27.5556V21.7778C13.1111 20.98 13.7578 20.3333 14.5556 20.3333H17.4444C18.2422 20.3333 18.8889 20.98 18.8889 21.7778V27.5556C18.8889 28.3533 19.5356 29 20.3333 29M11.6667 29H20.3333"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-identification'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 8.77779H5.88889C4.2934 8.77779 3 10.0712 3 11.6667V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V11.6667C29 10.0712 27.7066 8.77779 26.1111 8.77779H18.8889M13.1111 8.77779V7.33335C13.1111 5.73786 14.4045 4.44446 16 4.44446C17.5955 4.44446 18.8889 5.73786 18.8889 7.33335V8.77779M13.1111 8.77779C13.1111 10.3733 14.4045 11.6667 16 11.6667C17.5955 11.6667 18.8889 10.3733 18.8889 8.77779M11.6667 20.3333C13.2622 20.3333 14.5556 19.0399 14.5556 17.4445C14.5556 15.849 13.2622 14.5556 11.6667 14.5556C10.0712 14.5556 8.77778 15.849 8.77778 17.4445C8.77778 19.0399 10.0712 20.3333 11.6667 20.3333ZM11.6667 20.3333C13.5534 20.3333 15.1585 21.5392 15.7534 23.2222M11.6667 20.3333C9.77991 20.3333 8.17471 21.5392 7.57983 23.2222M20.3333 16H24.6667M20.3333 21.7778H23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-hand'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.50008 15.2778V18.8889M9.50008 15.2778V6.61111C9.50008 5.41449 10.4701 4.44444 11.6667 4.44444C12.8634 4.44444 13.8334 5.41449 13.8334 6.61111M9.50008 15.2778C9.50008 14.0812 8.53003 13.1111 7.33341 13.1111C6.1368 13.1111 5.16675 14.0812 5.16675 15.2778V18.1667C5.16675 24.1498 10.017 29 16.0001 29C21.9832 29 26.8334 24.1498 26.8334 18.1667V10.9444C26.8334 9.74783 25.8634 8.77778 24.6667 8.77778C23.4701 8.77778 22.5001 9.74783 22.5001 10.9444M13.8334 6.61111V14.5556M13.8334 6.61111V5.16667C13.8334 3.97005 14.8035 3 16.0001 3C17.1967 3 18.1667 3.97005 18.1667 5.16667V6.61111M18.1667 6.61111V14.5556M18.1667 6.61111C18.1667 5.41449 19.1368 4.44444 20.3334 4.44444C21.53 4.44444 22.5001 5.41449 22.5001 6.61111V10.9444M22.5001 10.9444V14.5556"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-inbox-in'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.8823 4.52941H6.82347C5.13413 4.52941 3.76465 5.89889 3.76465 7.58824V25.9412C3.76465 27.6305 5.13413 29 6.82347 29H25.1764C26.8658 29 28.2352 27.6305 28.2352 25.9412V7.58824C28.2352 5.89889 26.8658 4.52941 25.1764 4.52941H22.1176M15.9999 3V15.2353M15.9999 15.2353L20.5882 10.6471M15.9999 15.2353L11.4117 10.6471M3.76465 18.2941H7.71938C8.12501 18.2941 8.51402 18.4553 8.80084 18.7421L12.4932 22.4344C12.78 22.7212 13.169 22.8824 13.5746 22.8824H18.4253C18.8309 22.8824 19.2199 22.7212 19.5067 22.4344L23.199 18.7421C23.4859 18.4553 23.8749 18.2941 24.2805 18.2941H28.2352"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-information-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 21.7778H16V16H14.5556M16 10.2222H16.0144M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-inbox'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 17.625V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V17.625M29 17.625V25.75C29 27.5449 27.5449 29 25.75 29H6.25C4.45507 29 3 27.5449 3 25.75V17.625M29 17.625H24.7981C24.3671 17.625 23.9538 17.7962 23.649 18.101L19.726 22.024C19.4212 22.3288 19.0079 22.5 18.5769 22.5H13.4231C12.9921 22.5 12.5788 22.3288 12.274 22.024L8.35095 18.101C8.04621 17.7962 7.63288 17.625 7.2019 17.625H3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-globe'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.07934 14.5556H5.88889C7.48438 14.5556 8.77778 15.849 8.77778 17.4444V18.8889C8.77778 20.4844 10.0712 21.7778 11.6667 21.7778C13.2622 21.7778 14.5556 23.0712 14.5556 24.6667V28.9207M10.2222 4.35131V6.61111C10.2222 8.60547 11.839 10.2222 13.8333 10.2222H14.5556C16.151 10.2222 17.4444 11.5156 17.4444 13.1111C17.4444 14.7066 18.7378 16 20.3333 16C21.9288 16 23.2222 14.7066 23.2222 13.1111C23.2222 11.5156 24.5156 10.2222 26.1111 10.2222L27.6487 10.2222M20.3333 28.2603V24.6667C20.3333 23.0712 21.6267 21.7778 23.2222 21.7778H27.6487M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-globe-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 16C29 23.1797 23.1797 29 16 29M29 16C29 8.8203 23.1797 3 16 3M29 16H3M16 29C8.8203 29 3 23.1797 3 16M16 29C18.3932 29 20.3333 23.1797 20.3333 16C20.3333 8.8203 18.3932 3 16 3M16 29C13.6068 29 11.6667 23.1797 11.6667 16C11.6667 8.8203 13.6068 3 16 3M3 16C3 8.8203 8.8203 3 16 3"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-light-bulb'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.625 23.2222H19.3748M15.9999 3V4.44444M25.1923 6.80761L24.1709 7.82899M29 15.9999H27.5556M4.44444 15.9999H3M7.82891 7.82899L6.80753 6.80761M10.893 21.1069C8.07259 18.2865 8.07259 13.7136 10.893 10.8932C13.7135 8.0727 18.2864 8.0727 21.1068 10.8932C23.9273 13.7136 23.9273 18.2865 21.1068 21.1069L20.3166 21.8972C19.4024 22.8113 18.8888 24.0512 18.8888 25.344V26.1111C18.8888 27.7066 17.5954 29 15.9999 29C14.4044 29 13.111 27.7066 13.111 26.1111V25.344C13.111 24.0512 12.5975 22.8113 11.6833 21.8972L10.893 21.1069Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-lightning-bolt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4443 13.1111V3L4.44434 18.8889H14.5554L14.5554 29L27.5554 13.1111L17.4443 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-lock-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2221 14.5556V8.77778C10.2221 5.5868 12.8089 3 15.9999 3C19.1909 3 21.7777 5.5868 21.7777 8.77778M15.9999 20.3333V23.2222M7.33322 29H24.6666C26.262 29 27.5554 27.7066 27.5554 26.1111V17.4444C27.5554 15.849 26.262 14.5556 24.6666 14.5556H7.33322C5.73774 14.5556 4.44434 15.849 4.44434 17.4444V26.1111C4.44434 27.7066 5.73774 29 7.33322 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-lock-closed'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.9999 20.3333V23.2222M7.33322 29H24.6666C26.262 29 27.5554 27.7066 27.5554 26.1111V17.4444C27.5554 15.849 26.262 14.5556 24.6666 14.5556H7.33322C5.73774 14.5556 4.44434 15.849 4.44434 17.4444V26.1111C4.44434 27.7066 5.73774 29 7.33322 29ZM21.7777 14.5556V8.77778C21.7777 5.5868 19.1909 3 15.9999 3C12.8089 3 10.2221 5.5868 10.2221 8.77778V14.5556H21.7777Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-location-marker'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.6152 21.3848C22.2353 22.7648 19.2071 25.7929 17.4129 27.5871C16.6319 28.3682 15.3686 28.3686 14.5875 27.5875C12.8234 25.8233 9.85815 22.8581 8.3848 21.3848C4.17903 17.179 4.17903 10.3601 8.3848 6.15433C12.5906 1.94856 19.4095 1.94856 23.6152 6.15433C27.821 10.3601 27.821 17.179 23.6152 21.3848Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.0386 13.7696C20.0386 16 18.2305 17.8081 16 17.8081C13.7696 17.8081 11.9614 16 11.9614 13.7696C11.9614 11.5391 13.7696 9.73097 16 9.73097C18.2305 9.73097 20.0386 11.5391 20.0386 13.7696Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-logout-left'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 21.7778L8.77778 16M8.77778 16L14.5556 10.2222M8.77778 16L29 16M21.7778 21.7778V23.2222C21.7778 25.6155 19.8377 27.5556 17.4444 27.5556H7.33333C4.9401 27.5556 3 25.6155 3 23.2222V8.77779C3 6.38456 4.9401 4.44446 7.33333 4.44446H17.4444C19.8377 4.44446 21.7778 6.38456 21.7778 8.77779V10.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-library'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 18.8889V23.2222M16 18.8889V23.2222M21.7778 18.8889V23.2222M3 29H29M3 13.1111H29M3 8.77778L16 3L29 8.77778M4.44444 13.1111H27.5556V29H4.44444V13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-key'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 8.77778C21.9288 8.77778 23.2222 10.0712 23.2222 11.6667M29 11.6667C29 16.4531 25.1198 20.3333 20.3333 20.3333C19.4578 20.3333 18.6125 20.2035 17.8158 19.962L14.5556 23.2222H11.6667V26.1111H8.77778V29H4.44444C3.6467 29 3 28.3533 3 27.5556V23.8205C3 23.4374 3.15218 23.07 3.42307 22.7992L12.038 14.1842C11.7965 13.3875 11.6667 12.5422 11.6667 11.6667C11.6667 6.8802 15.5469 3 20.3333 3C25.1198 3 29 6.8802 29 11.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-mail'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 10.2222L14.3975 17.8206C15.3679 18.4675 16.6321 18.4675 17.6025 17.8206L29 10.2222M5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H5.88889C4.2934 5.88892 3 7.18232 3 8.7778V23.2222C3 24.8177 4.2934 26.1111 5.88889 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25H29M3 16H29M3 25.75H29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu-alt-2'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25H29M3 16H29M3 25.75H14.375" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-mail-open'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 25.8195V12.9211C3 11.9552 3.48274 11.0532 4.28642 10.5174L14.3975 3.77669C15.3679 3.12977 16.6321 3.12977 17.6025 3.77669L27.7136 10.5174C28.5173 11.0532 29 11.9552 29 12.9211V25.8195M3 25.8195C3 27.415 4.2934 28.7084 5.88889 28.7084H26.1111C27.7066 28.7084 29 27.415 29 25.8195M3 25.8195L12.75 19.3195M29 25.8195L19.25 19.3195M3 12.8195L12.75 19.3195M29 12.8195L19.25 19.3195M19.25 19.3195L17.6025 20.4178C16.6321 21.0648 15.3679 21.0648 14.3975 20.4178L12.75 19.3195"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-emoji-happy'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9145 20.0855C14.1709 22.3419 17.8291 22.3419 20.0855 20.0855M20.3333 13.1111H20.3189M11.6667 13.1111H11.6522M3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-minus-sm'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 16H3" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu-alt-3'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.25H29M3 16H29M17.625 25.75H29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-moon'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 20.5415C27.447 21.1656 25.751 21.509 23.9748 21.509C16.5279 21.509 10.491 15.4721 10.491 8.02524C10.491 6.24901 10.8344 4.55301 11.4585 3C6.50051 4.99249 3 9.84556 3 15.5162C3 22.9631 9.03689 29 16.4838 29C22.1544 29 27.0075 25.4995 29 20.5415Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-map'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 27.5556L3.79847 23.6215C3.30911 23.3768 3 22.8766 3 22.3295V6.78162C3 5.70784 4.13001 5.00946 5.09042 5.48967L11.6667 8.77779M11.6667 27.5556L20.3333 23.2222M11.6667 27.5556V8.77779M20.3333 23.2222L26.9096 26.5104C27.87 26.9906 29 26.2922 29 25.2184V9.67051C29 9.12339 28.6909 8.62323 28.2015 8.37856L20.3333 4.44446M20.3333 23.2222V4.44446M20.3333 4.44446L11.6667 8.77779"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-microphone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M25.0999 14.7C25.0999 19.7258 21.0257 23.8 15.9999 23.8M15.9999 23.8C10.9741 23.8 6.8999 19.7258 6.8999 14.7M15.9999 23.8V29M15.9999 29H10.7999M15.9999 29H21.1999M15.9999 18.6C13.846 18.6 12.0999 16.8539 12.0999 14.7V6.9C12.0999 4.74609 13.846 3 15.9999 3C18.1538 3 19.8999 4.74609 19.8999 6.9V14.7C19.8999 16.8539 18.1538 18.6 15.9999 18.6Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-music-note'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 26.1111V7.33333L29 3V21.7778M11.6667 26.1111C11.6667 27.7066 9.72657 29 7.33333 29C4.9401 29 3 27.7066 3 26.1111C3 24.5156 4.9401 23.2222 7.33333 23.2222C9.72657 23.2222 11.6667 24.5156 11.6667 26.1111ZM29 21.7778C29 23.3733 27.0599 24.6667 24.6667 24.6667C22.2734 24.6667 20.3333 23.3733 20.3333 21.7778C20.3333 20.1823 22.2734 18.8889 24.6667 18.8889C27.0599 18.8889 29 20.1823 29 21.7778ZM11.6667 13.1111L29 8.77778"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-paper-airplane'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 26.1111L29 29L16 3L3 29L16 26.1111ZM16 26.1111V14.5556"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-newspaper'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 27.5556H5.88889C4.2934 27.5556 3 26.2622 3 24.6667L3 7.33335C3 5.73786 4.2934 4.44446 5.88889 4.44446L20.3333 4.44446C21.9288 4.44446 23.2222 5.73786 23.2222 7.33335V8.77779M26.1111 27.5556C24.5156 27.5556 23.2222 26.2622 23.2222 24.6667L23.2222 8.77779M26.1111 27.5556C27.7066 27.5556 29 26.2622 29 24.6667V11.6667C29 10.0712 27.7066 8.77779 26.1111 8.77779L23.2222 8.77779M17.4444 4.44446L11.6667 4.44446M8.77778 21.7778H17.4444M8.77778 10.2222H17.4444V16H8.77778V10.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-paper-clip'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.22 8.77778L10.7072 18.2906C9.57898 19.4188 9.57899 21.2479 10.7072 22.3761C11.8353 23.5043 13.6645 23.5043 14.7927 22.3761L24.0576 12.8633C26.314 10.6069 26.314 6.94863 24.0576 4.69227C21.8013 2.43591 18.143 2.43591 15.8866 4.69227L6.62166 14.2051C3.23712 17.5896 3.23712 23.077 6.62166 26.4616C10.0062 29.8461 15.4936 29.8461 18.8782 26.4616L27.9166 17.4444"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-logout-rught'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 21.7778L29 16M29 16L23.2222 10.2222M29 16L8.77778 16M17.4444 21.7778V23.2222C17.4444 25.6155 15.5043 27.5556 13.1111 27.5556H7.33333C4.9401 27.5556 3 25.6155 3 23.2222V8.77779C3 6.38456 4.9401 4.44446 7.33333 4.44446H13.1111C15.5043 4.44446 17.4444 6.38456 17.4444 8.77779V10.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-pause'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 11.6667V20.3333M18.8889 11.6667V20.3333M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone-missed-call'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 10.2222L24.6666 7.33333M24.6666 7.33333L27.5555 4.44444M24.6666 7.33333L21.7777 4.44444M24.6666 7.33333L27.5555 10.2222M5.88889 3C4.2934 3 3 4.2934 3 5.88889V7.33333C3 19.2995 12.7005 29 24.6667 29H26.1111C27.7066 29 29 27.7066 29 26.1111V21.3744C29 20.7527 28.6022 20.2007 28.0123 20.0041L21.5218 17.8406C20.8399 17.6133 20.0946 17.922 19.7731 18.5649L18.1428 21.8254C14.6116 20.2333 11.7667 17.3884 10.1746 13.8572L13.4351 12.2269C14.078 11.9054 14.3867 11.1601 14.1594 10.4782L11.9959 3.98767C11.7993 3.39784 11.2473 3 10.6256 3H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-minus-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 16H11.6667M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone-outgoing'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7778 3H29M29 3V10.2222M29 3L20.3333 11.6667M5.88889 3C4.2934 3 3 4.2934 3 5.88889V7.33333C3 19.2995 12.7005 29 24.6667 29H26.1111C27.7066 29 29 27.7066 29 26.1111V21.3744C29 20.7527 28.6022 20.2007 28.0123 20.0041L21.5218 17.8406C20.8399 17.6133 20.0946 17.922 19.7731 18.5649L18.1428 21.8254C14.6116 20.2333 11.7667 17.3884 10.1746 13.8572L13.4351 12.2269C14.078 11.9054 14.3867 11.1601 14.1594 10.4782L11.9959 3.98767C11.7993 3.39784 11.2473 3 10.6256 3H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-photograph'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 22.5L10.4519 15.0481C11.7211 13.7789 13.7789 13.7789 15.0481 15.0481L22.5 22.5M19.25 19.25L21.8269 16.6731C23.0961 15.4039 25.1539 15.4039 26.4231 16.6731L29 19.25M19.25 9.5H19.2663M6.25 29H25.75C27.5449 29 29 27.5449 29 25.75V6.25C29 4.45507 27.5449 3 25.75 3H6.25C4.45507 3 3 4.45507 3 6.25V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-pencil'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.6596 6.21799L25.7564 11.3148M22.822 4.05559C24.2294 2.64814 26.5114 2.64814 27.9188 4.05559C29.3263 5.46304 29.3263 7.74497 27.9188 9.15243L8.07125 29H3.02563V23.8519L22.822 4.05559Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone-incoming'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 3L20.3333 11.6667M20.3333 11.6667V4.44444M20.3333 11.6667H27.5556M5.88889 3C4.2934 3 3 4.2934 3 5.88889V7.33333C3 19.2995 12.7005 29 24.6667 29H26.1111C27.7066 29 29 27.7066 29 26.1111V21.3744C29 20.7527 28.6022 20.2007 28.0123 20.0041L21.5218 17.8406C20.8399 17.6133 20.0946 17.922 19.7731 18.5649L18.1428 21.8254C14.6116 20.2333 11.7667 17.3884 10.1746 13.8572L13.4351 12.2269C14.078 11.9054 14.3867 11.1601 14.1594 10.4782L11.9959 3.98767C11.7993 3.39784 11.2473 3 10.6256 3H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-play'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.975 14.7981L15.3568 11.7193C14.3969 11.0794 13.1111 11.7675 13.1111 12.9212V19.0788C13.1111 20.2325 14.3969 20.9206 15.3568 20.2807L19.975 17.2019C20.8326 16.6301 20.8326 15.3699 19.975 14.7981Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-presentation-chart-line'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.44444 3.72217V2.38717H3.10944V3.72217H4.44444ZM27.5556 3.72217H28.8906V2.38717H27.5556V3.72217ZM7.83379 14.3337C7.31244 14.8551 7.31244 15.7004 7.83379 16.2217C8.35514 16.7431 9.20042 16.7431 9.72177 16.2217L7.83379 14.3337ZM13.1111 10.9444L14.0551 10.0004C13.5337 9.47905 12.6885 9.47905 12.1671 10.0004L13.1111 10.9444ZM17.4444 15.2777L16.5005 16.2217C17.0218 16.7431 17.8671 16.7431 18.3884 16.2217L17.4444 15.2777ZM24.1662 10.4439C24.6876 9.92258 24.6876 9.07731 24.1662 8.55596C23.6449 8.03461 22.7996 8.03461 22.2782 8.55596L24.1662 10.4439ZM9.27823 27.3337C8.75688 27.8551 8.75688 28.7004 9.27823 29.2217C9.79958 29.7431 10.6449 29.7431 11.1662 29.2217L9.27823 27.3337ZM16 22.4999L16.944 21.556C16.4226 21.0346 15.5774 21.0346 15.056 21.556L16 22.4999ZM20.8338 29.2217C21.3551 29.7431 22.2004 29.7431 22.7218 29.2217C23.2431 28.7004 23.2431 27.8551 22.7218 27.3337L20.8338 29.2217ZM3 2.38717C2.2627 2.38717 1.665 2.98487 1.665 3.72217C1.665 4.45947 2.2627 5.05717 3 5.05717V2.38717ZM29 5.05717C29.7373 5.05717 30.335 4.45947 30.335 3.72217C30.335 2.98487 29.7373 2.38717 29 2.38717V5.05717ZM4.44444 5.05717H27.5556V2.38717H4.44444V5.05717ZM26.2206 3.72217V21.0555H28.8906V3.72217H26.2206ZM26.1111 21.1649H5.88889V23.8349H26.1111V21.1649ZM5.77944 21.0555V3.72217H3.10944V21.0555H5.77944ZM5.88889 21.1649C5.82844 21.1649 5.77944 21.1159 5.77944 21.0555H3.10944C3.10944 22.5905 4.35384 23.8349 5.88889 23.8349V21.1649ZM26.2206 21.0555C26.2206 21.1159 26.1716 21.1649 26.1111 21.1649V23.8349C27.6462 23.8349 28.8906 22.5905 28.8906 21.0555H26.2206ZM9.72177 16.2217L14.0551 11.8884L12.1671 10.0004L7.83379 14.3337L9.72177 16.2217ZM12.1671 11.8884L16.5005 16.2217L18.3884 14.3337L14.0551 10.0004L12.1671 11.8884ZM18.3884 16.2217L24.1662 10.4439L22.2782 8.55596L16.5005 14.3337L18.3884 16.2217ZM11.1662 29.2217L16.944 23.4439L15.056 21.556L9.27823 27.3337L11.1662 29.2217ZM15.056 23.4439L20.8338 29.2217L22.7218 27.3337L16.944 21.556L15.056 23.4439ZM3 5.05717H29V2.38717H3V5.05717Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-link'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6411 13.3589C16.3847 11.1026 12.7264 11.1026 10.47 13.3589L4.69227 19.1367C2.43591 21.3931 2.43591 25.0514 4.69227 27.3077C6.94863 29.5641 10.6069 29.5641 12.8633 27.3077L14.4544 25.7166M13.3589 18.6411C15.6153 20.8974 19.2736 20.8974 21.5299 18.6411L27.3077 12.8633C29.5641 10.6069 29.5641 6.94863 27.3077 4.69227C25.0514 2.43591 21.3931 2.43591 19.1367 4.69227L17.5484 6.2806"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus-sm'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 3V16M16 16V29M16 16H29M16 16L3 16" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-office-building'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1111 29V5.88889C26.1111 4.2934 24.8177 3 23.2222 3H8.77778C7.18229 3 5.88889 4.2934 5.88889 5.88889V29M26.1111 29L29 29M26.1111 29H18.8889M5.88889 29L3 29M5.88889 29H13.1111M11.6667 8.77774H13.1111M11.6667 14.5555H13.1111M18.8889 8.77774H20.3333M18.8889 14.5555H20.3333M13.1111 29V21.7777C13.1111 20.98 13.7578 20.3333 14.5556 20.3333H17.4444C18.2422 20.3333 18.8889 20.98 18.8889 21.7777V29M13.1111 29H18.8889"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-puzzle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 5.88889C16 4.2934 17.2934 3 18.8889 3C20.4844 3 21.7778 4.2934 21.7778 5.88889V7.33333C21.7778 8.13108 22.4245 8.77778 23.2222 8.77778H27.5556C28.3533 8.77778 29 9.42448 29 10.2222V14.5556C29 15.3533 28.3533 16 27.5556 16H26.1111C24.5156 16 23.2222 17.2934 23.2222 18.8889C23.2222 20.4844 24.5156 21.7778 26.1111 21.7778H27.5556C28.3533 21.7778 29 22.4245 29 23.2222V27.5556C29 28.3533 28.3533 29 27.5556 29H23.2222C22.4245 29 21.7778 28.3533 21.7778 27.5556V26.1111C21.7778 24.5156 20.4844 23.2222 18.8889 23.2222C17.2934 23.2222 16 24.5156 16 26.1111V27.5556C16 28.3533 15.3533 29 14.5556 29H10.2222C9.42448 29 8.77778 28.3533 8.77778 27.5556V23.2222C8.77778 22.4245 8.13108 21.7778 7.33333 21.7778H5.88889C4.2934 21.7778 3 20.4844 3 18.8889C3 17.2934 4.2934 16 5.88889 16H7.33333C8.13108 16 8.77778 15.3533 8.77778 14.5556V10.2222C8.77778 9.42448 9.42448 8.77778 10.2222 8.77778H14.5556C15.3533 8.77778 16 8.13108 16 7.33333V5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-menu-alt-4'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9.5H29M3 22.5H29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 3V29M29 16L3 16" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-receipt-refund'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 20.3333V18.8889C21.7777 15.6979 19.1909 13.1111 15.9999 13.1111H10.2221M10.2221 13.1111L14.5554 17.4444M10.2221 13.1111L14.5554 8.77778M27.5554 29V5.88889C27.5554 4.2934 26.262 3 24.6666 3H7.33322C5.73774 3 4.44434 4.2934 4.44434 5.88889V29L10.2221 26.1111L15.9999 29L21.7777 26.1111L27.5554 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-refresh'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 3V11.125H3.94497M28.8994 14.375C28.0998 7.96224 22.6294 3 16 3C10.5443 3 5.87347 6.36078 3.94497 11.125M3.94497 11.125H11.125M29 29V20.875H28.055M28.055 20.875C26.1265 25.6392 21.4557 29 16 29C9.37062 29 3.90024 24.0378 3.10058 17.625M28.055 20.875H20.875"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-receipt-tax'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 18.8889L20.3334 10.2222M12.389 10.9444H12.4034M19.6112 18.1667H19.6256M26.1111 29V5.88889C26.1111 4.2934 24.8177 3 23.2222 3H8.7778C7.18232 3 5.88892 4.2934 5.88892 5.88889V29L10.9445 26.1111L16 29L21.0556 26.1111L26.1111 29ZM13.1111 10.9444C13.1111 11.3433 12.7878 11.6667 12.3889 11.6667C11.99 11.6667 11.6667 11.3433 11.6667 10.9444C11.6667 10.5456 11.99 10.2222 12.3889 10.2222C12.7878 10.2222 13.1111 10.5456 13.1111 10.9444ZM20.3334 18.1667C20.3334 18.5655 20.01 18.8889 19.6111 18.8889C19.2123 18.8889 18.8889 18.5655 18.8889 18.1667C18.8889 17.7678 19.2123 17.4444 19.6111 17.4444C20.01 17.4444 20.3334 17.7678 20.3334 18.1667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-qrcode'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.3269 3.00818C17.3269 2.27088 16.7292 1.67318 15.9919 1.67318C15.2546 1.67318 14.6569 2.27088 14.6569 3.00818H17.3269ZM14.6569 4.63216C14.6569 5.36946 15.2546 5.96716 15.9919 5.96716C16.7292 5.96716 17.3269 5.36946 17.3269 4.63216H14.6569ZM25.7358 21.161C24.9985 21.161 24.4008 21.7587 24.4008 22.496C24.4008 23.2333 24.9985 23.831 25.7358 23.831V21.161ZM28.9838 23.831C29.7211 23.831 30.3188 23.2333 30.3188 22.496C30.3188 21.7587 29.7211 21.161 28.9838 21.161V23.831ZM15.9919 22.496V21.161C15.2546 21.161 14.6569 21.7587 14.6569 22.496H15.9919ZM19.2398 23.831C19.9771 23.831 20.5749 23.2333 20.5749 22.496C20.5749 21.7587 19.9771 21.161 19.2398 21.161V23.831ZM14.6569 28.9919C14.6569 29.7292 15.2546 30.3269 15.9919 30.3269C16.7292 30.3269 17.3269 29.7292 17.3269 28.9919H14.6569ZM17.3269 11.1281C17.3269 10.3908 16.7292 9.7931 15.9919 9.7931C15.2546 9.7931 14.6569 10.3908 14.6569 11.1281H17.3269ZM15.9919 16.0001H14.6569C14.6569 16.7374 15.2546 17.3351 15.9919 17.3351V16.0001ZM22.4878 27.6569C21.7505 27.6569 21.1528 28.2546 21.1528 28.9919C21.1528 29.7292 21.7505 30.3269 22.4878 30.3269V27.6569ZM28.9838 30.3269C29.7211 30.3269 30.3188 29.7292 30.3188 28.9919C30.3188 28.2546 29.7211 27.6569 28.9838 27.6569V30.3269ZM3 14.6651C2.2627 14.6651 1.665 15.2628 1.665 16.0001C1.665 16.7374 2.2627 17.3351 3 17.3351V14.6651ZM9.49594 17.3351C10.2332 17.3351 10.8309 16.7374 10.8309 16.0001C10.8309 15.2628 10.2332 14.6651 9.49594 14.6651V17.3351ZM16.0081 17.3351C16.7454 17.3351 17.3431 16.7374 17.3431 16.0001C17.3431 15.2628 16.7454 14.6651 16.0081 14.6651V17.3351ZM22.5041 17.3351C23.2414 17.3351 23.8391 16.7374 23.8391 16.0001C23.8391 15.2628 23.2414 14.6651 22.5041 14.6651V17.3351ZM28.9838 14.6651C28.2465 14.6651 27.6488 15.2628 27.6488 16.0001C27.6488 16.7374 28.2465 17.3351 28.9838 17.3351V14.6651ZM29 17.3351C29.7373 17.3351 30.335 16.7374 30.335 16.0001C30.335 15.2628 29.7373 14.6651 29 14.6651V17.3351ZM4.62398 4.34318H7.87195V1.67318H4.62398V4.34318ZM8.16094 4.63216V7.88013H10.8309V4.63216H8.16094ZM7.87195 8.16912H4.62398V10.8391H7.87195V8.16912ZM4.335 7.88013V4.63216H1.665V7.88013H4.335ZM4.62398 8.16912C4.46438 8.16912 4.335 8.03974 4.335 7.88013H1.665C1.665 9.51434 2.98978 10.8391 4.62398 10.8391V8.16912ZM8.16094 7.88013C8.16094 8.03974 8.03156 8.16912 7.87195 8.16912V10.8391C9.50616 10.8391 10.8309 9.51434 10.8309 7.88013H8.16094ZM7.87195 4.34318C8.03156 4.34318 8.16094 4.47256 8.16094 4.63216H10.8309C10.8309 2.99796 9.50616 1.67318 7.87195 1.67318V4.34318ZM4.62398 1.67318C2.98978 1.67318 1.665 2.99796 1.665 4.63216H4.335C4.335 4.47256 4.46438 4.34318 4.62398 4.34318V1.67318ZM24.1118 4.34318H27.3598V1.67318H24.1118V4.34318ZM27.6488 4.63216V7.88013H30.3188V4.63216H27.6488ZM27.3598 8.16912H24.1118V10.8391H27.3598V8.16912ZM23.8228 7.88013V4.63216H21.1528V7.88013H23.8228ZM24.1118 8.16912C23.9522 8.16912 23.8228 8.03974 23.8228 7.88013H21.1528C21.1528 9.51434 22.4776 10.8391 24.1118 10.8391V8.16912ZM27.6488 7.88013C27.6488 8.03974 27.5194 8.16912 27.3598 8.16912V10.8391C28.994 10.8391 30.3188 9.51434 30.3188 7.88013H27.6488ZM27.3598 4.34318C27.5194 4.34318 27.6488 4.47256 27.6488 4.63216H30.3188C30.3188 2.99796 28.994 1.67318 27.3598 1.67318V4.34318ZM24.1118 1.67318C22.4776 1.67318 21.1528 2.99796 21.1528 4.63216H23.8228C23.8228 4.47256 23.9522 4.34318 24.1118 4.34318V1.67318ZM4.62398 23.831H7.87195V21.161H4.62398V23.831ZM8.16094 24.12V27.368H10.8309V24.12H8.16094ZM7.87195 27.6569H4.62398V30.3269H7.87195V27.6569ZM4.335 27.368V24.12H1.665V27.368H4.335ZM4.62398 27.6569C4.46438 27.6569 4.335 27.5276 4.335 27.368H1.665C1.665 29.0022 2.98978 30.3269 4.62398 30.3269V27.6569ZM8.16094 27.368C8.16094 27.5276 8.03156 27.6569 7.87195 27.6569V30.3269C9.50616 30.3269 10.8309 29.0022 10.8309 27.368H8.16094ZM7.87195 23.831C8.03156 23.831 8.16094 23.9604 8.16094 24.12H10.8309C10.8309 22.4858 9.50616 21.161 7.87195 21.161V23.831ZM4.62398 21.161C2.98978 21.161 1.665 22.4858 1.665 24.12H4.335C4.335 23.9604 4.46438 23.831 4.62398 23.831V21.161ZM14.6569 3.00818V4.63216H17.3269V3.00818H14.6569ZM25.7358 23.831H28.9838V21.161H25.7358V23.831ZM15.9919 23.831H19.2398V21.161H15.9919V23.831ZM14.6569 22.496V28.9919H17.3269V22.496H14.6569ZM14.6569 11.1281V16.0001H17.3269V11.1281H14.6569ZM22.4878 30.3269H28.9838V27.6569H22.4878V30.3269ZM3 17.3351H9.49594V14.6651H3V17.3351ZM15.9919 17.3351H16.0081V14.6651H15.9919V17.3351ZM28.9838 17.3351H29V14.6651H28.9838V17.3351ZM15.9919 17.3351H22.5041V14.6651H15.9919V17.3351Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-reply'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.1111H17.4444C23.8264 13.1111 29 18.2847 29 24.6667V27.5556M3 13.1111L11.6667 21.7778M3 13.1111L11.6667 4.44446"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-plus-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11.6667V16M16 16V20.3333M16 16H20.3333M16 16H11.6667M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-rss'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.85714 3C18.1909 3 29 13.8091 29 27.1429M4.85714 14.1429C12.0368 14.1429 17.8571 19.9632 17.8571 27.1429M6.71429 27.1429C6.71429 28.1685 5.88281 29 4.85714 29C3.83147 29 3 28.1685 3 27.1429C3 26.1172 3.83147 25.2857 4.85714 25.2857C5.88281 25.2857 6.71429 26.1172 6.71429 27.1429Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-rewind'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.2435 14.6435C16.3391 15.3218 16.3391 16.6783 17.2435 17.3565L26.287 24.1391C27.4048 24.9775 29 24.1799 29 22.7826V9.21741C29 7.82012 27.4048 7.02251 26.287 7.86089L17.2435 14.6435Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3.67826 14.6435C2.77391 15.3218 2.77391 16.6783 3.67826 17.3565L12.7217 24.1391C13.8396 24.9775 15.4348 24.1799 15.4348 22.7826V9.21741C15.4348 7.82011 13.8396 7.02251 12.7217 7.86089L3.67826 14.6435Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-save-as'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 22.4999V25.3888C23.2222 26.9843 21.9288 28.2777 20.3333 28.2777H5.88889C4.2934 28.2777 3 26.9843 3 25.3888V15.2777C3 13.6822 4.2934 12.3888 5.88889 12.3888H8.77778M13.1111 6.61106H11.6667C10.0712 6.61106 8.77778 7.90446 8.77778 9.49995V19.6111C8.77778 21.2065 10.0712 22.4999 11.6667 22.4999H26.1111C27.7066 22.4999 29 21.2065 29 19.6111V9.49995C29 7.90446 27.7066 6.61106 26.1111 6.61106H24.6667M23.2222 12.3888L18.8889 16.7222M18.8889 16.7222L14.5556 12.3888M18.8889 16.7222L18.8889 3.72217"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-scissors'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.2596 19.4471L28.1875 27.375M16.8125 16L28.1875 4.625M16.8125 16L12.1346 20.6779M16.8125 16L12.1346 11.3221M12.1346 20.6779C11.2524 19.7957 10.0337 19.25 8.6875 19.25C5.99511 19.25 3.8125 21.4326 3.8125 24.125C3.8125 26.8174 5.99511 29 8.6875 29C11.3799 29 13.5625 26.8174 13.5625 24.125C13.5625 22.7788 13.0168 21.5601 12.1346 20.6779ZM12.1346 11.3221C13.0168 10.4399 13.5625 9.22119 13.5625 7.875C13.5625 5.18261 11.3799 3 8.6875 3C5.99511 3 3.8125 5.18261 3.8125 7.875C3.8125 10.5674 5.99511 12.75 8.6875 12.75C10.0337 12.75 11.2524 12.2043 12.1346 11.3221Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-minus'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29 16H3" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-scale'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 7.33402L7.33305 8.77837M7.33305 8.77837L3 21.7775C5.56015 23.7034 9.10767 23.7034 11.6678 21.7775M7.33305 8.77837L11.6662 21.7775M7.33305 8.77837L15.9991 5.88967M24.6652 8.77837L28.9983 7.33402M24.6652 8.77837L20.3322 21.7775C22.8923 23.7034 26.4399 23.7034 29 21.7775M24.6652 8.77837L28.9984 21.7775M24.6652 8.77837L15.9991 5.88967M15.9991 3.00098V5.88967M15.9991 28.9993V5.88967M15.9991 28.9993H11.6661M15.9991 28.9993H20.3322"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-save'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 8.77779H5.88889C4.2934 8.77779 3 10.0712 3 11.6667V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V11.6667C29 10.0712 27.7066 8.77779 26.1111 8.77779H21.7778M20.3333 14.5556L16 18.8889M16 18.8889L11.6667 14.5556M16 18.8889L16 4.44446"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-phone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 5.88889C3 4.2934 4.2934 3 5.88889 3H10.6256C11.2473 3 11.7993 3.39784 11.9959 3.98767L14.1594 10.4782C14.3867 11.1601 14.078 11.9054 13.4351 12.2269L10.1746 13.8572C11.7667 17.3884 14.6116 20.2333 18.1428 21.8254L19.7731 18.5649C20.0946 17.922 20.8399 17.6133 21.5218 17.8406L28.0123 20.0041C28.6022 20.2007 29 20.7527 29 21.3744V26.1111C29 27.7066 27.7066 29 26.1111 29H24.6667C12.7005 29 3 19.2995 3 7.33333V5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-pencil-alt'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.7059 6.05883H6.05882C4.36948 6.05883 3 7.42831 3 9.11765V25.9412C3 27.6305 4.36948 29 6.05882 29H22.8823C24.5717 29 25.9412 27.6305 25.9412 25.9412V18.2941M23.7783 3.89591C24.9728 2.70136 26.9095 2.70136 28.1041 3.89591C29.2986 5.09045 29.2986 7.02719 28.1041 8.22174L14.9729 21.3529H10.6471L10.6471 17.0271L23.7783 3.89591Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-search-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 21.7778L14.3803 17.6197M14.3803 17.6197C15.1645 18.4039 16.2478 18.8889 17.4444 18.8889C19.8377 18.8889 21.7778 16.9488 21.7778 14.5556C21.7778 12.1623 19.8377 10.2222 17.4444 10.2222C15.0512 10.2222 13.1111 12.1623 13.1111 14.5556C13.1111 15.7522 13.5961 16.8355 14.3803 17.6197ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-share'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.21 17.9383C11.5022 17.3551 11.6667 16.6968 11.6667 16C11.6667 15.3032 11.5022 14.6449 11.21 14.0617M11.21 17.9383C10.4986 19.3585 9.02981 20.3333 7.33333 20.3333C4.9401 20.3333 3 18.3932 3 16C3 13.6068 4.9401 11.6667 7.33333 11.6667C9.02981 11.6667 10.4986 12.6415 11.21 14.0617M11.21 17.9383L20.79 22.7283M11.21 14.0617L20.79 9.27168M20.79 9.27168C21.5014 10.6918 22.9702 11.6667 24.6667 11.6667C27.0599 11.6667 29 9.72657 29 7.33333C29 4.9401 27.0599 3 24.6667 3C22.2734 3 20.3333 4.9401 20.3333 7.33333C20.3333 8.03009 20.4978 8.68844 20.79 9.27168ZM20.79 22.7283C20.4978 23.3116 20.3333 23.9699 20.3333 24.6667C20.3333 27.0599 22.2734 29 24.6667 29C27.0599 29 29 27.0599 29 24.6667C29 22.2734 27.0599 20.3333 24.6667 20.3333C22.9702 20.3333 21.5014 21.3082 20.79 22.7283Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-presentation-chart-bar'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 16.7222V15.2777M16 16.7222V12.3888M21.7778 16.7222V9.49995M10.2222 28.2777L16 22.4999L21.7778 28.2777M3 3.72217H29M4.44444 3.72217H27.5556V21.0555C27.5556 21.8532 26.9089 22.4999 26.1111 22.4999H5.88889C5.09114 22.4999 4.44444 21.8532 4.44444 21.0555V3.72217Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shield-check'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 16.3133L14.5556 19.2022L20.3333 13.4244M28.4481 7.62402C28.1525 7.63902 27.8549 7.64661 27.5556 7.64661C23.1161 7.64661 19.0665 5.97764 15.9999 3.23291C12.9333 5.97753 8.88378 7.64643 4.44444 7.64643C4.14512 7.64643 3.84756 7.63884 3.55196 7.62385C3.19168 9.01574 3 10.4755 3 11.98C3 20.0566 8.52402 26.8431 16 28.7672C23.476 26.8431 29 20.0566 29 11.98C29 10.4755 28.8083 9.01586 28.4481 7.62402Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-server'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 16H26.1111M5.88889 16C4.2934 16 3 14.7066 3 13.1111V7.33335C3 5.73786 4.2934 4.44446 5.88889 4.44446H26.1111C27.7066 4.44446 29 5.73786 29 7.33335V13.1111C29 14.7066 27.7066 16 26.1111 16M5.88889 16C4.2934 16 3 17.2934 3 18.8889V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V18.8889C29 17.2934 27.7066 16 26.1111 16M23.2222 10.2222H23.2367M23.2222 21.7778H23.2367"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sort-ascending'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.44446H21.7778M3 10.2222H16M3 16H11.6667M17.4444 16L23.2222 10.2222M23.2222 10.2222L29 16M23.2222 10.2222V27.5556"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shopping-bag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7777 14.5556V8.77778C21.7777 5.5868 19.1909 3 15.9999 3C12.8089 3 10.2221 5.5868 10.2221 8.77778V14.5556M5.88878 11.6667H26.111L27.5554 29H4.44434L5.88878 11.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shield-exclamation'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 11.98V14.8689M16 20.6467H16.0144M28.4481 7.62402C28.1525 7.63902 27.8549 7.64661 27.5556 7.64661C23.1161 7.64661 19.0665 5.97764 15.9999 3.23291C12.9333 5.97753 8.88378 7.64643 4.44444 7.64643C4.14512 7.64643 3.84756 7.63884 3.55196 7.62385C3.19168 9.01574 3 10.4755 3 11.98C3 20.0566 8.52402 26.8431 16 28.7672C23.476 26.8431 29 20.0566 29 11.98C29 10.4755 28.8083 9.01586 28.4481 7.62402Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-shopping-cart'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 3H5.88889L6.46667 5.88889M8.77778 17.4444H23.2222L29 5.88889H6.46667M8.77778 17.4444L6.46667 5.88889M8.77778 17.4444L5.46582 20.7564C4.55587 21.6663 5.20033 23.2222 6.4872 23.2222H23.2222M23.2222 23.2222C21.6267 23.2222 20.3333 24.5156 20.3333 26.1111C20.3333 27.7066 21.6267 29 23.2222 29C24.8177 29 26.1111 27.7066 26.1111 26.1111C26.1111 24.5156 24.8177 23.2222 23.2222 23.2222ZM11.6667 26.1111C11.6667 27.7066 10.3733 29 8.77778 29C7.18229 29 5.88889 27.7066 5.88889 26.1111C5.88889 24.5156 7.18229 23.2222 8.77778 23.2222C10.3733 23.2222 11.6667 24.5156 11.6667 26.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sm-view-grid-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.125 19.25V29M19.25 24.125H29M6.25 12.75H9.5C11.2949 12.75 12.75 11.2949 12.75 9.5V6.25C12.75 4.45507 11.2949 3 9.5 3H6.25C4.45507 3 3 4.45507 3 6.25V9.5C3 11.2949 4.45507 12.75 6.25 12.75ZM22.5 12.75H25.75C27.5449 12.75 29 11.2949 29 9.5V6.25C29 4.45507 27.5449 3 25.75 3H22.5C20.7051 3 19.25 4.45507 19.25 6.25V9.5C19.25 11.2949 20.7051 12.75 22.5 12.75ZM6.25 29H9.5C11.2949 29 12.75 27.5449 12.75 25.75V22.5C12.75 20.7051 11.2949 19.25 9.5 19.25H6.25C4.45507 19.25 3 20.7051 3 22.5V25.75C3 27.5449 4.45507 29 6.25 29Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sort-descending'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.44446H21.7778M3 10.2222H16M3 16H16M23.2222 10.2222V27.5556M23.2222 27.5556L17.4444 21.7778M23.2222 27.5556L29 21.7778"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-speakerphone'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.5556 7.16315V26.458C14.5556 27.8619 13.4175 29 12.0136 29C10.9393 29 9.98103 28.3247 9.61972 27.313L6.51935 18.4308M24.6667 17.4444C27.0599 17.4444 29 15.5043 29 13.1111C29 10.7179 27.0599 8.77778 24.6667 8.77778M6.51935 18.4308C4.45065 17.5515 3 15.5007 3 13.1111C3 9.92013 5.58679 7.33333 8.77777 7.33333H11.4241C17.3473 7.33333 22.4377 5.55075 24.6667 3L24.6667 23.2222C22.4377 20.6715 17.3473 18.8889 11.4241 18.8889L8.77774 18.8889C7.97637 18.8889 7.21311 18.7257 6.51935 18.4308Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-star'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.049 5.92664C15.3483 5.00538 16.6517 5.00538 16.951 5.92664L18.6944 11.2915C18.8283 11.7035 19.2122 11.9824 19.6454 11.9824L25.2864 11.9827C26.2551 11.9827 26.6579 13.2222 25.8742 13.7917L21.3107 17.1075C20.9602 17.3622 20.8136 17.8135 20.9474 18.2255L22.6904 23.5905C22.9897 24.5118 21.9353 25.2779 21.1516 24.7085L16.5878 21.393C16.2373 21.1384 15.7627 21.1384 15.4122 21.393L10.8484 24.7085C10.0647 25.2779 9.01031 24.5118 9.30962 23.5905L11.0526 18.2255C11.1864 17.8135 11.0398 17.3622 10.6893 17.1075L6.12578 13.7917C5.34211 13.2222 5.74487 11.9827 6.71355 11.9827L12.3546 11.9824C12.7878 11.9824 13.1717 11.7035 13.3056 11.2915L15.049 5.92664Z"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-search'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 29L20.3333 20.3333M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-selector'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.57153 10.4286L16.0001 3L23.4287 10.4286M23.4287 21.5714L16.0001 29L8.57153 21.5714"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-switch-vertical'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.77778 21.7777V4.44434M8.77778 4.44434L3 10.2221M8.77778 4.44434L14.5556 10.2221M23.2222 10.2221V27.5554M23.2222 27.5554L29 21.7777M23.2222 27.5554L17.4444 21.7777"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-support'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M27.665 16C27.665 22.4424 22.4424 27.665 16 27.665V30.335C23.917 30.335 30.335 23.917 30.335 16H27.665ZM16 27.665C9.5576 27.665 4.335 22.4424 4.335 16H1.665C1.665 23.917 8.083 30.335 16 30.335V27.665ZM4.335 16C4.335 9.5576 9.5576 4.335 16 4.335V1.665C8.083 1.665 1.665 8.083 1.665 16H4.335ZM16 4.335C22.4424 4.335 27.665 9.5576 27.665 16H30.335C30.335 8.083 23.917 1.665 16 1.665V4.335ZM20.4428 16C20.4428 18.4537 18.4537 20.4428 16 20.4428V23.1128C19.9283 23.1128 23.1128 19.9283 23.1128 16H20.4428ZM16 20.4428C13.5463 20.4428 11.5572 18.4537 11.5572 16H8.88722C8.88722 19.9283 12.0717 23.1128 16 23.1128V20.4428ZM11.5572 16C11.5572 13.5463 13.5463 11.5572 16 11.5572V8.88722C12.0717 8.88722 8.88722 12.0717 8.88722 16H11.5572ZM16 11.5572C18.4537 11.5572 20.4428 13.5463 20.4428 16H23.1128C23.1128 12.0717 19.9283 8.88722 16 8.88722V11.5572ZM24.2484 5.86362L19.1415 10.9705L21.0295 12.8585L26.1364 7.7516L24.2484 5.86362ZM19.1415 21.0295L24.2484 26.1364L26.1364 24.2484L21.0295 19.1415L19.1415 21.0295ZM12.8585 10.9705L7.7516 5.86362L5.86362 7.7516L10.9705 12.8585L12.8585 10.9705ZM10.9705 19.1415L5.86362 24.2484L7.7516 26.1364L12.8585 21.0295L10.9705 19.1415Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-switch-horizontal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2223 8.77778H27.5557M27.5557 8.77778L21.7779 3M27.5557 8.77778L21.7779 14.5556M21.7779 23.2222H4.44455M4.44455 23.2222L10.2223 29M4.44455 23.2222L10.2223 17.4444"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sparkles'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.88889 3V8.77778M3 5.88889H8.77778M7.33333 23.2222V29M4.44444 26.1111H10.2222M17.4444 3L20.746 12.9048L29 16L20.746 19.0952L17.4444 29L14.1429 19.0952L5.88889 16L14.1429 12.9048L17.4444 3Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-question-mark-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.5511 11.6667C11.3442 9.98361 13.4844 8.77778 16.0001 8.77778C19.1911 8.77778 21.7779 10.7179 21.7779 13.1111C21.7779 15.1325 19.9324 16.8307 17.4362 17.3095C16.6527 17.4598 16.0001 18.0911 16.0001 18.8889M16 23.2222H16.0144M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-status-online'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.80761 25.1924C1.7308 20.1156 1.7308 11.8844 6.80761 6.80762M25.1924 6.80762C30.2692 11.8844 30.2692 20.1156 25.1924 25.1924M10.8931 21.1069C8.07266 18.2864 8.07266 13.7136 10.8931 10.8931M21.1069 10.8931C23.9273 13.7136 23.9273 18.2864 21.1069 21.1069M17.4444 16C17.4444 16.7978 16.7977 17.4444 16 17.4444C15.2023 17.4444 14.5556 16.7978 14.5556 16C14.5556 15.2023 15.2023 14.5556 16 14.5556C16.7977 14.5556 17.4444 15.2023 17.4444 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-tag'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.1667 3.97802L17.1658 4.86143C17.1841 4.88221 17.2031 4.90241 17.2227 4.922L18.1667 3.97802ZM28.022 18.1667L27.1386 17.1658C27.1178 17.1841 27.0976 17.2031 27.078 17.2227L28.022 18.1667ZM28.2778 14.0891L29.2787 13.2057C29.2603 13.1849 29.2414 13.1647 29.2218 13.1451L28.2778 14.0891ZM14.0891 28.2778L13.1451 29.2218C13.1647 29.2414 13.1849 29.2603 13.2057 29.2787L14.0891 28.2778ZM17.9109 28.2778L18.7943 29.2787C18.8151 29.2603 18.8353 29.2414 18.8549 29.2218L17.9109 28.2778ZM3.97802 18.1667L4.922 17.2227L4.8926 17.1933L4.86143 17.1658L3.97802 18.1667ZM8.77778 7.44278C8.04048 7.44278 7.44278 8.04048 7.44278 8.77778C7.44278 9.51508 8.04048 10.1128 8.77778 10.1128V7.44278ZM8.79222 10.1128C9.52952 10.1128 10.1272 9.51508 10.1272 8.77778C10.1272 8.04048 9.52952 7.44278 8.79222 7.44278V10.1128ZM4.335 8.77778C4.335 6.3241 6.3241 4.335 8.77778 4.335V1.665C4.8495 1.665 1.665 4.8495 1.665 8.77778H4.335ZM4.335 16V8.77778H1.665V16H4.335ZM8.77778 4.335H16V1.665H8.77778V4.335ZM16 4.335C16.4639 4.335 16.8791 4.53662 17.1658 4.86143L19.1676 3.0946C18.3956 2.21991 17.2618 1.665 16 1.665V4.335ZM27.665 16C27.665 16.4639 27.4634 16.8791 27.1386 17.1658L28.9054 19.1676C29.7801 18.3956 30.335 17.2617 30.335 16H27.665ZM27.2769 14.9725C27.5194 15.2473 27.665 15.605 27.665 16H30.335C30.335 14.9297 29.9352 13.9495 29.2787 13.2057L27.2769 14.9725ZM16 27.665C15.605 27.665 15.2473 27.5194 14.9725 27.2769L13.2057 29.2787C13.9495 29.9352 14.9297 30.335 16 30.335V27.665ZM17.0275 27.2769C16.7527 27.5194 16.395 27.665 16 27.665V30.335C17.0703 30.335 18.0505 29.9352 18.7943 29.2787L17.0275 27.2769ZM4.86143 17.1658C4.53662 16.8791 4.335 16.4639 4.335 16H1.665C1.665 17.2618 2.21991 18.3956 3.0946 19.1676L4.86143 17.1658ZM17.2227 4.922L27.3338 15.0331L29.2218 13.1451L19.1107 3.03403L17.2227 4.922ZM15.0331 27.3338L4.922 17.2227L3.03403 19.1107L13.1451 29.2218L15.0331 27.3338ZM27.078 17.2227L16.9669 27.3338L18.8549 29.2218L28.966 19.1107L27.078 17.2227ZM8.77778 10.1128H8.79222V7.44278H8.77778V10.1128Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-status-offline'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.1364 5.86364C25.615 5.34229 24.7698 5.34229 24.2484 5.86364C23.7271 6.38499 23.7271 7.23026 24.2484 7.75161L26.1364 5.86364ZM25.1924 25.1924L24.2484 26.1364H24.2484L25.1924 25.1924ZM22.0509 9.94914C21.5295 9.42779 20.6842 9.42779 20.1629 9.94914C19.6415 10.4705 19.6415 11.3158 20.1629 11.8371L22.0509 9.94914ZM21.1069 21.1069L20.1629 22.0509L20.1629 22.0509L21.1069 21.1069ZM9.94913 22.0509C10.4705 22.5722 11.3158 22.5722 11.8371 22.0509C12.3585 21.5295 12.3585 20.6843 11.8371 20.1629L9.94913 22.0509ZM10.1716 16.8332C10.068 16.1032 9.39216 15.5955 8.66219 15.6991C7.93221 15.8028 7.42447 16.4786 7.52812 17.2086L10.1716 16.8332ZM5.86362 26.1364C6.38497 26.6577 7.23025 26.6577 7.7516 26.1364C8.27295 25.615 8.27295 24.7698 7.7516 24.2484L5.86362 26.1364ZM4.94309 12.2739C5.17795 11.575 4.80177 10.818 4.10288 10.5832C3.40398 10.3483 2.64703 10.7245 2.41217 11.4234L4.94309 12.2739ZM3.94399 2.05601C3.42264 1.53466 2.57736 1.53466 2.05601 2.05601C1.53466 2.57736 1.53466 3.42264 2.05601 3.94399L3.94399 2.05601ZM28.056 29.944C28.5774 30.4653 29.4226 30.4653 29.944 29.944C30.4653 29.4226 30.4653 28.5774 29.944 28.056L28.056 29.944ZM24.2484 7.75161C28.8039 12.3071 28.8039 19.6929 24.2484 24.2484L26.1364 26.1364C31.7345 20.5382 31.7345 11.4618 26.1364 5.86364L24.2484 7.75161ZM20.1629 11.8371C22.462 14.1362 22.462 17.8638 20.1629 20.1629L22.0509 22.0509C25.3927 18.7091 25.3927 13.2909 22.0509 9.94914L20.1629 11.8371ZM16 15.8906C16.0604 15.8906 16.1094 15.9396 16.1094 16H18.7794C18.7794 14.465 17.535 13.2206 16 13.2206V15.8906ZM11.8371 20.1629C10.8987 19.2245 10.3446 18.0517 10.1716 16.8332L7.52812 17.2086C7.77966 18.98 8.58777 20.6895 9.94913 22.0509L11.8371 20.1629ZM7.7516 24.2484C4.51436 21.0112 3.57569 16.343 4.94309 12.2739L2.41217 11.4234C0.734353 16.4162 1.88234 22.1551 5.86362 26.1364L7.7516 24.2484ZM15.9226 15.9226C15.9335 15.9117 15.9457 15.9037 15.9578 15.8986C15.969 15.8939 15.9824 15.8906 16 15.8906V13.2206C15.2329 13.2206 14.5362 13.5331 14.0346 14.0346L15.9226 15.9226ZM2.05601 3.94399L14.0346 15.9226L15.9226 14.0346L3.94399 2.05601L2.05601 3.94399ZM14.0346 15.9226L16.0774 17.9654L17.9654 16.0774L15.9226 14.0346L14.0346 15.9226ZM16.0774 17.9654L20.1629 22.0509L22.0509 20.1629L17.9654 16.0774L16.0774 17.9654ZM20.1629 22.0509L24.2484 26.1364L26.1364 24.2484L22.0509 20.1629L20.1629 22.0509ZM24.2484 26.1364L28.056 29.944L29.944 28.056L26.1364 24.2484L24.2484 26.1364ZM16.1094 16C16.1094 16.0176 16.1061 16.031 16.1014 16.0422C16.0963 16.0543 16.0883 16.0665 16.0774 16.0774L17.9654 17.9654C18.4669 17.4638 18.7794 16.7672 18.7794 16H16.1094Z"
                    fill="#111827"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-printer'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 23.2222H26.1111C27.7066 23.2222 29 21.9288 29 20.3333V14.5556C29 12.9601 27.7066 11.6667 26.1111 11.6667H5.88889C4.2934 11.6667 3 12.9601 3 14.5556V20.3333C3 21.9288 4.2934 23.2222 5.88889 23.2222H8.77778M11.6667 29H20.3333C21.9288 29 23.2222 27.7066 23.2222 26.1111V20.3333C23.2222 18.7378 21.9288 17.4444 20.3333 17.4444H11.6667C10.0712 17.4444 8.77778 18.7378 8.77778 20.3333V26.1111C8.77778 27.7066 10.0712 29 11.6667 29ZM23.2222 11.6667V5.88889C23.2222 4.2934 21.9288 3 20.3333 3H11.6667C10.0712 3 8.77778 4.2934 8.77778 5.88889V11.6667H23.2222Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-table'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 13.1112H29M3 18.8889H29M16 13.1112V24.6667M5.88889 24.6667H26.1111C27.7066 24.6667 29 23.3733 29 21.7778V10.2223C29 8.62677 27.7066 7.33337 26.1111 7.33337H5.88889C4.2934 7.33337 3 8.62677 3 10.2223V21.7778C3 23.3733 4.2934 24.6667 5.88889 24.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-template'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 4.625C3 3.72754 3.72754 3 4.625 3H27.375C28.2725 3 29 3.72754 29 4.625V7.875C29 8.77246 28.2725 9.5 27.375 9.5H4.625C3.72754 9.5 3 8.77246 3 7.875V4.625Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3 17.625C3 16.7275 3.72754 16 4.625 16H14.375C15.2725 16 16 16.7275 16 17.625V27.375C16 28.2725 15.2725 29 14.375 29H4.625C3.72754 29 3 28.2725 3 27.375V17.625Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M22.5 17.625C22.5 16.7275 23.2275 16 24.125 16H27.375C28.2725 16 29 16.7275 29 17.625V27.375C29 28.2725 28.2725 29 27.375 29H24.125C23.2275 29 22.5 28.2725 22.5 27.375V17.625Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-terminal'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.2222 11.6667L14.5556 16L10.2222 20.3333M17.4444 20.3333H21.7778M5.88889 27.5556H26.1111C27.7066 27.5556 29 26.2622 29 24.6667V7.33335C29 5.73786 27.7066 4.44446 26.1111 4.44446H5.88889C4.2934 4.44446 3 5.73786 3 7.33335V24.6667C3 26.2622 4.2934 27.5556 5.88889 27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-thumb-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.0576 18.8889H25.9388C28.0864 18.8889 29.4831 16.6289 28.5227 14.708L23.4672 4.59694C22.9778 3.61823 21.9775 3 20.8833 3H15.0799C14.8437 3 14.6084 3.02897 14.3792 3.08626L8.94648 4.44444M19.0576 18.8889V26.1111C19.0576 27.7066 17.7642 29 16.1687 29H16.0308C15.3092 29 14.7243 28.415 14.7243 27.6935C14.7243 26.6617 14.4189 25.653 13.8465 24.7945L8.94648 17.4444V4.44444M19.0576 18.8889H16.1687M8.94648 4.44444H6.05759C4.4621 4.44444 3.1687 5.73784 3.1687 7.33333V16C3.1687 17.5955 4.4621 18.8889 6.05759 18.8889H9.6687"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-trending-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 23.2223H29M29 23.2223V11.6667M29 23.2223L17.4444 11.6667L11.6667 17.4445L3 8.77783"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-thumb-down'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.9426 13.1111H6.06132C3.91377 13.1111 2.517 15.3711 3.47742 17.292L8.53297 27.4031C9.02233 28.3818 10.0226 29 11.1169 29H16.9202C17.1564 29 17.3918 28.971 17.6209 28.9137L23.0537 27.5556M12.9426 13.1111V5.88889C12.9426 4.2934 14.236 3 15.8314 3H15.9693C16.6909 3 17.2759 3.58496 17.2759 4.30654C17.2759 5.33831 17.5813 6.347 18.1536 7.20549L23.0537 14.5556V27.5556M12.9426 13.1111H15.8314M23.0537 27.5556H25.9426C27.538 27.5556 28.8314 26.2622 28.8314 24.6667V16C28.8314 14.4045 27.538 13.1111 25.9426 13.1111H22.3314"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-translate'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 5.88889H20.3333M11.6667 3V5.88889M13.1807 19.6111C10.9745 17.3257 9.18327 14.6371 7.92825 11.6667M16.7222 24.6667H26.8333M14.5556 29L21.7778 14.5556L29 29M17.085 5.88889C15.6867 14.2237 10.3229 21.2138 3 24.8529"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-trash'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M26.111 8.77778L24.8582 26.3169C24.7502 27.8287 23.4923 29 21.9767 29H10.0231C8.5075 29 7.24956 27.8287 7.14158 26.3169L5.88878 8.77778M13.111 14.5556V23.2222M18.8888 14.5556V23.2222M20.3332 8.77778V4.44444C20.3332 3.6467 19.6865 3 18.8888 3H13.111C12.3133 3 11.6666 3.6467 11.6666 4.44444V8.77778M4.44434 8.77778H27.5554"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-truck'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 21.7778V7.33336C17.4444 6.53562 16.7977 5.88892 16 5.88892H4.44444C3.6467 5.88892 3 6.53562 3 7.33336V21.7778C3 22.5755 3.6467 23.2222 4.44444 23.2222H5.88889M17.4444 21.7778C17.4444 22.5755 16.7977 23.2222 16 23.2222H11.6667M17.4444 21.7778L17.4444 10.2222C17.4444 9.4245 18.0911 8.7778 18.8889 8.7778H22.6239C23.007 8.7778 23.3744 8.92999 23.6453 9.20087L28.5769 14.1325C28.8478 14.4034 29 14.7708 29 15.1539V21.7778C29 22.5755 28.3533 23.2222 27.5556 23.2222H26.1111M17.4444 21.7778C17.4444 22.5755 18.0911 23.2222 18.8889 23.2222H20.3333M5.88889 23.2222C5.88889 24.8177 7.18229 26.1111 8.77778 26.1111C10.3733 26.1111 11.6667 24.8177 11.6667 23.2222M5.88889 23.2222C5.88889 21.6268 7.18229 20.3334 8.77778 20.3334C10.3733 20.3334 11.6667 21.6268 11.6667 23.2222M20.3333 23.2222C20.3333 24.8177 21.6267 26.1111 23.2222 26.1111C24.8177 26.1111 26.1111 24.8177 26.1111 23.2222M20.3333 23.2222C20.3333 21.6268 21.6267 20.3334 23.2222 20.3334C24.8177 20.3334 26.1111 21.6268 26.1111 23.2222"
                    stroke="#111827"
                    stroke-width="2.67"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user-add'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24.6667 11.6667V16M24.6667 16V20.3333M24.6667 16H29M24.6667 16H20.3333M17.4444 8.77778C17.4444 11.9688 14.8576 14.5556 11.6667 14.5556C8.47569 14.5556 5.88889 11.9688 5.88889 8.77778C5.88889 5.5868 8.47569 3 11.6667 3C14.8576 3 17.4444 5.5868 17.4444 8.77778ZM3 27.5556C3 22.7691 6.8802 18.8889 11.6667 18.8889C16.4531 18.8889 20.3333 22.7691 20.3333 27.5556V29H3V27.5556Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-trending-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.4444 8.77783H29M29 8.77783V20.3334M29 8.77783L17.4444 20.3334L11.6667 14.5556L3 23.2223"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.7778 8.77778C21.7778 11.9688 19.191 14.5556 16 14.5556C12.809 14.5556 10.2222 11.9688 10.2222 8.77778C10.2222 5.5868 12.809 3 16 3C19.191 3 21.7778 5.5868 21.7778 8.77778Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M16 18.8889C10.4158 18.8889 5.88892 23.4158 5.88892 29H26.1111C26.1111 23.4158 21.5842 18.8889 16 18.8889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.06372 24.3832C8.9983 22.7245 12.3886 21.7778 16 21.7778C19.6114 21.7778 23.0017 22.7245 25.9363 24.3832M20.3333 13.1111C20.3333 15.5043 18.3932 17.4444 16 17.4444C13.6068 17.4444 11.6667 15.5043 11.6667 13.1111C11.6667 10.7179 13.6068 8.77778 16 8.77778C18.3932 8.77778 20.3333 10.7179 20.3333 13.1111ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-variable'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.72211 4.36108C3.97972 7.86719 3 11.8192 3 16C3 20.1808 3.97972 24.1328 5.72211 27.6389M26.2779 27.6389C28.0203 24.1328 29 20.1808 29 16C29 11.8192 28.0203 7.86719 26.2779 4.36108M11.7292 11.6354H13.5415C14.1911 11.6354 14.7619 12.066 14.9404 12.6906L17.2472 20.7643C17.4256 21.3888 17.9965 21.8194 18.646 21.8194H20.4584M21.9132 11.6354H21.7966C20.9472 11.6354 20.1402 12.0066 19.5874 12.6515L12.6001 20.8033C12.0473 21.4483 11.2403 21.8194 10.3909 21.8194H10.2743"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-sun'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 3V4.44444M16 27.5556V29M29 16H27.5556M4.44444 16H3M25.1924 25.1924L24.171 24.171M7.82899 7.82899L6.80761 6.80761M25.1925 6.80769L24.1711 7.82907M7.82906 24.1711L6.80769 25.1925M21.7778 16C21.7778 19.191 19.191 21.7778 16 21.7778C12.809 21.7778 10.2222 19.191 10.2222 16C10.2222 12.809 12.809 10.2222 16 10.2222C19.191 10.2222 21.7778 12.809 21.7778 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-view-boards'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.6667 23.2222V8.7778M11.6667 23.2222C11.6667 24.8177 10.3733 26.1111 8.77778 26.1111H5.88889C4.2934 26.1111 3 24.8177 3 23.2222V8.7778C3 7.18232 4.2934 5.88892 5.88889 5.88892H8.77778C10.3733 5.88892 11.6667 7.18232 11.6667 8.7778M11.6667 23.2222C11.6667 24.8177 12.9601 26.1111 14.5556 26.1111H17.4444C19.0399 26.1111 20.3333 24.8177 20.3333 23.2222M11.6667 8.7778C11.6667 7.18232 12.9601 5.88892 14.5556 5.88892H17.4444C19.0399 5.88892 20.3333 7.18232 20.3333 8.7778M20.3333 23.2222V8.7778M20.3333 23.2222C20.3333 24.8177 21.6267 26.1111 23.2222 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H23.2222C21.6267 5.88892 20.3333 7.18232 20.3333 8.7778"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-ticket'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 5.88892V8.7778M20.3333 14.5556V17.4445M20.3333 23.2222V26.1111M5.88889 5.88892C4.2934 5.88892 3 7.18232 3 8.7778V13.1111C4.59549 13.1111 5.88889 14.4045 5.88889 16C5.88889 17.5955 4.59549 18.8889 3 18.8889V23.2222C3 24.8177 4.2934 26.1111 5.88889 26.1111H26.1111C27.7066 26.1111 29 24.8177 29 23.2222V18.8889C27.4045 18.8889 26.1111 17.5955 26.1111 16C26.1111 14.4045 27.4045 13.1111 29 13.1111V8.7778C29 7.18232 27.7066 5.88892 26.1111 5.88892H5.88889Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-view-list'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 6.25H29M3 12.75H29M3 19.25H29M3 25.75H29"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-user-group'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 26.4001H29V23.8001C29 21.6462 27.2539 19.9001 25.1 19.9001C23.8577 19.9001 22.7511 20.4809 22.0369 21.3859M22.5 26.4001H9.5M22.5 26.4001V23.8001C22.5 22.947 22.3356 22.1323 22.0369 21.3859M9.5 26.4001H3V23.8001C3 21.6462 4.74609 19.9001 6.9 19.9001C8.14229 19.9001 9.24892 20.4809 9.96312 21.3859M9.5 26.4001V23.8001C9.5 22.947 9.66435 22.1323 9.96312 21.3859M9.96312 21.3859C10.9216 18.9914 13.2633 17.3001 16 17.3001C18.7367 17.3001 21.0784 18.9914 22.0369 21.3859M19.9 9.5001C19.9 11.654 18.1539 13.4001 16 13.4001C13.8461 13.4001 12.1 11.654 12.1 9.5001C12.1 7.34619 13.8461 5.6001 16 5.6001C18.1539 5.6001 19.9 7.34619 19.9 9.5001ZM27.7 13.4001C27.7 14.836 26.5359 16.0001 25.1 16.0001C23.6641 16.0001 22.5 14.836 22.5 13.4001C22.5 11.9642 23.6641 10.8001 25.1 10.8001C26.5359 10.8001 27.7 11.9642 27.7 13.4001ZM9.5 13.4001C9.5 14.836 8.33594 16.0001 6.9 16.0001C5.46406 16.0001 4.3 14.836 4.3 13.4001C4.3 11.9642 5.46406 10.8001 6.9 10.8001C8.33594 10.8001 9.5 11.9642 9.5 13.4001Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-volume-up'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M21.1068 10.8931C23.9273 13.7136 23.9273 18.2864 21.1068 21.1069M25.1924 6.80756C30.2692 11.8844 30.2692 20.1155 25.1924 25.1923M6.73501 20.3334H4.44444C3.6467 20.3334 3 19.6867 3 18.8889V13.1112C3 12.3134 3.6467 11.6667 4.44444 11.6667H6.73501L13.5341 4.86761C14.4441 3.95767 16 4.60213 16 5.88899V26.1111C16 27.398 14.4441 28.0425 13.5341 27.1325L6.73501 20.3334Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-video-camera'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3333 13.1112L26.9096 9.82303C27.87 9.34282 29 10.0412 29 11.115V20.8851C29 21.9589 27.87 22.6573 26.9096 22.177L20.3333 18.8889M5.88889 24.6667H17.4444C19.0399 24.6667 20.3333 23.3733 20.3333 21.7778V10.2223C20.3333 8.62677 19.0399 7.33337 17.4444 7.33337H5.88889C4.2934 7.33337 3 8.62677 3 10.2223V21.7778C3 23.3733 4.2934 24.6667 5.88889 24.6667Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-volume-off'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.2222 18.8889L26.1111 16M26.1111 16L29 13.1111M26.1111 16L23.2222 13.1111M26.1111 16L29 18.8889M6.73502 20.3334H4.44444C3.6467 20.3334 3 19.6867 3 18.889V13.1112C3 12.3135 3.6467 11.6668 4.44444 11.6668H6.73502L13.5342 4.86761C14.4441 3.95766 16 4.60213 16 5.88899V26.1112C16 27.3981 14.4441 28.0425 13.5342 27.1326L6.73502 20.3334Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-view-grid'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 6.25C3 4.45507 4.45507 3 6.25 3H9.5C11.2949 3 12.75 4.45507 12.75 6.25V9.5C12.75 11.2949 11.2949 12.75 9.5 12.75H6.25C4.45507 12.75 3 11.2949 3 9.5V6.25Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.25 6.25C19.25 4.45507 20.7051 3 22.5 3H25.75C27.5449 3 29 4.45507 29 6.25V9.5C29 11.2949 27.5449 12.75 25.75 12.75H22.5C20.7051 12.75 19.25 11.2949 19.25 9.5V6.25Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M3 22.5C3 20.7051 4.45507 19.25 6.25 19.25H9.5C11.2949 19.25 12.75 20.7051 12.75 22.5V25.75C12.75 27.5449 11.2949 29 9.5 29H6.25C4.45507 29 3 27.5449 3 25.75V22.5Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.25 22.5C19.25 20.7051 20.7051 19.25 22.5 19.25H25.75C27.5449 19.25 29 20.7051 29 22.5V25.75C29 27.5449 27.5449 29 25.75 29H22.5C20.7051 29 19.25 27.5449 19.25 25.75V22.5Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-stop'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11.6667 13.1111C11.6667 12.3134 12.3134 11.6667 13.1111 11.6667H18.8889C19.6866 11.6667 20.3333 12.3134 20.3333 13.1111V18.8889C20.3333 19.6866 19.6866 20.3333 18.8889 20.3333H13.1111C12.3134 20.3333 11.6667 19.6866 11.6667 18.8889V13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-users'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 4.95603C17.0587 3.75653 18.6077 3 20.3333 3C23.5243 3 26.1111 5.5868 26.1111 8.77778C26.1111 11.9688 23.5243 14.5556 20.3333 14.5556C18.6077 14.5556 17.0587 13.799 16 12.5995M20.3333 29H3V27.5556C3 22.7691 6.8802 18.8889 11.6667 18.8889C16.4531 18.8889 20.3333 22.7691 20.3333 27.5556V29ZM20.3333 29H29V27.5556C29 22.7691 25.1198 18.8889 20.3333 18.8889C18.7548 18.8889 17.2748 19.3109 16 20.0483M17.4444 8.77778C17.4444 11.9688 14.8576 14.5556 11.6667 14.5556C8.47569 14.5556 5.88889 11.9688 5.88889 8.77778C5.88889 5.5868 8.47569 3 11.6667 3C14.8576 3 17.4444 5.5868 17.4444 8.77778Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-x'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 29L29 3M3 3L29 29" stroke="#111827" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </template>

        <template v-if="icon === 'design-system-wifi'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.2333 20.7848C13.8659 18.1522 18.1341 18.1522 20.7667 20.7848M16 25.1924H16.0123M7.33338 16.5257C12.1198 11.7393 19.8802 11.7393 24.6667 16.5257M3 12.1924C10.1797 5.01269 21.8203 5.01269 29 12.1924"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-x-circle'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1111 18.8889L16 16M16 16L18.8889 13.1111M16 16L13.1111 13.1111M16 16L18.8889 18.8889M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-upload'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 22.5L3 24.125C3 26.8174 5.18261 29 7.875 29L24.125 29C26.8174 29 29 26.8174 29 24.125L29 22.5M22.5 9.5L16 3M16 3L9.5 9.5M16 3L16 22.5"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-zoom-out'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 29L20.3333 20.3333M17.4444 13.1111H8.77778M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-zoom-in'">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M29 29L20.3333 20.3333M13.1111 8.77778V13.1111M13.1111 13.1111V17.4444M13.1111 13.1111H17.4444M13.1111 13.1111H8.77778M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-analyse'">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.75 11.3844C1.28919 11.3844 0.915625 11.7579 0.915625 12.2187C0.915625 12.6796 1.28919 13.0531 1.75 13.0531V11.3844ZM19.275 13.0531C19.7358 13.0531 20.1094 12.6796 20.1094 12.2187C20.1094 11.7579 19.7358 11.3844 19.275 11.3844V13.0531ZM4.45937 9.40625C4.45937 9.86706 4.83294 10.2406 5.29375 10.2406C5.75456 10.2406 6.12813 9.86706 6.12813 9.40625H4.45937ZM11.4688 3.34375L10.8658 3.92049C10.8702 3.92511 10.8747 3.92968 10.8792 3.9342L11.4688 3.34375ZM15.5063 7.375L16.0962 6.78501L16.0958 6.78455L15.5063 7.375ZM14.8906 9.40625C14.8906 9.86706 15.2642 10.2406 15.725 10.2406C16.1858 10.2406 16.5594 9.86706 16.5594 9.40625H14.8906ZM16.5594 14.7252C16.5595 14.2644 16.186 13.8907 15.7252 13.8906C15.2644 13.8905 14.8907 14.264 14.8906 14.7248L16.5594 14.7252ZM6.12813 14.7251C6.12819 14.2643 5.75469 13.8907 5.29388 13.8906C4.83306 13.8906 4.45944 14.2641 4.45938 14.7249L6.12813 14.7251ZM4.45933 8.80625V10.6125H6.12808V8.80625H4.45933ZM14.8905 8.80625V10.6125H16.5593V8.80625H14.8905ZM14.8905 13.8313V15.05H16.5593V13.8313H14.8905ZM4.45933 13.8313V15.05H6.12808V13.8313H4.45933ZM1.75 13.0531H19.275V11.3844H1.75V13.0531ZM6.12813 9.40625V4.61875H4.45937V9.40625H6.12813ZM6.12813 4.61875C6.12813 4.24603 6.41934 3.95938 6.78125 3.95938V2.29062C5.49316 2.29062 4.45937 3.32897 4.45937 4.61875H6.12813ZM6.78125 3.95938H10.9437V2.29062H6.78125V3.95938ZM10.9437 3.95938C10.9392 3.95938 10.9276 3.95845 10.9117 3.95186C10.8951 3.94505 10.8788 3.93413 10.8658 3.92049L12.0717 2.76701C11.7663 2.44771 11.3558 2.29062 10.9437 2.29062V3.95938ZM10.8792 3.9342L14.9167 7.96545L16.0958 6.78455L12.0583 2.7533L10.8792 3.9342ZM14.9163 7.96499C14.9103 7.95906 14.9027 7.9488 14.8972 7.93519C14.8917 7.92184 14.8906 7.91122 14.8906 7.90625H16.5594C16.5594 7.49067 16.4005 7.08923 16.0962 6.78501L14.9163 7.96499ZM14.8906 7.90625V9.40625H16.5594V7.90625H14.8906ZM14.8906 14.7248L14.8905 15.0498L16.5593 15.0502L16.5594 14.7252L14.8906 14.7248ZM14.8905 15.05C14.8905 15.4165 14.5931 15.7094 14.2375 15.7094V17.3781C15.5194 17.3781 16.5593 16.3335 16.5593 15.05H14.8905ZM14.2375 15.7094H6.78125V17.3781H14.2375V15.7094ZM6.78125 15.7094C6.42158 15.7094 6.12808 15.4187 6.12808 15.05H4.45933C4.45933 16.3313 5.49092 17.3781 6.78125 17.3781V15.7094ZM6.12808 15.0501L6.12813 14.7251L4.45938 14.7249L4.45933 15.0499L6.12808 15.0501Z"
                    fill="white"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-searchAdd'">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path
                    d="M29 29L20.3333 20.3333M13.1111 8.77778V13.1111M13.1111 13.1111V17.4444M13.1111 13.1111H17.4444M13.1111 13.1111H8.77778M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-searchLess'">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path
                    d="M29 29L20.3333 20.3333M17.4444 13.1111H8.77778M23.2222 13.1111C23.2222 18.6953 18.6953 23.2222 13.1111 23.2222C7.5269 23.2222 3 18.6953 3 13.1111C3 7.5269 7.5269 3 13.1111 3C18.6953 3 23.2222 7.5269 23.2222 13.1111Z"
                    stroke="#111827"
                    stroke-width="2.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>

        <template v-if="icon === 'design-system-chevron-down'">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.52864 5.52864C3.78899 5.26829 4.2111 5.26829 4.47145 5.52864L8.00004 9.05723L11.5286 5.52864C11.789 5.26829 12.2111 5.26829 12.4714 5.52864C12.7318 5.78899 12.7318 6.2111 12.4714 6.47145L8.47145 10.4714C8.2111 10.7318 7.78899 10.7318 7.52864 10.4714L3.52864 6.47145C3.26829 6.2111 3.26829 5.78899 3.52864 5.52864Z"
                    fill="#00061A"
                />
            </svg>
        </template>

        <template v-if="icon === 'active-proposition'">
            <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.46447 1.46447C4.40215 0.526784 5.67392 0 7 0C8.32608 0 9.59785 0.526784 10.5355 1.46447C11.4732 2.40215 12 3.67392 12 5C12 6.32608 11.4732 7.59785 10.5355 8.53553C9.59785 9.47322 8.32608 10 7 10C5.67392 10 4.40215 9.47322 3.46447 8.53553C2.52678 7.59785 2 6.32608 2 5C2 3.67392 2.52678 2.40215 3.46447 1.46447ZM7 2C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5C4 5.79565 4.31607 6.55871 4.87868 7.12132C5.44129 7.68393 6.20435 8 7 8C7.79565 8 8.55871 7.68393 9.12132 7.12132C9.68393 6.55871 10 5.79565 10 5C10 4.20435 9.68393 3.44129 9.12132 2.87868C8.55871 2.31607 7.79565 2 7 2Z"
                    fill="#00061A"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5 14C4.20435 14 3.44129 14.3161 2.87868 14.8787C2.31607 15.4413 2 16.2043 2 17V19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19V17C0 15.6739 0.526784 14.4021 1.46447 13.4645C2.40215 12.5268 3.67392 12 5 12H8C8.55228 12 9 12.4477 9 13C9 13.5523 8.55228 14 8 14H5Z"
                    fill="#00061A"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.7071 14.2929C17.0976 14.6834 17.0976 15.3166 16.7071 15.7071L11.7071 20.7071C11.3166 21.0976 10.6834 21.0976 10.2929 20.7071C9.90237 20.3166 9.90237 19.6834 10.2929 19.2929L15.2929 14.2929C15.6834 13.9024 16.3166 13.9024 16.7071 14.2929Z"
                    fill="#00061A"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.5 15C10.5 14.4477 10.9477 14 11.5 14H16C16.5523 14 17 14.4477 17 15V19.5C17 20.0523 16.5523 20.5 16 20.5C15.4477 20.5 15 20.0523 15 19.5V16H11.5C10.9477 16 10.5 15.5523 10.5 15Z"
                    fill="#00061A"
                />
            </svg>
        </template>
    </div>
</template>
<style scoped lang="scss">
.Icon {
    img,
    svg {
        height: 18px;
        max-width: 18px;
        transition: 0.2s linear;
    }

    .cls-2 {
        fill: white;
    }

    &.smallLogo {
        .cls-1 {
            fill: #5c6df3 !important;
            opacity: 0.9;
        }

        .cls-2 {
            fill: #00e2e0 !important;
            opacity: 0.76;
        }
    }

    &.logo {
        .cls-1 {
            fill: #5c6df3 !important;
        }

        .cls-2 {
            fill: #00e2e0 !important;
        }
    }

    &.logo2 {
        svg {
            .st0 {
                fill: #517cbe !important;
            }

            .st1 {
                fill: #68b5e0 !important;
            }

            .st2 {
                fill: #6cc8ea !important;
            }
        }
    }

    &.logotxt {
        svg {
            .st0 {
                enable-background: new;
            }

            .st1 {
                fill: #ffffff;
            }

            .st2 {
                clip-path: url(#SVGID_00000116216217968986577370000017252538941074772394_);
            }

            .st3 {
                fill: url(#SVGID_00000023975338878937153000000014183857298647329156_);
            }
        }
    }

    &.hand {
        .cls-2 {
            fill: $purple;
        }
    }

    &.green {
        svg {
            fill: $green;
        }
    }

    &.purple {
        svg {
            fill: $purple;
        }
    }

    &.grey,
    &.workerStatus_placed {
        svg {
            fill: $grey;
        }
    }

    &.red,
    &.workerStatus_aborted {
        svg {
            fill: $red;
        }
    }

    &.white {
        svg {
            fill: $white;
        }
    }

    &.workerStatus_validated {
        .st0 {
            fill: #5e72eb;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_rejectedByCompany {
        .st0 {
            fill: #d5d8e2;
        }

        .st2 {
            fill: #ffffff;
        }
    }

    &.workerStatus_rejectedByAgency {
        .st0 {
            fill: #cc0033;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_proposed {
        .st0 {
            fill: #fbb03b;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_reproposed {
        .st0 {
            fill: #fbb03b;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_presented {
        .st0 {
            fill: #5e72eb;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_declined {
        .st0 {
            fill: #d5d8e2;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_confirmed {
        .st0 {
            fill: #4adede;
        }

        .st2 {
            fill: #ffffff;
        }
    }

    &.workerStatus_notconfirmed {
        .st0 {
            fill: #d5d8e2;
        }

        .st2 {
            fill: #ffffff;
        }
    }

    &.workerStatus_accepted {
        .st0 {
            fill: #3ab54a;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.cv {
        svg {
            width: 120px !important;
            height: 164px !important;
        }
    }

    &.workerStatus_aborted {
        .st0 {
            fill: #cc0033;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.workerStatus_lost {
        .st0 {
            fill: #d5d8e2;
        }

        .st1 {
            fill: #ffffff;
        }
    }

    &.notification-alert {
        .cls-1 {
            fill: $black;
        }

        .cls-2 {
            fill: $white;
        }
    }

    &.missionDetail {
        width: 28px;
        height: 28px;

        svg {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
